window.vehicleData = [
  // Aprilia
  // Aprilia - Dorsoduro 900
  { make: "Aprilia", model: "Dorsoduro 900", year: 2017 },
  { make: "Aprilia", model: "Dorsoduro 900", year: 2018 },
  { make: "Aprilia", model: "Dorsoduro 900", year: 2019 },
  // Aprilia - RS 660
  { make: "Aprilia", model: "RS 660", year: 2020 },
  { make: "Aprilia", model: "RS 660", year: 2021 },
  { make: "Aprilia", model: "RS 660", year: 2022 },
  { make: "Aprilia", model: "RS 660", year: 2023 },
  { make: "Aprilia", model: "RS 660", year: 2024 },
  { make: "Aprilia", model: "RS 660", year: 2025 },
  { make: "Aprilia", model: "RS 660", year: 2026 },
  // Aprilia - RS660
  { make: "Aprilia", model: "RS660", year: 2020 },
  { make: "Aprilia", model: "RS660", year: 2021 },
  { make: "Aprilia", model: "RS660", year: 2022 },
  { make: "Aprilia", model: "RS660", year: 2023 },
  { make: "Aprilia", model: "RS660", year: 2024 },
  { make: "Aprilia", model: "RS660", year: 2025 },
  // Aprilia - RS660 E5
  { make: "Aprilia", model: "RS660 E5", year: 2025 },
  // Aprilia - RSV-4
  { make: "Aprilia", model: "RSV-4", year: 2009 },
  { make: "Aprilia", model: "RSV-4", year: 2010 },
  { make: "Aprilia", model: "RSV-4", year: 2011 },
  { make: "Aprilia", model: "RSV-4", year: 2012 },
  { make: "Aprilia", model: "RSV-4", year: 2013 },
  { make: "Aprilia", model: "RSV-4", year: 2014 },
  { make: "Aprilia", model: "RSV-4", year: 2015 },
  // Aprilia - RSV-4 1100
  { make: "Aprilia", model: "RSV-4 1100", year: 2019 },
  { make: "Aprilia", model: "RSV-4 1100", year: 2020 },
  // Aprilia - RSV-1000
  { make: "Aprilia", model: "RSV-1000", year: 2004 },
  { make: "Aprilia", model: "RSV-1000", year: 2005 },
  // Aprilia - RSV4
  { make: "Aprilia", model: "RSV4", year: 2009 },
  { make: "Aprilia", model: "RSV4", year: 2010 },
  { make: "Aprilia", model: "RSV4", year: 2011 },
  { make: "Aprilia", model: "RSV4", year: 2012 },
  { make: "Aprilia", model: "RSV4", year: 2013 },
  { make: "Aprilia", model: "RSV4", year: 2014 },
  { make: "Aprilia", model: "RSV4", year: 2015 },
  { make: "Aprilia", model: "RSV4", year: 2016 },
  { make: "Aprilia", model: "RSV4", year: 2017 },
  { make: "Aprilia", model: "RSV4", year: 2018 },
  { make: "Aprilia", model: "RSV4", year: 2019 },
  { make: "Aprilia", model: "RSV4", year: 2020 },
  { make: "Aprilia", model: "RSV4", year: 2021 },
  { make: "Aprilia", model: "RSV4", year: 2022 },
  { make: "Aprilia", model: "RSV4", year: 2023 },
  { make: "Aprilia", model: "RSV4", year: 2024 },
  { make: "Aprilia", model: "RSV4", year: 2025 },
  { make: "Aprilia", model: "RSV4", year: 2026 },
  { make: "Aprilia", model: "RSV4", year: 2027 },
  // Aprilia - RSV4 1100
  { make: "Aprilia", model: "RSV4 1100", year: 2019 },
  { make: "Aprilia", model: "RSV4 1100", year: 2020 },
  // Aprilia - RSV4 Clip Ons
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2021 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2022 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2023 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2024 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2025 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2026 },
  { make: "Aprilia", model: "RSV4 Clip Ons", year: 2027 },
  // Aprilia - RSV4 Gloss
  { make: "Aprilia", model: "RSV4 Gloss", year: 2009 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2010 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2011 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2012 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2013 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2014 },
  { make: "Aprilia", model: "RSV4 Gloss", year: 2015 },
  // Aprilia - RSV4 Grid O
  { make: "Aprilia", model: "RSV4 Grid O", year: 2017 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2018 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2019 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2020 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2021 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2022 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2023 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2024 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2025 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2026 },
  { make: "Aprilia", model: "RSV4 Grid O", year: 2027 },
  // Aprilia - RSV4 Matt
  { make: "Aprilia", model: "RSV4 Matt", year: 2009 },
  { make: "Aprilia", model: "RSV4 Matt", year: 2010 },
  { make: "Aprilia", model: "RSV4 Matt", year: 2011 },
  { make: "Aprilia", model: "RSV4 Matt", year: 2012 },
  // Aprilia - RSV4 Rf
  { make: "Aprilia", model: "RSV4 Rf", year: 2017 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2018 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2019 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2020 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2021 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2022 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2023 },
  { make: "Aprilia", model: "RSV4 Rf", year: 2024 },
  // Aprilia - RSV4 RR RSV4 Rf
  { make: "Aprilia", model: "RSV4 RR RSV4 Rf", year: 2015 },
  { make: "Aprilia", model: "RSV4 RR RSV4 Rf", year: 2016 },
  // Aprilia - RSV4 Tuono V4 15401STU
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2017 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2018 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2019 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2020 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2021 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2022 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2023 },
  { make: "Aprilia", model: "RSV4 Tuono V4 15401STU", year: 2024 },
  // Aprilia - SR-200 GT
  { make: "Aprilia", model: "SR-200 GT", year: 2022 },
  { make: "Aprilia", model: "SR-200 GT", year: 2023 },
  // Aprilia - SX V 4 5
  { make: "Aprilia", model: "SX V 4 5", year: 2007 },
  { make: "Aprilia", model: "SX V 4 5", year: 2008 },
  { make: "Aprilia", model: "SX V 4 5", year: 2009 },
  // Aprilia - SX V 5 5
  { make: "Aprilia", model: "SX V 5 5", year: 2007 },
  { make: "Aprilia", model: "SX V 5 5", year: 2008 },
  { make: "Aprilia", model: "SX V 5 5", year: 2009 },
  // Aprilia - SX-V4 5
  { make: "Aprilia", model: "SX-V4 5", year: 2007 },
  { make: "Aprilia", model: "SX-V4 5", year: 2008 },
  { make: "Aprilia", model: "SX-V4 5", year: 2009 },
  // Aprilia - SX-V5 5
  { make: "Aprilia", model: "SX-V5 5", year: 2007 },
  { make: "Aprilia", model: "SX-V5 5", year: 2008 },
  { make: "Aprilia", model: "SX-V5 5", year: 2009 },
  // Aprilia - Tuareg 660
  { make: "Aprilia", model: "Tuareg 660", year: 2022 },
  { make: "Aprilia", model: "Tuareg 660", year: 2023 },
  { make: "Aprilia", model: "Tuareg 660", year: 2024 },
  { make: "Aprilia", model: "Tuareg 660", year: 2025 },
  { make: "Aprilia", model: "Tuareg 660", year: 2026 },
  // Aprilia - Tuareg 660 15626BU
  { make: "Aprilia", model: "Tuareg 660 15626BU", year: 2022 },
  { make: "Aprilia", model: "Tuareg 660 15626BU", year: 2023 },
  { make: "Aprilia", model: "Tuareg 660 15626BU", year: 2024 },
  // Aprilia - Tuareg 660 15626TU
  { make: "Aprilia", model: "Tuareg 660 15626TU", year: 2022 },
  { make: "Aprilia", model: "Tuareg 660 15626TU", year: 2023 },
  { make: "Aprilia", model: "Tuareg 660 15626TU", year: 2024 },
  // Aprilia - Tuareg 660 15626U
  { make: "Aprilia", model: "Tuareg 660 15626U", year: 2022 },
  { make: "Aprilia", model: "Tuareg 660 15626U", year: 2023 },
  { make: "Aprilia", model: "Tuareg 660 15626U", year: 2024 },
  // Aprilia - Tuareg 660 E5
  { make: "Aprilia", model: "Tuareg 660 E5", year: 2025 },
  // Aprilia - Tuareg 660 Euro 5
  { make: "Aprilia", model: "Tuareg 660 Euro 5", year: 2025 },
  // Aprilia - Tuono 660
  { make: "Aprilia", model: "Tuono 660", year: 2021 },
  { make: "Aprilia", model: "Tuono 660", year: 2022 },
  { make: "Aprilia", model: "Tuono 660", year: 2023 },
  { make: "Aprilia", model: "Tuono 660", year: 2024 },
  { make: "Aprilia", model: "Tuono 660", year: 2025 },
  { make: "Aprilia", model: "Tuono 660", year: 2026 },
  // Aprilia - Tuono 1100 V4
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2015 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2016 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2017 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2018 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2019 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2020 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2021 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2022 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2023 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2024 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2025 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2026 },
  { make: "Aprilia", model: "Tuono 1100 V4", year: 2027 },
  // Aprilia - Tuono V4
  { make: "Aprilia", model: "Tuono V4", year: 2012 },
  { make: "Aprilia", model: "Tuono V4", year: 2013 },
  { make: "Aprilia", model: "Tuono V4", year: 2014 },
  { make: "Aprilia", model: "Tuono V4", year: 2015 },
  { make: "Aprilia", model: "Tuono V4", year: 2016 },
  { make: "Aprilia", model: "Tuono V4", year: 2017 },
  { make: "Aprilia", model: "Tuono V4", year: 2018 },
  { make: "Aprilia", model: "Tuono V4", year: 2019 },
  { make: "Aprilia", model: "Tuono V4", year: 2020 },
  { make: "Aprilia", model: "Tuono V4", year: 2021 },
  { make: "Aprilia", model: "Tuono V4", year: 2022 },
  { make: "Aprilia", model: "Tuono V4", year: 2023 },
  { make: "Aprilia", model: "Tuono V4", year: 2024 },
  { make: "Aprilia", model: "Tuono V4", year: 2025 },
  { make: "Aprilia", model: "Tuono V4", year: 2026 },
  // Aprilia - Tuono V4 1100
  { make: "Aprilia", model: "Tuono V4 1100", year: 2019 },
  { make: "Aprilia", model: "Tuono V4 1100", year: 2020 },
  { make: "Aprilia", model: "Tuono V4 1100", year: 2021 },
  { make: "Aprilia", model: "Tuono V4 1100", year: 2022 },
  { make: "Aprilia", model: "Tuono V4 1100", year: 2023 },
  { make: "Aprilia", model: "Tuono V4 1100", year: 2024 },
  // Aprilia - Tuono V4 1100 71674MI
  { make: "Aprilia", model: "Tuono V4 1100 71674MI", year: 2019 },
  { make: "Aprilia", model: "Tuono V4 1100 71674MI", year: 2020 },
  // Aprilia - Tuono V4 1100 RR
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2017 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2018 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2019 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2020 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2021 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2022 },
  { make: "Aprilia", model: "Tuono V4 1100 RR", year: 2023 },
  // Aprilia - Tuono V4 1100RR
  { make: "Aprilia", model: "Tuono V4 1100RR", year: 2017 },
  { make: "Aprilia", model: "Tuono V4 1100RR", year: 2018 },
  { make: "Aprilia", model: "Tuono V4 1100RR", year: 2019 },
  { make: "Aprilia", model: "Tuono V4 1100RR", year: 2020 },
  // Benelli
  // Benelli - 302S
  { make: "Benelli", model: "302S", year: 2019 },
  { make: "Benelli", model: "302S", year: 2020 },
  { make: "Benelli", model: "302S", year: 2021 },
  { make: "Benelli", model: "302S", year: 2022 },
  { make: "Benelli", model: "302S", year: 2023 },
  { make: "Benelli", model: "302S", year: 2024 },
  { make: "Benelli", model: "302S", year: 2025 },
  { make: "Benelli", model: "302S", year: 2026 },
  // Benelli - 502C
  { make: "Benelli", model: "502C", year: 2019 },
  { make: "Benelli", model: "502C", year: 2020 },
  // Benelli - 752S
  { make: "Benelli", model: "752S", year: 2019 },
  { make: "Benelli", model: "752S", year: 2020 },
  // Benelli - BN-302
  { make: "Benelli", model: "BN-302", year: 2014 },
  { make: "Benelli", model: "BN-302", year: 2015 },
  { make: "Benelli", model: "BN-302", year: 2019 },
  { make: "Benelli", model: "BN-302", year: 2020 },
  // Benelli - BN-302S
  { make: "Benelli", model: "BN-302S", year: 2019 },
  // Benelli - Leoncino 500
  { make: "Benelli", model: "Leoncino 500", year: 2017 },
  { make: "Benelli", model: "Leoncino 500", year: 2018 },
  { make: "Benelli", model: "Leoncino 500", year: 2019 },
  { make: "Benelli", model: "Leoncino 500", year: 2020 },
  { make: "Benelli", model: "Leoncino 500", year: 2021 },
  { make: "Benelli", model: "Leoncino 500", year: 2022 },
  { make: "Benelli", model: "Leoncino 500", year: 2023 },
  { make: "Benelli", model: "Leoncino 500", year: 2024 },
  // Benelli - Leoncino 500 Trail
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2017 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2018 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2019 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2020 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2021 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2022 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2023 },
  { make: "Benelli", model: "Leoncino 500 Trail", year: 2024 },
  // Benelli - Leoncino 800
  { make: "Benelli", model: "Leoncino 800", year: 2022 },
  { make: "Benelli", model: "Leoncino 800", year: 2023 },
  { make: "Benelli", model: "Leoncino 800", year: 2024 },
  // Benelli - Leoncino/Trail 500
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2017 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2018 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2019 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2020 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2021 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2022 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2023 },
  { make: "Benelli", model: "Leoncino/Trail 500", year: 2024 },
  // Benelli - TNT 135
  { make: "Benelli", model: "TNT 135", year: 2018 },
  { make: "Benelli", model: "TNT 135", year: 2019 },
  { make: "Benelli", model: "TNT 135", year: 2020 },
  { make: "Benelli", model: "TNT 135", year: 2021 },
  { make: "Benelli", model: "TNT 135", year: 2022 },
  { make: "Benelli", model: "TNT 135", year: 2023 },
  { make: "Benelli", model: "TNT 135", year: 2024 },
  { make: "Benelli", model: "TNT 135", year: 2025 },
  { make: "Benelli", model: "TNT 135", year: 2026 },
  // Benelli - Trail 500
  { make: "Benelli", model: "Trail 500", year: 2017 },
  { make: "Benelli", model: "Trail 500", year: 2018 },
  { make: "Benelli", model: "Trail 500", year: 2019 },
  { make: "Benelli", model: "Trail 500", year: 2020 },
  { make: "Benelli", model: "Trail 500", year: 2021 },
  { make: "Benelli", model: "Trail 500", year: 2022 },
  { make: "Benelli", model: "Trail 500", year: 2023 },
  { make: "Benelli", model: "Trail 500", year: 2024 },
  // Benelli - TRK 502
  { make: "Benelli", model: "TRK 502", year: 2017 },
  { make: "Benelli", model: "TRK 502", year: 2018 },
  { make: "Benelli", model: "TRK 502", year: 2019 },
  { make: "Benelli", model: "TRK 502", year: 2020 },
  { make: "Benelli", model: "TRK 502", year: 2021 },
  { make: "Benelli", model: "TRK 502", year: 2022 },
  { make: "Benelli", model: "TRK 502", year: 2023 },
  { make: "Benelli", model: "TRK 502", year: 2024 },
  { make: "Benelli", model: "TRK 502", year: 2025 },
  { make: "Benelli", model: "TRK 502", year: 2026 },
  // Benelli - TRK-502 X
  { make: "Benelli", model: "TRK-502 X", year: 2018 },
  { make: "Benelli", model: "TRK-502 X", year: 2019 },
  { make: "Benelli", model: "TRK-502 X", year: 2020 },
  { make: "Benelli", model: "TRK-502 X", year: 2021 },
  { make: "Benelli", model: "TRK-502 X", year: 2022 },
  { make: "Benelli", model: "TRK-502 X", year: 2023 },
  { make: "Benelli", model: "TRK-502 X", year: 2024 },
  // Benelli - TRK-702
  { make: "Benelli", model: "TRK-702", year: 2025 },
  // Beta
  // Beta - 125 RR
  { make: "Beta", model: "125 RR", year: 2018 },
  { make: "Beta", model: "125 RR", year: 2019 },
  { make: "Beta", model: "125 RR", year: 2020 },
  { make: "Beta", model: "125 RR", year: 2021 },
  { make: "Beta", model: "125 RR", year: 2022 },
  { make: "Beta", model: "125 RR", year: 2023 },
  { make: "Beta", model: "125 RR", year: 2024 },
  { make: "Beta", model: "125 RR", year: 2025 },
  { make: "Beta", model: "125 RR", year: 2026 },
  // Beta - 200 RR
  { make: "Beta", model: "200 RR", year: 2019 },
  { make: "Beta", model: "200 RR", year: 2020 },
  { make: "Beta", model: "200 RR", year: 2021 },
  { make: "Beta", model: "200 RR", year: 2022 },
  { make: "Beta", model: "200 RR", year: 2023 },
  { make: "Beta", model: "200 RR", year: 2024 },
  { make: "Beta", model: "200 RR", year: 2025 },
  { make: "Beta", model: "200 RR", year: 2026 },
  // Beta - 200RR
  { make: "Beta", model: "200RR", year: 2020 },
  { make: "Beta", model: "200RR", year: 2021 },
  { make: "Beta", model: "200RR", year: 2022 },
  { make: "Beta", model: "200RR", year: 2023 },
  { make: "Beta", model: "200RR", year: 2024 },
  { make: "Beta", model: "200RR", year: 2025 },
  { make: "Beta", model: "200RR", year: 2026 },
  // Beta - 250 RR
  { make: "Beta", model: "250 RR", year: 2013 },
  { make: "Beta", model: "250 RR", year: 2014 },
  { make: "Beta", model: "250 RR", year: 2015 },
  { make: "Beta", model: "250 RR", year: 2016 },
  { make: "Beta", model: "250 RR", year: 2017 },
  { make: "Beta", model: "250 RR", year: 2018 },
  { make: "Beta", model: "250 RR", year: 2019 },
  { make: "Beta", model: "250 RR", year: 2020 },
  { make: "Beta", model: "250 RR", year: 2021 },
  { make: "Beta", model: "250 RR", year: 2022 },
  { make: "Beta", model: "250 RR", year: 2023 },
  { make: "Beta", model: "250 RR", year: 2024 },
  { make: "Beta", model: "250 RR", year: 2025 },
  { make: "Beta", model: "250 RR", year: 2026 },
  // Beta - 250 RX
  { make: "Beta", model: "250 RX", year: 2021 },
  { make: "Beta", model: "250 RX", year: 2022 },
  { make: "Beta", model: "250 RX", year: 2023 },
  { make: "Beta", model: "250 RX", year: 2024 },
  { make: "Beta", model: "250 RX", year: 2025 },
  { make: "Beta", model: "250 RX", year: 2026 },
  // Beta - 250RR
  { make: "Beta", model: "250RR", year: 2020 },
  { make: "Beta", model: "250RR", year: 2021 },
  { make: "Beta", model: "250RR", year: 2022 },
  { make: "Beta", model: "250RR", year: 2023 },
  { make: "Beta", model: "250RR", year: 2024 },
  { make: "Beta", model: "250RR", year: 2025 },
  { make: "Beta", model: "250RR", year: 2026 },
  // Beta - 300 RR
  { make: "Beta", model: "300 RR", year: 2013 },
  { make: "Beta", model: "300 RR", year: 2014 },
  { make: "Beta", model: "300 RR", year: 2015 },
  { make: "Beta", model: "300 RR", year: 2016 },
  { make: "Beta", model: "300 RR", year: 2017 },
  { make: "Beta", model: "300 RR", year: 2018 },
  { make: "Beta", model: "300 RR", year: 2019 },
  { make: "Beta", model: "300 RR", year: 2020 },
  { make: "Beta", model: "300 RR", year: 2021 },
  { make: "Beta", model: "300 RR", year: 2022 },
  { make: "Beta", model: "300 RR", year: 2023 },
  { make: "Beta", model: "300 RR", year: 2024 },
  { make: "Beta", model: "300 RR", year: 2025 },
  { make: "Beta", model: "300 RR", year: 2026 },
  // Beta - 300 RX
  { make: "Beta", model: "300 RX", year: 2021 },
  { make: "Beta", model: "300 RX", year: 2022 },
  { make: "Beta", model: "300 RX", year: 2023 },
  { make: "Beta", model: "300 RX", year: 2024 },
  { make: "Beta", model: "300 RX", year: 2025 },
  { make: "Beta", model: "300 RX", year: 2026 },
  // Beta - 300RR
  { make: "Beta", model: "300RR", year: 2020 },
  { make: "Beta", model: "300RR", year: 2021 },
  { make: "Beta", model: "300RR", year: 2022 },
  { make: "Beta", model: "300RR", year: 2023 },
  { make: "Beta", model: "300RR", year: 2024 },
  { make: "Beta", model: "300RR", year: 2025 },
  { make: "Beta", model: "300RR", year: 2026 },
  // Beta - 300RX
  { make: "Beta", model: "300RX", year: 2021 },
  { make: "Beta", model: "300RX", year: 2022 },
  { make: "Beta", model: "300RX", year: 2023 },
  { make: "Beta", model: "300RX", year: 2024 },
  // Beta - 350 RR
  { make: "Beta", model: "350 RR", year: 2011 },
  { make: "Beta", model: "350 RR", year: 2012 },
  { make: "Beta", model: "350 RR", year: 2013 },
  { make: "Beta", model: "350 RR", year: 2014 },
  { make: "Beta", model: "350 RR", year: 2015 },
  { make: "Beta", model: "350 RR", year: 2016 },
  { make: "Beta", model: "350 RR", year: 2017 },
  { make: "Beta", model: "350 RR", year: 2018 },
  // Beta - 350 RR-S
  { make: "Beta", model: "350 RR-S", year: 2015 },
  { make: "Beta", model: "350 RR-S", year: 2016 },
  { make: "Beta", model: "350 RR-S", year: 2017 },
  { make: "Beta", model: "350 RR-S", year: 2018 },
  { make: "Beta", model: "350 RR-S", year: 2019 },
  { make: "Beta", model: "350 RR-S", year: 2020 },
  { make: "Beta", model: "350 RR-S", year: 2021 },
  { make: "Beta", model: "350 RR-S", year: 2022 },
  { make: "Beta", model: "350 RR-S", year: 2023 },
  { make: "Beta", model: "350 RR-S", year: 2024 },
  { make: "Beta", model: "350 RR-S", year: 2025 },
  { make: "Beta", model: "350 RR-S", year: 2026 },
  // Beta - 350 RS
  { make: "Beta", model: "350 RS", year: 2012 },
  { make: "Beta", model: "350 RS", year: 2013 },
  // Beta - 350RR
  { make: "Beta", model: "350RR", year: 2020 },
  { make: "Beta", model: "350RR", year: 2021 },
  { make: "Beta", model: "350RR", year: 2022 },
  { make: "Beta", model: "350RR", year: 2023 },
  { make: "Beta", model: "350RR", year: 2024 },
  { make: "Beta", model: "350RR", year: 2025 },
  { make: "Beta", model: "350RR", year: 2026 },
  // Beta - 390 RR
  { make: "Beta", model: "390 RR", year: 2017 },
  { make: "Beta", model: "390 RR", year: 2018 },
  // Beta - 390 RR-S
  { make: "Beta", model: "390 RR-S", year: 2015 },
  { make: "Beta", model: "390 RR-S", year: 2016 },
  { make: "Beta", model: "390 RR-S", year: 2017 },
  { make: "Beta", model: "390 RR-S", year: 2018 },
  { make: "Beta", model: "390 RR-S", year: 2019 },
  { make: "Beta", model: "390 RR-S", year: 2020 },
  { make: "Beta", model: "390 RR-S", year: 2021 },
  { make: "Beta", model: "390 RR-S", year: 2022 },
  { make: "Beta", model: "390 RR-S", year: 2023 },
  { make: "Beta", model: "390 RR-S", year: 2024 },
  { make: "Beta", model: "390 RR-S", year: 2025 },
  { make: "Beta", model: "390 RR-S", year: 2026 },
  // Beta - 390RR
  { make: "Beta", model: "390RR", year: 2020 },
  { make: "Beta", model: "390RR", year: 2021 },
  { make: "Beta", model: "390RR", year: 2022 },
  { make: "Beta", model: "390RR", year: 2023 },
  { make: "Beta", model: "390RR", year: 2024 },
  { make: "Beta", model: "390RR", year: 2025 },
  { make: "Beta", model: "390RR", year: 2026 },
  // Beta - 400 RR
  { make: "Beta", model: "400 RR", year: 2010 },
  { make: "Beta", model: "400 RR", year: 2011 },
  { make: "Beta", model: "400 RR", year: 2012 },
  { make: "Beta", model: "400 RR", year: 2013 },
  { make: "Beta", model: "400 RR", year: 2014 },
  // Beta - 400 RS
  { make: "Beta", model: "400 RS", year: 2011 },
  { make: "Beta", model: "400 RS", year: 2012 },
  { make: "Beta", model: "400 RS", year: 2013 },
  { make: "Beta", model: "400 RS", year: 2014 },
  // Beta - 430 RR
  { make: "Beta", model: "430 RR", year: 2017 },
  { make: "Beta", model: "430 RR", year: 2018 },
  // Beta - 430 RR-S
  { make: "Beta", model: "430 RR-S", year: 2015 },
  { make: "Beta", model: "430 RR-S", year: 2016 },
  { make: "Beta", model: "430 RR-S", year: 2017 },
  { make: "Beta", model: "430 RR-S", year: 2018 },
  { make: "Beta", model: "430 RR-S", year: 2019 },
  { make: "Beta", model: "430 RR-S", year: 2020 },
  { make: "Beta", model: "430 RR-S", year: 2021 },
  { make: "Beta", model: "430 RR-S", year: 2022 },
  { make: "Beta", model: "430 RR-S", year: 2023 },
  { make: "Beta", model: "430 RR-S", year: 2024 },
  { make: "Beta", model: "430 RR-S", year: 2025 },
  { make: "Beta", model: "430 RR-S", year: 2026 },
  // Beta - 430RR
  { make: "Beta", model: "430RR", year: 2020 },
  { make: "Beta", model: "430RR", year: 2021 },
  { make: "Beta", model: "430RR", year: 2022 },
  { make: "Beta", model: "430RR", year: 2023 },
  { make: "Beta", model: "430RR", year: 2024 },
  { make: "Beta", model: "430RR", year: 2025 },
  { make: "Beta", model: "430RR", year: 2026 },
  // Beta - 450 RR
  { make: "Beta", model: "450 RR", year: 2010 },
  { make: "Beta", model: "450 RR", year: 2011 },
  { make: "Beta", model: "450 RR", year: 2012 },
  { make: "Beta", model: "450 RR", year: 2013 },
  { make: "Beta", model: "450 RR", year: 2014 },
  // Beta - 450 RS
  { make: "Beta", model: "450 RS", year: 2010 },
  { make: "Beta", model: "450 RS", year: 2011 },
  { make: "Beta", model: "450 RS", year: 2012 },
  { make: "Beta", model: "450 RS", year: 2013 },
  { make: "Beta", model: "450 RS", year: 2014 },
  // Beta - 450 RX
  { make: "Beta", model: "450 RX", year: 2024 },
  { make: "Beta", model: "450 RX", year: 2025 },
  { make: "Beta", model: "450 RX", year: 2026 },
  // Beta - 480 RR
  { make: "Beta", model: "480 RR", year: 2017 },
  { make: "Beta", model: "480 RR", year: 2018 },
  // Beta - 480RR
  { make: "Beta", model: "480RR", year: 2020 },
  { make: "Beta", model: "480RR", year: 2021 },
  { make: "Beta", model: "480RR", year: 2022 },
  { make: "Beta", model: "480RR", year: 2023 },
  { make: "Beta", model: "480RR", year: 2024 },
  { make: "Beta", model: "480RR", year: 2025 },
  { make: "Beta", model: "480RR", year: 2026 },
  // Beta - 498 RR
  { make: "Beta", model: "498 RR", year: 2012 },
  { make: "Beta", model: "498 RR", year: 2013 },
  { make: "Beta", model: "498 RR", year: 2014 },
  // Beta - 500 RR-S
  { make: "Beta", model: "500 RR-S", year: 2015 },
  { make: "Beta", model: "500 RR-S", year: 2016 },
  { make: "Beta", model: "500 RR-S", year: 2017 },
  { make: "Beta", model: "500 RR-S", year: 2018 },
  { make: "Beta", model: "500 RR-S", year: 2019 },
  { make: "Beta", model: "500 RR-S", year: 2020 },
  { make: "Beta", model: "500 RR-S", year: 2021 },
  { make: "Beta", model: "500 RR-S", year: 2022 },
  { make: "Beta", model: "500 RR-S", year: 2023 },
  { make: "Beta", model: "500 RR-S", year: 2024 },
  { make: "Beta", model: "500 RR-S", year: 2025 },
  { make: "Beta", model: "500 RR-S", year: 2026 },
  // Beta - 520 RR
  { make: "Beta", model: "520 RR", year: 2010 },
  { make: "Beta", model: "520 RR", year: 2011 },
  // Beta - 520 RS
  { make: "Beta", model: "520 RS", year: 2011 },
  { make: "Beta", model: "520 RS", year: 2012 },
  { make: "Beta", model: "520 RS", year: 2013 },
  { make: "Beta", model: "520 RS", year: 2014 },
  // Beta - RR 4T
  { make: "Beta", model: "RR 4T", year: 2020 },
  { make: "Beta", model: "RR 4T", year: 2021 },
  { make: "Beta", model: "RR 4T", year: 2022 },
  { make: "Beta", model: "RR 4T", year: 2023 },
  { make: "Beta", model: "RR 4T", year: 2024 },
  { make: "Beta", model: "RR 4T", year: 2025 },
  // Beta - RR-125
  { make: "Beta", model: "RR-125", year: 2018 },
  // Beta - RR-350
  { make: "Beta", model: "RR-350", year: 2010 },
  { make: "Beta", model: "RR-350", year: 2012 },
  { make: "Beta", model: "RR-350", year: 2013 },
  { make: "Beta", model: "RR-350", year: 2014 },
  { make: "Beta", model: "RR-350", year: 2016 },
  { make: "Beta", model: "RR-350", year: 2017 },
  { make: "Beta", model: "RR-350", year: 2018 },
  // Beta - RR-390
  { make: "Beta", model: "RR-390", year: 2017 },
  { make: "Beta", model: "RR-390", year: 2018 },
  // Beta - RR-400
  { make: "Beta", model: "RR-400", year: 2010 },
  { make: "Beta", model: "RR-400", year: 2011 },
  { make: "Beta", model: "RR-400", year: 2012 },
  { make: "Beta", model: "RR-400", year: 2013 },
  { make: "Beta", model: "RR-400", year: 2014 },
  // Beta - RR-430
  { make: "Beta", model: "RR-430", year: 2015 },
  { make: "Beta", model: "RR-430", year: 2016 },
  { make: "Beta", model: "RR-430", year: 2017 },
  { make: "Beta", model: "RR-430", year: 2018 },
  // Beta - RR-450
  { make: "Beta", model: "RR-450", year: 2010 },
  { make: "Beta", model: "RR-450", year: 2011 },
  { make: "Beta", model: "RR-450", year: 2012 },
  { make: "Beta", model: "RR-450", year: 2013 },
  { make: "Beta", model: "RR-450", year: 2014 },
  // Beta - RR-480
  { make: "Beta", model: "RR-480", year: 2015 },
  { make: "Beta", model: "RR-480", year: 2016 },
  { make: "Beta", model: "RR-480", year: 2017 },
  { make: "Beta", model: "RR-480", year: 2018 },
  // Beta - RR-498
  { make: "Beta", model: "RR-498", year: 2010 },
  { make: "Beta", model: "RR-498", year: 2011 },
  { make: "Beta", model: "RR-498", year: 2012 },
  { make: "Beta", model: "RR-498", year: 2013 },
  { make: "Beta", model: "RR-498", year: 2014 },
  // Beta - RR-520
  { make: "Beta", model: "RR-520", year: 2010 },
  { make: "Beta", model: "RR-520", year: 2011 },
  { make: "Beta", model: "RR-520", year: 2012 },
  { make: "Beta", model: "RR-520", year: 2013 },
  { make: "Beta", model: "RR-520", year: 2014 },
  // BMW
  // BMW - C 650
  { make: "BMW", model: "C 650", year: 2016 },
  { make: "BMW", model: "C 650", year: 2017 },
  { make: "BMW", model: "C 650", year: 2018 },
  { make: "BMW", model: "C 650", year: 2019 },
  { make: "BMW", model: "C 650", year: 2020 },
  // BMW - C400GT
  { make: "BMW", model: "C400GT", year: 2019 },
  { make: "BMW", model: "C400GT", year: 2020 },
  { make: "BMW", model: "C400GT", year: 2021 },
  { make: "BMW", model: "C400GT", year: 2022 },
  { make: "BMW", model: "C400GT", year: 2023 },
  { make: "BMW", model: "C400GT", year: 2024 },
  { make: "BMW", model: "C400GT", year: 2025 },
  { make: "BMW", model: "C400GT", year: 2026 },
  // BMW - F 650 GS
  { make: "BMW", model: "F 650 GS", year: 2008 },
  { make: "BMW", model: "F 650 GS", year: 2009 },
  // BMW - F 650 GS E8GS
  { make: "BMW", model: "F 650 GS E8GS", year: 2008 },
  { make: "BMW", model: "F 650 GS E8GS", year: 2009 },
  { make: "BMW", model: "F 650 GS E8GS", year: 2010 },
  { make: "BMW", model: "F 650 GS E8GS", year: 2011 },
  { make: "BMW", model: "F 650 GS E8GS", year: 2012 },
  // BMW - F 700 GS
  { make: "BMW", model: "F 700 GS", year: 2017 },
  { make: "BMW", model: "F 700 GS", year: 2018 },
  // BMW - F 750 GS 4G85
  { make: "BMW", model: "F 750 GS 4G85", year: 2018 },
  // BMW - F 800
  { make: "BMW", model: "F 800", year: 2009 },
  { make: "BMW", model: "F 800", year: 2010 },
  // BMW - F 800 GS
  { make: "BMW", model: "F 800 GS", year: 2017 },
  { make: "BMW", model: "F 800 GS", year: 2018 },
  // BMW - F 800 GS Adventure
  { make: "BMW", model: "F 800 GS Adventure", year: 2017 },
  { make: "BMW", model: "F 800 GS Adventure", year: 2018 },
  // BMW - F 800 GS/F 900 GS Adventure
  { make: "BMW", model: "F 800 GS/F 900 GS Adventure", year: 2024 },
  { make: "BMW", model: "F 800 GS/F 900 GS Adventure", year: 2025 },
  { make: "BMW", model: "F 800 GS/F 900 GS Adventure", year: 2026 },
  // BMW - F 850GS
  { make: "BMW", model: "F 850GS", year: 2018 },
  { make: "BMW", model: "F 850GS", year: 2019 },
  { make: "BMW", model: "F 850GS", year: 2020 },
  { make: "BMW", model: "F 850GS", year: 2021 },
  { make: "BMW", model: "F 850GS", year: 2022 },
  // BMW - F 900
  { make: "BMW", model: "F 900", year: 2020 },
  // BMW - F650GS
  { make: "BMW", model: "F650GS", year: 2008 },
  { make: "BMW", model: "F650GS", year: 2009 },
  { make: "BMW", model: "F650GS", year: 2010 },
  { make: "BMW", model: "F650GS", year: 2011 },
  { make: "BMW", model: "F650GS", year: 2012 },
  { make: "BMW", model: "F650GS", year: 2013 },
  { make: "BMW", model: "F650GS", year: 2014 },
  { make: "BMW", model: "F650GS", year: 2015 },
  { make: "BMW", model: "F650GS", year: 2016 },
  { make: "BMW", model: "F650GS", year: 2017 },
  // BMW - F700GS
  { make: "BMW", model: "F700GS", year: 2008 },
  { make: "BMW", model: "F700GS", year: 2009 },
  { make: "BMW", model: "F700GS", year: 2010 },
  { make: "BMW", model: "F700GS", year: 2011 },
  { make: "BMW", model: "F700GS", year: 2012 },
  { make: "BMW", model: "F700GS", year: 2013 },
  { make: "BMW", model: "F700GS", year: 2014 },
  { make: "BMW", model: "F700GS", year: 2015 },
  { make: "BMW", model: "F700GS", year: 2016 },
  { make: "BMW", model: "F700GS", year: 2017 },
  // BMW - F750GS
  { make: "BMW", model: "F750GS", year: 2018 },
  { make: "BMW", model: "F750GS", year: 2019 },
  { make: "BMW", model: "F750GS", year: 2020 },
  { make: "BMW", model: "F750GS", year: 2021 },
  { make: "BMW", model: "F750GS", year: 2022 },
  { make: "BMW", model: "F750GS", year: 2023 },
  { make: "BMW", model: "F750GS", year: 2024 },
  // BMW - F800GS
  { make: "BMW", model: "F800GS", year: 2008 },
  { make: "BMW", model: "F800GS", year: 2009 },
  { make: "BMW", model: "F800GS", year: 2010 },
  { make: "BMW", model: "F800GS", year: 2011 },
  { make: "BMW", model: "F800GS", year: 2012 },
  { make: "BMW", model: "F800GS", year: 2013 },
  { make: "BMW", model: "F800GS", year: 2014 },
  { make: "BMW", model: "F800GS", year: 2015 },
  { make: "BMW", model: "F800GS", year: 2016 },
  { make: "BMW", model: "F800GS", year: 2017 },
  { make: "BMW", model: "F800GS", year: 2018 },
  { make: "BMW", model: "F800GS", year: 2024 },
  { make: "BMW", model: "F800GS", year: 2025 },
  { make: "BMW", model: "F800GS", year: 2026 },
  // BMW - F800GS Adventure
  { make: "BMW", model: "F800GS Adventure", year: 2008 },
  { make: "BMW", model: "F800GS Adventure", year: 2009 },
  { make: "BMW", model: "F800GS Adventure", year: 2010 },
  { make: "BMW", model: "F800GS Adventure", year: 2011 },
  { make: "BMW", model: "F800GS Adventure", year: 2012 },
  { make: "BMW", model: "F800GS Adventure", year: 2013 },
  { make: "BMW", model: "F800GS Adventure", year: 2014 },
  { make: "BMW", model: "F800GS Adventure", year: 2015 },
  { make: "BMW", model: "F800GS Adventure", year: 2016 },
  { make: "BMW", model: "F800GS Adventure", year: 2017 },
  { make: "BMW", model: "F800GS Adventure", year: 2018 },
  // BMW - F800GT
  { make: "BMW", model: "F800GT", year: 2009 },
  { make: "BMW", model: "F800GT", year: 2010 },
  { make: "BMW", model: "F800GT", year: 2011 },
  { make: "BMW", model: "F800GT", year: 2012 },
  { make: "BMW", model: "F800GT", year: 2013 },
  { make: "BMW", model: "F800GT", year: 2014 },
  { make: "BMW", model: "F800GT", year: 2015 },
  { make: "BMW", model: "F800GT", year: 2016 },
  { make: "BMW", model: "F800GT", year: 2017 },
  { make: "BMW", model: "F800GT", year: 2018 },
  // BMW - F800R
  { make: "BMW", model: "F800R", year: 2009 },
  { make: "BMW", model: "F800R", year: 2010 },
  { make: "BMW", model: "F800R", year: 2011 },
  { make: "BMW", model: "F800R", year: 2012 },
  { make: "BMW", model: "F800R", year: 2013 },
  { make: "BMW", model: "F800R", year: 2014 },
  { make: "BMW", model: "F800R", year: 2015 },
  { make: "BMW", model: "F800R", year: 2016 },
  { make: "BMW", model: "F800R", year: 2017 },
  { make: "BMW", model: "F800R", year: 2018 },
  // BMW - F850 GS
  { make: "BMW", model: "F850 GS", year: 2018 },
  { make: "BMW", model: "F850 GS", year: 2024 },
  // BMW - F850GS
  { make: "BMW", model: "F850GS", year: 2018 },
  { make: "BMW", model: "F850GS", year: 2019 },
  { make: "BMW", model: "F850GS", year: 2020 },
  { make: "BMW", model: "F850GS", year: 2021 },
  { make: "BMW", model: "F850GS", year: 2022 },
  { make: "BMW", model: "F850GS", year: 2023 },
  { make: "BMW", model: "F850GS", year: 2024 },
  // BMW - F850GS Adventure
  { make: "BMW", model: "F850GS Adventure", year: 2018 },
  { make: "BMW", model: "F850GS Adventure", year: 2019 },
  { make: "BMW", model: "F850GS Adventure", year: 2020 },
  { make: "BMW", model: "F850GS Adventure", year: 2021 },
  { make: "BMW", model: "F850GS Adventure", year: 2022 },
  { make: "BMW", model: "F850GS Adventure", year: 2023 },
  { make: "BMW", model: "F850GS Adventure", year: 2024 },
  // BMW - F900GS
  { make: "BMW", model: "F900GS", year: 2024 },
  { make: "BMW", model: "F900GS", year: 2025 },
  { make: "BMW", model: "F900GS", year: 2026 },
  // BMW - F900GS Adv
  { make: "BMW", model: "F900GS Adv", year: 2024 },
  { make: "BMW", model: "F900GS Adv", year: 2025 },
  // BMW - F900GS Adventure
  { make: "BMW", model: "F900GS Adventure", year: 2024 },
  { make: "BMW", model: "F900GS Adventure", year: 2025 },
  { make: "BMW", model: "F900GS Adventure", year: 2026 },
  // BMW - F900R
  { make: "BMW", model: "F900R", year: 2020 },
  { make: "BMW", model: "F900R", year: 2021 },
  { make: "BMW", model: "F900R", year: 2022 },
  { make: "BMW", model: "F900R", year: 2023 },
  { make: "BMW", model: "F900R", year: 2024 },
  { make: "BMW", model: "F900R", year: 2025 },
  { make: "BMW", model: "F900R", year: 2026 },
  { make: "BMW", model: "F900R", year: 2027 },
  // BMW - F900R E5
  { make: "BMW", model: "F900R E5", year: 2025 },
  // BMW - F900XR
  { make: "BMW", model: "F900XR", year: 2020 },
  { make: "BMW", model: "F900XR", year: 2021 },
  { make: "BMW", model: "F900XR", year: 2022 },
  { make: "BMW", model: "F900XR", year: 2023 },
  { make: "BMW", model: "F900XR", year: 2024 },
  { make: "BMW", model: "F900XR", year: 2025 },
  { make: "BMW", model: "F900XR", year: 2026 },
  // BMW - G 650 GS
  { make: "BMW", model: "G 650 GS", year: 2011 },
  { make: "BMW", model: "G 650 GS", year: 2012 },
  { make: "BMW", model: "G 650 GS", year: 2013 },
  { make: "BMW", model: "G 650 GS", year: 2014 },
  { make: "BMW", model: "G 650 GS", year: 2015 },
  { make: "BMW", model: "G 650 GS", year: 2016 },
  // BMW - K 1200
  { make: "BMW", model: "K 1200", year: 2005 },
  { make: "BMW", model: "K 1200", year: 2006 },
  // BMW - K 1300
  { make: "BMW", model: "K 1300", year: 2009 },
  { make: "BMW", model: "K 1300", year: 2010 },
  { make: "BMW", model: "K 1300", year: 2011 },
  { make: "BMW", model: "K 1300", year: 2012 },
  // BMW - K 1600 Bagger Custom
  { make: "BMW", model: "K 1600 Bagger Custom", year: 2018 },
  { make: "BMW", model: "K 1600 Bagger Custom", year: 2019 },
  // BMW - K1600 Grand America
  { make: "BMW", model: "K1600 Grand America", year: 2017 },
  { make: "BMW", model: "K1600 Grand America", year: 2018 },
  { make: "BMW", model: "K1600 Grand America", year: 2019 },
  { make: "BMW", model: "K1600 Grand America", year: 2020 },
  // BMW - K1600 GT K1600 Gtl S B16SO5 Hzaat
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2017 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2018 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2019 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2020 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2021 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2022 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2023 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2024 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2025 },
  { make: "BMW", model: "K1600 GT K1600 Gtl S B16SO5 Hzaat", year: 2026 },
  // BMW - K1600 GT/GTL
  { make: "BMW", model: "K1600 GT/GTL", year: 2017 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2018 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2019 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2020 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2021 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2022 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2023 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2024 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2025 },
  { make: "BMW", model: "K1600 GT/GTL", year: 2026 },
  // BMW - K1600B
  { make: "BMW", model: "K1600B", year: 2017 },
  { make: "BMW", model: "K1600B", year: 2018 },
  { make: "BMW", model: "K1600B", year: 2019 },
  { make: "BMW", model: "K1600B", year: 2020 },
  // BMW - K1600GT
  { make: "BMW", model: "K1600GT", year: 2011 },
  { make: "BMW", model: "K1600GT", year: 2012 },
  { make: "BMW", model: "K1600GT", year: 2013 },
  { make: "BMW", model: "K1600GT", year: 2014 },
  { make: "BMW", model: "K1600GT", year: 2015 },
  { make: "BMW", model: "K1600GT", year: 2016 },
  { make: "BMW", model: "K1600GT", year: 2017 },
  { make: "BMW", model: "K1600GT", year: 2018 },
  { make: "BMW", model: "K1600GT", year: 2019 },
  { make: "BMW", model: "K1600GT", year: 2020 },
  { make: "BMW", model: "K1600GT", year: 2021 },
  { make: "BMW", model: "K1600GT", year: 2022 },
  { make: "BMW", model: "K1600GT", year: 2023 },
  { make: "BMW", model: "K1600GT", year: 2024 },
  // BMW - K1600GTL
  { make: "BMW", model: "K1600GTL", year: 2011 },
  { make: "BMW", model: "K1600GTL", year: 2012 },
  { make: "BMW", model: "K1600GTL", year: 2013 },
  { make: "BMW", model: "K1600GTL", year: 2014 },
  { make: "BMW", model: "K1600GTL", year: 2015 },
  { make: "BMW", model: "K1600GTL", year: 2016 },
  { make: "BMW", model: "K1600GTL", year: 2017 },
  { make: "BMW", model: "K1600GTL", year: 2018 },
  { make: "BMW", model: "K1600GTL", year: 2019 },
  { make: "BMW", model: "K1600GTL", year: 2020 },
  { make: "BMW", model: "K1600GTL", year: 2021 },
  { make: "BMW", model: "K1600GTL", year: 2022 },
  { make: "BMW", model: "K1600GTL", year: 2023 },
  { make: "BMW", model: "K1600GTL", year: 2024 },
  // BMW - M1000 RR
  { make: "BMW", model: "M1000 RR", year: 2019 },
  { make: "BMW", model: "M1000 RR", year: 2020 },
  { make: "BMW", model: "M1000 RR", year: 2021 },
  { make: "BMW", model: "M1000 RR", year: 2022 },
  { make: "BMW", model: "M1000 RR", year: 2023 },
  { make: "BMW", model: "M1000 RR", year: 2024 },
  // BMW - M1000R
  { make: "BMW", model: "M1000R", year: 2020 },
  { make: "BMW", model: "M1000R", year: 2021 },
  { make: "BMW", model: "M1000R", year: 2022 },
  { make: "BMW", model: "M1000R", year: 2023 },
  { make: "BMW", model: "M1000R", year: 2024 },
  { make: "BMW", model: "M1000R", year: 2025 },
  { make: "BMW", model: "M1000R", year: 2026 },
  // BMW - M1000RR
  { make: "BMW", model: "M1000RR", year: 2021 },
  { make: "BMW", model: "M1000RR", year: 2022 },
  { make: "BMW", model: "M1000RR", year: 2023 },
  { make: "BMW", model: "M1000RR", year: 2024 },
  { make: "BMW", model: "M1000RR", year: 2025 },
  { make: "BMW", model: "M1000RR", year: 2026 },
  { make: "BMW", model: "M1000RR", year: 2027 },
  // BMW - M1000RR E5
  { make: "BMW", model: "M1000RR E5", year: 2025 },
  { make: "BMW", model: "M1000RR E5", year: 2026 },
  // BMW - M1000XR
  { make: "BMW", model: "M1000XR", year: 2020 },
  { make: "BMW", model: "M1000XR", year: 2021 },
  { make: "BMW", model: "M1000XR", year: 2022 },
  { make: "BMW", model: "M1000XR", year: 2023 },
  { make: "BMW", model: "M1000XR", year: 2024 },
  { make: "BMW", model: "M1000XR", year: 2025 },
  // BMW - M1000XR E5
  { make: "BMW", model: "M1000XR E5", year: 2025 },
  { make: "BMW", model: "M1000XR E5", year: 2026 },
  // BMW - R 1200
  { make: "BMW", model: "R 1200", year: 2014 },
  { make: "BMW", model: "R 1200", year: 2015 },
  { make: "BMW", model: "R 1200", year: 2016 },
  { make: "BMW", model: "R 1200", year: 2017 },
  { make: "BMW", model: "R 1200", year: 2018 },
  // BMW - R 1200 GS
  { make: "BMW", model: "R 1200 GS", year: 2004 },
  { make: "BMW", model: "R 1200 GS", year: 2005 },
  { make: "BMW", model: "R 1200 GS", year: 2006 },
  { make: "BMW", model: "R 1200 GS", year: 2007 },
  { make: "BMW", model: "R 1200 GS", year: 2008 },
  { make: "BMW", model: "R 1200 GS", year: 2009 },
  { make: "BMW", model: "R 1200 GS", year: 2010 },
  { make: "BMW", model: "R 1200 GS", year: 2011 },
  { make: "BMW", model: "R 1200 GS", year: 2012 },
  // BMW - R 1200 R 1200 RS
  { make: "BMW", model: "R 1200 R 1200 RS", year: 2015 },
  { make: "BMW", model: "R 1200 R 1200 RS", year: 2016 },
  { make: "BMW", model: "R 1200 R 1200 RS", year: 2017 },
  { make: "BMW", model: "R 1200 R 1200 RS", year: 2018 },
  // BMW - R 1250
  { make: "BMW", model: "R 1250", year: 2019 },
  { make: "BMW", model: "R 1250", year: 2020 },
  { make: "BMW", model: "R 1250", year: 2021 },
  { make: "BMW", model: "R 1250", year: 2022 },
  { make: "BMW", model: "R 1250", year: 2023 },
  // BMW - R 1250 R R 1250
  { make: "BMW", model: "R 1250 R R 1250", year: 2019 },
  // BMW - R 1250 RT
  { make: "BMW", model: "R 1250 RT", year: 2019 },
  // BMW - R 1300 GS 15604T
  { make: "BMW", model: "R 1300 GS 15604T", year: 2024 },
  { make: "BMW", model: "R 1300 GS 15604T", year: 2025 },
  { make: "BMW", model: "R 1300 GS 15604T", year: 2026 },
  // BMW - R 1300 GS CB B13T1
  { make: "BMW", model: "R 1300 GS CB B13T1", year: 2024 },
  { make: "BMW", model: "R 1300 GS CB B13T1", year: 2025 },
  { make: "BMW", model: "R 1300 GS CB B13T1", year: 2026 },
  // BMW - R 1300 GS E B13E1
  { make: "BMW", model: "R 1300 GS E B13E1", year: 2024 },
  { make: "BMW", model: "R 1300 GS E B13E1", year: 2025 },
  { make: "BMW", model: "R 1300 GS E B13E1", year: 2026 },
  // BMW - R 1300 GS R 1300
  { make: "BMW", model: "R 1300 GS R 1300", year: 2024 },
  { make: "BMW", model: "R 1300 GS R 1300", year: 2025 },
  { make: "BMW", model: "R 1300 GS R 1300", year: 2026 },
  // BMW - R 1300 GS S B13SO4 Hjgt
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgt", year: 2024 },
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgt", year: 2025 },
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgt", year: 2026 },
  // BMW - R 1300 GS S B13SO4 Hjgtbl
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgtbl", year: 2024 },
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgtbl", year: 2025 },
  { make: "BMW", model: "R 1300 GS S B13SO4 Hjgtbl", year: 2026 },
  // BMW - R nineT
  { make: "BMW", model: "R nineT", year: 2014 },
  { make: "BMW", model: "R nineT", year: 2015 },
  { make: "BMW", model: "R nineT", year: 2016 },
  { make: "BMW", model: "R nineT", year: 2017 },
  { make: "BMW", model: "R nineT", year: 2018 },
  { make: "BMW", model: "R nineT", year: 2019 },
  { make: "BMW", model: "R nineT", year: 2020 },
  { make: "BMW", model: "R nineT", year: 2021 },
  { make: "BMW", model: "R nineT", year: 2022 },
  { make: "BMW", model: "R nineT", year: 2023 },
  { make: "BMW", model: "R nineT", year: 2024 },
  { make: "BMW", model: "R nineT", year: 2025 },
  { make: "BMW", model: "R nineT", year: 2026 },
  // BMW - R12 nineT
  { make: "BMW", model: "R12 nineT", year: 2024 },
  { make: "BMW", model: "R12 nineT", year: 2025 },
  { make: "BMW", model: "R12 nineT", year: 2026 },
  // BMW - R1200GS
  { make: "BMW", model: "R1200GS", year: 2004 },
  { make: "BMW", model: "R1200GS", year: 2005 },
  { make: "BMW", model: "R1200GS", year: 2006 },
  { make: "BMW", model: "R1200GS", year: 2007 },
  { make: "BMW", model: "R1200GS", year: 2008 },
  { make: "BMW", model: "R1200GS", year: 2009 },
  { make: "BMW", model: "R1200GS", year: 2013 },
  { make: "BMW", model: "R1200GS", year: 2014 },
  { make: "BMW", model: "R1200GS", year: 2015 },
  { make: "BMW", model: "R1200GS", year: 2016 },
  { make: "BMW", model: "R1200GS", year: 2017 },
  { make: "BMW", model: "R1200GS", year: 2018 },
  { make: "BMW", model: "R1200GS", year: 2019 },
  // BMW - R1200GS Adventure
  { make: "BMW", model: "R1200GS Adventure", year: 2004 },
  { make: "BMW", model: "R1200GS Adventure", year: 2005 },
  { make: "BMW", model: "R1200GS Adventure", year: 2006 },
  { make: "BMW", model: "R1200GS Adventure", year: 2007 },
  { make: "BMW", model: "R1200GS Adventure", year: 2008 },
  { make: "BMW", model: "R1200GS Adventure", year: 2009 },
  { make: "BMW", model: "R1200GS Adventure", year: 2013 },
  { make: "BMW", model: "R1200GS Adventure", year: 2014 },
  { make: "BMW", model: "R1200GS Adventure", year: 2015 },
  { make: "BMW", model: "R1200GS Adventure", year: 2016 },
  { make: "BMW", model: "R1200GS Adventure", year: 2017 },
  { make: "BMW", model: "R1200GS Adventure", year: 2018 },
  // BMW - R1200R
  { make: "BMW", model: "R1200R", year: 2015 },
  { make: "BMW", model: "R1200R", year: 2016 },
  { make: "BMW", model: "R1200R", year: 2017 },
  { make: "BMW", model: "R1200R", year: 2018 },
  { make: "BMW", model: "R1200R", year: 2019 },
  { make: "BMW", model: "R1200R", year: 2020 },
  { make: "BMW", model: "R1200R", year: 2021 },
  { make: "BMW", model: "R1200R", year: 2022 },
  { make: "BMW", model: "R1200R", year: 2023 },
  { make: "BMW", model: "R1200R", year: 2024 },
  { make: "BMW", model: "R1200R", year: 2025 },
  { make: "BMW", model: "R1200R", year: 2026 },
  { make: "BMW", model: "R1200R", year: 2027 },
  // BMW - R1250
  { make: "BMW", model: "R1250", year: 2019 },
  { make: "BMW", model: "R1250", year: 2020 },
  { make: "BMW", model: "R1250", year: 2021 },
  { make: "BMW", model: "R1250", year: 2022 },
  { make: "BMW", model: "R1250", year: 2023 },
  // BMW - R1250GS
  { make: "BMW", model: "R1250GS", year: 2019 },
  { make: "BMW", model: "R1250GS", year: 2020 },
  { make: "BMW", model: "R1250GS", year: 2021 },
  { make: "BMW", model: "R1250GS", year: 2022 },
  { make: "BMW", model: "R1250GS", year: 2023 },
  { make: "BMW", model: "R1250GS", year: 2024 },
  // BMW - R1250R
  { make: "BMW", model: "R1250R", year: 2019 },
  { make: "BMW", model: "R1250R", year: 2020 },
  { make: "BMW", model: "R1250R", year: 2021 },
  { make: "BMW", model: "R1250R", year: 2022 },
  { make: "BMW", model: "R1250R", year: 2023 },
  { make: "BMW", model: "R1250R", year: 2024 },
  // BMW - R1250RT
  { make: "BMW", model: "R1250RT", year: 2019 },
  { make: "BMW", model: "R1250RT", year: 2020 },
  { make: "BMW", model: "R1250RT", year: 2021 },
  { make: "BMW", model: "R1250RT", year: 2022 },
  { make: "BMW", model: "R1250RT", year: 2023 },
  { make: "BMW", model: "R1250RT", year: 2024 },
  // BMW - R1300GS
  { make: "BMW", model: "R1300GS", year: 2024 },
  { make: "BMW", model: "R1300GS", year: 2025 },
  { make: "BMW", model: "R1300GS", year: 2026 },
  // BMW - S 1000 RR
  { make: "BMW", model: "S 1000 RR", year: 2009 },
  { make: "BMW", model: "S 1000 RR", year: 2010 },
  { make: "BMW", model: "S 1000 RR", year: 2011 },
  { make: "BMW", model: "S 1000 RR", year: 2012 },
  { make: "BMW", model: "S 1000 RR", year: 2013 },
  { make: "BMW", model: "S 1000 RR", year: 2014 },
  { make: "BMW", model: "S 1000 RR", year: 2015 },
  { make: "BMW", model: "S 1000 RR", year: 2016 },
  { make: "BMW", model: "S 1000 RR", year: 2017 },
  { make: "BMW", model: "S 1000 RR", year: 2018 },
  { make: "BMW", model: "S 1000 RR", year: 2019 },
  { make: "BMW", model: "S 1000 RR", year: 2020 },
  // BMW - S 1000 RR Nxt
  { make: "BMW", model: "S 1000 RR Nxt", year: 2019 },
  // BMW - S1000 RR
  { make: "BMW", model: "S1000 RR", year: 2012 },
  { make: "BMW", model: "S1000 RR", year: 2013 },
  { make: "BMW", model: "S1000 RR", year: 2014 },
  { make: "BMW", model: "S1000 RR", year: 2015 },
  { make: "BMW", model: "S1000 RR", year: 2016 },
  { make: "BMW", model: "S1000 RR", year: 2017 },
  { make: "BMW", model: "S1000 RR", year: 2018 },
  { make: "BMW", model: "S1000 RR", year: 2019 },
  { make: "BMW", model: "S1000 RR", year: 2020 },
  { make: "BMW", model: "S1000 RR", year: 2021 },
  { make: "BMW", model: "S1000 RR", year: 2022 },
  { make: "BMW", model: "S1000 RR", year: 2023 },
  { make: "BMW", model: "S1000 RR", year: 2024 },
  { make: "BMW", model: "S1000 RR", year: 2025 },
  { make: "BMW", model: "S1000 RR", year: 2026 },
  // BMW - S1000R
  { make: "BMW", model: "S1000R", year: 2014 },
  { make: "BMW", model: "S1000R", year: 2015 },
  { make: "BMW", model: "S1000R", year: 2016 },
  { make: "BMW", model: "S1000R", year: 2017 },
  { make: "BMW", model: "S1000R", year: 2018 },
  { make: "BMW", model: "S1000R", year: 2019 },
  { make: "BMW", model: "S1000R", year: 2020 },
  { make: "BMW", model: "S1000R", year: 2021 },
  { make: "BMW", model: "S1000R", year: 2022 },
  { make: "BMW", model: "S1000R", year: 2023 },
  { make: "BMW", model: "S1000R", year: 2024 },
  { make: "BMW", model: "S1000R", year: 2025 },
  { make: "BMW", model: "S1000R", year: 2026 },
  { make: "BMW", model: "S1000R", year: 2027 },
  // BMW - S1000RR
  { make: "BMW", model: "S1000RR", year: 2008 },
  { make: "BMW", model: "S1000RR", year: 2009 },
  { make: "BMW", model: "S1000RR", year: 2010 },
  { make: "BMW", model: "S1000RR", year: 2011 },
  { make: "BMW", model: "S1000RR", year: 2012 },
  { make: "BMW", model: "S1000RR", year: 2013 },
  { make: "BMW", model: "S1000RR", year: 2014 },
  { make: "BMW", model: "S1000RR", year: 2015 },
  { make: "BMW", model: "S1000RR", year: 2016 },
  { make: "BMW", model: "S1000RR", year: 2017 },
  { make: "BMW", model: "S1000RR", year: 2018 },
  { make: "BMW", model: "S1000RR", year: 2019 },
  { make: "BMW", model: "S1000RR", year: 2020 },
  { make: "BMW", model: "S1000RR", year: 2021 },
  { make: "BMW", model: "S1000RR", year: 2022 },
  { make: "BMW", model: "S1000RR", year: 2023 },
  { make: "BMW", model: "S1000RR", year: 2024 },
  { make: "BMW", model: "S1000RR", year: 2025 },
  { make: "BMW", model: "S1000RR", year: 2026 },
  { make: "BMW", model: "S1000RR", year: 2027 },
  // BMW - S1000RR Bullet Style
  { make: "BMW", model: "S1000RR Bullet Style", year: 2020 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2021 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2022 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2023 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2024 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2025 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2026 },
  { make: "BMW", model: "S1000RR Bullet Style", year: 2027 },
  // BMW - S1000RR Clip Ons
  { make: "BMW", model: "S1000RR Clip Ons", year: 2020 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2021 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2022 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2023 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2024 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2025 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2026 },
  { make: "BMW", model: "S1000RR Clip Ons", year: 2027 },
  // BMW - S1000RR Gloss
  { make: "BMW", model: "S1000RR Gloss", year: 2009 },
  { make: "BMW", model: "S1000RR Gloss", year: 2010 },
  { make: "BMW", model: "S1000RR Gloss", year: 2011 },
  { make: "BMW", model: "S1000RR Gloss", year: 2012 },
  { make: "BMW", model: "S1000RR Gloss", year: 2013 },
  { make: "BMW", model: "S1000RR Gloss", year: 2014 },
  // BMW - S1000RR Gp
  { make: "BMW", model: "S1000RR Gp", year: 2009 },
  { make: "BMW", model: "S1000RR Gp", year: 2010 },
  { make: "BMW", model: "S1000RR Gp", year: 2011 },
  { make: "BMW", model: "S1000RR Gp", year: 2012 },
  { make: "BMW", model: "S1000RR Gp", year: 2013 },
  { make: "BMW", model: "S1000RR Gp", year: 2014 },
  { make: "BMW", model: "S1000RR Gp", year: 2015 },
  { make: "BMW", model: "S1000RR Gp", year: 2016 },
  { make: "BMW", model: "S1000RR Gp", year: 2017 },
  { make: "BMW", model: "S1000RR Gp", year: 2018 },
  { make: "BMW", model: "S1000RR Gp", year: 2019 },
  // BMW - S1000RR Grid O
  { make: "BMW", model: "S1000RR Grid O", year: 2020 },
  { make: "BMW", model: "S1000RR Grid O", year: 2021 },
  { make: "BMW", model: "S1000RR Grid O", year: 2022 },
  { make: "BMW", model: "S1000RR Grid O", year: 2023 },
  { make: "BMW", model: "S1000RR Grid O", year: 2024 },
  { make: "BMW", model: "S1000RR Grid O", year: 2025 },
  { make: "BMW", model: "S1000RR Grid O", year: 2026 },
  { make: "BMW", model: "S1000RR Grid O", year: 2027 },
  // BMW - S1000RR Led
  { make: "BMW", model: "S1000RR Led", year: 2009 },
  { make: "BMW", model: "S1000RR Led", year: 2010 },
  { make: "BMW", model: "S1000RR Led", year: 2011 },
  { make: "BMW", model: "S1000RR Led", year: 2012 },
  { make: "BMW", model: "S1000RR Led", year: 2013 },
  { make: "BMW", model: "S1000RR Led", year: 2014 },
  { make: "BMW", model: "S1000RR Led", year: 2015 },
  { make: "BMW", model: "S1000RR Led", year: 2016 },
  { make: "BMW", model: "S1000RR Led", year: 2017 },
  { make: "BMW", model: "S1000RR Led", year: 2018 },
  { make: "BMW", model: "S1000RR Led", year: 2019 },
  // BMW - S1000RR M1000R
  { make: "BMW", model: "S1000RR M1000R", year: 2020 },
  { make: "BMW", model: "S1000RR M1000R", year: 2021 },
  { make: "BMW", model: "S1000RR M1000R", year: 2022 },
  { make: "BMW", model: "S1000RR M1000R", year: 2023 },
  { make: "BMW", model: "S1000RR M1000R", year: 2024 },
  { make: "BMW", model: "S1000RR M1000R", year: 2025 },
  { make: "BMW", model: "S1000RR M1000R", year: 2026 },
  // BMW - S1000XR
  { make: "BMW", model: "S1000XR", year: 2020 },
  { make: "BMW", model: "S1000XR", year: 2021 },
  { make: "BMW", model: "S1000XR", year: 2022 },
  { make: "BMW", model: "S1000XR", year: 2023 },
  { make: "BMW", model: "S1000XR", year: 2024 },
  { make: "BMW", model: "S1000XR", year: 2025 },
  { make: "BMW", model: "S1000XR", year: 2026 },
  // Can-Am
  // Can-Am - Commander
  { make: "Can-Am", model: "Commander", year: 2011 },
  { make: "Can-Am", model: "Commander", year: 2012 },
  { make: "Can-Am", model: "Commander", year: 2013 },
  { make: "Can-Am", model: "Commander", year: 2014 },
  { make: "Can-Am", model: "Commander", year: 2015 },
  { make: "Can-Am", model: "Commander", year: 2016 },
  { make: "Can-Am", model: "Commander", year: 2017 },
  { make: "Can-Am", model: "Commander", year: 2018 },
  { make: "Can-Am", model: "Commander", year: 2019 },
  { make: "Can-Am", model: "Commander", year: 2020 },
  { make: "Can-Am", model: "Commander", year: 2021 },
  { make: "Can-Am", model: "Commander", year: 2022 },
  { make: "Can-Am", model: "Commander", year: 2023 },
  { make: "Can-Am", model: "Commander", year: 2024 },
  { make: "Can-Am", model: "Commander", year: 2025 },
  { make: "Can-Am", model: "Commander", year: 2026 },
  // Can-Am - Defender
  { make: "Can-Am", model: "Defender", year: 2016 },
  { make: "Can-Am", model: "Defender", year: 2017 },
  { make: "Can-Am", model: "Defender", year: 2018 },
  { make: "Can-Am", model: "Defender", year: 2019 },
  { make: "Can-Am", model: "Defender", year: 2020 },
  { make: "Can-Am", model: "Defender", year: 2021 },
  { make: "Can-Am", model: "Defender", year: 2022 },
  { make: "Can-Am", model: "Defender", year: 2023 },
  { make: "Can-Am", model: "Defender", year: 2024 },
  { make: "Can-Am", model: "Defender", year: 2025 },
  { make: "Can-Am", model: "Defender", year: 2026 },
  // Can-Am - DS-250
  { make: "Can-Am", model: "DS-250", year: 2006 },
  { make: "Can-Am", model: "DS-250", year: 2007 },
  { make: "Can-Am", model: "DS-250", year: 2008 },
  { make: "Can-Am", model: "DS-250", year: 2009 },
  { make: "Can-Am", model: "DS-250", year: 2010 },
  { make: "Can-Am", model: "DS-250", year: 2011 },
  { make: "Can-Am", model: "DS-250", year: 2012 },
  { make: "Can-Am", model: "DS-250", year: 2013 },
  { make: "Can-Am", model: "DS-250", year: 2014 },
  { make: "Can-Am", model: "DS-250", year: 2015 },
  { make: "Can-Am", model: "DS-250", year: 2016 },
  { make: "Can-Am", model: "DS-250", year: 2017 },
  { make: "Can-Am", model: "DS-250", year: 2018 },
  { make: "Can-Am", model: "DS-250", year: 2019 },
  { make: "Can-Am", model: "DS-250", year: 2020 },
  { make: "Can-Am", model: "DS-250", year: 2021 },
  { make: "Can-Am", model: "DS-250", year: 2022 },
  { make: "Can-Am", model: "DS-250", year: 2023 },
  // Can-Am - Maverick R
  { make: "Can-Am", model: "Maverick R", year: 2024 },
  { make: "Can-Am", model: "Maverick R", year: 2025 },
  { make: "Can-Am", model: "Maverick R", year: 2026 },
  // Can-Am - Maverick X3
  { make: "Can-Am", model: "Maverick X3", year: 2017 },
  { make: "Can-Am", model: "Maverick X3", year: 2018 },
  { make: "Can-Am", model: "Maverick X3", year: 2019 },
  { make: "Can-Am", model: "Maverick X3", year: 2020 },
  { make: "Can-Am", model: "Maverick X3", year: 2021 },
  { make: "Can-Am", model: "Maverick X3", year: 2022 },
  { make: "Can-Am", model: "Maverick X3", year: 2023 },
  { make: "Can-Am", model: "Maverick X3", year: 2024 },
  { make: "Can-Am", model: "Maverick X3", year: 2025 },
  { make: "Can-Am", model: "Maverick X3", year: 2026 },
  // Can-Am - Maverick X3 DS Turbo
  { make: "Can-Am", model: "Maverick X3 DS Turbo", year: 2021 },
  { make: "Can-Am", model: "Maverick X3 DS Turbo", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 DS Turbo", year: 2023 },
  // Can-Am - Maverick X3 DS Turbo R
  { make: "Can-Am", model: "Maverick X3 DS Turbo R", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 DS Turbo R", year: 2021 },
  // Can-Am - Maverick X3 DS Turbo RR
  { make: "Can-Am", model: "Maverick X3 DS Turbo RR", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 DS Turbo RR", year: 2023 },
  // Can-Am - Maverick X3 Max DS Turbo
  { make: "Can-Am", model: "Maverick X3 Max DS Turbo", year: 2021 },
  // Can-Am - Maverick X3 Max DS Turbo R
  { make: "Can-Am", model: "Maverick X3 Max DS Turbo R", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Max DS Turbo R", year: 2021 },
  // Can-Am - Maverick X3 Max RS Turbo R
  { make: "Can-Am", model: "Maverick X3 Max RS Turbo R", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Max RS Turbo R", year: 2021 },
  // Can-Am - Maverick X3 Max Turbo
  { make: "Can-Am", model: "Maverick X3 Max Turbo", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Max Turbo", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 Max Turbo", year: 2020 },
  // Can-Am - Maverick X3 Max Turbo R
  { make: "Can-Am", model: "Maverick X3 Max Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Max Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Max Turbo R", year: 2019 },
  // Can-Am - Maverick X3 Max X ds Turbo R
  { make: "Can-Am", model: "Maverick X3 Max X ds Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Max X ds Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Max X ds Turbo R", year: 2019 },
  // Can-Am - Maverick X3 Max X ds Turbo RR
  { make: "Can-Am", model: "Maverick X3 Max X ds Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Max X ds Turbo RR", year: 2021 },
  // Can-Am - Maverick X3 Max X mr Turbo RR
  { make: "Can-Am", model: "Maverick X3 Max X mr Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Max X mr Turbo RR", year: 2021 },
  // Can-Am - Maverick X3 Max X rs Turbo R
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo R", year: 2019 },
  // Can-Am - Maverick X3 Max X rs Turbo RR
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo RR", year: 2021 },
  // Can-Am - Maverick X3 Max X rs Turbo RR Smart-Shox
  { make: "Can-Am", model: "Maverick X3 Max X rs Turbo RR Smart-Shox", year: 2021 },
  // Can-Am - Maverick X3 RS Turbo R
  { make: "Can-Am", model: "Maverick X3 RS Turbo R", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 RS Turbo R", year: 2021 },
  // Can-Am - Maverick X3 RS Turbo RR
  { make: "Can-Am", model: "Maverick X3 RS Turbo RR", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 RS Turbo RR", year: 2023 },
  // Can-Am - Maverick X3 Turbo
  { make: "Can-Am", model: "Maverick X3 Turbo", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Turbo", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 Turbo", year: 2020 },
  // Can-Am - Maverick X3 Turbo 2 5IN
  { make: "Can-Am", model: "Maverick X3 Turbo 2 5IN", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 5IN", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 5IN", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 5IN", year: 2020 },
  // Can-Am - Maverick X3 Turbo 2 25IN
  { make: "Can-Am", model: "Maverick X3 Turbo 2 25IN", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 25IN", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 25IN", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 Turbo 2 25IN", year: 2020 },
  // Can-Am - Maverick X3 Turbo R
  { make: "Can-Am", model: "Maverick X3 Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Turbo R", year: 2019 },
  // Can-Am - Maverick X3 Turbo Xfactor
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2021 },
  { make: "Can-Am", model: "Maverick X3 Turbo Xfactor", year: 2022 },
  // Can-Am - Maverick X3 X ds Turbo R
  { make: "Can-Am", model: "Maverick X3 X ds Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 X ds Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 X ds Turbo R", year: 2019 },
  // Can-Am - Maverick X3 X ds Turbo RR
  { make: "Can-Am", model: "Maverick X3 X ds Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X ds Turbo RR", year: 2021 },
  { make: "Can-Am", model: "Maverick X3 X ds Turbo RR", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X ds Turbo RR", year: 2023 },
  // Can-Am - Maverick X3 X mr Turbo
  { make: "Can-Am", model: "Maverick X3 X mr Turbo", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 X mr Turbo", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X mr Turbo", year: 2021 },
  // Can-Am - Maverick X3 X mr Turbo R
  { make: "Can-Am", model: "Maverick X3 X mr Turbo R", year: 2019 },
  // Can-Am - Maverick X3 X mr Turbo RR
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR", year: 2021 },
  // Can-Am - Maverick X3 X mr Turbo RR 64
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR 64", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR 64", year: 2023 },
  // Can-Am - Maverick X3 X mr Turbo RR 72
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR 72", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X mr Turbo RR 72", year: 2023 },
  // Can-Am - Maverick X3 X rc Turbo
  { make: "Can-Am", model: "Maverick X3 X rc Turbo", year: 2019 },
  { make: "Can-Am", model: "Maverick X3 X rc Turbo", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X rc Turbo", year: 2021 },
  // Can-Am - Maverick X3 X rc Turbo R
  { make: "Can-Am", model: "Maverick X3 X rc Turbo R", year: 2019 },
  // Can-Am - Maverick X3 X rc Turbo RR
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR", year: 2021 },
  // Can-Am - Maverick X3 X rc Turbo RR 64
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR 64", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR 64", year: 2023 },
  // Can-Am - Maverick X3 X rc Turbo RR 72
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR 72", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X rc Turbo RR 72", year: 2023 },
  // Can-Am - Maverick X3 X rs Turbo R
  { make: "Can-Am", model: "Maverick X3 X rs Turbo R", year: 2017 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo R", year: 2018 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo R", year: 2019 },
  // Can-Am - Maverick X3 X rs Turbo RR
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR", year: 2020 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR", year: 2021 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR", year: 2023 },
  // Can-Am - Maverick X3 X rs Turbo RR Smart-Shox
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR Smart-Shox", year: 2021 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR Smart-Shox", year: 2022 },
  { make: "Can-Am", model: "Maverick X3 X rs Turbo RR Smart-Shox", year: 2023 },
  // Can-Am - Outlander
  { make: "Can-Am", model: "Outlander", year: 2016 },
  { make: "Can-Am", model: "Outlander", year: 2017 },
  { make: "Can-Am", model: "Outlander", year: 2018 },
  { make: "Can-Am", model: "Outlander", year: 2019 },
  { make: "Can-Am", model: "Outlander", year: 2020 },
  { make: "Can-Am", model: "Outlander", year: 2021 },
  { make: "Can-Am", model: "Outlander", year: 2022 },
  { make: "Can-Am", model: "Outlander", year: 2023 },
  { make: "Can-Am", model: "Outlander", year: 2024 },
  { make: "Can-Am", model: "Outlander", year: 2025 },
  { make: "Can-Am", model: "Outlander", year: 2026 },
  // Can-Am - Outlander 500
  { make: "Can-Am", model: "Outlander 500", year: 2013 },
  { make: "Can-Am", model: "Outlander 500", year: 2014 },
  { make: "Can-Am", model: "Outlander 500", year: 2015 },
  // Can-Am - Outlander 570
  { make: "Can-Am", model: "Outlander 570", year: 2016 },
  { make: "Can-Am", model: "Outlander 570", year: 2017 },
  { make: "Can-Am", model: "Outlander 570", year: 2018 },
  { make: "Can-Am", model: "Outlander 570", year: 2019 },
  { make: "Can-Am", model: "Outlander 570", year: 2020 },
  { make: "Can-Am", model: "Outlander 570", year: 2021 },
  { make: "Can-Am", model: "Outlander 570", year: 2022 },
  { make: "Can-Am", model: "Outlander 570", year: 2023 },
  { make: "Can-Am", model: "Outlander 570", year: 2024 },
  { make: "Can-Am", model: "Outlander 570", year: 2025 },
  { make: "Can-Am", model: "Outlander 570", year: 2026 },
  // Can-Am - Outlander 800
  { make: "Can-Am", model: "Outlander 800", year: 2006 },
  { make: "Can-Am", model: "Outlander 800", year: 2007 },
  // Can-Am - Outlander 850
  { make: "Can-Am", model: "Outlander 850", year: 2016 },
  { make: "Can-Am", model: "Outlander 850", year: 2017 },
  { make: "Can-Am", model: "Outlander 850", year: 2018 },
  { make: "Can-Am", model: "Outlander 850", year: 2019 },
  { make: "Can-Am", model: "Outlander 850", year: 2020 },
  { make: "Can-Am", model: "Outlander 850", year: 2021 },
  { make: "Can-Am", model: "Outlander 850", year: 2022 },
  { make: "Can-Am", model: "Outlander 850", year: 2023 },
  { make: "Can-Am", model: "Outlander 850", year: 2024 },
  { make: "Can-Am", model: "Outlander 850", year: 2025 },
  { make: "Can-Am", model: "Outlander 850", year: 2026 },
  // Can-Am - Outlander Max 400
  { make: "Can-Am", model: "Outlander Max 400", year: 2004 },
  { make: "Can-Am", model: "Outlander Max 400", year: 2005 },
  { make: "Can-Am", model: "Outlander Max 400", year: 2006 },
  { make: "Can-Am", model: "Outlander Max 400", year: 2007 },
  { make: "Can-Am", model: "Outlander Max 400", year: 2008 },
  // Can-Am - Outlander Max 400 Evo U
  { make: "Can-Am", model: "Outlander Max 400 Evo U", year: 2004 },
  { make: "Can-Am", model: "Outlander Max 400 Evo U", year: 2005 },
  { make: "Can-Am", model: "Outlander Max 400 Evo U", year: 2006 },
  { make: "Can-Am", model: "Outlander Max 400 Evo U", year: 2007 },
  { make: "Can-Am", model: "Outlander Max 400 Evo U", year: 2008 },
  // Can-Am - Renegade 500
  { make: "Can-Am", model: "Renegade 500", year: 2008 },
  { make: "Can-Am", model: "Renegade 500", year: 2009 },
  { make: "Can-Am", model: "Renegade 500", year: 2010 },
  { make: "Can-Am", model: "Renegade 500", year: 2011 },
  { make: "Can-Am", model: "Renegade 500", year: 2012 },
  // Can-Am - Renegade 1000R
  { make: "Can-Am", model: "Renegade 1000R", year: 2012 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2013 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2014 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2015 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2016 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2017 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2018 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2019 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2020 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2021 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2022 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2023 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2024 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2025 },
  { make: "Can-Am", model: "Renegade 1000R", year: 2026 },
  // Can-Am - Ryker
  { make: "Can-Am", model: "Ryker", year: 2019 },
  { make: "Can-Am", model: "Ryker", year: 2020 },
  { make: "Can-Am", model: "Ryker", year: 2021 },
  { make: "Can-Am", model: "Ryker", year: 2022 },
  { make: "Can-Am", model: "Ryker", year: 2023 },
  { make: "Can-Am", model: "Ryker", year: 2024 },
  // Can-Am - Ryker 600
  { make: "Can-Am", model: "Ryker 600", year: 2019 },
  { make: "Can-Am", model: "Ryker 600", year: 2020 },
  { make: "Can-Am", model: "Ryker 600", year: 2021 },
  { make: "Can-Am", model: "Ryker 600", year: 2022 },
  { make: "Can-Am", model: "Ryker 600", year: 2023 },
  { make: "Can-Am", model: "Ryker 600", year: 2024 },
  { make: "Can-Am", model: "Ryker 600", year: 2025 },
  // Can-Am - Ryker 600/900 Sport/Rally/Ace
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2019 },
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2020 },
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2021 },
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2022 },
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2023 },
  { make: "Can-Am", model: "Ryker 600/900 Sport/Rally/Ace", year: 2024 },
  // Can-Am - Ryker 900
  { make: "Can-Am", model: "Ryker 900", year: 2019 },
  { make: "Can-Am", model: "Ryker 900", year: 2020 },
  { make: "Can-Am", model: "Ryker 900", year: 2021 },
  { make: "Can-Am", model: "Ryker 900", year: 2022 },
  { make: "Can-Am", model: "Ryker 900", year: 2023 },
  { make: "Can-Am", model: "Ryker 900", year: 2024 },
  { make: "Can-Am", model: "Ryker 900", year: 2025 },
  // Can-Am - Ryker 900 Rally
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2019 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2020 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2021 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2022 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2023 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2024 },
  { make: "Can-Am", model: "Ryker 900 Rally", year: 2025 },
  // Can-Am - Ryker 900 Sport
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2019 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2020 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2021 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2022 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2023 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2024 },
  { make: "Can-Am", model: "Ryker 900 Sport", year: 2025 },
  // CFMoto
  // CFMoto - 450 Mt
  { make: "CFMoto", model: "450 Mt", year: 2024 },
  { make: "CFMoto", model: "450 Mt", year: 2025 },
  // CFMoto - 450 Mt 15612U
  { make: "CFMoto", model: "450 Mt 15612U", year: 2024 },
  { make: "CFMoto", model: "450 Mt 15612U", year: 2025 },
  // CFMoto - 450 Mt 80071
  { make: "CFMoto", model: "450 Mt 80071", year: 2024 },
  { make: "CFMoto", model: "450 Mt 80071", year: 2025 },
  // CFMoto - 450MT
  { make: "CFMoto", model: "450MT", year: 2025 },
  { make: "CFMoto", model: "450MT", year: 2026 },
  // CFMoto - 450NK
  { make: "CFMoto", model: "450NK", year: 2024 },
  { make: "CFMoto", model: "450NK", year: 2025 },
  { make: "CFMoto", model: "450NK", year: 2026 },
  // CFMoto - 450SS
  { make: "CFMoto", model: "450SS", year: 2023 },
  { make: "CFMoto", model: "450SS", year: 2024 },
  // CFMoto - 675 Sr R E5
  { make: "CFMoto", model: "675 Sr R E5", year: 2025 },
  { make: "CFMoto", model: "675 Sr R E5", year: 2026 },
  // CFMoto - 700CL X
  { make: "CFMoto", model: "700CL X", year: 2021 },
  { make: "CFMoto", model: "700CL X", year: 2022 },
  { make: "CFMoto", model: "700CL X", year: 2023 },
  // CFMoto - 800 Mt
  { make: "CFMoto", model: "800 Mt", year: 2023 },
  { make: "CFMoto", model: "800 Mt", year: 2024 },
  { make: "CFMoto", model: "800 Mt", year: 2025 },
  // CFMoto - 800MT
  { make: "CFMoto", model: "800MT", year: 2023 },
  { make: "CFMoto", model: "800MT", year: 2024 },
  // CFMoto - 800MT 800 Mt
  { make: "CFMoto", model: "800MT 800 Mt", year: 2023 },
  { make: "CFMoto", model: "800MT 800 Mt", year: 2024 },
  // CFMoto - 800NK
  { make: "CFMoto", model: "800NK", year: 2024 },
  { make: "CFMoto", model: "800NK", year: 2025 },
  // CFMoto - 800NK S CF8SO1 Haplc
  { make: "CFMoto", model: "800NK S CF8SO1 Haplc", year: 2023 },
  { make: "CFMoto", model: "800NK S CF8SO1 Haplc", year: 2024 },
  { make: "CFMoto", model: "800NK S CF8SO1 Haplc", year: 2025 },
  { make: "CFMoto", model: "800NK S CF8SO1 Haplc", year: 2026 },
  // CFMOTO
  // CFMOTO - 450 MT
  { make: "CFMOTO", model: "450 MT", year: 2024 },
  { make: "CFMOTO", model: "450 MT", year: 2025 },
  // CFMOTO - 450NK
  { make: "CFMOTO", model: "450NK", year: 2024 },
  { make: "CFMOTO", model: "450NK", year: 2025 },
  { make: "CFMOTO", model: "450NK", year: 2026 },
  // CFMOTO - 450SS
  { make: "CFMOTO", model: "450SS", year: 2023 },
  { make: "CFMOTO", model: "450SS", year: 2024 },
  { make: "CFMOTO", model: "450SS", year: 2025 },
  { make: "CFMOTO", model: "450SS", year: 2026 },
  // CFMOTO - 650NK
  { make: "CFMOTO", model: "650NK", year: 2012 },
  { make: "CFMOTO", model: "650NK", year: 2013 },
  { make: "CFMOTO", model: "650NK", year: 2014 },
  { make: "CFMOTO", model: "650NK", year: 2015 },
  { make: "CFMOTO", model: "650NK", year: 2016 },
  { make: "CFMOTO", model: "650NK", year: 2017 },
  { make: "CFMOTO", model: "650NK", year: 2018 },
  { make: "CFMOTO", model: "650NK", year: 2019 },
  { make: "CFMOTO", model: "650NK", year: 2020 },
  { make: "CFMOTO", model: "650NK", year: 2021 },
  { make: "CFMOTO", model: "650NK", year: 2022 },
  { make: "CFMOTO", model: "650NK", year: 2023 },
  { make: "CFMOTO", model: "650NK", year: 2024 },
  { make: "CFMOTO", model: "650NK", year: 2025 },
  { make: "CFMOTO", model: "650NK", year: 2026 },
  // CFMOTO - 700 CL-X Heritage/Sport
  { make: "CFMOTO", model: "700 CL-X Heritage/Sport", year: 2021 },
  { make: "CFMOTO", model: "700 CL-X Heritage/Sport", year: 2022 },
  { make: "CFMOTO", model: "700 CL-X Heritage/Sport", year: 2023 },
  // CFMOTO - 700CL-X Adventure
  { make: "CFMOTO", model: "700CL-X Adventure", year: 2022 },
  { make: "CFMOTO", model: "700CL-X Adventure", year: 2023 },
  { make: "CFMOTO", model: "700CL-X Adventure", year: 2024 },
  // CFMOTO - 700CL-X Heritage
  { make: "CFMOTO", model: "700CL-X Heritage", year: 2022 },
  { make: "CFMOTO", model: "700CL-X Heritage", year: 2023 },
  { make: "CFMOTO", model: "700CL-X Heritage", year: 2024 },
  // CFMOTO - 700CL-X Sport
  { make: "CFMOTO", model: "700CL-X Sport", year: 2022 },
  { make: "CFMOTO", model: "700CL-X Sport", year: 2023 },
  { make: "CFMOTO", model: "700CL-X Sport", year: 2024 },
  // CFMOTO - 800NK
  { make: "CFMOTO", model: "800NK", year: 2024 },
  { make: "CFMOTO", model: "800NK", year: 2025 },
  { make: "CFMOTO", model: "800NK", year: 2026 },
  // CFMOTO - Ibex 800
  { make: "CFMOTO", model: "Ibex 800", year: 2022 },
  { make: "CFMOTO", model: "Ibex 800", year: 2023 },
  { make: "CFMOTO", model: "Ibex 800", year: 2024 },
  { make: "CFMOTO", model: "Ibex 800", year: 2025 },
  { make: "CFMOTO", model: "Ibex 800", year: 2026 },
  // Ducati
  // Ducati - 749
  { make: "Ducati", model: "749", year: 2002 },
  { make: "Ducati", model: "749", year: 2003 },
  { make: "Ducati", model: "749", year: 2004 },
  { make: "Ducati", model: "749", year: 2005 },
  { make: "Ducati", model: "749", year: 2006 },
  // Ducati - 800
  { make: "Ducati", model: "800", year: 2017 },
  { make: "Ducati", model: "800", year: 2018 },
  { make: "Ducati", model: "800", year: 2019 },
  { make: "Ducati", model: "800", year: 2020 },
  // Ducati - 800 Scrambler 80068
  { make: "Ducati", model: "800 Scrambler 80068", year: 2023 },
  { make: "Ducati", model: "800 Scrambler 80068", year: 2024 },
  // Ducati - 848 / 848 EVO
  { make: "Ducati", model: "848 / 848 EVO", year: 2007 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2008 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2009 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2010 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2011 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2012 },
  { make: "Ducati", model: "848 / 848 EVO", year: 2013 },
  // Ducati - 899 Panigale
  { make: "Ducati", model: "899 Panigale", year: 2013 },
  { make: "Ducati", model: "899 Panigale", year: 2014 },
  { make: "Ducati", model: "899 Panigale", year: 2015 },
  // Ducati - 959 Panigale
  { make: "Ducati", model: "959 Panigale", year: 2016 },
  { make: "Ducati", model: "959 Panigale", year: 2017 },
  { make: "Ducati", model: "959 Panigale", year: 2018 },
  { make: "Ducati", model: "959 Panigale", year: 2019 },
  // Ducati - 999
  { make: "Ducati", model: "999", year: 2003 },
  { make: "Ducati", model: "999", year: 2004 },
  { make: "Ducati", model: "999", year: 2005 },
  { make: "Ducati", model: "999", year: 2006 },
  // Ducati - 1098
  { make: "Ducati", model: "1098", year: 2007 },
  { make: "Ducati", model: "1098", year: 2008 },
  { make: "Ducati", model: "1098", year: 2009 },
  { make: "Ducati", model: "1098", year: 2010 },
  { make: "Ducati", model: "1098", year: 2011 },
  { make: "Ducati", model: "1098", year: 2012 },
  { make: "Ducati", model: "1098", year: 2013 },
  // Ducati - 1198
  { make: "Ducati", model: "1198", year: 2007 },
  { make: "Ducati", model: "1198", year: 2008 },
  { make: "Ducati", model: "1198", year: 2009 },
  { make: "Ducati", model: "1198", year: 2010 },
  { make: "Ducati", model: "1198", year: 2011 },
  { make: "Ducati", model: "1198", year: 2012 },
  { make: "Ducati", model: "1198", year: 2013 },
  // Ducati - 1199 Panigale
  { make: "Ducati", model: "1199 Panigale", year: 2011 },
  { make: "Ducati", model: "1199 Panigale", year: 2012 },
  { make: "Ducati", model: "1199 Panigale", year: 2013 },
  { make: "Ducati", model: "1199 Panigale", year: 2014 },
  // Ducati - 1299 Panigale
  { make: "Ducati", model: "1299 Panigale", year: 2015 },
  { make: "Ducati", model: "1299 Panigale", year: 2016 },
  { make: "Ducati", model: "1299 Panigale", year: 2017 },
  { make: "Ducati", model: "1299 Panigale", year: 2018 },
  { make: "Ducati", model: "1299 Panigale", year: 2019 },
  // Ducati - DesertX
  { make: "Ducati", model: "DesertX", year: 2022 },
  { make: "Ducati", model: "DesertX", year: 2023 },
  { make: "Ducati", model: "DesertX", year: 2024 },
  { make: "Ducati", model: "DesertX", year: 2025 },
  { make: "Ducati", model: "DesertX", year: 2026 },
  // Ducati - Desertx 950
  { make: "Ducati", model: "Desertx 950", year: 2022 },
  { make: "Ducati", model: "Desertx 950", year: 2023 },
  { make: "Ducati", model: "Desertx 950", year: 2024 },
  // Ducati - Diavel
  { make: "Ducati", model: "Diavel", year: 2010 },
  { make: "Ducati", model: "Diavel", year: 2011 },
  { make: "Ducati", model: "Diavel", year: 2012 },
  { make: "Ducati", model: "Diavel", year: 2013 },
  { make: "Ducati", model: "Diavel", year: 2014 },
  { make: "Ducati", model: "Diavel", year: 2015 },
  { make: "Ducati", model: "Diavel", year: 2016 },
  { make: "Ducati", model: "Diavel", year: 2017 },
  { make: "Ducati", model: "Diavel", year: 2018 },
  { make: "Ducati", model: "Diavel", year: 2019 },
  // Ducati - Diavel 2 Position
  { make: "Ducati", model: "Diavel 2 Position", year: 2010 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2011 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2012 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2013 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2014 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2015 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2016 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2017 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2018 },
  { make: "Ducati", model: "Diavel 2 Position", year: 2019 },
  // Ducati - Diavel 1260
  { make: "Ducati", model: "Diavel 1260", year: 2019 },
  { make: "Ducati", model: "Diavel 1260", year: 2020 },
  { make: "Ducati", model: "Diavel 1260", year: 2021 },
  { make: "Ducati", model: "Diavel 1260", year: 2022 },
  { make: "Ducati", model: "Diavel 1260", year: 2023 },
  { make: "Ducati", model: "Diavel 1260", year: 2024 },
  { make: "Ducati", model: "Diavel 1260", year: 2025 },
  // Ducati - Diavel 1260 Side Mount License
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2019 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2020 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2021 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2022 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2023 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2024 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2025 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2026 },
  { make: "Ducati", model: "Diavel 1260 Side Mount License", year: 2027 },
  // Ducati - Diavel 1260S
  { make: "Ducati", model: "Diavel 1260S", year: 2019 },
  { make: "Ducati", model: "Diavel 1260S", year: 2020 },
  { make: "Ducati", model: "Diavel 1260S", year: 2021 },
  { make: "Ducati", model: "Diavel 1260S", year: 2022 },
  // Ducati - Diavel V4
  { make: "Ducati", model: "Diavel V4", year: 2023 },
  { make: "Ducati", model: "Diavel V4", year: 2024 },
  { make: "Ducati", model: "Diavel V4", year: 2025 },
  { make: "Ducati", model: "Diavel V4", year: 2026 },
  { make: "Ducati", model: "Diavel V4", year: 2027 },
  // Ducati - Diavel V4 Side Mount License
  { make: "Ducati", model: "Diavel V4 Side Mount License", year: 2023 },
  { make: "Ducati", model: "Diavel V4 Side Mount License", year: 2024 },
  { make: "Ducati", model: "Diavel V4 Side Mount License", year: 2025 },
  { make: "Ducati", model: "Diavel V4 Side Mount License", year: 2026 },
  { make: "Ducati", model: "Diavel V4 Side Mount License", year: 2027 },
  // Ducati - Hyper 821 Multistrada 1200
  { make: "Ducati", model: "Hyper 821 Multistrada 1200", year: 2010 },
  { make: "Ducati", model: "Hyper 821 Multistrada 1200", year: 2011 },
  { make: "Ducati", model: "Hyper 821 Multistrada 1200", year: 2012 },
  { make: "Ducati", model: "Hyper 821 Multistrada 1200", year: 2013 },
  { make: "Ducati", model: "Hyper 821 Multistrada 1200", year: 2014 },
  // Ducati - Hypermotard
  { make: "Ducati", model: "Hypermotard", year: 2013 },
  { make: "Ducati", model: "Hypermotard", year: 2014 },
  { make: "Ducati", model: "Hypermotard", year: 2015 },
  { make: "Ducati", model: "Hypermotard", year: 2016 },
  { make: "Ducati", model: "Hypermotard", year: 2017 },
  { make: "Ducati", model: "Hypermotard", year: 2018 },
  // Ducati - Hypermotard 698
  { make: "Ducati", model: "Hypermotard 698", year: 2024 },
  { make: "Ducati", model: "Hypermotard 698", year: 2025 },
  { make: "Ducati", model: "Hypermotard 698", year: 2026 },
  { make: "Ducati", model: "Hypermotard 698", year: 2027 },
  // Ducati - Hypermotard 698 Mono
  { make: "Ducati", model: "Hypermotard 698 Mono", year: 2024 },
  // Ducati - Hypermotard 698 S D6SO2 Haplt
  { make: "Ducati", model: "Hypermotard 698 S D6SO2 Haplt", year: 2024 },
  { make: "Ducati", model: "Hypermotard 698 S D6SO2 Haplt", year: 2025 },
  { make: "Ducati", model: "Hypermotard 698 S D6SO2 Haplt", year: 2026 },
  // Ducati - Hypermotard 950
  { make: "Ducati", model: "Hypermotard 950", year: 2019 },
  { make: "Ducati", model: "Hypermotard 950", year: 2020 },
  { make: "Ducati", model: "Hypermotard 950", year: 2021 },
  { make: "Ducati", model: "Hypermotard 950", year: 2022 },
  { make: "Ducati", model: "Hypermotard 950", year: 2023 },
  { make: "Ducati", model: "Hypermotard 950", year: 2024 },
  { make: "Ducati", model: "Hypermotard 950", year: 2025 },
  { make: "Ducati", model: "Hypermotard 950", year: 2026 },
  { make: "Ducati", model: "Hypermotard 950", year: 2027 },
  // Ducati - Hypermotard 950 Double Grid O Semi Full
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2019 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2020 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2021 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2022 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2023 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2024 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2025 },
  { make: "Ducati", model: "Hypermotard 950 Double Grid O Semi Full", year: 2026 },
  // Ducati - Hypermotard 950 Side Mount License
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2019 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2020 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2021 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2022 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2023 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2024 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2025 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2026 },
  { make: "Ducati", model: "Hypermotard 950 Side Mount License", year: 2027 },
  // Ducati - Hypermotard 1100
  { make: "Ducati", model: "Hypermotard 1100", year: 2007 },
  { make: "Ducati", model: "Hypermotard 1100", year: 2008 },
  // Ducati - Hyperstrada
  { make: "Ducati", model: "Hyperstrada", year: 2013 },
  { make: "Ducati", model: "Hyperstrada", year: 2014 },
  { make: "Ducati", model: "Hyperstrada", year: 2015 },
  { make: "Ducati", model: "Hyperstrada", year: 2016 },
  { make: "Ducati", model: "Hyperstrada", year: 2017 },
  { make: "Ducati", model: "Hyperstrada", year: 2018 },
  // Ducati - Monster
  { make: "Ducati", model: "Monster", year: 1993 },
  { make: "Ducati", model: "Monster", year: 1994 },
  { make: "Ducati", model: "Monster", year: 1995 },
  { make: "Ducati", model: "Monster", year: 1996 },
  { make: "Ducati", model: "Monster", year: 1997 },
  { make: "Ducati", model: "Monster", year: 1998 },
  { make: "Ducati", model: "Monster", year: 1999 },
  { make: "Ducati", model: "Monster", year: 2000 },
  { make: "Ducati", model: "Monster", year: 2001 },
  { make: "Ducati", model: "Monster", year: 2002 },
  { make: "Ducati", model: "Monster", year: 2003 },
  { make: "Ducati", model: "Monster", year: 2004 },
  { make: "Ducati", model: "Monster", year: 2005 },
  { make: "Ducati", model: "Monster", year: 2006 },
  { make: "Ducati", model: "Monster", year: 2007 },
  { make: "Ducati", model: "Monster", year: 2008 },
  { make: "Ducati", model: "Monster", year: 2009 },
  { make: "Ducati", model: "Monster", year: 2010 },
  { make: "Ducati", model: "Monster", year: 2011 },
  { make: "Ducati", model: "Monster", year: 2012 },
  { make: "Ducati", model: "Monster", year: 2013 },
  { make: "Ducati", model: "Monster", year: 2014 },
  { make: "Ducati", model: "Monster", year: 2015 },
  { make: "Ducati", model: "Monster", year: 2016 },
  { make: "Ducati", model: "Monster", year: 2017 },
  { make: "Ducati", model: "Monster", year: 2018 },
  { make: "Ducati", model: "Monster", year: 2019 },
  { make: "Ducati", model: "Monster", year: 2020 },
  { make: "Ducati", model: "Monster", year: 2021 },
  { make: "Ducati", model: "Monster", year: 2022 },
  { make: "Ducati", model: "Monster", year: 2023 },
  { make: "Ducati", model: "Monster", year: 2024 },
  { make: "Ducati", model: "Monster", year: 2025 },
  { make: "Ducati", model: "Monster", year: 2026 },
  // Ducati - Monster 696
  { make: "Ducati", model: "Monster 696", year: 2008 },
  { make: "Ducati", model: "Monster 696", year: 2009 },
  { make: "Ducati", model: "Monster 696", year: 2010 },
  { make: "Ducati", model: "Monster 696", year: 2011 },
  { make: "Ducati", model: "Monster 696", year: 2012 },
  { make: "Ducati", model: "Monster 696", year: 2013 },
  { make: "Ducati", model: "Monster 696", year: 2014 },
  // Ducati - Monster 696 Type M5 From
  { make: "Ducati", model: "Monster 696 Type M5 From", year: 2008 },
  // Ducati - Monster 796
  { make: "Ducati", model: "Monster 796", year: 2010 },
  { make: "Ducati", model: "Monster 796", year: 2011 },
  { make: "Ducati", model: "Monster 796", year: 2012 },
  { make: "Ducati", model: "Monster 796", year: 2013 },
  { make: "Ducati", model: "Monster 796", year: 2014 },
  // Ducati - Monster 821
  { make: "Ducati", model: "Monster 821", year: 2014 },
  { make: "Ducati", model: "Monster 821", year: 2015 },
  { make: "Ducati", model: "Monster 821", year: 2016 },
  { make: "Ducati", model: "Monster 821", year: 2017 },
  { make: "Ducati", model: "Monster 821", year: 2018 },
  { make: "Ducati", model: "Monster 821", year: 2019 },
  { make: "Ducati", model: "Monster 821", year: 2020 },
  { make: "Ducati", model: "Monster 821", year: 2021 },
  { make: "Ducati", model: "Monster 821", year: 2022 },
  { make: "Ducati", model: "Monster 821", year: 2023 },
  { make: "Ducati", model: "Monster 821", year: 2024 },
  { make: "Ducati", model: "Monster 821", year: 2025 },
  { make: "Ducati", model: "Monster 821", year: 2026 },
  { make: "Ducati", model: "Monster 821", year: 2027 },
  // Ducati - Monster 821 1200
  { make: "Ducati", model: "Monster 821 1200", year: 2014 },
  { make: "Ducati", model: "Monster 821 1200", year: 2015 },
  { make: "Ducati", model: "Monster 821 1200", year: 2016 },
  // Ducati - Monster 821 Stealth
  { make: "Ducati", model: "Monster 821 Stealth", year: 2014 },
  { make: "Ducati", model: "Monster 821 Stealth", year: 2015 },
  { make: "Ducati", model: "Monster 821 Stealth", year: 2016 },
  { make: "Ducati", model: "Monster 821 Stealth", year: 2017 },
  // Ducati - Monster 937
  { make: "Ducati", model: "Monster 937", year: 2021 },
  { make: "Ducati", model: "Monster 937", year: 2022 },
  { make: "Ducati", model: "Monster 937", year: 2023 },
  { make: "Ducati", model: "Monster 937", year: 2024 },
  { make: "Ducati", model: "Monster 937", year: 2025 },
  { make: "Ducati", model: "Monster 937", year: 2026 },
  { make: "Ducati", model: "Monster 937", year: 2027 },
  // Ducati - Monster 937 Desertx Multistrada V2
  { make: "Ducati", model: "Monster 937 Desertx Multistrada V2", year: 2025 },
  { make: "Ducati", model: "Monster 937 Desertx Multistrada V2", year: 2026 },
  { make: "Ducati", model: "Monster 937 Desertx Multistrada V2", year: 2027 },
  // Ducati - Monster 937 Family
  { make: "Ducati", model: "Monster 937 Family", year: 2021 },
  { make: "Ducati", model: "Monster 937 Family", year: 2022 },
  { make: "Ducati", model: "Monster 937 Family", year: 2023 },
  { make: "Ducati", model: "Monster 937 Family", year: 2024 },
  // Ducati - Monster 937 Hypermotard 698 Mono
  { make: "Ducati", model: "Monster 937 Hypermotard 698 Mono", year: 2025 },
  { make: "Ducati", model: "Monster 937 Hypermotard 698 Mono", year: 2026 },
  { make: "Ducati", model: "Monster 937 Hypermotard 698 Mono", year: 2027 },
  // Ducati - Monster 937 Multistrada V2 Hypermotard
  { make: "Ducati", model: "Monster 937 Multistrada V2 Hypermotard", year: 2025 },
  { make: "Ducati", model: "Monster 937 Multistrada V2 Hypermotard", year: 2026 },
  { make: "Ducati", model: "Monster 937 Multistrada V2 Hypermotard", year: 2027 },
  // Ducati - Monster 937 Panigale
  { make: "Ducati", model: "Monster 937 Panigale", year: 2025 },
  { make: "Ducati", model: "Monster 937 Panigale", year: 2026 },
  { make: "Ducati", model: "Monster 937 Panigale", year: 2027 },
  // Ducati - Monster 1100
  { make: "Ducati", model: "Monster 1100", year: 2009 },
  { make: "Ducati", model: "Monster 1100", year: 2010 },
  { make: "Ducati", model: "Monster 1100", year: 2011 },
  { make: "Ducati", model: "Monster 1100", year: 2012 },
  { make: "Ducati", model: "Monster 1100", year: 2013 },
  // Ducati - Monster 1200
  { make: "Ducati", model: "Monster 1200", year: 2014 },
  { make: "Ducati", model: "Monster 1200", year: 2015 },
  { make: "Ducati", model: "Monster 1200", year: 2016 },
  { make: "Ducati", model: "Monster 1200", year: 2017 },
  { make: "Ducati", model: "Monster 1200", year: 2018 },
  { make: "Ducati", model: "Monster 1200", year: 2019 },
  { make: "Ducati", model: "Monster 1200", year: 2020 },
  { make: "Ducati", model: "Monster 1200", year: 2021 },
  { make: "Ducati", model: "Monster 1200", year: 2022 },
  { make: "Ducati", model: "Monster 1200", year: 2023 },
  { make: "Ducati", model: "Monster 1200", year: 2024 },
  { make: "Ducati", model: "Monster 1200", year: 2025 },
  { make: "Ducati", model: "Monster 1200", year: 2026 },
  { make: "Ducati", model: "Monster 1200", year: 2027 },
  // Ducati - Monster 1200 110 Kw Monster
  { make: "Ducati", model: "Monster 1200 110 Kw Monster", year: 2017 },
  // Ducati - Monster 1200 S High
  { make: "Ducati", model: "Monster 1200 S High", year: 2016 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2017 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2018 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2019 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2020 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2021 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2022 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2023 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2024 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2025 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2026 },
  { make: "Ducati", model: "Monster 1200 S High", year: 2027 },
  // Ducati - Monster 1200 S High Double Gp
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2016 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2017 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2018 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2019 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2020 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2021 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2022 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2023 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2024 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2025 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2026 },
  { make: "Ducati", model: "Monster 1200 S High Double Gp", year: 2027 },
  // Ducati - Monster 1200 Stealth
  { make: "Ducati", model: "Monster 1200 Stealth", year: 2014 },
  { make: "Ducati", model: "Monster 1200 Stealth", year: 2015 },
  { make: "Ducati", model: "Monster 1200 Stealth", year: 2016 },
  // Ducati - Monster 1200R
  { make: "Ducati", model: "Monster 1200R", year: 2017 },
  { make: "Ducati", model: "Monster 1200R", year: 2018 },
  { make: "Ducati", model: "Monster 1200R", year: 2019 },
  { make: "Ducati", model: "Monster 1200R", year: 2020 },
  { make: "Ducati", model: "Monster 1200R", year: 2021 },
  { make: "Ducati", model: "Monster 1200R", year: 2022 },
  { make: "Ducati", model: "Monster 1200R", year: 2023 },
  { make: "Ducati", model: "Monster 1200R", year: 2024 },
  { make: "Ducati", model: "Monster 1200R", year: 2025 },
  { make: "Ducati", model: "Monster 1200R", year: 2026 },
  { make: "Ducati", model: "Monster 1200R", year: 2027 },
  // Ducati - Multistrada 950
  { make: "Ducati", model: "Multistrada 950", year: 2019 },
  { make: "Ducati", model: "Multistrada 950", year: 2020 },
  // Ducati - Multistrada 950 80055
  { make: "Ducati", model: "Multistrada 950 80055", year: 2017 },
  { make: "Ducati", model: "Multistrada 950 80055", year: 2018 },
  { make: "Ducati", model: "Multistrada 950 80055", year: 2019 },
  { make: "Ducati", model: "Multistrada 950 80055", year: 2020 },
  { make: "Ducati", model: "Multistrada 950 80055", year: 2021 },
  // Ducati - Multistrada 950/S
  { make: "Ducati", model: "Multistrada 950/S", year: 2017 },
  { make: "Ducati", model: "Multistrada 950/S", year: 2018 },
  { make: "Ducati", model: "Multistrada 950/S", year: 2019 },
  { make: "Ducati", model: "Multistrada 950/S", year: 2020 },
  { make: "Ducati", model: "Multistrada 950/S", year: 2021 },
  // Ducati - Multistrada 1200
  { make: "Ducati", model: "Multistrada 1200", year: 2010 },
  { make: "Ducati", model: "Multistrada 1200", year: 2011 },
  { make: "Ducati", model: "Multistrada 1200", year: 2012 },
  { make: "Ducati", model: "Multistrada 1200", year: 2013 },
  { make: "Ducati", model: "Multistrada 1200", year: 2014 },
  { make: "Ducati", model: "Multistrada 1200", year: 2015 },
  { make: "Ducati", model: "Multistrada 1200", year: 2016 },
  { make: "Ducati", model: "Multistrada 1200", year: 2017 },
  { make: "Ducati", model: "Multistrada 1200", year: 2018 },
  { make: "Ducati", model: "Multistrada 1200", year: 2019 },
  { make: "Ducati", model: "Multistrada 1200", year: 2020 },
  // Ducati - Multistrada 1200 Pikes Peak
  { make: "Ducati", model: "Multistrada 1200 Pikes Peak", year: 2012 },
  { make: "Ducati", model: "Multistrada 1200 Pikes Peak", year: 2013 },
  { make: "Ducati", model: "Multistrada 1200 Pikes Peak", year: 2014 },
  // Ducati - Multistrada 1200 S
  { make: "Ducati", model: "Multistrada 1200 S", year: 2015 },
  { make: "Ducati", model: "Multistrada 1200 S", year: 2016 },
  { make: "Ducati", model: "Multistrada 1200 S", year: 2017 },
  // Ducati - Multistrada 1200 S D-Air
  { make: "Ducati", model: "Multistrada 1200 S D-Air", year: 2015 },
  { make: "Ducati", model: "Multistrada 1200 S D-Air", year: 2016 },
  { make: "Ducati", model: "Multistrada 1200 S D-Air", year: 2017 },
  // Ducati - Multistrada 1200 S DVT
  { make: "Ducati", model: "Multistrada 1200 S DVT", year: 2015 },
  { make: "Ducati", model: "Multistrada 1200 S DVT", year: 2016 },
  { make: "Ducati", model: "Multistrada 1200 S DVT", year: 2017 },
  // Ducati - Multistrada 1200S
  { make: "Ducati", model: "Multistrada 1200S", year: 2015 },
  { make: "Ducati", model: "Multistrada 1200S", year: 2016 },
  { make: "Ducati", model: "Multistrada 1200S", year: 2017 },
  { make: "Ducati", model: "Multistrada 1200S", year: 2018 },
  { make: "Ducati", model: "Multistrada 1200S", year: 2019 },
  { make: "Ducati", model: "Multistrada 1200S", year: 2020 },
  // Ducati - Multistrada 1260
  { make: "Ducati", model: "Multistrada 1260", year: 2015 },
  { make: "Ducati", model: "Multistrada 1260", year: 2016 },
  { make: "Ducati", model: "Multistrada 1260", year: 2017 },
  { make: "Ducati", model: "Multistrada 1260", year: 2018 },
  { make: "Ducati", model: "Multistrada 1260", year: 2019 },
  { make: "Ducati", model: "Multistrada 1260", year: 2020 },
  // Ducati - Multistrada 1260S
  { make: "Ducati", model: "Multistrada 1260S", year: 2015 },
  { make: "Ducati", model: "Multistrada 1260S", year: 2016 },
  { make: "Ducati", model: "Multistrada 1260S", year: 2017 },
  { make: "Ducati", model: "Multistrada 1260S", year: 2018 },
  { make: "Ducati", model: "Multistrada 1260S", year: 2019 },
  { make: "Ducati", model: "Multistrada 1260S", year: 2020 },
  // Ducati - Multistrada V4
  { make: "Ducati", model: "Multistrada V4", year: 2020 },
  { make: "Ducati", model: "Multistrada V4", year: 2021 },
  { make: "Ducati", model: "Multistrada V4", year: 2022 },
  { make: "Ducati", model: "Multistrada V4", year: 2023 },
  { make: "Ducati", model: "Multistrada V4", year: 2024 },
  { make: "Ducati", model: "Multistrada V4", year: 2025 },
  { make: "Ducati", model: "Multistrada V4", year: 2026 },
  // Ducati - Multistrada V4 1100
  { make: "Ducati", model: "Multistrada V4 1100", year: 2021 },
  { make: "Ducati", model: "Multistrada V4 1100", year: 2022 },
  { make: "Ducati", model: "Multistrada V4 1100", year: 2023 },
  { make: "Ducati", model: "Multistrada V4 1100", year: 2024 },
  // Ducati - Multistrada V4 80069
  { make: "Ducati", model: "Multistrada V4 80069", year: 2021 },
  { make: "Ducati", model: "Multistrada V4 80069", year: 2022 },
  { make: "Ducati", model: "Multistrada V4 80069", year: 2023 },
  { make: "Ducati", model: "Multistrada V4 80069", year: 2024 },
  { make: "Ducati", model: "Multistrada V4 80069", year: 2025 },
  { make: "Ducati", model: "Multistrada V4 80069", year: 2026 },
  // Ducati - Panigale 899
  { make: "Ducati", model: "Panigale 899", year: 2013 },
  { make: "Ducati", model: "Panigale 899", year: 2014 },
  { make: "Ducati", model: "Panigale 899", year: 2015 },
  // Ducati - Panigale 959
  { make: "Ducati", model: "Panigale 959", year: 2016 },
  { make: "Ducati", model: "Panigale 959", year: 2017 },
  { make: "Ducati", model: "Panigale 959", year: 2018 },
  { make: "Ducati", model: "Panigale 959", year: 2019 },
  // Ducati - Panigale 1199
  { make: "Ducati", model: "Panigale 1199", year: 2011 },
  { make: "Ducati", model: "Panigale 1199", year: 2012 },
  { make: "Ducati", model: "Panigale 1199", year: 2013 },
  { make: "Ducati", model: "Panigale 1199", year: 2014 },
  // Ducati - Panigale 1299
  { make: "Ducati", model: "Panigale 1299", year: 2015 },
  { make: "Ducati", model: "Panigale 1299", year: 2016 },
  { make: "Ducati", model: "Panigale 1299", year: 2017 },
  { make: "Ducati", model: "Panigale 1299", year: 2018 },
  { make: "Ducati", model: "Panigale 1299", year: 2019 },
  // Ducati - Panigale V2
  { make: "Ducati", model: "Panigale V2", year: 2020 },
  { make: "Ducati", model: "Panigale V2", year: 2021 },
  { make: "Ducati", model: "Panigale V2", year: 2022 },
  { make: "Ducati", model: "Panigale V2", year: 2023 },
  { make: "Ducati", model: "Panigale V2", year: 2024 },
  { make: "Ducati", model: "Panigale V2", year: 2025 },
  { make: "Ducati", model: "Panigale V2", year: 2026 },
  { make: "Ducati", model: "Panigale V2", year: 2027 },
  // Ducati - Panigale V2 S Streetfighter V2
  { make: "Ducati", model: "Panigale V2 S Streetfighter V2", year: 2020 },
  { make: "Ducati", model: "Panigale V2 S Streetfighter V2", year: 2021 },
  { make: "Ducati", model: "Panigale V2 S Streetfighter V2", year: 2022 },
  { make: "Ducati", model: "Panigale V2 S Streetfighter V2", year: 2023 },
  { make: "Ducati", model: "Panigale V2 S Streetfighter V2", year: 2024 },
  // Ducati - Panigale V4
  { make: "Ducati", model: "Panigale V4", year: 2018 },
  { make: "Ducati", model: "Panigale V4", year: 2019 },
  { make: "Ducati", model: "Panigale V4", year: 2020 },
  { make: "Ducati", model: "Panigale V4", year: 2021 },
  { make: "Ducati", model: "Panigale V4", year: 2022 },
  { make: "Ducati", model: "Panigale V4", year: 2023 },
  { make: "Ducati", model: "Panigale V4", year: 2024 },
  { make: "Ducati", model: "Panigale V4", year: 2025 },
  { make: "Ducati", model: "Panigale V4", year: 2026 },
  { make: "Ducati", model: "Panigale V4", year: 2027 },
  // Ducati - Panigale V4 Clip Ons Unlifted Tangent 53MM
  { make: "Ducati", model: "Panigale V4 Clip Ons Unlifted Tangent 53MM", year: 2024 },
  { make: "Ducati", model: "Panigale V4 Clip Ons Unlifted Tangent 53MM", year: 2025 },
  { make: "Ducati", model: "Panigale V4 Clip Ons Unlifted Tangent 53MM", year: 2026 },
  { make: "Ducati", model: "Panigale V4 Clip Ons Unlifted Tangent 53MM", year: 2027 },
  // Ducati - Panigale V4 R
  { make: "Ducati", model: "Panigale V4 R", year: 2019 },
  // Ducati - Panigale V4 S Double Dyno
  { make: "Ducati", model: "Panigale V4 S Double Dyno", year: 2025 },
  { make: "Ducati", model: "Panigale V4 S Double Dyno", year: 2026 },
  { make: "Ducati", model: "Panigale V4 S Double Dyno", year: 2027 },
  // Ducati - Panigale V4 S Gold
  { make: "Ducati", model: "Panigale V4 S Gold", year: 2025 },
  { make: "Ducati", model: "Panigale V4 S Gold", year: 2026 },
  { make: "Ducati", model: "Panigale V4 S Gold", year: 2027 },
  // Ducati - Panigale V4 S Red
  { make: "Ducati", model: "Panigale V4 S Red", year: 2024 },
  { make: "Ducati", model: "Panigale V4 S Red", year: 2025 },
  { make: "Ducati", model: "Panigale V4 S Red", year: 2026 },
  { make: "Ducati", model: "Panigale V4 S Red", year: 2027 },
  // Ducati - Panigale V4 S Streetfighter
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2018 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2019 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2020 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2021 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2022 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2023 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter", year: 2024 },
  // Ducati - Panigale V4 S Streetfighter Double
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2018 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2019 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2020 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2021 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2022 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2023 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter Double", year: 2024 },
  // Ducati - Panigale V4 S Streetfighter V4
  { make: "Ducati", model: "Panigale V4 S Streetfighter V4", year: 2025 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter V4", year: 2026 },
  { make: "Ducati", model: "Panigale V4 S Streetfighter V4", year: 2027 },
  // Ducati - Panigale V4 Streetfighter V4S
  { make: "Ducati", model: "Panigale V4 Streetfighter V4S", year: 2025 },
  { make: "Ducati", model: "Panigale V4 Streetfighter V4S", year: 2026 },
  // Ducati - Scrambler
  { make: "Ducati", model: "Scrambler", year: 2015 },
  { make: "Ducati", model: "Scrambler", year: 2016 },
  { make: "Ducati", model: "Scrambler", year: 2017 },
  { make: "Ducati", model: "Scrambler", year: 2018 },
  { make: "Ducati", model: "Scrambler", year: 2019 },
  { make: "Ducati", model: "Scrambler", year: 2020 },
  { make: "Ducati", model: "Scrambler", year: 2021 },
  { make: "Ducati", model: "Scrambler", year: 2022 },
  { make: "Ducati", model: "Scrambler", year: 2023 },
  { make: "Ducati", model: "Scrambler", year: 2024 },
  { make: "Ducati", model: "Scrambler", year: 2025 },
  { make: "Ducati", model: "Scrambler", year: 2026 },
  { make: "Ducati", model: "Scrambler", year: 2027 },
  // Ducati - Scrambler 800
  { make: "Ducati", model: "Scrambler 800", year: 2017 },
  { make: "Ducati", model: "Scrambler 800", year: 2018 },
  { make: "Ducati", model: "Scrambler 800", year: 2019 },
  { make: "Ducati", model: "Scrambler 800", year: 2020 },
  { make: "Ducati", model: "Scrambler 800", year: 2021 },
  { make: "Ducati", model: "Scrambler 800", year: 2022 },
  { make: "Ducati", model: "Scrambler 800", year: 2023 },
  { make: "Ducati", model: "Scrambler 800", year: 2024 },
  { make: "Ducati", model: "Scrambler 800", year: 2025 },
  { make: "Ducati", model: "Scrambler 800", year: 2026 },
  { make: "Ducati", model: "Scrambler 800", year: 2027 },
  // Ducati - Scrambler 800 14399
  { make: "Ducati", model: "Scrambler 800 14399", year: 2023 },
  { make: "Ducati", model: "Scrambler 800 14399", year: 2024 },
  // Ducati - Scrambler 800 Desert Sled
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2017 },
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2018 },
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2019 },
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2020 },
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2021 },
  { make: "Ducati", model: "Scrambler 800 Desert Sled", year: 2022 },
  // Ducati - Scrambler 803
  { make: "Ducati", model: "Scrambler 803", year: 2023 },
  { make: "Ducati", model: "Scrambler 803", year: 2024 },
  // Ducati - Scrambler 1100
  { make: "Ducati", model: "Scrambler 1100", year: 2018 },
  { make: "Ducati", model: "Scrambler 1100", year: 2019 },
  { make: "Ducati", model: "Scrambler 1100", year: 2020 },
  { make: "Ducati", model: "Scrambler 1100", year: 2021 },
  { make: "Ducati", model: "Scrambler 1100", year: 2022 },
  { make: "Ducati", model: "Scrambler 1100", year: 2023 },
  { make: "Ducati", model: "Scrambler 1100", year: 2024 },
  { make: "Ducati", model: "Scrambler 1100", year: 2025 },
  { make: "Ducati", model: "Scrambler 1100", year: 2026 },
  { make: "Ducati", model: "Scrambler 1100", year: 2027 },
  // Ducati - Scrambler Full Throttle
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2015 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2016 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2017 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2018 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2019 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2020 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2021 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2022 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2023 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2024 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2025 },
  { make: "Ducati", model: "Scrambler Full Throttle", year: 2026 },
  // Ducati - Scrambler Icon
  { make: "Ducati", model: "Scrambler Icon", year: 2015 },
  { make: "Ducati", model: "Scrambler Icon", year: 2016 },
  { make: "Ducati", model: "Scrambler Icon", year: 2017 },
  { make: "Ducati", model: "Scrambler Icon", year: 2018 },
  { make: "Ducati", model: "Scrambler Icon", year: 2019 },
  { make: "Ducati", model: "Scrambler Icon", year: 2020 },
  { make: "Ducati", model: "Scrambler Icon", year: 2021 },
  { make: "Ducati", model: "Scrambler Icon", year: 2022 },
  { make: "Ducati", model: "Scrambler Icon", year: 2023 },
  { make: "Ducati", model: "Scrambler Icon", year: 2024 },
  { make: "Ducati", model: "Scrambler Icon", year: 2025 },
  { make: "Ducati", model: "Scrambler Icon", year: 2026 },
  // Ducati - Scrambler Next Gen 800
  { make: "Ducati", model: "Scrambler Next Gen 800", year: 2023 },
  { make: "Ducati", model: "Scrambler Next Gen 800", year: 2024 },
  { make: "Ducati", model: "Scrambler Next Gen 800", year: 2025 },
  { make: "Ducati", model: "Scrambler Next Gen 800", year: 2026 },
  { make: "Ducati", model: "Scrambler Next Gen 800", year: 2027 },
  // Ducati - Scrambler Sixty2
  { make: "Ducati", model: "Scrambler Sixty2", year: 2015 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2016 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2017 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2018 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2019 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2020 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2021 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2022 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2023 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2024 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2025 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2026 },
  { make: "Ducati", model: "Scrambler Sixty2", year: 2027 },
  // Ducati - Streetfighter V2
  { make: "Ducati", model: "Streetfighter V2", year: 2022 },
  { make: "Ducati", model: "Streetfighter V2", year: 2023 },
  { make: "Ducati", model: "Streetfighter V2", year: 2024 },
  { make: "Ducati", model: "Streetfighter V2", year: 2025 },
  { make: "Ducati", model: "Streetfighter V2", year: 2026 },
  { make: "Ducati", model: "Streetfighter V2", year: 2027 },
  // Ducati - Streetfighter V4
  { make: "Ducati", model: "Streetfighter V4", year: 2020 },
  { make: "Ducati", model: "Streetfighter V4", year: 2021 },
  { make: "Ducati", model: "Streetfighter V4", year: 2022 },
  { make: "Ducati", model: "Streetfighter V4", year: 2023 },
  { make: "Ducati", model: "Streetfighter V4", year: 2024 },
  { make: "Ducati", model: "Streetfighter V4", year: 2025 },
  { make: "Ducati", model: "Streetfighter V4", year: 2026 },
  { make: "Ducati", model: "Streetfighter V4", year: 2027 },
  // Ducati - Supersport 939
  { make: "Ducati", model: "Supersport 939", year: 2017 },
  { make: "Ducati", model: "Supersport 939", year: 2018 },
  { make: "Ducati", model: "Supersport 939", year: 2019 },
  { make: "Ducati", model: "Supersport 939", year: 2020 },
  { make: "Ducati", model: "Supersport 939", year: 2021 },
  { make: "Ducati", model: "Supersport 939", year: 2022 },
  { make: "Ducati", model: "Supersport 939", year: 2023 },
  { make: "Ducati", model: "Supersport 939", year: 2024 },
  { make: "Ducati", model: "Supersport 939", year: 2025 },
  { make: "Ducati", model: "Supersport 939", year: 2026 },
  { make: "Ducati", model: "Supersport 939", year: 2027 },
  // Ducati - Supersport 950
  { make: "Ducati", model: "Supersport 950", year: 2021 },
  { make: "Ducati", model: "Supersport 950", year: 2022 },
  { make: "Ducati", model: "Supersport 950", year: 2023 },
  { make: "Ducati", model: "Supersport 950", year: 2024 },
  { make: "Ducati", model: "Supersport 950", year: 2025 },
  { make: "Ducati", model: "Supersport 950", year: 2026 },
  { make: "Ducati", model: "Supersport 950", year: 2027 },
  // Ducati - V2
  { make: "Ducati", model: "V2", year: 2025 },
  { make: "Ducati", model: "V2", year: 2026 },
  // Ducati - Xdiavel Side Mount License Plate 2
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2016 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2017 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2018 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2019 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2020 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2021 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2022 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2023 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2024 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2025 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2026 },
  { make: "Ducati", model: "Xdiavel Side Mount License Plate 2", year: 2027 },
  // Ducati - Xdiavel V4
  { make: "Ducati", model: "Xdiavel V4", year: 2025 },
  { make: "Ducati", model: "Xdiavel V4", year: 2026 },
  { make: "Ducati", model: "Xdiavel V4", year: 2027 },
  // Ducati - Xdiavel V4 Side Mount License
  { make: "Ducati", model: "Xdiavel V4 Side Mount License", year: 2025 },
  { make: "Ducati", model: "Xdiavel V4 Side Mount License", year: 2026 },
  { make: "Ducati", model: "Xdiavel V4 Side Mount License", year: 2027 },
  // GasGas
  // GasGas - 200
  { make: "GasGas", model: "200", year: 2003 },
  { make: "GasGas", model: "200", year: 2004 },
  { make: "GasGas", model: "200", year: 2005 },
  // GasGas - 250
  { make: "GasGas", model: "250", year: 2003 },
  { make: "GasGas", model: "250", year: 2004 },
  { make: "GasGas", model: "250", year: 2005 },
  { make: "GasGas", model: "250", year: 2006 },
  { make: "GasGas", model: "250", year: 2007 },
  { make: "GasGas", model: "250", year: 2008 },
  { make: "GasGas", model: "250", year: 2009 },
  { make: "GasGas", model: "250", year: 2010 },
  { make: "GasGas", model: "250", year: 2011 },
  { make: "GasGas", model: "250", year: 2018 },
  { make: "GasGas", model: "250", year: 2019 },
  // GasGas - 250 500 Enduro
  { make: "GasGas", model: "250 500 Enduro", year: 2020 },
  { make: "GasGas", model: "250 500 Enduro", year: 2021 },
  { make: "GasGas", model: "250 500 Enduro", year: 2022 },
  { make: "GasGas", model: "250 500 Enduro", year: 2023 },
  // GasGas - 300
  { make: "GasGas", model: "300", year: 2003 },
  { make: "GasGas", model: "300", year: 2004 },
  { make: "GasGas", model: "300", year: 2005 },
  { make: "GasGas", model: "300", year: 2006 },
  { make: "GasGas", model: "300", year: 2007 },
  { make: "GasGas", model: "300", year: 2008 },
  { make: "GasGas", model: "300", year: 2009 },
  { make: "GasGas", model: "300", year: 2010 },
  { make: "GasGas", model: "300", year: 2011 },
  { make: "GasGas", model: "300", year: 2018 },
  { make: "GasGas", model: "300", year: 2019 },
  // GasGas - 700
  { make: "GasGas", model: "700", year: 2019 },
  { make: "GasGas", model: "700", year: 2020 },
  { make: "GasGas", model: "700", year: 2021 },
  { make: "GasGas", model: "700", year: 2022 },
  { make: "GasGas", model: "700", year: 2023 },
  { make: "GasGas", model: "700", year: 2024 },
  // GasGas - EC-250
  { make: "GasGas", model: "EC-250", year: 2021 },
  { make: "GasGas", model: "EC-250", year: 2022 },
  { make: "GasGas", model: "EC-250", year: 2023 },
  // GasGas - EC-250F
  { make: "GasGas", model: "EC-250F", year: 2021 },
  // GasGas - EC-300
  { make: "GasGas", model: "EC-300", year: 2021 },
  { make: "GasGas", model: "EC-300", year: 2022 },
  { make: "GasGas", model: "EC-300", year: 2023 },
  // GasGas - EC350F
  { make: "GasGas", model: "EC350F", year: 2021 },
  // GasGas - ES-700
  { make: "GasGas", model: "ES-700", year: 2023 },
  { make: "GasGas", model: "ES-700", year: 2024 },
  // GasGas - EX-250
  { make: "GasGas", model: "EX-250", year: 2022 },
  // GasGas - EX-250F
  { make: "GasGas", model: "EX-250F", year: 2021 },
  { make: "GasGas", model: "EX-250F", year: 2022 },
  { make: "GasGas", model: "EX-250F", year: 2023 },
  // GasGas - EX-300
  { make: "GasGas", model: "EX-300", year: 2021 },
  { make: "GasGas", model: "EX-300", year: 2022 },
  // GasGas - EX-350F
  { make: "GasGas", model: "EX-350F", year: 2021 },
  { make: "GasGas", model: "EX-350F", year: 2022 },
  { make: "GasGas", model: "EX-350F", year: 2023 },
  // GasGas - EX-450F
  { make: "GasGas", model: "EX-450F", year: 2021 },
  { make: "GasGas", model: "EX-450F", year: 2022 },
  { make: "GasGas", model: "EX-450F", year: 2023 },
  // GasGas - EX250
  { make: "GasGas", model: "EX250", year: 2022 },
  // GasGas - EX300
  { make: "GasGas", model: "EX300", year: 2021 },
  { make: "GasGas", model: "EX300", year: 2022 },
  // GasGas - MC-85
  { make: "GasGas", model: "MC-85", year: 2021 },
  { make: "GasGas", model: "MC-85", year: 2022 },
  { make: "GasGas", model: "MC-85", year: 2023 },
  { make: "GasGas", model: "MC-85", year: 2024 },
  // GasGas - MC-105
  { make: "GasGas", model: "MC-105", year: 2021 },
  { make: "GasGas", model: "MC-105", year: 2022 },
  { make: "GasGas", model: "MC-105", year: 2023 },
  { make: "GasGas", model: "MC-105", year: 2024 },
  // GasGas - MC-125
  { make: "GasGas", model: "MC-125", year: 2021 },
  { make: "GasGas", model: "MC-125", year: 2022 },
  { make: "GasGas", model: "MC-125", year: 2023 },
  // GasGas - MC-250
  { make: "GasGas", model: "MC-250", year: 2022 },
  { make: "GasGas", model: "MC-250", year: 2023 },
  // GasGas - MC-250F
  { make: "GasGas", model: "MC-250F", year: 2021 },
  { make: "GasGas", model: "MC-250F", year: 2022 },
  { make: "GasGas", model: "MC-250F", year: 2023 },
  // GasGas - MC-350F
  { make: "GasGas", model: "MC-350F", year: 2021 },
  { make: "GasGas", model: "MC-350F", year: 2022 },
  { make: "GasGas", model: "MC-350F", year: 2023 },
  // GasGas - MC-450F
  { make: "GasGas", model: "MC-450F", year: 2021 },
  { make: "GasGas", model: "MC-450F", year: 2022 },
  { make: "GasGas", model: "MC-450F", year: 2023 },
  // GasGas - MC50
  { make: "GasGas", model: "MC50", year: 2021 },
  { make: "GasGas", model: "MC50", year: 2022 },
  { make: "GasGas", model: "MC50", year: 2023 },
  // GasGas - MC65
  { make: "GasGas", model: "MC65", year: 2021 },
  { make: "GasGas", model: "MC65", year: 2022 },
  { make: "GasGas", model: "MC65", year: 2023 },
  // GasGas - MC85
  { make: "GasGas", model: "MC85", year: 2021 },
  { make: "GasGas", model: "MC85", year: 2022 },
  { make: "GasGas", model: "MC85", year: 2023 },
  // GasGas - MC125
  { make: "GasGas", model: "MC125", year: 2021 },
  { make: "GasGas", model: "MC125", year: 2022 },
  { make: "GasGas", model: "MC125", year: 2023 },
  // GASGAS
  // GASGAS - EC 200
  { make: "GASGAS", model: "EC 200", year: 2003 },
  { make: "GASGAS", model: "EC 200", year: 2004 },
  { make: "GASGAS", model: "EC 200", year: 2005 },
  { make: "GASGAS", model: "EC 200", year: 2006 },
  // GASGAS - EC 250
  { make: "GASGAS", model: "EC 250", year: 2003 },
  { make: "GASGAS", model: "EC 250", year: 2004 },
  { make: "GASGAS", model: "EC 250", year: 2005 },
  { make: "GASGAS", model: "EC 250", year: 2006 },
  { make: "GASGAS", model: "EC 250", year: 2007 },
  { make: "GASGAS", model: "EC 250", year: 2008 },
  { make: "GASGAS", model: "EC 250", year: 2009 },
  { make: "GASGAS", model: "EC 250", year: 2010 },
  { make: "GASGAS", model: "EC 250", year: 2011 },
  { make: "GASGAS", model: "EC 250", year: 2018 },
  { make: "GASGAS", model: "EC 250", year: 2021 },
  { make: "GASGAS", model: "EC 250", year: 2022 },
  { make: "GASGAS", model: "EC 250", year: 2023 },
  { make: "GASGAS", model: "EC 250", year: 2024 },
  { make: "GASGAS", model: "EC 250", year: 2025 },
  { make: "GASGAS", model: "EC 250", year: 2026 },
  // GASGAS - EC 300
  { make: "GASGAS", model: "EC 300", year: 2003 },
  { make: "GASGAS", model: "EC 300", year: 2004 },
  { make: "GASGAS", model: "EC 300", year: 2005 },
  { make: "GASGAS", model: "EC 300", year: 2006 },
  { make: "GASGAS", model: "EC 300", year: 2007 },
  { make: "GASGAS", model: "EC 300", year: 2008 },
  { make: "GASGAS", model: "EC 300", year: 2009 },
  { make: "GASGAS", model: "EC 300", year: 2010 },
  { make: "GASGAS", model: "EC 300", year: 2011 },
  { make: "GASGAS", model: "EC 300", year: 2018 },
  { make: "GASGAS", model: "EC 300", year: 2021 },
  { make: "GASGAS", model: "EC 300", year: 2022 },
  { make: "GASGAS", model: "EC 300", year: 2023 },
  { make: "GASGAS", model: "EC 300", year: 2024 },
  { make: "GASGAS", model: "EC 300", year: 2025 },
  { make: "GASGAS", model: "EC 300", year: 2026 },
  // GASGAS - ES 700
  { make: "GASGAS", model: "ES 700", year: 2023 },
  { make: "GASGAS", model: "ES 700", year: 2024 },
  { make: "GASGAS", model: "ES 700", year: 2025 },
  { make: "GASGAS", model: "ES 700", year: 2026 },
  // GASGAS - EX 250F
  { make: "GASGAS", model: "EX 250F", year: 2021 },
  { make: "GASGAS", model: "EX 250F", year: 2022 },
  { make: "GASGAS", model: "EX 250F", year: 2023 },
  { make: "GASGAS", model: "EX 250F", year: 2024 },
  { make: "GASGAS", model: "EX 250F", year: 2025 },
  { make: "GASGAS", model: "EX 250F", year: 2026 },
  // GASGAS - EX 300
  { make: "GASGAS", model: "EX 300", year: 2021 },
  { make: "GASGAS", model: "EX 300", year: 2022 },
  { make: "GASGAS", model: "EX 300", year: 2023 },
  { make: "GASGAS", model: "EX 300", year: 2024 },
  { make: "GASGAS", model: "EX 300", year: 2025 },
  { make: "GASGAS", model: "EX 300", year: 2026 },
  // GASGAS - EX 350F
  { make: "GASGAS", model: "EX 350F", year: 2021 },
  { make: "GASGAS", model: "EX 350F", year: 2022 },
  { make: "GASGAS", model: "EX 350F", year: 2023 },
  { make: "GASGAS", model: "EX 350F", year: 2024 },
  { make: "GASGAS", model: "EX 350F", year: 2025 },
  { make: "GASGAS", model: "EX 350F", year: 2026 },
  // GASGAS - EX 450F
  { make: "GASGAS", model: "EX 450F", year: 2021 },
  { make: "GASGAS", model: "EX 450F", year: 2022 },
  { make: "GASGAS", model: "EX 450F", year: 2023 },
  { make: "GASGAS", model: "EX 450F", year: 2024 },
  { make: "GASGAS", model: "EX 450F", year: 2025 },
  { make: "GASGAS", model: "EX 450F", year: 2026 },
  // GASGAS - MC 50
  { make: "GASGAS", model: "MC 50", year: 2021 },
  { make: "GASGAS", model: "MC 50", year: 2022 },
  { make: "GASGAS", model: "MC 50", year: 2023 },
  // GASGAS - MC 65
  { make: "GASGAS", model: "MC 65", year: 2021 },
  { make: "GASGAS", model: "MC 65", year: 2022 },
  { make: "GASGAS", model: "MC 65", year: 2023 },
  { make: "GASGAS", model: "MC 65", year: 2024 },
  { make: "GASGAS", model: "MC 65", year: 2025 },
  { make: "GASGAS", model: "MC 65", year: 2026 },
  // GASGAS - MC 85
  { make: "GASGAS", model: "MC 85", year: 2021 },
  { make: "GASGAS", model: "MC 85", year: 2022 },
  { make: "GASGAS", model: "MC 85", year: 2023 },
  { make: "GASGAS", model: "MC 85", year: 2024 },
  { make: "GASGAS", model: "MC 85", year: 2025 },
  { make: "GASGAS", model: "MC 85", year: 2026 },
  // GASGAS - MC 125
  { make: "GASGAS", model: "MC 125", year: 2021 },
  { make: "GASGAS", model: "MC 125", year: 2022 },
  { make: "GASGAS", model: "MC 125", year: 2023 },
  { make: "GASGAS", model: "MC 125", year: 2024 },
  { make: "GASGAS", model: "MC 125", year: 2025 },
  { make: "GASGAS", model: "MC 125", year: 2026 },
  // GASGAS - MC 250
  { make: "GASGAS", model: "MC 250", year: 2022 },
  { make: "GASGAS", model: "MC 250", year: 2023 },
  { make: "GASGAS", model: "MC 250", year: 2024 },
  { make: "GASGAS", model: "MC 250", year: 2025 },
  { make: "GASGAS", model: "MC 250", year: 2026 },
  // GASGAS - MC 250F
  { make: "GASGAS", model: "MC 250F", year: 2021 },
  { make: "GASGAS", model: "MC 250F", year: 2022 },
  { make: "GASGAS", model: "MC 250F", year: 2023 },
  { make: "GASGAS", model: "MC 250F", year: 2024 },
  { make: "GASGAS", model: "MC 250F", year: 2025 },
  { make: "GASGAS", model: "MC 250F", year: 2026 },
  // GASGAS - MC 350F
  { make: "GASGAS", model: "MC 350F", year: 2022 },
  { make: "GASGAS", model: "MC 350F", year: 2023 },
  { make: "GASGAS", model: "MC 350F", year: 2024 },
  { make: "GASGAS", model: "MC 350F", year: 2025 },
  { make: "GASGAS", model: "MC 350F", year: 2026 },
  // GASGAS - MC 450F
  { make: "GASGAS", model: "MC 450F", year: 2021 },
  { make: "GASGAS", model: "MC 450F", year: 2022 },
  { make: "GASGAS", model: "MC 450F", year: 2023 },
  { make: "GASGAS", model: "MC 450F", year: 2024 },
  { make: "GASGAS", model: "MC 450F", year: 2025 },
  { make: "GASGAS", model: "MC 450F", year: 2026 },
  // GASGAS - XC 250
  { make: "GASGAS", model: "XC 250", year: 2018 },
  { make: "GASGAS", model: "XC 250", year: 2019 },
  // GASGAS - XC 300
  { make: "GASGAS", model: "XC 300", year: 2018 },
  { make: "GASGAS", model: "XC 300", year: 2019 },
  { make: "GASGAS", model: "XC 300", year: 2020 },
  { make: "GASGAS", model: "XC 300", year: 2021 },
  // Harley-Davidson
  // Harley-Davidson - Breakout
  { make: "Harley-Davidson", model: "Breakout", year: 2013 },
  { make: "Harley-Davidson", model: "Breakout", year: 2014 },
  { make: "Harley-Davidson", model: "Breakout", year: 2015 },
  { make: "Harley-Davidson", model: "Breakout", year: 2016 },
  { make: "Harley-Davidson", model: "Breakout", year: 2017 },
  { make: "Harley-Davidson", model: "Breakout", year: 2018 },
  { make: "Harley-Davidson", model: "Breakout", year: 2019 },
  { make: "Harley-Davidson", model: "Breakout", year: 2020 },
  // Harley-Davidson - Fat Bob
  { make: "Harley-Davidson", model: "Fat Bob", year: 2018 },
  { make: "Harley-Davidson", model: "Fat Bob", year: 2019 },
  { make: "Harley-Davidson", model: "Fat Bob", year: 2021 },
  { make: "Harley-Davidson", model: "Fat Bob", year: 2022 },
  // Harley-Davidson - Fat Boy
  { make: "Harley-Davidson", model: "Fat Boy", year: 2018 },
  { make: "Harley-Davidson", model: "Fat Boy", year: 2019 },
  // Harley-Davidson - Fat Boy Flstf 6000
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2000 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2001 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2002 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2003 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2004 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2005 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6000", year: 2006 },
  // Harley-Davidson - Fat Boy Flstf 6001
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2007 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2008 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2009 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2010 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2011 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2012 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2013 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2014 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2015 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2016 },
  { make: "Harley-Davidson", model: "Fat Boy Flstf 6001", year: 2017 },
  // Harley-Davidson - FLFBS Fat Boy 114
  { make: "Harley-Davidson", model: "FLFBS Fat Boy 114", year: 2022 },
  // Harley-Davidson - FLHCS Heritage Classic 114
  { make: "Harley-Davidson", model: "FLHCS Heritage Classic 114", year: 2022 },
  // Harley-Davidson - FLHR Road King
  { make: "Harley-Davidson", model: "FLHR Road King", year: 1995 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 1996 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 1997 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 1998 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 1999 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2000 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2001 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2002 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2003 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2004 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2005 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2006 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2007 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2008 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2009 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2010 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2011 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2012 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2013 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2014 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2015 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2016 },
  { make: "Harley-Davidson", model: "FLHR Road King", year: 2022 },
  // Harley-Davidson - FLHRXS Road King Special
  { make: "Harley-Davidson", model: "FLHRXS Road King Special", year: 2022 },
  // Harley-Davidson - FLHTK Ultra Limited
  { make: "Harley-Davidson", model: "FLHTK Ultra Limited", year: 2022 },
  { make: "Harley-Davidson", model: "FLHTK Ultra Limited", year: 2023 },
  // Harley-Davidson - FLHX Street Glide
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 1995 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 1996 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 1997 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 1998 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 1999 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2000 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2001 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2002 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2003 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2004 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2005 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2006 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2007 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2008 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2009 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2010 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2011 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2012 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2013 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2014 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2015 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2016 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2022 },
  { make: "Harley-Davidson", model: "FLHX Street Glide", year: 2023 },
  // Harley-Davidson - FLHXS Street Glide Special
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 1995 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 1996 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 1997 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 1998 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 1999 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2000 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2001 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2002 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2003 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2004 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2005 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2006 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2007 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2008 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2009 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2010 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2011 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2012 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2013 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2014 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2015 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2016 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2022 },
  { make: "Harley-Davidson", model: "FLHXS Street Glide Special", year: 2023 },
  // Harley-Davidson - FLHXSE CVO Street Glide
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 1995 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 1996 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 1997 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 1998 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 1999 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2000 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2001 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2002 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2003 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2004 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2005 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2006 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2007 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2008 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2009 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2010 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2011 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2012 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2013 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2014 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2015 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2016 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2022 },
  { make: "Harley-Davidson", model: "FLHXSE CVO Street Glide", year: 2023 },
  // Harley-Davidson - FLHXST Street Glide ST
  { make: "Harley-Davidson", model: "FLHXST Street Glide ST", year: 2022 },
  // Harley-Davidson - FLRT Freewheeler
  { make: "Harley-Davidson", model: "FLRT Freewheeler", year: 2015 },
  { make: "Harley-Davidson", model: "FLRT Freewheeler", year: 2016 },
  { make: "Harley-Davidson", model: "FLRT Freewheeler", year: 2022 },
  // Harley-Davidson - FLTRK Road Glide Limited
  { make: "Harley-Davidson", model: "FLTRK Road Glide Limited", year: 2022 },
  { make: "Harley-Davidson", model: "FLTRK Road Glide Limited", year: 2023 },
  // Harley-Davidson - FLTRKSE CVO Road Glide Limited
  { make: "Harley-Davidson", model: "FLTRKSE CVO Road Glide Limited", year: 2022 },
  // Harley-Davidson - FLTRX Road Glide
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 1995 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 1996 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 1997 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 1998 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 1999 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2000 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2001 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2002 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2003 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2004 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2005 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2006 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2007 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2008 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2009 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2010 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2011 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2012 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2013 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2014 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2015 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2016 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2022 },
  { make: "Harley-Davidson", model: "FLTRX Road Glide", year: 2023 },
  // Harley-Davidson - FLTRXS Road Glide Special
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 1995 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 1996 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 1997 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 1998 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 1999 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2000 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2001 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2002 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2003 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2004 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2005 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2006 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2007 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2008 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2009 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2010 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2011 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2012 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2013 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2014 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2015 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2016 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2022 },
  { make: "Harley-Davidson", model: "FLTRXS Road Glide Special", year: 2023 },
  // Harley-Davidson - FLTRXSE CVO Road Glide
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 1995 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 1996 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 1997 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 1998 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 1999 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2000 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2001 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2002 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2003 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2004 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2005 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2006 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2007 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2008 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2009 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2010 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2011 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2012 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2013 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2014 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2015 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2016 },
  { make: "Harley-Davidson", model: "FLTRXSE CVO Road Glide", year: 2022 },
  // Harley-Davidson - FLTRXST Road Glide ST
  { make: "Harley-Davidson", model: "FLTRXST Road Glide ST", year: 2022 },
  // Harley-Davidson - Forty Eight
  { make: "Harley-Davidson", model: "Forty Eight", year: 2014 },
  { make: "Harley-Davidson", model: "Forty Eight", year: 2016 },
  { make: "Harley-Davidson", model: "Forty Eight", year: 2017 },
  // Harley-Davidson - Freewheeler
  { make: "Harley-Davidson", model: "Freewheeler", year: 2015 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2016 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2017 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2018 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2019 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2020 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2021 },
  { make: "Harley-Davidson", model: "Freewheeler", year: 2022 },
  // Harley-Davidson - FXBBS Street Bob 114
  { make: "Harley-Davidson", model: "FXBBS Street Bob 114", year: 2022 },
  // Harley-Davidson - Fxdr
  { make: "Harley-Davidson", model: "Fxdr", year: 2019 },
  // Harley-Davidson - FXFBS Fat Bob 114
  { make: "Harley-Davidson", model: "FXFBS Fat Bob 114", year: 2022 },
  // Harley-Davidson - GOLD-0063 2105M G
  { make: "Harley-Davidson", model: "GOLD-0063 2105M G", year: 2024 },
  { make: "Harley-Davidson", model: "GOLD-0063 2105M G", year: 2025 },
  { make: "Harley-Davidson", model: "GOLD-0063 2105M G", year: 2026 },
  { make: "Harley-Davidson", model: "GOLD-0063 2105M G", year: 2027 },
  // Harley-Davidson - Gunmetal Gray 0063 2105M Gu
  { make: "Harley-Davidson", model: "Gunmetal Gray 0063 2105M Gu", year: 2024 },
  { make: "Harley-Davidson", model: "Gunmetal Gray 0063 2105M Gu", year: 2025 },
  { make: "Harley-Davidson", model: "Gunmetal Gray 0063 2105M Gu", year: 2026 },
  { make: "Harley-Davidson", model: "Gunmetal Gray 0063 2105M Gu", year: 2027 },
  // Harley-Davidson - Heritage
  { make: "Harley-Davidson", model: "Heritage", year: 2018 },
  { make: "Harley-Davidson", model: "Heritage", year: 2019 },
  { make: "Harley-Davidson", model: "Heritage", year: 2020 },
  { make: "Harley-Davidson", model: "Heritage", year: 2021 },
  // Harley-Davidson - Low Rider S
  { make: "Harley-Davidson", model: "Low Rider S", year: 2016 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2017 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2018 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2019 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2020 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2021 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2022 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2023 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2024 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2025 },
  { make: "Harley-Davidson", model: "Low Rider S", year: 2026 },
  // Harley-Davidson - M8 Softail
  { make: "Harley-Davidson", model: "M8 Softail", year: 2018 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2019 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2020 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2021 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2022 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2023 },
  { make: "Harley-Davidson", model: "M8 Softail", year: 2024 },
  // Harley-Davidson - Nightster
  { make: "Harley-Davidson", model: "Nightster", year: 2022 },
  { make: "Harley-Davidson", model: "Nightster", year: 2023 },
  { make: "Harley-Davidson", model: "Nightster", year: 2024 },
  { make: "Harley-Davidson", model: "Nightster", year: 2025 },
  { make: "Harley-Davidson", model: "Nightster", year: 2026 },
  // Harley-Davidson - Pan America 1250
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2020 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2021 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2022 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2023 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2024 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2025 },
  { make: "Harley-Davidson", model: "Pan America 1250", year: 2026 },
  // Harley-Davidson - RED-0063 2105M
  { make: "Harley-Davidson", model: "RED-0063 2105M", year: 2024 },
  { make: "Harley-Davidson", model: "RED-0063 2105M", year: 2025 },
  { make: "Harley-Davidson", model: "RED-0063 2105M", year: 2026 },
  { make: "Harley-Davidson", model: "RED-0063 2105M", year: 2027 },
  // Harley-Davidson - Seventy Two
  { make: "Harley-Davidson", model: "Seventy Two", year: 2014 },
  { make: "Harley-Davidson", model: "Seventy Two", year: 2015 },
  // Harley-Davidson - Softail 6043
  { make: "Harley-Davidson", model: "Softail 6043", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2011 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6043", year: 2017 },
  // Harley-Davidson - Softail 6223
  { make: "Harley-Davidson", model: "Softail 6223", year: 1986 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1987 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6223", year: 2006 },
  // Harley-Davidson - Softail 6224
  { make: "Harley-Davidson", model: "Softail 6224", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6224", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6224", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6224", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6224", year: 2011 },
  // Harley-Davidson - Softail 6225
  { make: "Harley-Davidson", model: "Softail 6225", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6225", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6225", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6225", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6225", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6225", year: 2017 },
  // Harley-Davidson - Softail 6225B
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6225B", year: 2017 },
  // Harley-Davidson - Softail 6420
  { make: "Harley-Davidson", model: "Softail 6420", year: 1986 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1987 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6420", year: 2006 },
  // Harley-Davidson - Softail 6421
  { make: "Harley-Davidson", model: "Softail 6421", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6421", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6421", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6421", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6421", year: 2011 },
  // Harley-Davidson - Softail 6422
  { make: "Harley-Davidson", model: "Softail 6422", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6422", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6422", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6422", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6422", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6422", year: 2017 },
  // Harley-Davidson - Softail 6483
  { make: "Harley-Davidson", model: "Softail 6483", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6483", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6483", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6483", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6483", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6483", year: 2017 },
  // Harley-Davidson - Softail 6483B
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6483B", year: 2017 },
  // Harley-Davidson - Softail 6484
  { make: "Harley-Davidson", model: "Softail 6484", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6484", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6484", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6484", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6484", year: 2011 },
  // Harley-Davidson - Softail 6485
  { make: "Harley-Davidson", model: "Softail 6485", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6485", year: 2006 },
  // Harley-Davidson - Softail 6485B
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6485B", year: 2006 },
  // Harley-Davidson - Softail 6711B
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6711B", year: 2017 },
  // Harley-Davidson - Softail 6712
  { make: "Harley-Davidson", model: "Softail 6712", year: 2018 },
  { make: "Harley-Davidson", model: "Softail 6712", year: 2019 },
  { make: "Harley-Davidson", model: "Softail 6712", year: 2020 },
  // Harley-Davidson - Softail 6712B
  { make: "Harley-Davidson", model: "Softail 6712B", year: 2018 },
  { make: "Harley-Davidson", model: "Softail 6712B", year: 2019 },
  { make: "Harley-Davidson", model: "Softail 6712B", year: 2020 },
  // Harley-Davidson - Softail 6810T
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1986 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1987 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6810T", year: 2006 },
  // Harley-Davidson - Softail 6811T
  { make: "Harley-Davidson", model: "Softail 6811T", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6811T", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6811T", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6811T", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6811T", year: 2011 },
  // Harley-Davidson - Softail 6850
  { make: "Harley-Davidson", model: "Softail 6850", year: 1986 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1987 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6850", year: 2006 },
  // Harley-Davidson - Softail 6852
  { make: "Harley-Davidson", model: "Softail 6852", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6852", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6852", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6852", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6852", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6852", year: 2017 },
  // Harley-Davidson - Softail 6852B
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6852B", year: 2017 },
  // Harley-Davidson - Softail 6853
  { make: "Harley-Davidson", model: "Softail 6853", year: 2018 },
  { make: "Harley-Davidson", model: "Softail 6853", year: 2019 },
  { make: "Harley-Davidson", model: "Softail 6853", year: 2020 },
  // Harley-Davidson - Softail 6853B
  { make: "Harley-Davidson", model: "Softail 6853B", year: 2018 },
  { make: "Harley-Davidson", model: "Softail 6853B", year: 2019 },
  { make: "Harley-Davidson", model: "Softail 6853B", year: 2020 },
  // Harley-Davidson - Softail 6950T
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1986 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1987 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1988 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1989 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1990 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1991 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1992 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1993 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1994 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1995 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1996 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6950T", year: 2006 },
  // Harley-Davidson - Softail 6951T
  { make: "Harley-Davidson", model: "Softail 6951T", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6951T", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6951T", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6951T", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6951T", year: 2011 },
  // Harley-Davidson - Softail 6952T
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6952T", year: 2017 },
  // Harley-Davidson - Softail 6987
  { make: "Harley-Davidson", model: "Softail 6987", year: 1997 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 1998 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 1999 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2000 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2001 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2002 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2003 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2004 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2005 },
  { make: "Harley-Davidson", model: "Softail 6987", year: 2006 },
  // Harley-Davidson - Softail 6988
  { make: "Harley-Davidson", model: "Softail 6988", year: 2007 },
  { make: "Harley-Davidson", model: "Softail 6988", year: 2008 },
  { make: "Harley-Davidson", model: "Softail 6988", year: 2009 },
  { make: "Harley-Davidson", model: "Softail 6988", year: 2010 },
  { make: "Harley-Davidson", model: "Softail 6988", year: 2011 },
  // Harley-Davidson - Softail 6989
  { make: "Harley-Davidson", model: "Softail 6989", year: 2012 },
  { make: "Harley-Davidson", model: "Softail 6989", year: 2013 },
  { make: "Harley-Davidson", model: "Softail 6989", year: 2014 },
  { make: "Harley-Davidson", model: "Softail 6989", year: 2015 },
  { make: "Harley-Davidson", model: "Softail 6989", year: 2016 },
  { make: "Harley-Davidson", model: "Softail 6989", year: 2017 },
  // Harley-Davidson - Softail Twin Slash 4IN Round
  { make: "Harley-Davidson", model: "Softail Twin Slash 4IN Round", year: 2025 },
  { make: "Harley-Davidson", model: "Softail Twin Slash 4IN Round", year: 2026 },
  { make: "Harley-Davidson", model: "Softail Twin Slash 4IN Round", year: 2027 },
  // Harley-Davidson - Sportster S
  { make: "Harley-Davidson", model: "Sportster S", year: 2021 },
  { make: "Harley-Davidson", model: "Sportster S", year: 2022 },
  { make: "Harley-Davidson", model: "Sportster S", year: 2023 },
  { make: "Harley-Davidson", model: "Sportster S", year: 2024 },
  { make: "Harley-Davidson", model: "Sportster S", year: 2025 },
  { make: "Harley-Davidson", model: "Sportster S", year: 2026 },
  // Harley-Davidson - Sportster Xl 6030
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2004 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2005 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2006 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2007 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2008 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2009 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2010 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2011 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2012 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030", year: 2013 },
  // Harley-Davidson - Sportster Xl 6030RB
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2004 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2005 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2006 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2007 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2008 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2009 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2010 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2011 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2012 },
  { make: "Harley-Davidson", model: "Sportster Xl 6030RB", year: 2013 },
  // Harley-Davidson - Sportster Xl 6036
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1986 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1987 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1988 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1989 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1990 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1991 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1992 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1993 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1994 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1995 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1996 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1997 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1998 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 1999 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 2000 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 2001 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 2002 },
  { make: "Harley-Davidson", model: "Sportster Xl 6036", year: 2003 },
  // Harley-Davidson - Sportster Xl 6233
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2014 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2015 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2016 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2017 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2018 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2019 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233", year: 2020 },
  // Harley-Davidson - Sportster Xl 6233B
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2014 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2015 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2016 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2017 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2018 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2019 },
  { make: "Harley-Davidson", model: "Sportster Xl 6233B", year: 2020 },
  // Harley-Davidson - Sportster Xl 6701
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1986 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1987 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1988 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1989 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1990 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1991 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1992 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1993 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1994 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1995 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1996 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1997 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1998 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 1999 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 2000 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 2001 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 2002 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701", year: 2003 },
  // Harley-Davidson - Sportster Xl 6701B
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1986 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1987 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1988 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1989 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1990 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1991 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1992 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1993 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1994 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1995 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1996 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1997 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1998 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 1999 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 2000 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 2001 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 2002 },
  { make: "Harley-Davidson", model: "Sportster Xl 6701B", year: 2003 },
  // Harley-Davidson - Sportster Xl 6704
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2007 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2008 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2009 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2010 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2011 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2012 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704", year: 2013 },
  // Harley-Davidson - Sportster Xl 6704B
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2007 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2008 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2009 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2010 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2011 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2012 },
  { make: "Harley-Davidson", model: "Sportster Xl 6704B", year: 2013 },
  // Harley-Davidson - Sportster Xl 6882
  { make: "Harley-Davidson", model: "Sportster Xl 6882", year: 2004 },
  { make: "Harley-Davidson", model: "Sportster Xl 6882", year: 2005 },
  { make: "Harley-Davidson", model: "Sportster Xl 6882", year: 2006 },
  // Harley-Davidson - Street 500
  { make: "Harley-Davidson", model: "Street 500", year: 2014 },
  { make: "Harley-Davidson", model: "Street 500", year: 2015 },
  { make: "Harley-Davidson", model: "Street 500", year: 2016 },
  { make: "Harley-Davidson", model: "Street 500", year: 2017 },
  { make: "Harley-Davidson", model: "Street 500", year: 2018 },
  { make: "Harley-Davidson", model: "Street 500", year: 2019 },
  { make: "Harley-Davidson", model: "Street 500", year: 2020 },
  { make: "Harley-Davidson", model: "Street 500", year: 2021 },
  // Harley-Davidson - Street 750
  { make: "Harley-Davidson", model: "Street 750", year: 2014 },
  { make: "Harley-Davidson", model: "Street 750", year: 2015 },
  { make: "Harley-Davidson", model: "Street 750", year: 2016 },
  { make: "Harley-Davidson", model: "Street 750", year: 2017 },
  { make: "Harley-Davidson", model: "Street 750", year: 2018 },
  { make: "Harley-Davidson", model: "Street 750", year: 2019 },
  { make: "Harley-Davidson", model: "Street 750", year: 2020 },
  { make: "Harley-Davidson", model: "Street 750", year: 2021 },
  // Harley-Davidson - Street Bob
  { make: "Harley-Davidson", model: "Street Bob", year: 2021 },
  { make: "Harley-Davidson", model: "Street Bob", year: 2022 },
  // Harley-Davidson - Street Rod XG750A
  { make: "Harley-Davidson", model: "Street Rod XG750A", year: 2017 },
  { make: "Harley-Davidson", model: "Street Rod XG750A", year: 2018 },
  { make: "Harley-Davidson", model: "Street Rod XG750A", year: 2019 },
  { make: "Harley-Davidson", model: "Street Rod XG750A", year: 2020 },
  // Harley-Davidson - Touring 2 1 High Output Pcx
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2017 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2018 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2019 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2020 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2021 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2022 },
  { make: "Harley-Davidson", model: "Touring 2 1 High Output Pcx", year: 2023 },
  // Harley-Davidson - XL1200X Forty-Eight
  { make: "Harley-Davidson", model: "XL1200X Forty-Eight", year: 2022 },
  // Honda
  // Honda - 600 Transalp
  { make: "Honda", model: "600 Transalp", year: 1987 },
  { make: "Honda", model: "600 Transalp", year: 1988 },
  { make: "Honda", model: "600 Transalp", year: 1989 },
  { make: "Honda", model: "600 Transalp", year: 1990 },
  { make: "Honda", model: "600 Transalp", year: 1991 },
  { make: "Honda", model: "600 Transalp", year: 1992 },
  { make: "Honda", model: "600 Transalp", year: 1993 },
  { make: "Honda", model: "600 Transalp", year: 1994 },
  { make: "Honda", model: "600 Transalp", year: 1995 },
  { make: "Honda", model: "600 Transalp", year: 1996 },
  { make: "Honda", model: "600 Transalp", year: 1997 },
  // Honda - ADV160
  { make: "Honda", model: "ADV160", year: 2023 },
  { make: "Honda", model: "ADV160", year: 2024 },
  { make: "Honda", model: "ADV160", year: 2025 },
  { make: "Honda", model: "ADV160", year: 2026 },
  // Honda - Africa Twin
  { make: "Honda", model: "Africa Twin", year: 2016 },
  { make: "Honda", model: "Africa Twin", year: 2017 },
  { make: "Honda", model: "Africa Twin", year: 2018 },
  { make: "Honda", model: "Africa Twin", year: 2019 },
  { make: "Honda", model: "Africa Twin", year: 2020 },
  { make: "Honda", model: "Africa Twin", year: 2021 },
  { make: "Honda", model: "Africa Twin", year: 2022 },
  { make: "Honda", model: "Africa Twin", year: 2023 },
  { make: "Honda", model: "Africa Twin", year: 2024 },
  { make: "Honda", model: "Africa Twin", year: 2025 },
  { make: "Honda", model: "Africa Twin", year: 2026 },
  // Honda - Africa Twin 750 93 95
  { make: "Honda", model: "Africa Twin 750 93 95", year: 1996 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 1997 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 1998 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 1999 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 2000 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 2001 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 2002 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 2003 },
  { make: "Honda", model: "Africa Twin 750 93 95", year: 2004 },
  // Honda - Africa Twin 1000
  { make: "Honda", model: "Africa Twin 1000", year: 2016 },
  { make: "Honda", model: "Africa Twin 1000", year: 2017 },
  { make: "Honda", model: "Africa Twin 1000", year: 2018 },
  { make: "Honda", model: "Africa Twin 1000", year: 2019 },
  // Honda - Africa Twin 1000 CRF1000L
  { make: "Honda", model: "Africa Twin 1000 CRF1000L", year: 2015 },
  { make: "Honda", model: "Africa Twin 1000 CRF1000L", year: 2016 },
  { make: "Honda", model: "Africa Twin 1000 CRF1000L", year: 2017 },
  { make: "Honda", model: "Africa Twin 1000 CRF1000L", year: 2018 },
  { make: "Honda", model: "Africa Twin 1000 CRF1000L", year: 2019 },
  // Honda - Africa Twin 1100
  { make: "Honda", model: "Africa Twin 1100", year: 2020 },
  { make: "Honda", model: "Africa Twin 1100", year: 2021 },
  // Honda - Africa Twin 1100 80049
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2020 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2021 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2022 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2023 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2024 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2025 },
  { make: "Honda", model: "Africa Twin 1100 80049", year: 2026 },
  // Honda - Africa Twin CRF1100L
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2020 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2021 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2022 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2023 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2024 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2025 },
  { make: "Honda", model: "Africa Twin CRF1100L", year: 2026 },
  // Honda - ATC250ES
  { make: "Honda", model: "ATC250ES", year: 1985 },
  { make: "Honda", model: "ATC250ES", year: 1986 },
  { make: "Honda", model: "ATC250ES", year: 1987 },
  // Honda - ATC250ES Big Red
  { make: "Honda", model: "ATC250ES Big Red", year: 1985 },
  { make: "Honda", model: "ATC250ES Big Red", year: 1986 },
  { make: "Honda", model: "ATC250ES Big Red", year: 1987 },
  // Honda - ATC250R
  { make: "Honda", model: "ATC250R", year: 1985 },
  { make: "Honda", model: "ATC250R", year: 1986 },
  // Honda - CB-125 F
  { make: "Honda", model: "CB-125 F", year: 2015 },
  { make: "Honda", model: "CB-125 F", year: 2016 },
  // Honda - CB-125R
  { make: "Honda", model: "CB-125R", year: 2018 },
  { make: "Honda", model: "CB-125R", year: 2019 },
  { make: "Honda", model: "CB-125R", year: 2020 },
  // Honda - CB-300
  { make: "Honda", model: "CB-300", year: 2018 },
  { make: "Honda", model: "CB-300", year: 2019 },
  { make: "Honda", model: "CB-300", year: 2020 },
  // Honda - CB-500F
  { make: "Honda", model: "CB-500F", year: 2019 },
  { make: "Honda", model: "CB-500F", year: 2020 },
  // Honda - CB-500X
  { make: "Honda", model: "CB-500X", year: 2019 },
  { make: "Honda", model: "CB-500X", year: 2020 },
  { make: "Honda", model: "CB-500X", year: 2021 },
  { make: "Honda", model: "CB-500X", year: 2022 },
  { make: "Honda", model: "CB-500X", year: 2023 },
  // Honda - CB-600 F Hornet
  { make: "Honda", model: "CB-600 F Hornet", year: 2007 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2008 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2009 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2010 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2011 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2012 },
  { make: "Honda", model: "CB-600 F Hornet", year: 2013 },
  // Honda - CB-1000
  { make: "Honda", model: "CB-1000", year: 2008 },
  { make: "Honda", model: "CB-1000", year: 2009 },
  { make: "Honda", model: "CB-1000", year: 2010 },
  // Honda - CB-1000 R CB1000
  { make: "Honda", model: "CB-1000 R CB1000", year: 2008 },
  { make: "Honda", model: "CB-1000 R CB1000", year: 2009 },
  { make: "Honda", model: "CB-1000 R CB1000", year: 2010 },
  { make: "Honda", model: "CB-1000 R CB1000", year: 2011 },
  { make: "Honda", model: "CB-1000 R CB1000", year: 2012 },
  { make: "Honda", model: "CB-1000 R CB1000", year: 2013 },
  // Honda - CB-1000 R SC80 107
  { make: "Honda", model: "CB-1000 R SC80 107", year: 2018 },
  // Honda - CB-1000R
  { make: "Honda", model: "CB-1000R", year: 2018 },
  { make: "Honda", model: "CB-1000R", year: 2019 },
  // Honda - CB-1100
  { make: "Honda", model: "CB-1100", year: 2017 },
  { make: "Honda", model: "CB-1100", year: 2018 },
  { make: "Honda", model: "CB-1100", year: 2019 },
  { make: "Honda", model: "CB-1100", year: 2020 },
  { make: "Honda", model: "CB-1100", year: 2021 },
  { make: "Honda", model: "CB-1100", year: 2022 },
  { make: "Honda", model: "CB-1100", year: 2023 },
  { make: "Honda", model: "CB-1100", year: 2024 },
  // Honda - CB125
  { make: "Honda", model: "CB125", year: 2015 },
  { make: "Honda", model: "CB125", year: 2016 },
  // Honda - CB125R
  { make: "Honda", model: "CB125R", year: 2024 },
  // Honda - CB300F
  { make: "Honda", model: "CB300F", year: 2014 },
  { make: "Honda", model: "CB300F", year: 2015 },
  { make: "Honda", model: "CB300F", year: 2016 },
  { make: "Honda", model: "CB300F", year: 2017 },
  { make: "Honda", model: "CB300F", year: 2018 },
  { make: "Honda", model: "CB300F", year: 2019 },
  // Honda - CB300R
  { make: "Honda", model: "CB300R", year: 2017 },
  { make: "Honda", model: "CB300R", year: 2018 },
  { make: "Honda", model: "CB300R", year: 2019 },
  { make: "Honda", model: "CB300R", year: 2020 },
  { make: "Honda", model: "CB300R", year: 2021 },
  { make: "Honda", model: "CB300R", year: 2022 },
  { make: "Honda", model: "CB300R", year: 2023 },
  { make: "Honda", model: "CB300R", year: 2024 },
  { make: "Honda", model: "CB300R", year: 2025 },
  { make: "Honda", model: "CB300R", year: 2026 },
  { make: "Honda", model: "CB300R", year: 2027 },
  // Honda - CB500 Hornet
  { make: "Honda", model: "CB500 Hornet", year: 2024 },
  { make: "Honda", model: "CB500 Hornet", year: 2025 },
  { make: "Honda", model: "CB500 Hornet", year: 2026 },
  // Honda - CB500F
  { make: "Honda", model: "CB500F", year: 2013 },
  { make: "Honda", model: "CB500F", year: 2014 },
  { make: "Honda", model: "CB500F", year: 2015 },
  { make: "Honda", model: "CB500F", year: 2016 },
  { make: "Honda", model: "CB500F", year: 2017 },
  { make: "Honda", model: "CB500F", year: 2018 },
  { make: "Honda", model: "CB500F", year: 2019 },
  { make: "Honda", model: "CB500F", year: 2020 },
  { make: "Honda", model: "CB500F", year: 2021 },
  { make: "Honda", model: "CB500F", year: 2022 },
  { make: "Honda", model: "CB500F", year: 2023 },
  { make: "Honda", model: "CB500F", year: 2024 },
  { make: "Honda", model: "CB500F", year: 2025 },
  { make: "Honda", model: "CB500F", year: 2026 },
  // Honda - CB500X
  { make: "Honda", model: "CB500X", year: 2013 },
  { make: "Honda", model: "CB500X", year: 2014 },
  { make: "Honda", model: "CB500X", year: 2015 },
  { make: "Honda", model: "CB500X", year: 2016 },
  { make: "Honda", model: "CB500X", year: 2017 },
  { make: "Honda", model: "CB500X", year: 2018 },
  { make: "Honda", model: "CB500X", year: 2019 },
  { make: "Honda", model: "CB500X", year: 2020 },
  { make: "Honda", model: "CB500X", year: 2021 },
  { make: "Honda", model: "CB500X", year: 2022 },
  { make: "Honda", model: "CB500X", year: 2023 },
  { make: "Honda", model: "CB500X", year: 2024 },
  // Honda - CB650F
  { make: "Honda", model: "CB650F", year: 2014 },
  { make: "Honda", model: "CB650F", year: 2015 },
  { make: "Honda", model: "CB650F", year: 2016 },
  { make: "Honda", model: "CB650F", year: 2017 },
  { make: "Honda", model: "CB650F", year: 2018 },
  { make: "Honda", model: "CB650F", year: 2019 },
  { make: "Honda", model: "CB650F", year: 2020 },
  { make: "Honda", model: "CB650F", year: 2021 },
  { make: "Honda", model: "CB650F", year: 2022 },
  // Honda - CB650R
  { make: "Honda", model: "CB650R", year: 2019 },
  { make: "Honda", model: "CB650R", year: 2020 },
  { make: "Honda", model: "CB650R", year: 2021 },
  { make: "Honda", model: "CB650R", year: 2022 },
  { make: "Honda", model: "CB650R", year: 2023 },
  { make: "Honda", model: "CB650R", year: 2024 },
  { make: "Honda", model: "CB650R", year: 2025 },
  { make: "Honda", model: "CB650R", year: 2026 },
  // Honda - CB750 Hornet
  { make: "Honda", model: "CB750 Hornet", year: 2024 },
  { make: "Honda", model: "CB750 Hornet", year: 2025 },
  { make: "Honda", model: "CB750 Hornet", year: 2026 },
  // Honda - CB750 Hornet E H7R6
  { make: "Honda", model: "CB750 Hornet E H7R6", year: 2025 },
  // Honda - CB1000 Hornet
  { make: "Honda", model: "CB1000 Hornet", year: 2025 },
  { make: "Honda", model: "CB1000 Hornet", year: 2026 },
  // Honda - CB1000R
  { make: "Honda", model: "CB1000R", year: 2008 },
  { make: "Honda", model: "CB1000R", year: 2009 },
  { make: "Honda", model: "CB1000R", year: 2010 },
  { make: "Honda", model: "CB1000R", year: 2011 },
  { make: "Honda", model: "CB1000R", year: 2012 },
  { make: "Honda", model: "CB1000R", year: 2013 },
  { make: "Honda", model: "CB1000R", year: 2014 },
  { make: "Honda", model: "CB1000R", year: 2015 },
  { make: "Honda", model: "CB1000R", year: 2016 },
  { make: "Honda", model: "CB1000R", year: 2017 },
  { make: "Honda", model: "CB1000R", year: 2018 },
  { make: "Honda", model: "CB1000R", year: 2019 },
  { make: "Honda", model: "CB1000R", year: 2020 },
  { make: "Honda", model: "CB1000R", year: 2021 },
  { make: "Honda", model: "CB1000R", year: 2022 },
  { make: "Honda", model: "CB1000R", year: 2023 },
  { make: "Honda", model: "CB1000R", year: 2024 },
  { make: "Honda", model: "CB1000R", year: 2025 },
  { make: "Honda", model: "CB1000R", year: 2026 },
  // Honda - CB1000R 15222B
  { make: "Honda", model: "CB1000R 15222B", year: 2018 },
  { make: "Honda", model: "CB1000R 15222B", year: 2019 },
  { make: "Honda", model: "CB1000R 15222B", year: 2020 },
  { make: "Honda", model: "CB1000R 15222B", year: 2021 },
  { make: "Honda", model: "CB1000R 15222B", year: 2022 },
  { make: "Honda", model: "CB1000R 15222B", year: 2023 },
  { make: "Honda", model: "CB1000R 15222B", year: 2024 },
  { make: "Honda", model: "CB1000R 15222B", year: 2025 },
  { make: "Honda", model: "CB1000R 15222B", year: 2026 },
  // Honda - CB1000R Neo Sports Caf
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2018 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2019 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2020 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2021 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2022 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2023 },
  { make: "Honda", model: "CB1000R Neo Sports Caf", year: 2024 },
  // Honda - CB1000R S H10SO20 Haplt
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2018 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2019 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2020 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2021 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2022 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2023 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2024 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2025 },
  { make: "Honda", model: "CB1000R S H10SO20 Haplt", year: 2026 },
  // Honda - CB1000R S H10SO21 Aszt
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2018 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2019 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2020 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2021 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2022 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2023 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2024 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2025 },
  { make: "Honda", model: "CB1000R S H10SO21 Aszt", year: 2026 },
  // Honda - CB1100
  { make: "Honda", model: "CB1100", year: 2013 },
  { make: "Honda", model: "CB1100", year: 2014 },
  // Honda - CBF-125
  { make: "Honda", model: "CBF-125", year: 2009 },
  { make: "Honda", model: "CBF-125", year: 2010 },
  { make: "Honda", model: "CBF-125", year: 2011 },
  { make: "Honda", model: "CBF-125", year: 2012 },
  { make: "Honda", model: "CBF-125", year: 2013 },
  { make: "Honda", model: "CBF-125", year: 2014 },
  { make: "Honda", model: "CBF-125", year: 2015 },
  { make: "Honda", model: "CBF-125", year: 2016 },
  // Honda - CBR-125
  { make: "Honda", model: "CBR-125", year: 2011 },
  { make: "Honda", model: "CBR-125", year: 2012 },
  { make: "Honda", model: "CBR-125", year: 2013 },
  { make: "Honda", model: "CBR-125", year: 2014 },
  { make: "Honda", model: "CBR-125", year: 2015 },
  { make: "Honda", model: "CBR-125", year: 2016 },
  // Honda - CBR-600 RR
  { make: "Honda", model: "CBR-600 RR", year: 2003 },
  { make: "Honda", model: "CBR-600 RR", year: 2004 },
  { make: "Honda", model: "CBR-600 RR", year: 2005 },
  { make: "Honda", model: "CBR-600 RR", year: 2006 },
  { make: "Honda", model: "CBR-600 RR", year: 2007 },
  { make: "Honda", model: "CBR-600 RR", year: 2008 },
  { make: "Honda", model: "CBR-600 RR", year: 2009 },
  { make: "Honda", model: "CBR-600 RR", year: 2010 },
  { make: "Honda", model: "CBR-600 RR", year: 2011 },
  { make: "Honda", model: "CBR-600 RR", year: 2012 },
  // Honda - CBR-600RR
  { make: "Honda", model: "CBR-600RR", year: 2007 },
  { make: "Honda", model: "CBR-600RR", year: 2008 },
  { make: "Honda", model: "CBR-600RR", year: 2009 },
  { make: "Honda", model: "CBR-600RR", year: 2010 },
  { make: "Honda", model: "CBR-600RR", year: 2011 },
  { make: "Honda", model: "CBR-600RR", year: 2012 },
  { make: "Honda", model: "CBR-600RR", year: 2013 },
  { make: "Honda", model: "CBR-600RR", year: 2014 },
  { make: "Honda", model: "CBR-600RR", year: 2015 },
  { make: "Honda", model: "CBR-600RR", year: 2016 },
  { make: "Honda", model: "CBR-600RR", year: 2017 },
  { make: "Honda", model: "CBR-600RR", year: 2018 },
  { make: "Honda", model: "CBR-600RR", year: 2019 },
  { make: "Honda", model: "CBR-600RR", year: 2020 },
  { make: "Honda", model: "CBR-600RR", year: 2021 },
  { make: "Honda", model: "CBR-600RR", year: 2022 },
  { make: "Honda", model: "CBR-600RR", year: 2023 },
  { make: "Honda", model: "CBR-600RR", year: 2024 },
  { make: "Honda", model: "CBR-600RR", year: 2025 },
  { make: "Honda", model: "CBR-600RR", year: 2026 },
  { make: "Honda", model: "CBR-600RR", year: 2027 },
  // Honda - CBR-1000 RR
  { make: "Honda", model: "CBR-1000 RR", year: 2004 },
  { make: "Honda", model: "CBR-1000 RR", year: 2005 },
  { make: "Honda", model: "CBR-1000 RR", year: 2006 },
  { make: "Honda", model: "CBR-1000 RR", year: 2007 },
  // Honda - CBR-1000RR
  { make: "Honda", model: "CBR-1000RR", year: 2004 },
  { make: "Honda", model: "CBR-1000RR", year: 2005 },
  { make: "Honda", model: "CBR-1000RR", year: 2006 },
  { make: "Honda", model: "CBR-1000RR", year: 2007 },
  { make: "Honda", model: "CBR-1000RR", year: 2008 },
  { make: "Honda", model: "CBR-1000RR", year: 2009 },
  { make: "Honda", model: "CBR-1000RR", year: 2010 },
  { make: "Honda", model: "CBR-1000RR", year: 2011 },
  { make: "Honda", model: "CBR-1000RR", year: 2012 },
  { make: "Honda", model: "CBR-1000RR", year: 2013 },
  { make: "Honda", model: "CBR-1000RR", year: 2014 },
  { make: "Honda", model: "CBR-1000RR", year: 2015 },
  { make: "Honda", model: "CBR-1000RR", year: 2016 },
  { make: "Honda", model: "CBR-1000RR", year: 2017 },
  { make: "Honda", model: "CBR-1000RR", year: 2018 },
  { make: "Honda", model: "CBR-1000RR", year: 2019 },
  { make: "Honda", model: "CBR-1000RR", year: 2020 },
  { make: "Honda", model: "CBR-1000RR", year: 2021 },
  { make: "Honda", model: "CBR-1000RR", year: 2022 },
  { make: "Honda", model: "CBR-1000RR", year: 2023 },
  { make: "Honda", model: "CBR-1000RR", year: 2024 },
  { make: "Honda", model: "CBR-1000RR", year: 2025 },
  { make: "Honda", model: "CBR-1000RR", year: 2026 },
  { make: "Honda", model: "CBR-1000RR", year: 2027 },
  // Honda - CBR-1000RR Fireblade
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2017 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2018 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2019 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2020 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2021 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2022 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2023 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2024 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2025 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2026 },
  { make: "Honda", model: "CBR-1000RR Fireblade", year: 2027 },
  // Honda - CBR-1000RR R Fireblade
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2020 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2021 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2022 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2023 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2024 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2025 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2026 },
  { make: "Honda", model: "CBR-1000RR R Fireblade", year: 2027 },
  // Honda - CBR10SPM CBR1000RR R Fireblade
  { make: "Honda", model: "CBR10SPM CBR1000RR R Fireblade", year: 2021 },
  { make: "Honda", model: "CBR10SPM CBR1000RR R Fireblade", year: 2022 },
  // Honda - CBR250R
  { make: "Honda", model: "CBR250R", year: 2011 },
  { make: "Honda", model: "CBR250R", year: 2012 },
  { make: "Honda", model: "CBR250R", year: 2013 },
  { make: "Honda", model: "CBR250R", year: 2014 },
  { make: "Honda", model: "CBR250R", year: 2015 },
  { make: "Honda", model: "CBR250R", year: 2016 },
  { make: "Honda", model: "CBR250R", year: 2017 },
  { make: "Honda", model: "CBR250R", year: 2018 },
  { make: "Honda", model: "CBR250R", year: 2019 },
  { make: "Honda", model: "CBR250R", year: 2020 },
  // Honda - CBR300R
  { make: "Honda", model: "CBR300R", year: 2014 },
  { make: "Honda", model: "CBR300R", year: 2015 },
  { make: "Honda", model: "CBR300R", year: 2016 },
  { make: "Honda", model: "CBR300R", year: 2017 },
  { make: "Honda", model: "CBR300R", year: 2018 },
  { make: "Honda", model: "CBR300R", year: 2019 },
  { make: "Honda", model: "CBR300R", year: 2020 },
  { make: "Honda", model: "CBR300R", year: 2021 },
  { make: "Honda", model: "CBR300R", year: 2022 },
  // Honda - CBR500R
  { make: "Honda", model: "CBR500R", year: 2013 },
  { make: "Honda", model: "CBR500R", year: 2014 },
  { make: "Honda", model: "CBR500R", year: 2015 },
  { make: "Honda", model: "CBR500R", year: 2016 },
  { make: "Honda", model: "CBR500R", year: 2017 },
  { make: "Honda", model: "CBR500R", year: 2018 },
  { make: "Honda", model: "CBR500R", year: 2019 },
  { make: "Honda", model: "CBR500R", year: 2020 },
  { make: "Honda", model: "CBR500R", year: 2021 },
  { make: "Honda", model: "CBR500R", year: 2022 },
  { make: "Honda", model: "CBR500R", year: 2023 },
  { make: "Honda", model: "CBR500R", year: 2024 },
  { make: "Honda", model: "CBR500R", year: 2025 },
  { make: "Honda", model: "CBR500R", year: 2026 },
  // Honda - CBR600
  { make: "Honda", model: "CBR600", year: 2007 },
  { make: "Honda", model: "CBR600", year: 2008 },
  // Honda - CBR600RR
  { make: "Honda", model: "CBR600RR", year: 2003 },
  { make: "Honda", model: "CBR600RR", year: 2004 },
  { make: "Honda", model: "CBR600RR", year: 2005 },
  { make: "Honda", model: "CBR600RR", year: 2006 },
  { make: "Honda", model: "CBR600RR", year: 2007 },
  { make: "Honda", model: "CBR600RR", year: 2008 },
  { make: "Honda", model: "CBR600RR", year: 2009 },
  { make: "Honda", model: "CBR600RR", year: 2010 },
  { make: "Honda", model: "CBR600RR", year: 2011 },
  { make: "Honda", model: "CBR600RR", year: 2012 },
  { make: "Honda", model: "CBR600RR", year: 2013 },
  { make: "Honda", model: "CBR600RR", year: 2014 },
  { make: "Honda", model: "CBR600RR", year: 2015 },
  { make: "Honda", model: "CBR600RR", year: 2016 },
  { make: "Honda", model: "CBR600RR", year: 2017 },
  { make: "Honda", model: "CBR600RR", year: 2018 },
  { make: "Honda", model: "CBR600RR", year: 2019 },
  { make: "Honda", model: "CBR600RR", year: 2020 },
  { make: "Honda", model: "CBR600RR", year: 2021 },
  { make: "Honda", model: "CBR600RR", year: 2022 },
  { make: "Honda", model: "CBR600RR", year: 2023 },
  { make: "Honda", model: "CBR600RR", year: 2024 },
  { make: "Honda", model: "CBR600RR", year: 2025 },
  { make: "Honda", model: "CBR600RR", year: 2026 },
  // Honda - CBR600RR 14460EBU
  { make: "Honda", model: "CBR600RR 14460EBU", year: 2024 },
  { make: "Honda", model: "CBR600RR 14460EBU", year: 2025 },
  { make: "Honda", model: "CBR600RR 14460EBU", year: 2026 },
  // Honda - CBR600RR 14460EU
  { make: "Honda", model: "CBR600RR 14460EU", year: 2024 },
  { make: "Honda", model: "CBR600RR 14460EU", year: 2025 },
  { make: "Honda", model: "CBR600RR 14460EU", year: 2026 },
  // Honda - CBR650F
  { make: "Honda", model: "CBR650F", year: 2014 },
  { make: "Honda", model: "CBR650F", year: 2015 },
  { make: "Honda", model: "CBR650F", year: 2016 },
  { make: "Honda", model: "CBR650F", year: 2017 },
  { make: "Honda", model: "CBR650F", year: 2018 },
  // Honda - CBR650R
  { make: "Honda", model: "CBR650R", year: 2019 },
  { make: "Honda", model: "CBR650R", year: 2020 },
  { make: "Honda", model: "CBR650R", year: 2021 },
  { make: "Honda", model: "CBR650R", year: 2022 },
  { make: "Honda", model: "CBR650R", year: 2023 },
  { make: "Honda", model: "CBR650R", year: 2024 },
  { make: "Honda", model: "CBR650R", year: 2025 },
  { make: "Honda", model: "CBR650R", year: 2026 },
  // Honda - CBR1000 RR
  { make: "Honda", model: "CBR1000 RR", year: 2004 },
  { make: "Honda", model: "CBR1000 RR", year: 2005 },
  { make: "Honda", model: "CBR1000 RR", year: 2006 },
  { make: "Honda", model: "CBR1000 RR", year: 2007 },
  // Honda - CBR1000RR
  { make: "Honda", model: "CBR1000RR", year: 2004 },
  { make: "Honda", model: "CBR1000RR", year: 2005 },
  { make: "Honda", model: "CBR1000RR", year: 2006 },
  { make: "Honda", model: "CBR1000RR", year: 2007 },
  { make: "Honda", model: "CBR1000RR", year: 2008 },
  { make: "Honda", model: "CBR1000RR", year: 2009 },
  { make: "Honda", model: "CBR1000RR", year: 2010 },
  { make: "Honda", model: "CBR1000RR", year: 2011 },
  { make: "Honda", model: "CBR1000RR", year: 2012 },
  { make: "Honda", model: "CBR1000RR", year: 2013 },
  { make: "Honda", model: "CBR1000RR", year: 2014 },
  { make: "Honda", model: "CBR1000RR", year: 2015 },
  { make: "Honda", model: "CBR1000RR", year: 2016 },
  { make: "Honda", model: "CBR1000RR", year: 2017 },
  { make: "Honda", model: "CBR1000RR", year: 2018 },
  { make: "Honda", model: "CBR1000RR", year: 2019 },
  { make: "Honda", model: "CBR1000RR", year: 2020 },
  { make: "Honda", model: "CBR1000RR", year: 2021 },
  { make: "Honda", model: "CBR1000RR", year: 2022 },
  { make: "Honda", model: "CBR1000RR", year: 2023 },
  { make: "Honda", model: "CBR1000RR", year: 2024 },
  { make: "Honda", model: "CBR1000RR", year: 2025 },
  { make: "Honda", model: "CBR1000RR", year: 2026 },
  { make: "Honda", model: "CBR1000RR", year: 2027 },
  // Honda - CBR1000RR 71175HCP
  { make: "Honda", model: "CBR1000RR 71175HCP", year: 2017 },
  { make: "Honda", model: "CBR1000RR 71175HCP", year: 2018 },
  { make: "Honda", model: "CBR1000RR 71175HCP", year: 2019 },
  { make: "Honda", model: "CBR1000RR 71175HCP", year: 2020 },
  // Honda - CBR1000RR R Fender
  { make: "Honda", model: "CBR1000RR R Fender", year: 2021 },
  { make: "Honda", model: "CBR1000RR R Fender", year: 2022 },
  { make: "Honda", model: "CBR1000RR R Fender", year: 2023 },
  { make: "Honda", model: "CBR1000RR R Fender", year: 2024 },
  // Honda - CBR1000RR R Fireblade
  { make: "Honda", model: "CBR1000RR R Fireblade", year: 2020 },
  { make: "Honda", model: "CBR1000RR R Fireblade", year: 2021 },
  { make: "Honda", model: "CBR1000RR R Fireblade", year: 2022 },
  { make: "Honda", model: "CBR1000RR R Fireblade", year: 2023 },
  { make: "Honda", model: "CBR1000RR R Fireblade", year: 2024 },
  // Honda - CL500
  { make: "Honda", model: "CL500", year: 2023 },
  // Honda - CMX-500 Rebel
  { make: "Honda", model: "CMX-500 Rebel", year: 2017 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2018 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2019 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2020 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2021 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2022 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2023 },
  { make: "Honda", model: "CMX-500 Rebel", year: 2024 },
  // Honda - CMX1100 Rebel
  { make: "Honda", model: "CMX1100 Rebel", year: 2021 },
  { make: "Honda", model: "CMX1100 Rebel", year: 2022 },
  { make: "Honda", model: "CMX1100 Rebel", year: 2023 },
  { make: "Honda", model: "CMX1100 Rebel", year: 2024 },
  // Honda - CR80R
  { make: "Honda", model: "CR80R", year: 1996 },
  { make: "Honda", model: "CR80R", year: 1997 },
  { make: "Honda", model: "CR80R", year: 1998 },
  { make: "Honda", model: "CR80R", year: 1999 },
  { make: "Honda", model: "CR80R", year: 2000 },
  { make: "Honda", model: "CR80R", year: 2001 },
  { make: "Honda", model: "CR80R", year: 2002 },
  // Honda - CR85R
  { make: "Honda", model: "CR85R", year: 2003 },
  { make: "Honda", model: "CR85R", year: 2004 },
  { make: "Honda", model: "CR85R", year: 2005 },
  { make: "Honda", model: "CR85R", year: 2006 },
  { make: "Honda", model: "CR85R", year: 2007 },
  // Honda - CR125R
  { make: "Honda", model: "CR125R", year: 1990 },
  { make: "Honda", model: "CR125R", year: 1991 },
  { make: "Honda", model: "CR125R", year: 1992 },
  { make: "Honda", model: "CR125R", year: 1993 },
  { make: "Honda", model: "CR125R", year: 1994 },
  { make: "Honda", model: "CR125R", year: 1995 },
  { make: "Honda", model: "CR125R", year: 1996 },
  { make: "Honda", model: "CR125R", year: 1997 },
  { make: "Honda", model: "CR125R", year: 1998 },
  { make: "Honda", model: "CR125R", year: 1999 },
  { make: "Honda", model: "CR125R", year: 2000 },
  { make: "Honda", model: "CR125R", year: 2001 },
  { make: "Honda", model: "CR125R", year: 2002 },
  { make: "Honda", model: "CR125R", year: 2003 },
  { make: "Honda", model: "CR125R", year: 2004 },
  { make: "Honda", model: "CR125R", year: 2005 },
  { make: "Honda", model: "CR125R", year: 2006 },
  { make: "Honda", model: "CR125R", year: 2007 },
  // Honda - CR250R
  { make: "Honda", model: "CR250R", year: 1991 },
  { make: "Honda", model: "CR250R", year: 1992 },
  { make: "Honda", model: "CR250R", year: 1993 },
  { make: "Honda", model: "CR250R", year: 1994 },
  { make: "Honda", model: "CR250R", year: 1995 },
  { make: "Honda", model: "CR250R", year: 1996 },
  { make: "Honda", model: "CR250R", year: 1997 },
  { make: "Honda", model: "CR250R", year: 1998 },
  { make: "Honda", model: "CR250R", year: 1999 },
  { make: "Honda", model: "CR250R", year: 2000 },
  { make: "Honda", model: "CR250R", year: 2001 },
  { make: "Honda", model: "CR250R", year: 2002 },
  { make: "Honda", model: "CR250R", year: 2003 },
  { make: "Honda", model: "CR250R", year: 2004 },
  { make: "Honda", model: "CR250R", year: 2005 },
  { make: "Honda", model: "CR250R", year: 2006 },
  { make: "Honda", model: "CR250R", year: 2007 },
  // Honda - CR500R
  { make: "Honda", model: "CR500R", year: 1989 },
  { make: "Honda", model: "CR500R", year: 1990 },
  { make: "Honda", model: "CR500R", year: 1991 },
  { make: "Honda", model: "CR500R", year: 1992 },
  { make: "Honda", model: "CR500R", year: 1993 },
  { make: "Honda", model: "CR500R", year: 1994 },
  { make: "Honda", model: "CR500R", year: 1995 },
  { make: "Honda", model: "CR500R", year: 1996 },
  { make: "Honda", model: "CR500R", year: 1997 },
  { make: "Honda", model: "CR500R", year: 1998 },
  { make: "Honda", model: "CR500R", year: 1999 },
  { make: "Honda", model: "CR500R", year: 2000 },
  { make: "Honda", model: "CR500R", year: 2001 },
  // Honda - CRF-110F
  { make: "Honda", model: "CRF-110F", year: 2013 },
  { make: "Honda", model: "CRF-110F", year: 2014 },
  { make: "Honda", model: "CRF-110F", year: 2015 },
  { make: "Honda", model: "CRF-110F", year: 2016 },
  { make: "Honda", model: "CRF-110F", year: 2017 },
  { make: "Honda", model: "CRF-110F", year: 2018 },
  { make: "Honda", model: "CRF-110F", year: 2019 },
  { make: "Honda", model: "CRF-110F", year: 2020 },
  { make: "Honda", model: "CRF-110F", year: 2021 },
  { make: "Honda", model: "CRF-110F", year: 2022 },
  { make: "Honda", model: "CRF-110F", year: 2023 },
  // Honda - CRF-150F
  { make: "Honda", model: "CRF-150F", year: 2003 },
  { make: "Honda", model: "CRF-150F", year: 2004 },
  { make: "Honda", model: "CRF-150F", year: 2005 },
  { make: "Honda", model: "CRF-150F", year: 2006 },
  { make: "Honda", model: "CRF-150F", year: 2007 },
  { make: "Honda", model: "CRF-150F", year: 2008 },
  { make: "Honda", model: "CRF-150F", year: 2009 },
  { make: "Honda", model: "CRF-150F", year: 2010 },
  { make: "Honda", model: "CRF-150F", year: 2011 },
  { make: "Honda", model: "CRF-150F", year: 2012 },
  { make: "Honda", model: "CRF-150F", year: 2013 },
  { make: "Honda", model: "CRF-150F", year: 2014 },
  { make: "Honda", model: "CRF-150F", year: 2015 },
  { make: "Honda", model: "CRF-150F", year: 2016 },
  { make: "Honda", model: "CRF-150F", year: 2017 },
  // Honda - CRF-230L Street Model
  { make: "Honda", model: "CRF-230L Street Model", year: 2008 },
  { make: "Honda", model: "CRF-230L Street Model", year: 2009 },
  // Honda - CRF-230L Street Model Evo
  { make: "Honda", model: "CRF-230L Street Model Evo", year: 2008 },
  { make: "Honda", model: "CRF-230L Street Model Evo", year: 2009 },
  // Honda - CRF-250 L Rally
  { make: "Honda", model: "CRF-250 L Rally", year: 2017 },
  { make: "Honda", model: "CRF-250 L Rally", year: 2018 },
  // Honda - CRF-250L
  { make: "Honda", model: "CRF-250L", year: 2013 },
  { make: "Honda", model: "CRF-250L", year: 2014 },
  { make: "Honda", model: "CRF-250L", year: 2015 },
  { make: "Honda", model: "CRF-250L", year: 2016 },
  { make: "Honda", model: "CRF-250L", year: 2017 },
  { make: "Honda", model: "CRF-250L", year: 2018 },
  { make: "Honda", model: "CRF-250L", year: 2019 },
  // Honda - CRF-250R
  { make: "Honda", model: "CRF-250R", year: 2004 },
  { make: "Honda", model: "CRF-250R", year: 2005 },
  { make: "Honda", model: "CRF-250R", year: 2006 },
  { make: "Honda", model: "CRF-250R", year: 2007 },
  { make: "Honda", model: "CRF-250R", year: 2008 },
  { make: "Honda", model: "CRF-250R", year: 2009 },
  { make: "Honda", model: "CRF-250R", year: 2010 },
  { make: "Honda", model: "CRF-250R", year: 2011 },
  { make: "Honda", model: "CRF-250R", year: 2012 },
  { make: "Honda", model: "CRF-250R", year: 2013 },
  { make: "Honda", model: "CRF-250R", year: 2022 },
  { make: "Honda", model: "CRF-250R", year: 2023 },
  // Honda - CRF-300 L E5
  { make: "Honda", model: "CRF-300 L E5", year: 2025 },
  // Honda - CRF-450R
  { make: "Honda", model: "CRF-450R", year: 2006 },
  { make: "Honda", model: "CRF-450R", year: 2007 },
  { make: "Honda", model: "CRF-450R", year: 2008 },
  { make: "Honda", model: "CRF-450R", year: 2009 },
  { make: "Honda", model: "CRF-450R", year: 2010 },
  { make: "Honda", model: "CRF-450R", year: 2011 },
  { make: "Honda", model: "CRF-450R", year: 2012 },
  { make: "Honda", model: "CRF-450R", year: 2013 },
  { make: "Honda", model: "CRF-450R", year: 2014 },
  { make: "Honda", model: "CRF-450R", year: 2015 },
  { make: "Honda", model: "CRF-450R", year: 2016 },
  { make: "Honda", model: "CRF-450R", year: 2019 },
  { make: "Honda", model: "CRF-450R", year: 2020 },
  { make: "Honda", model: "CRF-450R", year: 2021 },
  { make: "Honda", model: "CRF-450R", year: 2022 },
  { make: "Honda", model: "CRF-450R", year: 2023 },
  // Honda - CRF-450R Evo R Mx
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2015 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2016 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2019 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2020 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2021 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2022 },
  { make: "Honda", model: "CRF-450R Evo R Mx", year: 2023 },
  // Honda - CRF-450X
  { make: "Honda", model: "CRF-450X", year: 2005 },
  { make: "Honda", model: "CRF-450X", year: 2006 },
  { make: "Honda", model: "CRF-450X", year: 2007 },
  { make: "Honda", model: "CRF-450X", year: 2008 },
  { make: "Honda", model: "CRF-450X", year: 2009 },
  { make: "Honda", model: "CRF-450X", year: 2010 },
  { make: "Honda", model: "CRF-450X", year: 2011 },
  { make: "Honda", model: "CRF-450X", year: 2012 },
  { make: "Honda", model: "CRF-450X", year: 2013 },
  { make: "Honda", model: "CRF-450X", year: 2014 },
  { make: "Honda", model: "CRF-450X", year: 2015 },
  { make: "Honda", model: "CRF-450X", year: 2016 },
  { make: "Honda", model: "CRF-450X", year: 2017 },
  { make: "Honda", model: "CRF-450X", year: 2019 },
  { make: "Honda", model: "CRF-450X", year: 2020 },
  { make: "Honda", model: "CRF-450X", year: 2021 },
  { make: "Honda", model: "CRF-450X", year: 2022 },
  { make: "Honda", model: "CRF-450X", year: 2023 },
  // Honda - CRF-1000 Africa Twin Okami
  { make: "Honda", model: "CRF-1000 Africa Twin Okami", year: 2018 },
  // Honda - CRF-1000 L Africa Twin
  { make: "Honda", model: "CRF-1000 L Africa Twin", year: 2016 },
  { make: "Honda", model: "CRF-1000 L Africa Twin", year: 2017 },
  // Honda - CRF-1000L Africa Twin
  { make: "Honda", model: "CRF-1000L Africa Twin", year: 2016 },
  { make: "Honda", model: "CRF-1000L Africa Twin", year: 2017 },
  // Honda - CRF50F
  { make: "Honda", model: "CRF50F", year: 2004 },
  { make: "Honda", model: "CRF50F", year: 2005 },
  { make: "Honda", model: "CRF50F", year: 2006 },
  { make: "Honda", model: "CRF50F", year: 2007 },
  { make: "Honda", model: "CRF50F", year: 2008 },
  { make: "Honda", model: "CRF50F", year: 2009 },
  { make: "Honda", model: "CRF50F", year: 2010 },
  { make: "Honda", model: "CRF50F", year: 2011 },
  { make: "Honda", model: "CRF50F", year: 2012 },
  { make: "Honda", model: "CRF50F", year: 2013 },
  { make: "Honda", model: "CRF50F", year: 2014 },
  { make: "Honda", model: "CRF50F", year: 2015 },
  { make: "Honda", model: "CRF50F", year: 2016 },
  { make: "Honda", model: "CRF50F", year: 2017 },
  { make: "Honda", model: "CRF50F", year: 2018 },
  { make: "Honda", model: "CRF50F", year: 2019 },
  { make: "Honda", model: "CRF50F", year: 2020 },
  { make: "Honda", model: "CRF50F", year: 2021 },
  { make: "Honda", model: "CRF50F", year: 2022 },
  { make: "Honda", model: "CRF50F", year: 2023 },
  { make: "Honda", model: "CRF50F", year: 2024 },
  { make: "Honda", model: "CRF50F", year: 2025 },
  { make: "Honda", model: "CRF50F", year: 2026 },
  { make: "Honda", model: "CRF50F", year: 2027 },
  // Honda - CRF70F
  { make: "Honda", model: "CRF70F", year: 2005 },
  { make: "Honda", model: "CRF70F", year: 2006 },
  { make: "Honda", model: "CRF70F", year: 2007 },
  { make: "Honda", model: "CRF70F", year: 2008 },
  { make: "Honda", model: "CRF70F", year: 2009 },
  { make: "Honda", model: "CRF70F", year: 2010 },
  { make: "Honda", model: "CRF70F", year: 2011 },
  { make: "Honda", model: "CRF70F", year: 2012 },
  // Honda - CRF80F
  { make: "Honda", model: "CRF80F", year: 2004 },
  { make: "Honda", model: "CRF80F", year: 2005 },
  { make: "Honda", model: "CRF80F", year: 2006 },
  { make: "Honda", model: "CRF80F", year: 2007 },
  { make: "Honda", model: "CRF80F", year: 2008 },
  { make: "Honda", model: "CRF80F", year: 2009 },
  { make: "Honda", model: "CRF80F", year: 2010 },
  { make: "Honda", model: "CRF80F", year: 2011 },
  { make: "Honda", model: "CRF80F", year: 2012 },
  { make: "Honda", model: "CRF80F", year: 2013 },
  // Honda - CRF100F
  { make: "Honda", model: "CRF100F", year: 2004 },
  { make: "Honda", model: "CRF100F", year: 2005 },
  { make: "Honda", model: "CRF100F", year: 2006 },
  { make: "Honda", model: "CRF100F", year: 2007 },
  { make: "Honda", model: "CRF100F", year: 2008 },
  { make: "Honda", model: "CRF100F", year: 2009 },
  { make: "Honda", model: "CRF100F", year: 2010 },
  { make: "Honda", model: "CRF100F", year: 2011 },
  { make: "Honda", model: "CRF100F", year: 2012 },
  { make: "Honda", model: "CRF100F", year: 2013 },
  // Honda - CRF110F
  { make: "Honda", model: "CRF110F", year: 2013 },
  { make: "Honda", model: "CRF110F", year: 2014 },
  { make: "Honda", model: "CRF110F", year: 2015 },
  { make: "Honda", model: "CRF110F", year: 2016 },
  { make: "Honda", model: "CRF110F", year: 2017 },
  { make: "Honda", model: "CRF110F", year: 2018 },
  { make: "Honda", model: "CRF110F", year: 2019 },
  { make: "Honda", model: "CRF110F", year: 2020 },
  { make: "Honda", model: "CRF110F", year: 2021 },
  { make: "Honda", model: "CRF110F", year: 2022 },
  { make: "Honda", model: "CRF110F", year: 2023 },
  { make: "Honda", model: "CRF110F", year: 2024 },
  { make: "Honda", model: "CRF110F", year: 2025 },
  { make: "Honda", model: "CRF110F", year: 2026 },
  { make: "Honda", model: "CRF110F", year: 2027 },
  // Honda - CRF125F
  { make: "Honda", model: "CRF125F", year: 2014 },
  { make: "Honda", model: "CRF125F", year: 2015 },
  { make: "Honda", model: "CRF125F", year: 2016 },
  { make: "Honda", model: "CRF125F", year: 2017 },
  { make: "Honda", model: "CRF125F", year: 2018 },
  { make: "Honda", model: "CRF125F", year: 2019 },
  { make: "Honda", model: "CRF125F", year: 2020 },
  { make: "Honda", model: "CRF125F", year: 2021 },
  { make: "Honda", model: "CRF125F", year: 2022 },
  { make: "Honda", model: "CRF125F", year: 2023 },
  { make: "Honda", model: "CRF125F", year: 2024 },
  { make: "Honda", model: "CRF125F", year: 2025 },
  { make: "Honda", model: "CRF125F", year: 2026 },
  { make: "Honda", model: "CRF125F", year: 2027 },
  // Honda - CRF125F Big Wheel
  { make: "Honda", model: "CRF125F Big Wheel", year: 2014 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2015 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2016 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2017 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2018 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2019 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2020 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2021 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2022 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2023 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2024 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2025 },
  { make: "Honda", model: "CRF125F Big Wheel", year: 2026 },
  // Honda - CRF150F
  { make: "Honda", model: "CRF150F", year: 2003 },
  { make: "Honda", model: "CRF150F", year: 2004 },
  { make: "Honda", model: "CRF150F", year: 2005 },
  { make: "Honda", model: "CRF150F", year: 2006 },
  { make: "Honda", model: "CRF150F", year: 2007 },
  { make: "Honda", model: "CRF150F", year: 2008 },
  { make: "Honda", model: "CRF150F", year: 2009 },
  { make: "Honda", model: "CRF150F", year: 2010 },
  { make: "Honda", model: "CRF150F", year: 2011 },
  { make: "Honda", model: "CRF150F", year: 2012 },
  { make: "Honda", model: "CRF150F", year: 2013 },
  { make: "Honda", model: "CRF150F", year: 2014 },
  { make: "Honda", model: "CRF150F", year: 2015 },
  { make: "Honda", model: "CRF150F", year: 2016 },
  { make: "Honda", model: "CRF150F", year: 2017 },
  // Honda - CRF150R
  { make: "Honda", model: "CRF150R", year: 2007 },
  { make: "Honda", model: "CRF150R", year: 2008 },
  { make: "Honda", model: "CRF150R", year: 2009 },
  { make: "Honda", model: "CRF150R", year: 2010 },
  { make: "Honda", model: "CRF150R", year: 2011 },
  { make: "Honda", model: "CRF150R", year: 2012 },
  { make: "Honda", model: "CRF150R", year: 2013 },
  { make: "Honda", model: "CRF150R", year: 2014 },
  { make: "Honda", model: "CRF150R", year: 2015 },
  { make: "Honda", model: "CRF150R", year: 2016 },
  { make: "Honda", model: "CRF150R", year: 2017 },
  { make: "Honda", model: "CRF150R", year: 2018 },
  { make: "Honda", model: "CRF150R", year: 2019 },
  { make: "Honda", model: "CRF150R", year: 2020 },
  { make: "Honda", model: "CRF150R", year: 2021 },
  { make: "Honda", model: "CRF150R", year: 2022 },
  { make: "Honda", model: "CRF150R", year: 2023 },
  { make: "Honda", model: "CRF150R", year: 2024 },
  { make: "Honda", model: "CRF150R", year: 2025 },
  { make: "Honda", model: "CRF150R", year: 2026 },
  // Honda - CRF150R Expert
  { make: "Honda", model: "CRF150R Expert", year: 2007 },
  { make: "Honda", model: "CRF150R Expert", year: 2008 },
  { make: "Honda", model: "CRF150R Expert", year: 2009 },
  { make: "Honda", model: "CRF150R Expert", year: 2010 },
  { make: "Honda", model: "CRF150R Expert", year: 2011 },
  { make: "Honda", model: "CRF150R Expert", year: 2012 },
  { make: "Honda", model: "CRF150R Expert", year: 2013 },
  { make: "Honda", model: "CRF150R Expert", year: 2014 },
  { make: "Honda", model: "CRF150R Expert", year: 2015 },
  { make: "Honda", model: "CRF150R Expert", year: 2016 },
  { make: "Honda", model: "CRF150R Expert", year: 2017 },
  { make: "Honda", model: "CRF150R Expert", year: 2018 },
  { make: "Honda", model: "CRF150R Expert", year: 2019 },
  { make: "Honda", model: "CRF150R Expert", year: 2020 },
  { make: "Honda", model: "CRF150R Expert", year: 2021 },
  { make: "Honda", model: "CRF150R Expert", year: 2022 },
  { make: "Honda", model: "CRF150R Expert", year: 2023 },
  { make: "Honda", model: "CRF150R Expert", year: 2024 },
  { make: "Honda", model: "CRF150R Expert", year: 2025 },
  { make: "Honda", model: "CRF150R Expert", year: 2026 },
  // Honda - CRF230F
  { make: "Honda", model: "CRF230F", year: 2003 },
  { make: "Honda", model: "CRF230F", year: 2004 },
  { make: "Honda", model: "CRF230F", year: 2005 },
  { make: "Honda", model: "CRF230F", year: 2006 },
  { make: "Honda", model: "CRF230F", year: 2007 },
  { make: "Honda", model: "CRF230F", year: 2008 },
  { make: "Honda", model: "CRF230F", year: 2009 },
  { make: "Honda", model: "CRF230F", year: 2010 },
  { make: "Honda", model: "CRF230F", year: 2011 },
  { make: "Honda", model: "CRF230F", year: 2012 },
  { make: "Honda", model: "CRF230F", year: 2013 },
  { make: "Honda", model: "CRF230F", year: 2014 },
  { make: "Honda", model: "CRF230F", year: 2015 },
  { make: "Honda", model: "CRF230F", year: 2016 },
  { make: "Honda", model: "CRF230F", year: 2017 },
  { make: "Honda", model: "CRF230F", year: 2018 },
  { make: "Honda", model: "CRF230F", year: 2019 },
  // Honda - CRF230L
  { make: "Honda", model: "CRF230L", year: 2008 },
  { make: "Honda", model: "CRF230L", year: 2009 },
  // Honda - CRF230M
  { make: "Honda", model: "CRF230M", year: 2009 },
  // Honda - CRF250F
  { make: "Honda", model: "CRF250F", year: 2019 },
  { make: "Honda", model: "CRF250F", year: 2020 },
  { make: "Honda", model: "CRF250F", year: 2021 },
  { make: "Honda", model: "CRF250F", year: 2022 },
  { make: "Honda", model: "CRF250F", year: 2023 },
  { make: "Honda", model: "CRF250F", year: 2024 },
  { make: "Honda", model: "CRF250F", year: 2025 },
  { make: "Honda", model: "CRF250F", year: 2026 },
  // Honda - CRF250L
  { make: "Honda", model: "CRF250L", year: 2013 },
  { make: "Honda", model: "CRF250L", year: 2014 },
  { make: "Honda", model: "CRF250L", year: 2015 },
  { make: "Honda", model: "CRF250L", year: 2016 },
  { make: "Honda", model: "CRF250L", year: 2017 },
  { make: "Honda", model: "CRF250L", year: 2018 },
  { make: "Honda", model: "CRF250L", year: 2019 },
  { make: "Honda", model: "CRF250L", year: 2020 },
  { make: "Honda", model: "CRF250L", year: 2021 },
  // Honda - CRF250L Rally
  { make: "Honda", model: "CRF250L Rally", year: 2017 },
  { make: "Honda", model: "CRF250L Rally", year: 2018 },
  { make: "Honda", model: "CRF250L Rally", year: 2019 },
  { make: "Honda", model: "CRF250L Rally", year: 2020 },
  // Honda - CRF250R
  { make: "Honda", model: "CRF250R", year: 2004 },
  { make: "Honda", model: "CRF250R", year: 2005 },
  { make: "Honda", model: "CRF250R", year: 2006 },
  { make: "Honda", model: "CRF250R", year: 2007 },
  { make: "Honda", model: "CRF250R", year: 2008 },
  { make: "Honda", model: "CRF250R", year: 2009 },
  { make: "Honda", model: "CRF250R", year: 2010 },
  { make: "Honda", model: "CRF250R", year: 2011 },
  { make: "Honda", model: "CRF250R", year: 2012 },
  { make: "Honda", model: "CRF250R", year: 2013 },
  { make: "Honda", model: "CRF250R", year: 2014 },
  { make: "Honda", model: "CRF250R", year: 2015 },
  { make: "Honda", model: "CRF250R", year: 2016 },
  { make: "Honda", model: "CRF250R", year: 2017 },
  { make: "Honda", model: "CRF250R", year: 2018 },
  { make: "Honda", model: "CRF250R", year: 2019 },
  { make: "Honda", model: "CRF250R", year: 2020 },
  { make: "Honda", model: "CRF250R", year: 2021 },
  { make: "Honda", model: "CRF250R", year: 2022 },
  { make: "Honda", model: "CRF250R", year: 2023 },
  { make: "Honda", model: "CRF250R", year: 2024 },
  { make: "Honda", model: "CRF250R", year: 2025 },
  { make: "Honda", model: "CRF250R", year: 2026 },
  // Honda - CRF250RX
  { make: "Honda", model: "CRF250RX", year: 2019 },
  { make: "Honda", model: "CRF250RX", year: 2020 },
  { make: "Honda", model: "CRF250RX", year: 2021 },
  { make: "Honda", model: "CRF250RX", year: 2022 },
  { make: "Honda", model: "CRF250RX", year: 2023 },
  { make: "Honda", model: "CRF250RX", year: 2024 },
  { make: "Honda", model: "CRF250RX", year: 2025 },
  { make: "Honda", model: "CRF250RX", year: 2026 },
  // Honda - CRF250X
  { make: "Honda", model: "CRF250X", year: 2004 },
  { make: "Honda", model: "CRF250X", year: 2005 },
  { make: "Honda", model: "CRF250X", year: 2006 },
  { make: "Honda", model: "CRF250X", year: 2007 },
  { make: "Honda", model: "CRF250X", year: 2008 },
  { make: "Honda", model: "CRF250X", year: 2009 },
  { make: "Honda", model: "CRF250X", year: 2012 },
  { make: "Honda", model: "CRF250X", year: 2013 },
  { make: "Honda", model: "CRF250X", year: 2014 },
  { make: "Honda", model: "CRF250X", year: 2015 },
  { make: "Honda", model: "CRF250X", year: 2016 },
  { make: "Honda", model: "CRF250X", year: 2017 },
  // Honda - CRF300L
  { make: "Honda", model: "CRF300L", year: 2021 },
  { make: "Honda", model: "CRF300L", year: 2022 },
  { make: "Honda", model: "CRF300L", year: 2023 },
  { make: "Honda", model: "CRF300L", year: 2024 },
  { make: "Honda", model: "CRF300L", year: 2025 },
  { make: "Honda", model: "CRF300L", year: 2026 },
  // Honda - CRF300L Rally
  { make: "Honda", model: "CRF300L Rally", year: 2021 },
  { make: "Honda", model: "CRF300L Rally", year: 2022 },
  { make: "Honda", model: "CRF300L Rally", year: 2023 },
  { make: "Honda", model: "CRF300L Rally", year: 2024 },
  { make: "Honda", model: "CRF300L Rally", year: 2025 },
  { make: "Honda", model: "CRF300L Rally", year: 2026 },
  // Honda - CRF300L S H3SO11 Bnta
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2021 },
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2022 },
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2023 },
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2024 },
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2025 },
  { make: "Honda", model: "CRF300L S H3SO11 Bnta", year: 2026 },
  // Honda - CRF450R
  { make: "Honda", model: "CRF450R", year: 2002 },
  { make: "Honda", model: "CRF450R", year: 2003 },
  { make: "Honda", model: "CRF450R", year: 2004 },
  { make: "Honda", model: "CRF450R", year: 2005 },
  { make: "Honda", model: "CRF450R", year: 2006 },
  { make: "Honda", model: "CRF450R", year: 2007 },
  { make: "Honda", model: "CRF450R", year: 2008 },
  { make: "Honda", model: "CRF450R", year: 2009 },
  { make: "Honda", model: "CRF450R", year: 2010 },
  { make: "Honda", model: "CRF450R", year: 2011 },
  { make: "Honda", model: "CRF450R", year: 2012 },
  { make: "Honda", model: "CRF450R", year: 2013 },
  { make: "Honda", model: "CRF450R", year: 2014 },
  { make: "Honda", model: "CRF450R", year: 2015 },
  { make: "Honda", model: "CRF450R", year: 2016 },
  { make: "Honda", model: "CRF450R", year: 2017 },
  { make: "Honda", model: "CRF450R", year: 2018 },
  { make: "Honda", model: "CRF450R", year: 2019 },
  { make: "Honda", model: "CRF450R", year: 2020 },
  { make: "Honda", model: "CRF450R", year: 2021 },
  { make: "Honda", model: "CRF450R", year: 2022 },
  { make: "Honda", model: "CRF450R", year: 2023 },
  { make: "Honda", model: "CRF450R", year: 2024 },
  { make: "Honda", model: "CRF450R", year: 2025 },
  { make: "Honda", model: "CRF450R", year: 2026 },
  // Honda - CRF450R-S
  { make: "Honda", model: "CRF450R-S", year: 2021 },
  { make: "Honda", model: "CRF450R-S", year: 2022 },
  { make: "Honda", model: "CRF450R-S", year: 2023 },
  { make: "Honda", model: "CRF450R-S", year: 2024 },
  { make: "Honda", model: "CRF450R-S", year: 2025 },
  { make: "Honda", model: "CRF450R-S", year: 2026 },
  // Honda - CRF450RL
  { make: "Honda", model: "CRF450RL", year: 2019 },
  { make: "Honda", model: "CRF450RL", year: 2020 },
  { make: "Honda", model: "CRF450RL", year: 2021 },
  { make: "Honda", model: "CRF450RL", year: 2022 },
  { make: "Honda", model: "CRF450RL", year: 2023 },
  { make: "Honda", model: "CRF450RL", year: 2024 },
  { make: "Honda", model: "CRF450RL", year: 2025 },
  { make: "Honda", model: "CRF450RL", year: 2026 },
  // Honda - CRF450RX
  { make: "Honda", model: "CRF450RX", year: 2017 },
  { make: "Honda", model: "CRF450RX", year: 2018 },
  { make: "Honda", model: "CRF450RX", year: 2019 },
  { make: "Honda", model: "CRF450RX", year: 2020 },
  { make: "Honda", model: "CRF450RX", year: 2021 },
  { make: "Honda", model: "CRF450RX", year: 2022 },
  { make: "Honda", model: "CRF450RX", year: 2023 },
  { make: "Honda", model: "CRF450RX", year: 2024 },
  { make: "Honda", model: "CRF450RX", year: 2025 },
  { make: "Honda", model: "CRF450RX", year: 2026 },
  // Honda - CRF450X
  { make: "Honda", model: "CRF450X", year: 2005 },
  { make: "Honda", model: "CRF450X", year: 2006 },
  { make: "Honda", model: "CRF450X", year: 2007 },
  { make: "Honda", model: "CRF450X", year: 2008 },
  { make: "Honda", model: "CRF450X", year: 2009 },
  { make: "Honda", model: "CRF450X", year: 2010 },
  { make: "Honda", model: "CRF450X", year: 2011 },
  { make: "Honda", model: "CRF450X", year: 2012 },
  { make: "Honda", model: "CRF450X", year: 2013 },
  { make: "Honda", model: "CRF450X", year: 2014 },
  { make: "Honda", model: "CRF450X", year: 2015 },
  { make: "Honda", model: "CRF450X", year: 2016 },
  { make: "Honda", model: "CRF450X", year: 2017 },
  { make: "Honda", model: "CRF450X", year: 2018 },
  { make: "Honda", model: "CRF450X", year: 2019 },
  { make: "Honda", model: "CRF450X", year: 2020 },
  { make: "Honda", model: "CRF450X", year: 2021 },
  { make: "Honda", model: "CRF450X", year: 2022 },
  { make: "Honda", model: "CRF450X", year: 2023 },
  { make: "Honda", model: "CRF450X", year: 2024 },
  { make: "Honda", model: "CRF450X", year: 2025 },
  { make: "Honda", model: "CRF450X", year: 2026 },
  { make: "Honda", model: "CRF450X", year: 2027 },
  // Honda - CRF1000L Africa Twin 70KW SD04
  { make: "Honda", model: "CRF1000L Africa Twin 70KW SD04", year: 2017 },
  // Honda - CRF1000L Africa Twin Okami
  { make: "Honda", model: "CRF1000L Africa Twin Okami", year: 2016 },
  // Honda - CRF1100L
  { make: "Honda", model: "CRF1100L", year: 2020 },
  { make: "Honda", model: "CRF1100L", year: 2021 },
  { make: "Honda", model: "CRF1100L", year: 2022 },
  { make: "Honda", model: "CRF1100L", year: 2023 },
  { make: "Honda", model: "CRF1100L", year: 2024 },
  { make: "Honda", model: "CRF1100L", year: 2025 },
  // Honda - CRF1100L Africa Twin
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2020 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2021 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2022 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2023 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2024 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2025 },
  { make: "Honda", model: "CRF1100L Africa Twin", year: 2026 },
  // Honda - FMX-650
  { make: "Honda", model: "FMX-650", year: 2005 },
  { make: "Honda", model: "FMX-650", year: 2006 },
  // Honda - Foreman 500
  { make: "Honda", model: "Foreman 500", year: 2012 },
  { make: "Honda", model: "Foreman 500", year: 2013 },
  // Honda - Forza 125
  { make: "Honda", model: "Forza 125", year: 2015 },
  { make: "Honda", model: "Forza 125", year: 2016 },
  { make: "Honda", model: "Forza 125", year: 2017 },
  { make: "Honda", model: "Forza 125", year: 2018 },
  { make: "Honda", model: "Forza 125", year: 2019 },
  { make: "Honda", model: "Forza 125", year: 2020 },
  // Honda - Forza 300
  { make: "Honda", model: "Forza 300", year: 2018 },
  { make: "Honda", model: "Forza 300", year: 2019 },
  { make: "Honda", model: "Forza 300", year: 2020 },
  // Honda - Forza 750
  { make: "Honda", model: "Forza 750", year: 2021 },
  { make: "Honda", model: "Forza 750", year: 2022 },
  { make: "Honda", model: "Forza 750", year: 2023 },
  { make: "Honda", model: "Forza 750", year: 2024 },
  // Honda - Forza 750 E5
  { make: "Honda", model: "Forza 750 E5", year: 2025 },
  // Honda - GL1800 Gold Wing Dtc
  { make: "Honda", model: "GL1800 Gold Wing Dtc", year: 2019 },
  // Honda - Grom
  { make: "Honda", model: "Grom", year: 2014 },
  { make: "Honda", model: "Grom", year: 2015 },
  { make: "Honda", model: "Grom", year: 2016 },
  { make: "Honda", model: "Grom", year: 2017 },
  { make: "Honda", model: "Grom", year: 2018 },
  { make: "Honda", model: "Grom", year: 2019 },
  { make: "Honda", model: "Grom", year: 2020 },
  { make: "Honda", model: "Grom", year: 2021 },
  { make: "Honda", model: "Grom", year: 2022 },
  { make: "Honda", model: "Grom", year: 2023 },
  { make: "Honda", model: "Grom", year: 2024 },
  { make: "Honda", model: "Grom", year: 2025 },
  { make: "Honda", model: "Grom", year: 2026 },
  // Honda - GROM-125
  { make: "Honda", model: "GROM-125", year: 2014 },
  { make: "Honda", model: "GROM-125", year: 2015 },
  // Honda - Hornet 600
  { make: "Honda", model: "Hornet 600", year: 2007 },
  { make: "Honda", model: "Hornet 600", year: 2008 },
  { make: "Honda", model: "Hornet 600", year: 2009 },
  { make: "Honda", model: "Hornet 600", year: 2010 },
  { make: "Honda", model: "Hornet 600", year: 2011 },
  // Honda - Hornet 750
  { make: "Honda", model: "Hornet 750", year: 2023 },
  { make: "Honda", model: "Hornet 750", year: 2024 },
  { make: "Honda", model: "Hornet 750", year: 2025 },
  { make: "Honda", model: "Hornet 750", year: 2026 },
  // Honda - Monkey
  { make: "Honda", model: "Monkey", year: 2019 },
  { make: "Honda", model: "Monkey", year: 2020 },
  { make: "Honda", model: "Monkey", year: 2021 },
  { make: "Honda", model: "Monkey", year: 2022 },
  { make: "Honda", model: "Monkey", year: 2023 },
  { make: "Honda", model: "Monkey", year: 2024 },
  { make: "Honda", model: "Monkey", year: 2025 },
  { make: "Honda", model: "Monkey", year: 2026 },
  // Honda - MSX-125
  { make: "Honda", model: "MSX-125", year: 2021 },
  { make: "Honda", model: "MSX-125", year: 2022 },
  // Honda - NC-750X
  { make: "Honda", model: "NC-750X", year: 2021 },
  { make: "Honda", model: "NC-750X", year: 2022 },
  // Honda - NC750X
  { make: "Honda", model: "NC750X", year: 2012 },
  { make: "Honda", model: "NC750X", year: 2013 },
  { make: "Honda", model: "NC750X", year: 2014 },
  { make: "Honda", model: "NC750X", year: 2015 },
  { make: "Honda", model: "NC750X", year: 2016 },
  { make: "Honda", model: "NC750X", year: 2017 },
  { make: "Honda", model: "NC750X", year: 2018 },
  { make: "Honda", model: "NC750X", year: 2019 },
  { make: "Honda", model: "NC750X", year: 2020 },
  { make: "Honda", model: "NC750X", year: 2021 },
  { make: "Honda", model: "NC750X", year: 2022 },
  { make: "Honda", model: "NC750X", year: 2023 },
  { make: "Honda", model: "NC750X", year: 2024 },
  { make: "Honda", model: "NC750X", year: 2025 },
  { make: "Honda", model: "NC750X", year: 2026 },
  // Honda - NT1100
  { make: "Honda", model: "NT1100", year: 2022 },
  { make: "Honda", model: "NT1100", year: 2023 },
  { make: "Honda", model: "NT1100", year: 2024 },
  { make: "Honda", model: "NT1100", year: 2025 },
  { make: "Honda", model: "NT1100", year: 2026 },
  // Honda - NT1100 S H11SO3 Hgit
  { make: "Honda", model: "NT1100 S H11SO3 Hgit", year: 2022 },
  { make: "Honda", model: "NT1100 S H11SO3 Hgit", year: 2023 },
  { make: "Honda", model: "NT1100 S H11SO3 Hgit", year: 2024 },
  { make: "Honda", model: "NT1100 S H11SO3 Hgit", year: 2025 },
  { make: "Honda", model: "NT1100 S H11SO3 Hgit", year: 2026 },
  // Honda - NX500
  { make: "Honda", model: "NX500", year: 2024 },
  { make: "Honda", model: "NX500", year: 2025 },
  { make: "Honda", model: "NX500", year: 2026 },
  // Honda - PCX-125
  { make: "Honda", model: "PCX-125", year: 2012 },
  { make: "Honda", model: "PCX-125", year: 2013 },
  { make: "Honda", model: "PCX-125", year: 2014 },
  { make: "Honda", model: "PCX-125", year: 2015 },
  { make: "Honda", model: "PCX-125", year: 2016 },
  { make: "Honda", model: "PCX-125", year: 2017 },
  { make: "Honda", model: "PCX-125", year: 2018 },
  { make: "Honda", model: "PCX-125", year: 2019 },
  // Honda - PCX125
  { make: "Honda", model: "PCX125", year: 2018 },
  { make: "Honda", model: "PCX125", year: 2019 },
  // Honda - Rancher 420 Straight Axle
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2014 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2015 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2016 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2017 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2018 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2019 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2020 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2021 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2022 },
  { make: "Honda", model: "Rancher 420 Straight Axle", year: 2023 },
  // Honda - Rancher 420 Straight Axle Evo
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2014 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2015 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2016 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2017 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2018 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2019 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2020 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2021 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2022 },
  { make: "Honda", model: "Rancher 420 Straight Axle Evo", year: 2023 },
  // Honda - Rebel 300
  { make: "Honda", model: "Rebel 300", year: 2017 },
  { make: "Honda", model: "Rebel 300", year: 2018 },
  { make: "Honda", model: "Rebel 300", year: 2019 },
  { make: "Honda", model: "Rebel 300", year: 2020 },
  { make: "Honda", model: "Rebel 300", year: 2021 },
  { make: "Honda", model: "Rebel 300", year: 2022 },
  { make: "Honda", model: "Rebel 300", year: 2023 },
  { make: "Honda", model: "Rebel 300", year: 2024 },
  { make: "Honda", model: "Rebel 300", year: 2025 },
  { make: "Honda", model: "Rebel 300", year: 2026 },
  // Honda - Rebel 300/500
  { make: "Honda", model: "Rebel 300/500", year: 2017 },
  { make: "Honda", model: "Rebel 300/500", year: 2018 },
  { make: "Honda", model: "Rebel 300/500", year: 2019 },
  { make: "Honda", model: "Rebel 300/500", year: 2020 },
  { make: "Honda", model: "Rebel 300/500", year: 2021 },
  { make: "Honda", model: "Rebel 300/500", year: 2022 },
  { make: "Honda", model: "Rebel 300/500", year: 2023 },
  { make: "Honda", model: "Rebel 300/500", year: 2024 },
  { make: "Honda", model: "Rebel 300/500", year: 2025 },
  { make: "Honda", model: "Rebel 300/500", year: 2026 },
  // Honda - Rebel 500
  { make: "Honda", model: "Rebel 500", year: 2017 },
  { make: "Honda", model: "Rebel 500", year: 2018 },
  { make: "Honda", model: "Rebel 500", year: 2019 },
  { make: "Honda", model: "Rebel 500", year: 2020 },
  { make: "Honda", model: "Rebel 500", year: 2021 },
  { make: "Honda", model: "Rebel 500", year: 2022 },
  { make: "Honda", model: "Rebel 500", year: 2023 },
  { make: "Honda", model: "Rebel 500", year: 2024 },
  { make: "Honda", model: "Rebel 500", year: 2025 },
  { make: "Honda", model: "Rebel 500", year: 2026 },
  { make: "Honda", model: "Rebel 500", year: 2027 },
  // Honda - Rebel 1100
  { make: "Honda", model: "Rebel 1100", year: 2021 },
  { make: "Honda", model: "Rebel 1100", year: 2022 },
  { make: "Honda", model: "Rebel 1100", year: 2023 },
  { make: "Honda", model: "Rebel 1100", year: 2024 },
  { make: "Honda", model: "Rebel 1100", year: 2025 },
  { make: "Honda", model: "Rebel 1100", year: 2026 },
  // Honda - Rubicon 500 4X4
  { make: "Honda", model: "Rubicon 500 4X4", year: 2015 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2016 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2017 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2018 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2019 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2020 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2021 },
  { make: "Honda", model: "Rubicon 500 4X4", year: 2022 },
  // Honda - SCL500
  { make: "Honda", model: "SCL500", year: 2023 },
  { make: "Honda", model: "SCL500", year: 2024 },
  { make: "Honda", model: "SCL500", year: 2025 },
  { make: "Honda", model: "SCL500", year: 2026 },
  // Honda - SH-300
  { make: "Honda", model: "SH-300", year: 2016 },
  { make: "Honda", model: "SH-300", year: 2017 },
  { make: "Honda", model: "SH-300", year: 2018 },
  { make: "Honda", model: "SH-300", year: 2019 },
  { make: "Honda", model: "SH-300", year: 2020 },
  // Honda - SH125I
  { make: "Honda", model: "SH125I", year: 2017 },
  { make: "Honda", model: "SH125I", year: 2018 },
  { make: "Honda", model: "SH125I", year: 2019 },
  // Honda - SXS10S2R Talon 1000R
  { make: "Honda", model: "SXS10S2R Talon 1000R", year: 2019 },
  { make: "Honda", model: "SXS10S2R Talon 1000R", year: 2020 },
  { make: "Honda", model: "SXS10S2R Talon 1000R", year: 2021 },
  { make: "Honda", model: "SXS10S2R Talon 1000R", year: 2022 },
  // Honda - SXS10S2RD Talon 1000R FOX Live Valve
  { make: "Honda", model: "SXS10S2RD Talon 1000R FOX Live Valve", year: 2022 },
  // Honda - SXS10S2X Talon 1000X
  { make: "Honda", model: "SXS10S2X Talon 1000X", year: 2019 },
  { make: "Honda", model: "SXS10S2X Talon 1000X", year: 2020 },
  { make: "Honda", model: "SXS10S2X Talon 1000X", year: 2021 },
  { make: "Honda", model: "SXS10S2X Talon 1000X", year: 2022 },
  // Honda - SXS10S2XD Talon 1000X FOX Live Valve
  { make: "Honda", model: "SXS10S2XD Talon 1000X FOX Live Valve", year: 2022 },
  // Honda - SXS10S4 Talon 1000X-4
  { make: "Honda", model: "SXS10S4 Talon 1000X-4", year: 2022 },
  // Honda - SXS10S4 Talon 1000X-4 FOX Live Valve
  { make: "Honda", model: "SXS10S4 Talon 1000X-4 FOX Live Valve", year: 2022 },
  // Honda - Talon 1000R
  { make: "Honda", model: "Talon 1000R", year: 2019 },
  // Honda - Trail 125
  { make: "Honda", model: "Trail 125", year: 2021 },
  { make: "Honda", model: "Trail 125", year: 2022 },
  { make: "Honda", model: "Trail 125", year: 2023 },
  { make: "Honda", model: "Trail 125", year: 2024 },
  { make: "Honda", model: "Trail 125", year: 2025 },
  { make: "Honda", model: "Trail 125", year: 2026 },
  // Honda - TRX-250EX
  { make: "Honda", model: "TRX-250EX", year: 2001 },
  { make: "Honda", model: "TRX-250EX", year: 2002 },
  { make: "Honda", model: "TRX-250EX", year: 2003 },
  { make: "Honda", model: "TRX-250EX", year: 2004 },
  { make: "Honda", model: "TRX-250EX", year: 2005 },
  { make: "Honda", model: "TRX-250EX", year: 2006 },
  { make: "Honda", model: "TRX-250EX", year: 2007 },
  { make: "Honda", model: "TRX-250EX", year: 2008 },
  { make: "Honda", model: "TRX-250EX", year: 2009 },
  { make: "Honda", model: "TRX-250EX", year: 2010 },
  // Honda - TRX-250X
  { make: "Honda", model: "TRX-250X", year: 1987 },
  { make: "Honda", model: "TRX-250X", year: 1988 },
  { make: "Honda", model: "TRX-250X", year: 1989 },
  { make: "Honda", model: "TRX-250X", year: 1990 },
  { make: "Honda", model: "TRX-250X", year: 1991 },
  { make: "Honda", model: "TRX-250X", year: 1992 },
  { make: "Honda", model: "TRX-250X", year: 1993 },
  { make: "Honda", model: "TRX-250X", year: 1994 },
  { make: "Honda", model: "TRX-250X", year: 1995 },
  { make: "Honda", model: "TRX-250X", year: 1996 },
  { make: "Honda", model: "TRX-250X", year: 1997 },
  { make: "Honda", model: "TRX-250X", year: 1998 },
  { make: "Honda", model: "TRX-250X", year: 1999 },
  { make: "Honda", model: "TRX-250X", year: 2000 },
  { make: "Honda", model: "TRX-250X", year: 2001 },
  { make: "Honda", model: "TRX-250X", year: 2002 },
  { make: "Honda", model: "TRX-250X", year: 2003 },
  { make: "Honda", model: "TRX-250X", year: 2004 },
  { make: "Honda", model: "TRX-250X", year: 2005 },
  { make: "Honda", model: "TRX-250X", year: 2006 },
  { make: "Honda", model: "TRX-250X", year: 2007 },
  { make: "Honda", model: "TRX-250X", year: 2008 },
  { make: "Honda", model: "TRX-250X", year: 2009 },
  // Honda - TRX-450R
  { make: "Honda", model: "TRX-450R", year: 2004 },
  { make: "Honda", model: "TRX-450R", year: 2005 },
  { make: "Honda", model: "TRX-450R", year: 2006 },
  { make: "Honda", model: "TRX-450R", year: 2007 },
  { make: "Honda", model: "TRX-450R", year: 2008 },
  { make: "Honda", model: "TRX-450R", year: 2009 },
  { make: "Honda", model: "TRX-450R", year: 2010 },
  { make: "Honda", model: "TRX-450R", year: 2011 },
  { make: "Honda", model: "TRX-450R", year: 2012 },
  { make: "Honda", model: "TRX-450R", year: 2013 },
  { make: "Honda", model: "TRX-450R", year: 2014 },
  // Honda - TRX-700XX
  { make: "Honda", model: "TRX-700XX", year: 2008 },
  { make: "Honda", model: "TRX-700XX", year: 2009 },
  { make: "Honda", model: "TRX-700XX", year: 2010 },
  { make: "Honda", model: "TRX-700XX", year: 2011 },
  { make: "Honda", model: "TRX-700XX", year: 2012 },
  { make: "Honda", model: "TRX-700XX", year: 2013 },
  // Honda - TRX90
  { make: "Honda", model: "TRX90", year: 1993 },
  { make: "Honda", model: "TRX90", year: 1994 },
  { make: "Honda", model: "TRX90", year: 1995 },
  { make: "Honda", model: "TRX90", year: 1996 },
  { make: "Honda", model: "TRX90", year: 1997 },
  { make: "Honda", model: "TRX90", year: 1998 },
  { make: "Honda", model: "TRX90", year: 1999 },
  { make: "Honda", model: "TRX90", year: 2000 },
  { make: "Honda", model: "TRX90", year: 2001 },
  { make: "Honda", model: "TRX90", year: 2002 },
  { make: "Honda", model: "TRX90", year: 2003 },
  { make: "Honda", model: "TRX90", year: 2004 },
  { make: "Honda", model: "TRX90", year: 2005 },
  // Honda - TRX90 Sportrax
  { make: "Honda", model: "TRX90 Sportrax", year: 2006 },
  // Honda - TRX90EX
  { make: "Honda", model: "TRX90EX", year: 2006 },
  { make: "Honda", model: "TRX90EX", year: 2007 },
  { make: "Honda", model: "TRX90EX", year: 2008 },
  // Honda - TRX90EX Sportrax
  { make: "Honda", model: "TRX90EX Sportrax", year: 2007 },
  { make: "Honda", model: "TRX90EX Sportrax", year: 2008 },
  // Honda - TRX90X
  { make: "Honda", model: "TRX90X", year: 2009 },
  { make: "Honda", model: "TRX90X", year: 2013 },
  { make: "Honda", model: "TRX90X", year: 2014 },
  { make: "Honda", model: "TRX90X", year: 2015 },
  { make: "Honda", model: "TRX90X", year: 2016 },
  { make: "Honda", model: "TRX90X", year: 2017 },
  { make: "Honda", model: "TRX90X", year: 2018 },
  { make: "Honda", model: "TRX90X", year: 2019 },
  { make: "Honda", model: "TRX90X", year: 2020 },
  { make: "Honda", model: "TRX90X", year: 2021 },
  // Honda - TRX250EX
  { make: "Honda", model: "TRX250EX", year: 2001 },
  { make: "Honda", model: "TRX250EX", year: 2002 },
  { make: "Honda", model: "TRX250EX", year: 2003 },
  { make: "Honda", model: "TRX250EX", year: 2004 },
  { make: "Honda", model: "TRX250EX", year: 2005 },
  { make: "Honda", model: "TRX250EX", year: 2006 },
  { make: "Honda", model: "TRX250EX", year: 2007 },
  { make: "Honda", model: "TRX250EX", year: 2008 },
  // Honda - TRX250EX Sportrax
  { make: "Honda", model: "TRX250EX Sportrax", year: 2001 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2002 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2003 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2004 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2005 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2006 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2007 },
  { make: "Honda", model: "TRX250EX Sportrax", year: 2008 },
  // Honda - TRX250R
  { make: "Honda", model: "TRX250R", year: 1986 },
  { make: "Honda", model: "TRX250R", year: 1987 },
  { make: "Honda", model: "TRX250R", year: 1988 },
  { make: "Honda", model: "TRX250R", year: 1989 },
  // Honda - TRX250X
  { make: "Honda", model: "TRX250X", year: 2009 },
  { make: "Honda", model: "TRX250X", year: 2010 },
  { make: "Honda", model: "TRX250X", year: 2011 },
  { make: "Honda", model: "TRX250X", year: 2012 },
  { make: "Honda", model: "TRX250X", year: 2013 },
  { make: "Honda", model: "TRX250X", year: 2014 },
  { make: "Honda", model: "TRX250X", year: 2016 },
  { make: "Honda", model: "TRX250X", year: 2017 },
  { make: "Honda", model: "TRX250X", year: 2018 },
  { make: "Honda", model: "TRX250X", year: 2019 },
  { make: "Honda", model: "TRX250X", year: 2020 },
  // Honda - TRX350D Fourtrax Foreman 4X4
  { make: "Honda", model: "TRX350D Fourtrax Foreman 4X4", year: 1986 },
  { make: "Honda", model: "TRX350D Fourtrax Foreman 4X4", year: 1987 },
  { make: "Honda", model: "TRX350D Fourtrax Foreman 4X4", year: 1988 },
  { make: "Honda", model: "TRX350D Fourtrax Foreman 4X4", year: 1989 },
  // Honda - TRX400EX
  { make: "Honda", model: "TRX400EX", year: 1999 },
  { make: "Honda", model: "TRX400EX", year: 2000 },
  { make: "Honda", model: "TRX400EX", year: 2001 },
  { make: "Honda", model: "TRX400EX", year: 2002 },
  { make: "Honda", model: "TRX400EX", year: 2003 },
  { make: "Honda", model: "TRX400EX", year: 2004 },
  { make: "Honda", model: "TRX400EX", year: 2005 },
  { make: "Honda", model: "TRX400EX", year: 2006 },
  { make: "Honda", model: "TRX400EX", year: 2007 },
  { make: "Honda", model: "TRX400EX", year: 2008 },
  // Honda - TRX400EX Sportrax
  { make: "Honda", model: "TRX400EX Sportrax", year: 2001 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2002 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2003 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2004 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2005 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2006 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2007 },
  { make: "Honda", model: "TRX400EX Sportrax", year: 2008 },
  // Honda - TRX400X
  { make: "Honda", model: "TRX400X", year: 2009 },
  { make: "Honda", model: "TRX400X", year: 2010 },
  { make: "Honda", model: "TRX400X", year: 2012 },
  { make: "Honda", model: "TRX400X", year: 2013 },
  { make: "Honda", model: "TRX400X", year: 2014 },
  // Honda - TRX450R
  { make: "Honda", model: "TRX450R", year: 2004 },
  { make: "Honda", model: "TRX450R", year: 2005 },
  { make: "Honda", model: "TRX450R", year: 2006 },
  { make: "Honda", model: "TRX450R", year: 2007 },
  { make: "Honda", model: "TRX450R", year: 2008 },
  { make: "Honda", model: "TRX450R", year: 2009 },
  { make: "Honda", model: "TRX450R", year: 2010 },
  { make: "Honda", model: "TRX450R", year: 2011 },
  { make: "Honda", model: "TRX450R", year: 2012 },
  { make: "Honda", model: "TRX450R", year: 2013 },
  { make: "Honda", model: "TRX450R", year: 2014 },
  // Honda - XL-650 V Transalp
  { make: "Honda", model: "XL-650 V Transalp", year: 2001 },
  { make: "Honda", model: "XL-650 V Transalp", year: 2002 },
  { make: "Honda", model: "XL-650 V Transalp", year: 2003 },
  { make: "Honda", model: "XL-650 V Transalp", year: 2004 },
  { make: "Honda", model: "XL-650 V Transalp", year: 2005 },
  { make: "Honda", model: "XL-650 V Transalp", year: 2006 },
  // Honda - XL-750 Transalp
  { make: "Honda", model: "XL-750 Transalp", year: 2025 },
  // Honda - XL750 Transalp
  { make: "Honda", model: "XL750 Transalp", year: 2023 },
  { make: "Honda", model: "XL750 Transalp", year: 2024 },
  { make: "Honda", model: "XL750 Transalp", year: 2025 },
  { make: "Honda", model: "XL750 Transalp", year: 2026 },
  // Honda - XL750 Transalp 14440EBU
  { make: "Honda", model: "XL750 Transalp 14440EBU", year: 2023 },
  { make: "Honda", model: "XL750 Transalp 14440EBU", year: 2024 },
  { make: "Honda", model: "XL750 Transalp 14440EBU", year: 2025 },
  { make: "Honda", model: "XL750 Transalp 14440EBU", year: 2026 },
  // Honda - XL750 Transalp 14440EU
  { make: "Honda", model: "XL750 Transalp 14440EU", year: 2023 },
  { make: "Honda", model: "XL750 Transalp 14440EU", year: 2024 },
  { make: "Honda", model: "XL750 Transalp 14440EU", year: 2025 },
  { make: "Honda", model: "XL750 Transalp 14440EU", year: 2026 },
  // Honda - XL750 Transalp S H7SO6 Hrtbl
  { make: "Honda", model: "XL750 Transalp S H7SO6 Hrtbl", year: 2023 },
  { make: "Honda", model: "XL750 Transalp S H7SO6 Hrtbl", year: 2024 },
  { make: "Honda", model: "XL750 Transalp S H7SO6 Hrtbl", year: 2025 },
  { make: "Honda", model: "XL750 Transalp S H7SO6 Hrtbl", year: 2026 },
  // Honda - XR-400
  { make: "Honda", model: "XR-400", year: 1996 },
  { make: "Honda", model: "XR-400", year: 1997 },
  { make: "Honda", model: "XR-400", year: 1998 },
  { make: "Honda", model: "XR-400", year: 1999 },
  { make: "Honda", model: "XR-400", year: 2000 },
  { make: "Honda", model: "XR-400", year: 2001 },
  { make: "Honda", model: "XR-400", year: 2002 },
  { make: "Honda", model: "XR-400", year: 2003 },
  { make: "Honda", model: "XR-400", year: 2004 },
  { make: "Honda", model: "XR-400", year: 2005 },
  // Honda - XR-600R
  { make: "Honda", model: "XR-600R", year: 1985 },
  { make: "Honda", model: "XR-600R", year: 1986 },
  { make: "Honda", model: "XR-600R", year: 1987 },
  { make: "Honda", model: "XR-600R", year: 1988 },
  { make: "Honda", model: "XR-600R", year: 1989 },
  { make: "Honda", model: "XR-600R", year: 1990 },
  { make: "Honda", model: "XR-600R", year: 1991 },
  { make: "Honda", model: "XR-600R", year: 1992 },
  { make: "Honda", model: "XR-600R", year: 1993 },
  { make: "Honda", model: "XR-600R", year: 1994 },
  { make: "Honda", model: "XR-600R", year: 1995 },
  { make: "Honda", model: "XR-600R", year: 1996 },
  { make: "Honda", model: "XR-600R", year: 1997 },
  { make: "Honda", model: "XR-600R", year: 1998 },
  { make: "Honda", model: "XR-600R", year: 1999 },
  { make: "Honda", model: "XR-600R", year: 2000 },
  // Honda - XR-650L
  { make: "Honda", model: "XR-650L", year: 1993 },
  { make: "Honda", model: "XR-650L", year: 1994 },
  { make: "Honda", model: "XR-650L", year: 1995 },
  { make: "Honda", model: "XR-650L", year: 1996 },
  { make: "Honda", model: "XR-650L", year: 1997 },
  { make: "Honda", model: "XR-650L", year: 1998 },
  { make: "Honda", model: "XR-650L", year: 1999 },
  { make: "Honda", model: "XR-650L", year: 2000 },
  { make: "Honda", model: "XR-650L", year: 2001 },
  { make: "Honda", model: "XR-650L", year: 2002 },
  { make: "Honda", model: "XR-650L", year: 2003 },
  { make: "Honda", model: "XR-650L", year: 2004 },
  { make: "Honda", model: "XR-650L", year: 2005 },
  { make: "Honda", model: "XR-650L", year: 2006 },
  { make: "Honda", model: "XR-650L", year: 2007 },
  { make: "Honda", model: "XR-650L", year: 2008 },
  { make: "Honda", model: "XR-650L", year: 2009 },
  { make: "Honda", model: "XR-650L", year: 2010 },
  { make: "Honda", model: "XR-650L", year: 2011 },
  { make: "Honda", model: "XR-650L", year: 2012 },
  { make: "Honda", model: "XR-650L", year: 2013 },
  { make: "Honda", model: "XR-650L", year: 2014 },
  { make: "Honda", model: "XR-650L", year: 2015 },
  { make: "Honda", model: "XR-650L", year: 2016 },
  { make: "Honda", model: "XR-650L", year: 2017 },
  { make: "Honda", model: "XR-650L", year: 2018 },
  { make: "Honda", model: "XR-650L", year: 2019 },
  { make: "Honda", model: "XR-650L", year: 2020 },
  { make: "Honda", model: "XR-650L", year: 2021 },
  { make: "Honda", model: "XR-650L", year: 2022 },
  { make: "Honda", model: "XR-650L", year: 2023 },
  // Honda - XR-650R
  { make: "Honda", model: "XR-650R", year: 2000 },
  { make: "Honda", model: "XR-650R", year: 2001 },
  { make: "Honda", model: "XR-650R", year: 2002 },
  { make: "Honda", model: "XR-650R", year: 2003 },
  { make: "Honda", model: "XR-650R", year: 2004 },
  { make: "Honda", model: "XR-650R", year: 2005 },
  { make: "Honda", model: "XR-650R", year: 2006 },
  { make: "Honda", model: "XR-650R", year: 2007 },
  { make: "Honda", model: "XR-650R", year: 2008 },
  // Honda - XR50R
  { make: "Honda", model: "XR50R", year: 2000 },
  { make: "Honda", model: "XR50R", year: 2001 },
  { make: "Honda", model: "XR50R", year: 2002 },
  { make: "Honda", model: "XR50R", year: 2003 },
  // Honda - XR80R
  { make: "Honda", model: "XR80R", year: 1986 },
  { make: "Honda", model: "XR80R", year: 1987 },
  { make: "Honda", model: "XR80R", year: 1988 },
  { make: "Honda", model: "XR80R", year: 1989 },
  { make: "Honda", model: "XR80R", year: 1990 },
  // Honda - XR100R
  { make: "Honda", model: "XR100R", year: 1986 },
  { make: "Honda", model: "XR100R", year: 1987 },
  { make: "Honda", model: "XR100R", year: 1988 },
  { make: "Honda", model: "XR100R", year: 1989 },
  { make: "Honda", model: "XR100R", year: 1990 },
  { make: "Honda", model: "XR100R", year: 1991 },
  { make: "Honda", model: "XR100R", year: 1992 },
  { make: "Honda", model: "XR100R", year: 1993 },
  { make: "Honda", model: "XR100R", year: 1994 },
  { make: "Honda", model: "XR100R", year: 1995 },
  { make: "Honda", model: "XR100R", year: 1996 },
  { make: "Honda", model: "XR100R", year: 1997 },
  { make: "Honda", model: "XR100R", year: 1998 },
  { make: "Honda", model: "XR100R", year: 1999 },
  { make: "Honda", model: "XR100R", year: 2000 },
  { make: "Honda", model: "XR100R", year: 2001 },
  // Honda - XR400R
  { make: "Honda", model: "XR400R", year: 1996 },
  { make: "Honda", model: "XR400R", year: 1997 },
  { make: "Honda", model: "XR400R", year: 1998 },
  { make: "Honda", model: "XR400R", year: 1999 },
  { make: "Honda", model: "XR400R", year: 2000 },
  { make: "Honda", model: "XR400R", year: 2001 },
  { make: "Honda", model: "XR400R", year: 2002 },
  { make: "Honda", model: "XR400R", year: 2003 },
  { make: "Honda", model: "XR400R", year: 2004 },
  // Honda - XR600R
  { make: "Honda", model: "XR600R", year: 1985 },
  { make: "Honda", model: "XR600R", year: 1986 },
  { make: "Honda", model: "XR600R", year: 1987 },
  { make: "Honda", model: "XR600R", year: 1988 },
  { make: "Honda", model: "XR600R", year: 1989 },
  { make: "Honda", model: "XR600R", year: 1990 },
  { make: "Honda", model: "XR600R", year: 1991 },
  { make: "Honda", model: "XR600R", year: 1992 },
  { make: "Honda", model: "XR600R", year: 1993 },
  { make: "Honda", model: "XR600R", year: 1994 },
  { make: "Honda", model: "XR600R", year: 1995 },
  { make: "Honda", model: "XR600R", year: 1996 },
  { make: "Honda", model: "XR600R", year: 1997 },
  { make: "Honda", model: "XR600R", year: 1998 },
  { make: "Honda", model: "XR600R", year: 2000 },
  // Honda - XR650L
  { make: "Honda", model: "XR650L", year: 1993 },
  { make: "Honda", model: "XR650L", year: 1994 },
  { make: "Honda", model: "XR650L", year: 1995 },
  { make: "Honda", model: "XR650L", year: 1996 },
  { make: "Honda", model: "XR650L", year: 1997 },
  { make: "Honda", model: "XR650L", year: 1998 },
  { make: "Honda", model: "XR650L", year: 1999 },
  { make: "Honda", model: "XR650L", year: 2000 },
  { make: "Honda", model: "XR650L", year: 2001 },
  { make: "Honda", model: "XR650L", year: 2002 },
  { make: "Honda", model: "XR650L", year: 2003 },
  { make: "Honda", model: "XR650L", year: 2004 },
  { make: "Honda", model: "XR650L", year: 2005 },
  { make: "Honda", model: "XR650L", year: 2006 },
  { make: "Honda", model: "XR650L", year: 2007 },
  { make: "Honda", model: "XR650L", year: 2008 },
  { make: "Honda", model: "XR650L", year: 2009 },
  { make: "Honda", model: "XR650L", year: 2010 },
  { make: "Honda", model: "XR650L", year: 2011 },
  { make: "Honda", model: "XR650L", year: 2012 },
  { make: "Honda", model: "XR650L", year: 2013 },
  { make: "Honda", model: "XR650L", year: 2014 },
  { make: "Honda", model: "XR650L", year: 2015 },
  { make: "Honda", model: "XR650L", year: 2016 },
  { make: "Honda", model: "XR650L", year: 2017 },
  { make: "Honda", model: "XR650L", year: 2018 },
  { make: "Honda", model: "XR650L", year: 2019 },
  { make: "Honda", model: "XR650L", year: 2020 },
  { make: "Honda", model: "XR650L", year: 2021 },
  { make: "Honda", model: "XR650L", year: 2022 },
  { make: "Honda", model: "XR650L", year: 2023 },
  { make: "Honda", model: "XR650L", year: 2024 },
  { make: "Honda", model: "XR650L", year: 2025 },
  { make: "Honda", model: "XR650L", year: 2026 },
  // Honda - XR650R
  { make: "Honda", model: "XR650R", year: 2000 },
  { make: "Honda", model: "XR650R", year: 2001 },
  { make: "Honda", model: "XR650R", year: 2002 },
  { make: "Honda", model: "XR650R", year: 2003 },
  { make: "Honda", model: "XR650R", year: 2004 },
  { make: "Honda", model: "XR650R", year: 2005 },
  { make: "Honda", model: "XR650R", year: 2006 },
  { make: "Honda", model: "XR650R", year: 2007 },
  // Honda - XRV-750
  { make: "Honda", model: "XRV-750", year: 1993 },
  { make: "Honda", model: "XRV-750", year: 1994 },
  { make: "Honda", model: "XRV-750", year: 1995 },
  { make: "Honda", model: "XRV-750", year: 1996 },
  { make: "Honda", model: "XRV-750", year: 1997 },
  { make: "Honda", model: "XRV-750", year: 1998 },
  { make: "Honda", model: "XRV-750", year: 1999 },
  { make: "Honda", model: "XRV-750", year: 2000 },
  { make: "Honda", model: "XRV-750", year: 2001 },
  { make: "Honda", model: "XRV-750", year: 2002 },
  { make: "Honda", model: "XRV-750", year: 2003 },
  { make: "Honda", model: "XRV-750", year: 2004 },
  // Honda - XRV-750 Africa Twin
  { make: "Honda", model: "XRV-750 Africa Twin", year: 1990 },
  { make: "Honda", model: "XRV-750 Africa Twin", year: 1991 },
  { make: "Honda", model: "XRV-750 Africa Twin", year: 1992 },
  // Husqvarna
  // Husqvarna - 701 Enduro
  { make: "Husqvarna", model: "701 Enduro", year: 2016 },
  { make: "Husqvarna", model: "701 Enduro", year: 2017 },
  { make: "Husqvarna", model: "701 Enduro", year: 2018 },
  { make: "Husqvarna", model: "701 Enduro", year: 2019 },
  { make: "Husqvarna", model: "701 Enduro", year: 2020 },
  { make: "Husqvarna", model: "701 Enduro", year: 2021 },
  { make: "Husqvarna", model: "701 Enduro", year: 2022 },
  { make: "Husqvarna", model: "701 Enduro", year: 2023 },
  { make: "Husqvarna", model: "701 Enduro", year: 2024 },
  { make: "Husqvarna", model: "701 Enduro", year: 2025 },
  { make: "Husqvarna", model: "701 Enduro", year: 2026 },
  // Husqvarna - 701 Enduro 701 Supermoto 55KW
  { make: "Husqvarna", model: "701 Enduro 701 Supermoto 55KW", year: 2017 },
  // Husqvarna - 701 Enduro Supermoto
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2017 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2018 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2019 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2020 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2021 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2022 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2023 },
  { make: "Husqvarna", model: "701 Enduro Supermoto", year: 2024 },
  // Husqvarna - 701 Supermoto
  { make: "Husqvarna", model: "701 Supermoto", year: 2015 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2016 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2017 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2018 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2019 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2020 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2021 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2022 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2023 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2024 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2025 },
  { make: "Husqvarna", model: "701 Supermoto", year: 2026 },
  // Husqvarna - FC 250
  { make: "Husqvarna", model: "FC 250", year: 2014 },
  { make: "Husqvarna", model: "FC 250", year: 2015 },
  { make: "Husqvarna", model: "FC 250", year: 2016 },
  { make: "Husqvarna", model: "FC 250", year: 2017 },
  { make: "Husqvarna", model: "FC 250", year: 2018 },
  { make: "Husqvarna", model: "FC 250", year: 2019 },
  { make: "Husqvarna", model: "FC 250", year: 2020 },
  { make: "Husqvarna", model: "FC 250", year: 2021 },
  { make: "Husqvarna", model: "FC 250", year: 2022 },
  { make: "Husqvarna", model: "FC 250", year: 2023 },
  { make: "Husqvarna", model: "FC 250", year: 2024 },
  { make: "Husqvarna", model: "FC 250", year: 2025 },
  { make: "Husqvarna", model: "FC 250", year: 2026 },
  // Husqvarna - FC 350
  { make: "Husqvarna", model: "FC 350", year: 2014 },
  { make: "Husqvarna", model: "FC 350", year: 2015 },
  { make: "Husqvarna", model: "FC 350", year: 2016 },
  { make: "Husqvarna", model: "FC 350", year: 2017 },
  { make: "Husqvarna", model: "FC 350", year: 2018 },
  { make: "Husqvarna", model: "FC 350", year: 2019 },
  { make: "Husqvarna", model: "FC 350", year: 2020 },
  { make: "Husqvarna", model: "FC 350", year: 2021 },
  { make: "Husqvarna", model: "FC 350", year: 2022 },
  { make: "Husqvarna", model: "FC 350", year: 2023 },
  { make: "Husqvarna", model: "FC 350", year: 2024 },
  { make: "Husqvarna", model: "FC 350", year: 2025 },
  { make: "Husqvarna", model: "FC 350", year: 2026 },
  // Husqvarna - FC 450
  { make: "Husqvarna", model: "FC 450", year: 2014 },
  { make: "Husqvarna", model: "FC 450", year: 2015 },
  { make: "Husqvarna", model: "FC 450", year: 2016 },
  { make: "Husqvarna", model: "FC 450", year: 2017 },
  { make: "Husqvarna", model: "FC 450", year: 2018 },
  { make: "Husqvarna", model: "FC 450", year: 2019 },
  { make: "Husqvarna", model: "FC 450", year: 2020 },
  { make: "Husqvarna", model: "FC 450", year: 2021 },
  { make: "Husqvarna", model: "FC 450", year: 2022 },
  { make: "Husqvarna", model: "FC 450", year: 2023 },
  { make: "Husqvarna", model: "FC 450", year: 2024 },
  { make: "Husqvarna", model: "FC 450", year: 2025 },
  { make: "Husqvarna", model: "FC 450", year: 2026 },
  // Husqvarna - FC-450 Rockstar Edition
  { make: "Husqvarna", model: "FC-450 Rockstar Edition", year: 2018 },
  { make: "Husqvarna", model: "FC-450 Rockstar Edition", year: 2019 },
  { make: "Husqvarna", model: "FC-450 Rockstar Edition", year: 2020 },
  { make: "Husqvarna", model: "FC-450 Rockstar Edition", year: 2021 },
  // Husqvarna - FE 250
  { make: "Husqvarna", model: "FE 250", year: 2014 },
  { make: "Husqvarna", model: "FE 250", year: 2015 },
  { make: "Husqvarna", model: "FE 250", year: 2016 },
  { make: "Husqvarna", model: "FE 250", year: 2017 },
  { make: "Husqvarna", model: "FE 250", year: 2018 },
  { make: "Husqvarna", model: "FE 250", year: 2019 },
  { make: "Husqvarna", model: "FE 250", year: 2020 },
  { make: "Husqvarna", model: "FE 250", year: 2021 },
  { make: "Husqvarna", model: "FE 250", year: 2022 },
  { make: "Husqvarna", model: "FE 250", year: 2023 },
  { make: "Husqvarna", model: "FE 250", year: 2024 },
  { make: "Husqvarna", model: "FE 250", year: 2025 },
  { make: "Husqvarna", model: "FE 250", year: 2026 },
  // Husqvarna - FE 350
  { make: "Husqvarna", model: "FE 350", year: 2014 },
  { make: "Husqvarna", model: "FE 350", year: 2015 },
  { make: "Husqvarna", model: "FE 350", year: 2016 },
  { make: "Husqvarna", model: "FE 350", year: 2017 },
  { make: "Husqvarna", model: "FE 350", year: 2018 },
  { make: "Husqvarna", model: "FE 350", year: 2019 },
  { make: "Husqvarna", model: "FE 350", year: 2020 },
  { make: "Husqvarna", model: "FE 350", year: 2021 },
  { make: "Husqvarna", model: "FE 350", year: 2022 },
  { make: "Husqvarna", model: "FE 350", year: 2023 },
  { make: "Husqvarna", model: "FE 350", year: 2024 },
  { make: "Husqvarna", model: "FE 350", year: 2025 },
  { make: "Husqvarna", model: "FE 350", year: 2026 },
  // Husqvarna - FE 450
  { make: "Husqvarna", model: "FE 450", year: 2014 },
  { make: "Husqvarna", model: "FE 450", year: 2015 },
  { make: "Husqvarna", model: "FE 450", year: 2016 },
  { make: "Husqvarna", model: "FE 450", year: 2017 },
  { make: "Husqvarna", model: "FE 450", year: 2018 },
  { make: "Husqvarna", model: "FE 450", year: 2019 },
  { make: "Husqvarna", model: "FE 450", year: 2020 },
  { make: "Husqvarna", model: "FE 450", year: 2021 },
  { make: "Husqvarna", model: "FE 450", year: 2022 },
  { make: "Husqvarna", model: "FE 450", year: 2023 },
  { make: "Husqvarna", model: "FE 450", year: 2024 },
  { make: "Husqvarna", model: "FE 450", year: 2025 },
  { make: "Husqvarna", model: "FE 450", year: 2026 },
  // Husqvarna - FE 501
  { make: "Husqvarna", model: "FE 501", year: 2014 },
  { make: "Husqvarna", model: "FE 501", year: 2015 },
  { make: "Husqvarna", model: "FE 501", year: 2016 },
  { make: "Husqvarna", model: "FE 501", year: 2017 },
  { make: "Husqvarna", model: "FE 501", year: 2018 },
  { make: "Husqvarna", model: "FE 501", year: 2019 },
  { make: "Husqvarna", model: "FE 501", year: 2020 },
  { make: "Husqvarna", model: "FE 501", year: 2021 },
  { make: "Husqvarna", model: "FE 501", year: 2022 },
  { make: "Husqvarna", model: "FE 501", year: 2023 },
  { make: "Husqvarna", model: "FE 501", year: 2024 },
  { make: "Husqvarna", model: "FE 501", year: 2025 },
  { make: "Husqvarna", model: "FE 501", year: 2026 },
  // Husqvarna - FE-350 Rockstar Edition
  { make: "Husqvarna", model: "FE-350 Rockstar Edition", year: 2021 },
  // Husqvarna - FE501
  { make: "Husqvarna", model: "FE501", year: 2017 },
  { make: "Husqvarna", model: "FE501", year: 2018 },
  { make: "Husqvarna", model: "FE501", year: 2019 },
  { make: "Husqvarna", model: "FE501", year: 2020 },
  { make: "Husqvarna", model: "FE501", year: 2021 },
  { make: "Husqvarna", model: "FE501", year: 2022 },
  { make: "Husqvarna", model: "FE501", year: 2023 },
  // Husqvarna - FX 350
  { make: "Husqvarna", model: "FX 350", year: 2017 },
  { make: "Husqvarna", model: "FX 350", year: 2018 },
  { make: "Husqvarna", model: "FX 350", year: 2019 },
  { make: "Husqvarna", model: "FX 350", year: 2020 },
  { make: "Husqvarna", model: "FX 350", year: 2021 },
  { make: "Husqvarna", model: "FX 350", year: 2022 },
  { make: "Husqvarna", model: "FX 350", year: 2023 },
  { make: "Husqvarna", model: "FX 350", year: 2024 },
  { make: "Husqvarna", model: "FX 350", year: 2025 },
  { make: "Husqvarna", model: "FX 350", year: 2026 },
  // Husqvarna - FX 450
  { make: "Husqvarna", model: "FX 450", year: 2017 },
  { make: "Husqvarna", model: "FX 450", year: 2018 },
  { make: "Husqvarna", model: "FX 450", year: 2019 },
  { make: "Husqvarna", model: "FX 450", year: 2020 },
  { make: "Husqvarna", model: "FX 450", year: 2021 },
  { make: "Husqvarna", model: "FX 450", year: 2022 },
  { make: "Husqvarna", model: "FX 450", year: 2023 },
  { make: "Husqvarna", model: "FX 450", year: 2024 },
  { make: "Husqvarna", model: "FX 450", year: 2025 },
  { make: "Husqvarna", model: "FX 450", year: 2026 },
  // Husqvarna - Norden 901
  { make: "Husqvarna", model: "Norden 901", year: 2022 },
  { make: "Husqvarna", model: "Norden 901", year: 2023 },
  { make: "Husqvarna", model: "Norden 901", year: 2024 },
  { make: "Husqvarna", model: "Norden 901", year: 2025 },
  { make: "Husqvarna", model: "Norden 901", year: 2026 },
  // Husqvarna - NUDA-900
  { make: "Husqvarna", model: "NUDA-900", year: 2012 },
  { make: "Husqvarna", model: "NUDA-900", year: 2013 },
  // Husqvarna - Svartpilen 125
  { make: "Husqvarna", model: "Svartpilen 125", year: 2021 },
  { make: "Husqvarna", model: "Svartpilen 125", year: 2022 },
  { make: "Husqvarna", model: "Svartpilen 125", year: 2023 },
  // Husqvarna - Svartpilen 401
  { make: "Husqvarna", model: "Svartpilen 401", year: 2018 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2019 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2020 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2021 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2022 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2023 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2024 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2025 },
  { make: "Husqvarna", model: "Svartpilen 401", year: 2026 },
  // Husqvarna - Svartpilen 701
  { make: "Husqvarna", model: "Svartpilen 701", year: 2012 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2013 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2014 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2015 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2016 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2017 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2018 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2019 },
  { make: "Husqvarna", model: "Svartpilen 701", year: 2020 },
  // Husqvarna - TC 65
  { make: "Husqvarna", model: "TC 65", year: 2017 },
  { make: "Husqvarna", model: "TC 65", year: 2018 },
  { make: "Husqvarna", model: "TC 65", year: 2019 },
  { make: "Husqvarna", model: "TC 65", year: 2020 },
  { make: "Husqvarna", model: "TC 65", year: 2021 },
  { make: "Husqvarna", model: "TC 65", year: 2022 },
  { make: "Husqvarna", model: "TC 65", year: 2023 },
  { make: "Husqvarna", model: "TC 65", year: 2024 },
  { make: "Husqvarna", model: "TC 65", year: 2025 },
  { make: "Husqvarna", model: "TC 65", year: 2026 },
  // Husqvarna - TC 85
  { make: "Husqvarna", model: "TC 85", year: 2014 },
  { make: "Husqvarna", model: "TC 85", year: 2015 },
  { make: "Husqvarna", model: "TC 85", year: 2016 },
  { make: "Husqvarna", model: "TC 85", year: 2017 },
  { make: "Husqvarna", model: "TC 85", year: 2018 },
  { make: "Husqvarna", model: "TC 85", year: 2019 },
  { make: "Husqvarna", model: "TC 85", year: 2020 },
  { make: "Husqvarna", model: "TC 85", year: 2021 },
  { make: "Husqvarna", model: "TC 85", year: 2022 },
  { make: "Husqvarna", model: "TC 85", year: 2023 },
  { make: "Husqvarna", model: "TC 85", year: 2024 },
  { make: "Husqvarna", model: "TC 85", year: 2025 },
  { make: "Husqvarna", model: "TC 85", year: 2026 },
  // Husqvarna - TC 125
  { make: "Husqvarna", model: "TC 125", year: 2014 },
  { make: "Husqvarna", model: "TC 125", year: 2015 },
  { make: "Husqvarna", model: "TC 125", year: 2016 },
  { make: "Husqvarna", model: "TC 125", year: 2017 },
  { make: "Husqvarna", model: "TC 125", year: 2018 },
  { make: "Husqvarna", model: "TC 125", year: 2019 },
  { make: "Husqvarna", model: "TC 125", year: 2020 },
  { make: "Husqvarna", model: "TC 125", year: 2021 },
  { make: "Husqvarna", model: "TC 125", year: 2022 },
  { make: "Husqvarna", model: "TC 125", year: 2023 },
  { make: "Husqvarna", model: "TC 125", year: 2024 },
  { make: "Husqvarna", model: "TC 125", year: 2025 },
  { make: "Husqvarna", model: "TC 125", year: 2026 },
  // Husqvarna - TC 250
  { make: "Husqvarna", model: "TC 250", year: 2014 },
  { make: "Husqvarna", model: "TC 250", year: 2015 },
  { make: "Husqvarna", model: "TC 250", year: 2016 },
  { make: "Husqvarna", model: "TC 250", year: 2017 },
  { make: "Husqvarna", model: "TC 250", year: 2018 },
  { make: "Husqvarna", model: "TC 250", year: 2019 },
  { make: "Husqvarna", model: "TC 250", year: 2020 },
  { make: "Husqvarna", model: "TC 250", year: 2021 },
  { make: "Husqvarna", model: "TC 250", year: 2022 },
  { make: "Husqvarna", model: "TC 250", year: 2023 },
  { make: "Husqvarna", model: "TC 250", year: 2024 },
  { make: "Husqvarna", model: "TC 250", year: 2025 },
  { make: "Husqvarna", model: "TC 250", year: 2026 },
  // Husqvarna - TC-50
  { make: "Husqvarna", model: "TC-50", year: 2017 },
  { make: "Husqvarna", model: "TC-50", year: 2018 },
  { make: "Husqvarna", model: "TC-50", year: 2019 },
  { make: "Husqvarna", model: "TC-50", year: 2020 },
  { make: "Husqvarna", model: "TC-50", year: 2021 },
  { make: "Husqvarna", model: "TC-50", year: 2022 },
  { make: "Husqvarna", model: "TC-50", year: 2023 },
  // Husqvarna - TC-105
  { make: "Husqvarna", model: "TC-105", year: 2018 },
  { make: "Husqvarna", model: "TC-105", year: 2019 },
  { make: "Husqvarna", model: "TC-105", year: 2020 },
  { make: "Husqvarna", model: "TC-105", year: 2021 },
  { make: "Husqvarna", model: "TC-105", year: 2022 },
  { make: "Husqvarna", model: "TC-105", year: 2023 },
  { make: "Husqvarna", model: "TC-105", year: 2024 },
  // Husqvarna - TE 150
  { make: "Husqvarna", model: "TE 150", year: 2017 },
  { make: "Husqvarna", model: "TE 150", year: 2018 },
  { make: "Husqvarna", model: "TE 150", year: 2019 },
  { make: "Husqvarna", model: "TE 150", year: 2020 },
  { make: "Husqvarna", model: "TE 150", year: 2021 },
  { make: "Husqvarna", model: "TE 150", year: 2022 },
  { make: "Husqvarna", model: "TE 150", year: 2023 },
  { make: "Husqvarna", model: "TE 150", year: 2024 },
  { make: "Husqvarna", model: "TE 150", year: 2025 },
  { make: "Husqvarna", model: "TE 150", year: 2026 },
  // Husqvarna - TE 250
  { make: "Husqvarna", model: "TE 250", year: 2014 },
  { make: "Husqvarna", model: "TE 250", year: 2015 },
  { make: "Husqvarna", model: "TE 250", year: 2016 },
  { make: "Husqvarna", model: "TE 250", year: 2017 },
  { make: "Husqvarna", model: "TE 250", year: 2018 },
  { make: "Husqvarna", model: "TE 250", year: 2019 },
  { make: "Husqvarna", model: "TE 250", year: 2020 },
  { make: "Husqvarna", model: "TE 250", year: 2021 },
  { make: "Husqvarna", model: "TE 250", year: 2022 },
  { make: "Husqvarna", model: "TE 250", year: 2023 },
  { make: "Husqvarna", model: "TE 250", year: 2024 },
  { make: "Husqvarna", model: "TE 250", year: 2025 },
  { make: "Husqvarna", model: "TE 250", year: 2026 },
  // Husqvarna - TE 300
  { make: "Husqvarna", model: "TE 300", year: 2014 },
  { make: "Husqvarna", model: "TE 300", year: 2015 },
  { make: "Husqvarna", model: "TE 300", year: 2016 },
  { make: "Husqvarna", model: "TE 300", year: 2017 },
  { make: "Husqvarna", model: "TE 300", year: 2018 },
  { make: "Husqvarna", model: "TE 300", year: 2019 },
  { make: "Husqvarna", model: "TE 300", year: 2020 },
  { make: "Husqvarna", model: "TE 300", year: 2021 },
  { make: "Husqvarna", model: "TE 300", year: 2022 },
  { make: "Husqvarna", model: "TE 300", year: 2023 },
  { make: "Husqvarna", model: "TE 300", year: 2024 },
  { make: "Husqvarna", model: "TE 300", year: 2025 },
  { make: "Husqvarna", model: "TE 300", year: 2026 },
  // Husqvarna - TE-125
  { make: "Husqvarna", model: "TE-125", year: 2015 },
  { make: "Husqvarna", model: "TE-125", year: 2016 },
  // Husqvarna - TE-250I
  { make: "Husqvarna", model: "TE-250I", year: 2018 },
  { make: "Husqvarna", model: "TE-250I", year: 2019 },
  { make: "Husqvarna", model: "TE-250I", year: 2020 },
  { make: "Husqvarna", model: "TE-250I", year: 2021 },
  { make: "Husqvarna", model: "TE-250I", year: 2022 },
  // Husqvarna - TE-300I
  { make: "Husqvarna", model: "TE-300I", year: 2018 },
  { make: "Husqvarna", model: "TE-300I", year: 2019 },
  { make: "Husqvarna", model: "TE-300I", year: 2020 },
  { make: "Husqvarna", model: "TE-300I", year: 2021 },
  { make: "Husqvarna", model: "TE-300I", year: 2022 },
  // Husqvarna - TE-300I Rockstar Edition
  { make: "Husqvarna", model: "TE-300I Rockstar Edition", year: 2021 },
  // Husqvarna - TX 300
  { make: "Husqvarna", model: "TX 300", year: 2017 },
  { make: "Husqvarna", model: "TX 300", year: 2018 },
  { make: "Husqvarna", model: "TX 300", year: 2019 },
  { make: "Husqvarna", model: "TX 300", year: 2020 },
  { make: "Husqvarna", model: "TX 300", year: 2021 },
  { make: "Husqvarna", model: "TX 300", year: 2022 },
  { make: "Husqvarna", model: "TX 300", year: 2023 },
  { make: "Husqvarna", model: "TX 300", year: 2024 },
  { make: "Husqvarna", model: "TX 300", year: 2025 },
  { make: "Husqvarna", model: "TX 300", year: 2026 },
  // Husqvarna - TX-300I
  { make: "Husqvarna", model: "TX-300I", year: 2020 },
  { make: "Husqvarna", model: "TX-300I", year: 2021 },
  { make: "Husqvarna", model: "TX-300I", year: 2022 },
  // Husqvarna - Vitpilen 401
  { make: "Husqvarna", model: "Vitpilen 401", year: 2018 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2019 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2020 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2021 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2022 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2023 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2024 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2025 },
  { make: "Husqvarna", model: "Vitpilen 401", year: 2026 },
  // Husqvarna - Vitpilen 401 Euro 4
  { make: "Husqvarna", model: "Vitpilen 401 Euro 4", year: 2018 },
  { make: "Husqvarna", model: "Vitpilen 401 Euro 4", year: 2019 },
  // Husqvarna - Vitpilen 701
  { make: "Husqvarna", model: "Vitpilen 701", year: 2012 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2013 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2014 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2015 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2016 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2017 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2018 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2019 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2020 },
  { make: "Husqvarna", model: "Vitpilen 701", year: 2021 },
  // Husqvarna - Vitpilen 701 Svartpilen 701 Euro
  { make: "Husqvarna", model: "Vitpilen 701 Svartpilen 701 Euro", year: 2018 },
  // Indian
  // Indian - Chief Dark Horse
  { make: "Indian", model: "Chief Dark Horse", year: 2016 },
  { make: "Indian", model: "Chief Dark Horse", year: 2017 },
  { make: "Indian", model: "Chief Dark Horse", year: 2018 },
  { make: "Indian", model: "Chief Dark Horse", year: 2019 },
  { make: "Indian", model: "Chief Dark Horse", year: 2020 },
  { make: "Indian", model: "Chief Dark Horse", year: 2021 },
  { make: "Indian", model: "Chief Dark Horse", year: 2022 },
  { make: "Indian", model: "Chief Dark Horse", year: 2023 },
  { make: "Indian", model: "Chief Dark Horse", year: 2024 },
  { make: "Indian", model: "Chief Dark Horse", year: 2025 },
  { make: "Indian", model: "Chief Dark Horse", year: 2026 },
  // Indian - FTR
  { make: "Indian", model: "FTR", year: 2019 },
  { make: "Indian", model: "FTR", year: 2020 },
  { make: "Indian", model: "FTR", year: 2021 },
  { make: "Indian", model: "FTR", year: 2022 },
  { make: "Indian", model: "FTR", year: 2023 },
  { make: "Indian", model: "FTR", year: 2024 },
  { make: "Indian", model: "FTR", year: 2025 },
  { make: "Indian", model: "FTR", year: 2026 },
  // Indian - FTR-1200
  { make: "Indian", model: "FTR-1200", year: 2019 },
  { make: "Indian", model: "FTR-1200", year: 2020 },
  { make: "Indian", model: "FTR-1200", year: 2021 },
  { make: "Indian", model: "FTR-1200", year: 2022 },
  { make: "Indian", model: "FTR-1200", year: 2023 },
  { make: "Indian", model: "FTR-1200", year: 2024 },
  { make: "Indian", model: "FTR-1200", year: 2025 },
  { make: "Indian", model: "FTR-1200", year: 2026 },
  { make: "Indian", model: "FTR-1200", year: 2027 },
  // Indian - FTR-1200 Side Mount License
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2019 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2020 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2021 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2022 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2023 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2024 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2025 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2026 },
  { make: "Indian", model: "FTR-1200 Side Mount License", year: 2027 },
  // Indian - Scout 4 5IN Grand National
  { make: "Indian", model: "Scout 4 5IN Grand National", year: 2025 },
  // Indian - Scout 4IN Grand National
  { make: "Indian", model: "Scout 4IN Grand National", year: 2015 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2016 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2017 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2018 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2019 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2020 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2021 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2022 },
  { make: "Indian", model: "Scout 4IN Grand National", year: 2023 },
  // Indian - Scout Bobber
  { make: "Indian", model: "Scout Bobber", year: 2018 },
  { make: "Indian", model: "Scout Bobber", year: 2019 },
  { make: "Indian", model: "Scout Bobber", year: 2020 },
  { make: "Indian", model: "Scout Bobber", year: 2021 },
  { make: "Indian", model: "Scout Bobber", year: 2022 },
  { make: "Indian", model: "Scout Bobber", year: 2023 },
  { make: "Indian", model: "Scout Bobber", year: 2024 },
  { make: "Indian", model: "Scout Bobber", year: 2025 },
  { make: "Indian", model: "Scout Bobber", year: 2026 },
  // Indian - Scout Rogue
  { make: "Indian", model: "Scout Rogue", year: 2022 },
  { make: "Indian", model: "Scout Rogue", year: 2023 },
  { make: "Indian", model: "Scout Rogue", year: 2024 },
  { make: "Indian", model: "Scout Rogue", year: 2025 },
  { make: "Indian", model: "Scout Rogue", year: 2026 },
  // Indian - Scout Twin Slash 3IN Pcx
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2015 },
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2016 },
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2017 },
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2018 },
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2019 },
  { make: "Indian", model: "Scout Twin Slash 3IN Pcx", year: 2020 },
  // Indian - Sport Chief
  { make: "Indian", model: "Sport Chief", year: 2023 },
  { make: "Indian", model: "Sport Chief", year: 2024 },
  { make: "Indian", model: "Sport Chief", year: 2025 },
  { make: "Indian", model: "Sport Chief", year: 2026 },
  // Kawasaki
  // Kawasaki - 500 Ninja
  { make: "Kawasaki", model: "500 Ninja", year: 2024 },
  { make: "Kawasaki", model: "500 Ninja", year: 2025 },
  { make: "Kawasaki", model: "500 Ninja", year: 2026 },
  { make: "Kawasaki", model: "500 Ninja", year: 2027 },
  // Kawasaki - Brute Force 300
  { make: "Kawasaki", model: "Brute Force 300", year: 2012 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2013 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2014 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2015 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2016 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2017 },
  { make: "Kawasaki", model: "Brute Force 300", year: 2018 },
  // Kawasaki - Brute Force 300 Evo U
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2012 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2013 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2014 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2015 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2016 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2017 },
  { make: "Kawasaki", model: "Brute Force 300 Evo U", year: 2018 },
  // Kawasaki - Brute Force 650 Irs
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2006 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2007 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2008 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2009 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2010 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2011 },
  { make: "Kawasaki", model: "Brute Force 650 Irs", year: 2012 },
  // Kawasaki - Brute Force 650 Irs Evo
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2006 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2007 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2008 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2009 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2010 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2011 },
  { make: "Kawasaki", model: "Brute Force 650 Irs Evo", year: 2012 },
  // Kawasaki - Brute Force 650 Straight Axle
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2005 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2006 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2007 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2008 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2009 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2010 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2011 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2012 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2013 },
  { make: "Kawasaki", model: "Brute Force 650 Straight Axle", year: 2014 },
  // Kawasaki - Brute Force 750 Irs
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2012 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2013 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2014 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2015 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2016 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2017 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2018 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2019 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2020 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2021 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2022 },
  { make: "Kawasaki", model: "Brute Force 750 Irs", year: 2023 },
  // Kawasaki - Brute Force 750 Irs Evo
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2012 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2013 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2014 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2015 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2016 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2017 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2018 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2019 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2020 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2021 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2022 },
  { make: "Kawasaki", model: "Brute Force 750 Irs Evo", year: 2023 },
  // Kawasaki - Concours 14
  { make: "Kawasaki", model: "Concours 14", year: 2008 },
  { make: "Kawasaki", model: "Concours 14", year: 2009 },
  { make: "Kawasaki", model: "Concours 14", year: 2010 },
  { make: "Kawasaki", model: "Concours 14", year: 2011 },
  { make: "Kawasaki", model: "Concours 14", year: 2012 },
  { make: "Kawasaki", model: "Concours 14", year: 2013 },
  { make: "Kawasaki", model: "Concours 14", year: 2014 },
  { make: "Kawasaki", model: "Concours 14", year: 2015 },
  { make: "Kawasaki", model: "Concours 14", year: 2016 },
  { make: "Kawasaki", model: "Concours 14", year: 2017 },
  { make: "Kawasaki", model: "Concours 14", year: 2018 },
  { make: "Kawasaki", model: "Concours 14", year: 2019 },
  { make: "Kawasaki", model: "Concours 14", year: 2020 },
  { make: "Kawasaki", model: "Concours 14", year: 2021 },
  { make: "Kawasaki", model: "Concours 14", year: 2022 },
  { make: "Kawasaki", model: "Concours 14", year: 2023 },
  { make: "Kawasaki", model: "Concours 14", year: 2024 },
  { make: "Kawasaki", model: "Concours 14", year: 2025 },
  { make: "Kawasaki", model: "Concours 14", year: 2026 },
  // Kawasaki - Eliminator
  { make: "Kawasaki", model: "Eliminator", year: 2024 },
  { make: "Kawasaki", model: "Eliminator", year: 2025 },
  { make: "Kawasaki", model: "Eliminator", year: 2026 },
  // Kawasaki - EN650
  { make: "Kawasaki", model: "EN650", year: 2015 },
  { make: "Kawasaki", model: "EN650", year: 2016 },
  { make: "Kawasaki", model: "EN650", year: 2017 },
  { make: "Kawasaki", model: "EN650", year: 2018 },
  { make: "Kawasaki", model: "EN650", year: 2019 },
  { make: "Kawasaki", model: "EN650", year: 2020 },
  { make: "Kawasaki", model: "EN650", year: 2021 },
  // Kawasaki - ER-6N
  { make: "Kawasaki", model: "ER-6N", year: 2005 },
  { make: "Kawasaki", model: "ER-6N", year: 2006 },
  { make: "Kawasaki", model: "ER-6N", year: 2007 },
  { make: "Kawasaki", model: "ER-6N", year: 2008 },
  { make: "Kawasaki", model: "ER-6N", year: 2009 },
  { make: "Kawasaki", model: "ER-6N", year: 2010 },
  { make: "Kawasaki", model: "ER-6N", year: 2011 },
  { make: "Kawasaki", model: "ER-6N", year: 2012 },
  { make: "Kawasaki", model: "ER-6N", year: 2013 },
  { make: "Kawasaki", model: "ER-6N", year: 2014 },
  { make: "Kawasaki", model: "ER-6N", year: 2015 },
  { make: "Kawasaki", model: "ER-6N", year: 2016 },
  // Kawasaki - H2
  { make: "Kawasaki", model: "H2", year: 2015 },
  { make: "Kawasaki", model: "H2", year: 2016 },
  { make: "Kawasaki", model: "H2", year: 2017 },
  { make: "Kawasaki", model: "H2", year: 2018 },
  { make: "Kawasaki", model: "H2", year: 2019 },
  { make: "Kawasaki", model: "H2", year: 2020 },
  { make: "Kawasaki", model: "H2", year: 2021 },
  { make: "Kawasaki", model: "H2", year: 2022 },
  { make: "Kawasaki", model: "H2", year: 2023 },
  { make: "Kawasaki", model: "H2", year: 2024 },
  { make: "Kawasaki", model: "H2", year: 2025 },
  { make: "Kawasaki", model: "H2", year: 2026 },
  { make: "Kawasaki", model: "H2", year: 2027 },
  // Kawasaki - J-300
  { make: "Kawasaki", model: "J-300", year: 2014 },
  { make: "Kawasaki", model: "J-300", year: 2015 },
  { make: "Kawasaki", model: "J-300", year: 2016 },
  // Kawasaki - J125
  { make: "Kawasaki", model: "J125", year: 2009 },
  { make: "Kawasaki", model: "J125", year: 2010 },
  { make: "Kawasaki", model: "J125", year: 2011 },
  { make: "Kawasaki", model: "J125", year: 2012 },
  { make: "Kawasaki", model: "J125", year: 2013 },
  { make: "Kawasaki", model: "J125", year: 2014 },
  { make: "Kawasaki", model: "J125", year: 2015 },
  // Kawasaki - J300
  { make: "Kawasaki", model: "J300", year: 2017 },
  { make: "Kawasaki", model: "J300", year: 2018 },
  { make: "Kawasaki", model: "J300", year: 2019 },
  { make: "Kawasaki", model: "J300", year: 2020 },
  // Kawasaki - KDX200
  { make: "Kawasaki", model: "KDX200", year: 1989 },
  { make: "Kawasaki", model: "KDX200", year: 1990 },
  { make: "Kawasaki", model: "KDX200", year: 1991 },
  { make: "Kawasaki", model: "KDX200", year: 1992 },
  { make: "Kawasaki", model: "KDX200", year: 1993 },
  { make: "Kawasaki", model: "KDX200", year: 1994 },
  { make: "Kawasaki", model: "KDX200", year: 1995 },
  { make: "Kawasaki", model: "KDX200", year: 1996 },
  { make: "Kawasaki", model: "KDX200", year: 1997 },
  { make: "Kawasaki", model: "KDX200", year: 1998 },
  { make: "Kawasaki", model: "KDX200", year: 1999 },
  { make: "Kawasaki", model: "KDX200", year: 2000 },
  { make: "Kawasaki", model: "KDX200", year: 2001 },
  { make: "Kawasaki", model: "KDX200", year: 2002 },
  { make: "Kawasaki", model: "KDX200", year: 2003 },
  { make: "Kawasaki", model: "KDX200", year: 2004 },
  { make: "Kawasaki", model: "KDX200", year: 2005 },
  { make: "Kawasaki", model: "KDX200", year: 2006 },
  // Kawasaki - KDX220R
  { make: "Kawasaki", model: "KDX220R", year: 1995 },
  { make: "Kawasaki", model: "KDX220R", year: 1996 },
  { make: "Kawasaki", model: "KDX220R", year: 1997 },
  { make: "Kawasaki", model: "KDX220R", year: 1998 },
  { make: "Kawasaki", model: "KDX220R", year: 1999 },
  { make: "Kawasaki", model: "KDX220R", year: 2000 },
  { make: "Kawasaki", model: "KDX220R", year: 2001 },
  { make: "Kawasaki", model: "KDX220R", year: 2002 },
  { make: "Kawasaki", model: "KDX220R", year: 2003 },
  { make: "Kawasaki", model: "KDX220R", year: 2004 },
  { make: "Kawasaki", model: "KDX220R", year: 2005 },
  { make: "Kawasaki", model: "KDX220R", year: 2006 },
  // Kawasaki - KDX250
  { make: "Kawasaki", model: "KDX250", year: 1991 },
  { make: "Kawasaki", model: "KDX250", year: 1992 },
  { make: "Kawasaki", model: "KDX250", year: 1993 },
  { make: "Kawasaki", model: "KDX250", year: 1994 },
  // Kawasaki - KFX-80
  { make: "Kawasaki", model: "KFX-80", year: 2003 },
  { make: "Kawasaki", model: "KFX-80", year: 2004 },
  { make: "Kawasaki", model: "KFX-80", year: 2005 },
  { make: "Kawasaki", model: "KFX-80", year: 2006 },
  // Kawasaki - KFX-400
  { make: "Kawasaki", model: "KFX-400", year: 2003 },
  { make: "Kawasaki", model: "KFX-400", year: 2004 },
  { make: "Kawasaki", model: "KFX-400", year: 2005 },
  { make: "Kawasaki", model: "KFX-400", year: 2006 },
  // Kawasaki - KFX-450R
  { make: "Kawasaki", model: "KFX-450R", year: 2007 },
  { make: "Kawasaki", model: "KFX-450R", year: 2008 },
  { make: "Kawasaki", model: "KFX-450R", year: 2009 },
  { make: "Kawasaki", model: "KFX-450R", year: 2010 },
  { make: "Kawasaki", model: "KFX-450R", year: 2011 },
  { make: "Kawasaki", model: "KFX-450R", year: 2012 },
  { make: "Kawasaki", model: "KFX-450R", year: 2013 },
  { make: "Kawasaki", model: "KFX-450R", year: 2014 },
  // Kawasaki - KFX-450R Head
  { make: "Kawasaki", model: "KFX-450R Head", year: 2007 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2008 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2009 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2010 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2011 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2012 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2013 },
  { make: "Kawasaki", model: "KFX-450R Head", year: 2014 },
  // Kawasaki - KFX80
  { make: "Kawasaki", model: "KFX80", year: 2003 },
  { make: "Kawasaki", model: "KFX80", year: 2004 },
  { make: "Kawasaki", model: "KFX80", year: 2005 },
  { make: "Kawasaki", model: "KFX80", year: 2006 },
  // Kawasaki - KFX400
  { make: "Kawasaki", model: "KFX400", year: 2003 },
  { make: "Kawasaki", model: "KFX400", year: 2004 },
  { make: "Kawasaki", model: "KFX400", year: 2005 },
  { make: "Kawasaki", model: "KFX400", year: 2006 },
  // Kawasaki - KFX400R
  { make: "Kawasaki", model: "KFX400R", year: 2003 },
  { make: "Kawasaki", model: "KFX400R", year: 2004 },
  { make: "Kawasaki", model: "KFX400R", year: 2005 },
  { make: "Kawasaki", model: "KFX400R", year: 2006 },
  // Kawasaki - KLR-250
  { make: "Kawasaki", model: "KLR-250", year: 1984 },
  { make: "Kawasaki", model: "KLR-250", year: 1985 },
  { make: "Kawasaki", model: "KLR-250", year: 1986 },
  { make: "Kawasaki", model: "KLR-250", year: 1987 },
  { make: "Kawasaki", model: "KLR-250", year: 1988 },
  { make: "Kawasaki", model: "KLR-250", year: 1989 },
  { make: "Kawasaki", model: "KLR-250", year: 1990 },
  { make: "Kawasaki", model: "KLR-250", year: 1991 },
  { make: "Kawasaki", model: "KLR-250", year: 1992 },
  { make: "Kawasaki", model: "KLR-250", year: 1993 },
  { make: "Kawasaki", model: "KLR-250", year: 1994 },
  { make: "Kawasaki", model: "KLR-250", year: 1995 },
  { make: "Kawasaki", model: "KLR-250", year: 1996 },
  { make: "Kawasaki", model: "KLR-250", year: 1997 },
  { make: "Kawasaki", model: "KLR-250", year: 1998 },
  { make: "Kawasaki", model: "KLR-250", year: 1999 },
  { make: "Kawasaki", model: "KLR-250", year: 2000 },
  { make: "Kawasaki", model: "KLR-250", year: 2001 },
  { make: "Kawasaki", model: "KLR-250", year: 2002 },
  { make: "Kawasaki", model: "KLR-250", year: 2003 },
  { make: "Kawasaki", model: "KLR-250", year: 2004 },
  { make: "Kawasaki", model: "KLR-250", year: 2005 },
  // Kawasaki - KLR-650
  { make: "Kawasaki", model: "KLR-650", year: 1993 },
  { make: "Kawasaki", model: "KLR-650", year: 1994 },
  { make: "Kawasaki", model: "KLR-650", year: 1995 },
  { make: "Kawasaki", model: "KLR-650", year: 1996 },
  { make: "Kawasaki", model: "KLR-650", year: 1997 },
  { make: "Kawasaki", model: "KLR-650", year: 1998 },
  { make: "Kawasaki", model: "KLR-650", year: 1999 },
  { make: "Kawasaki", model: "KLR-650", year: 2000 },
  { make: "Kawasaki", model: "KLR-650", year: 2001 },
  { make: "Kawasaki", model: "KLR-650", year: 2002 },
  { make: "Kawasaki", model: "KLR-650", year: 2003 },
  { make: "Kawasaki", model: "KLR-650", year: 2004 },
  { make: "Kawasaki", model: "KLR-650", year: 2005 },
  { make: "Kawasaki", model: "KLR-650", year: 2006 },
  { make: "Kawasaki", model: "KLR-650", year: 2007 },
  { make: "Kawasaki", model: "KLR-650", year: 2008 },
  { make: "Kawasaki", model: "KLR-650", year: 2009 },
  { make: "Kawasaki", model: "KLR-650", year: 2010 },
  { make: "Kawasaki", model: "KLR-650", year: 2011 },
  { make: "Kawasaki", model: "KLR-650", year: 2012 },
  { make: "Kawasaki", model: "KLR-650", year: 2013 },
  { make: "Kawasaki", model: "KLR-650", year: 2014 },
  { make: "Kawasaki", model: "KLR-650", year: 2015 },
  { make: "Kawasaki", model: "KLR-650", year: 2016 },
  { make: "Kawasaki", model: "KLR-650", year: 2017 },
  { make: "Kawasaki", model: "KLR-650", year: 2018 },
  { make: "Kawasaki", model: "KLR-650", year: 2019 },
  // Kawasaki - KLR-650 3549
  { make: "Kawasaki", model: "KLR-650 3549", year: 2022 },
  { make: "Kawasaki", model: "KLR-650 3549", year: 2023 },
  { make: "Kawasaki", model: "KLR-650 3549", year: 2024 },
  { make: "Kawasaki", model: "KLR-650 3549", year: 2025 },
  { make: "Kawasaki", model: "KLR-650 3549", year: 2026 },
  // Kawasaki - KLR-650 14434X
  { make: "Kawasaki", model: "KLR-650 14434X", year: 2022 },
  { make: "Kawasaki", model: "KLR-650 14434X", year: 2023 },
  { make: "Kawasaki", model: "KLR-650 14434X", year: 2024 },
  { make: "Kawasaki", model: "KLR-650 14434X", year: 2025 },
  { make: "Kawasaki", model: "KLR-650 14434X", year: 2026 },
  // Kawasaki - KLR600
  { make: "Kawasaki", model: "KLR600", year: 1984 },
  { make: "Kawasaki", model: "KLR600", year: 1985 },
  { make: "Kawasaki", model: "KLR600", year: 1986 },
  { make: "Kawasaki", model: "KLR600", year: 1987 },
  { make: "Kawasaki", model: "KLR600", year: 1988 },
  { make: "Kawasaki", model: "KLR600", year: 1989 },
  { make: "Kawasaki", model: "KLR600", year: 1990 },
  { make: "Kawasaki", model: "KLR600", year: 1991 },
  { make: "Kawasaki", model: "KLR600", year: 1992 },
  { make: "Kawasaki", model: "KLR600", year: 1993 },
  { make: "Kawasaki", model: "KLR600", year: 1994 },
  { make: "Kawasaki", model: "KLR600", year: 1995 },
  { make: "Kawasaki", model: "KLR600", year: 1996 },
  { make: "Kawasaki", model: "KLR600", year: 1997 },
  { make: "Kawasaki", model: "KLR600", year: 1998 },
  { make: "Kawasaki", model: "KLR600", year: 1999 },
  { make: "Kawasaki", model: "KLR600", year: 2000 },
  { make: "Kawasaki", model: "KLR600", year: 2001 },
  { make: "Kawasaki", model: "KLR600", year: 2002 },
  { make: "Kawasaki", model: "KLR600", year: 2003 },
  { make: "Kawasaki", model: "KLR600", year: 2004 },
  // Kawasaki - KLR650
  { make: "Kawasaki", model: "KLR650", year: 1984 },
  { make: "Kawasaki", model: "KLR650", year: 1985 },
  { make: "Kawasaki", model: "KLR650", year: 1986 },
  { make: "Kawasaki", model: "KLR650", year: 1987 },
  { make: "Kawasaki", model: "KLR650", year: 1988 },
  { make: "Kawasaki", model: "KLR650", year: 1989 },
  { make: "Kawasaki", model: "KLR650", year: 1990 },
  { make: "Kawasaki", model: "KLR650", year: 1991 },
  { make: "Kawasaki", model: "KLR650", year: 1992 },
  { make: "Kawasaki", model: "KLR650", year: 1993 },
  { make: "Kawasaki", model: "KLR650", year: 1994 },
  { make: "Kawasaki", model: "KLR650", year: 1995 },
  { make: "Kawasaki", model: "KLR650", year: 1996 },
  { make: "Kawasaki", model: "KLR650", year: 1997 },
  { make: "Kawasaki", model: "KLR650", year: 1998 },
  { make: "Kawasaki", model: "KLR650", year: 1999 },
  { make: "Kawasaki", model: "KLR650", year: 2000 },
  { make: "Kawasaki", model: "KLR650", year: 2001 },
  { make: "Kawasaki", model: "KLR650", year: 2002 },
  { make: "Kawasaki", model: "KLR650", year: 2003 },
  { make: "Kawasaki", model: "KLR650", year: 2004 },
  { make: "Kawasaki", model: "KLR650", year: 2005 },
  { make: "Kawasaki", model: "KLR650", year: 2006 },
  { make: "Kawasaki", model: "KLR650", year: 2007 },
  { make: "Kawasaki", model: "KLR650", year: 2008 },
  { make: "Kawasaki", model: "KLR650", year: 2009 },
  { make: "Kawasaki", model: "KLR650", year: 2010 },
  { make: "Kawasaki", model: "KLR650", year: 2011 },
  { make: "Kawasaki", model: "KLR650", year: 2012 },
  { make: "Kawasaki", model: "KLR650", year: 2013 },
  { make: "Kawasaki", model: "KLR650", year: 2014 },
  { make: "Kawasaki", model: "KLR650", year: 2015 },
  { make: "Kawasaki", model: "KLR650", year: 2016 },
  { make: "Kawasaki", model: "KLR650", year: 2017 },
  { make: "Kawasaki", model: "KLR650", year: 2018 },
  { make: "Kawasaki", model: "KLR650", year: 2022 },
  { make: "Kawasaki", model: "KLR650", year: 2023 },
  { make: "Kawasaki", model: "KLR650", year: 2024 },
  { make: "Kawasaki", model: "KLR650", year: 2025 },
  { make: "Kawasaki", model: "KLR650", year: 2026 },
  // Kawasaki - KLR650 Camo
  { make: "Kawasaki", model: "KLR650 Camo", year: 2016 },
  { make: "Kawasaki", model: "KLR650 Camo", year: 2017 },
  { make: "Kawasaki", model: "KLR650 Camo", year: 2018 },
  // Kawasaki - KLX-125
  { make: "Kawasaki", model: "KLX-125", year: 2003 },
  { make: "Kawasaki", model: "KLX-125", year: 2004 },
  { make: "Kawasaki", model: "KLX-125", year: 2005 },
  { make: "Kawasaki", model: "KLX-125", year: 2006 },
  { make: "Kawasaki", model: "KLX-125", year: 2007 },
  { make: "Kawasaki", model: "KLX-125", year: 2008 },
  { make: "Kawasaki", model: "KLX-125", year: 2009 },
  // Kawasaki - KLX-250
  { make: "Kawasaki", model: "KLX-250", year: 1994 },
  { make: "Kawasaki", model: "KLX-250", year: 1995 },
  { make: "Kawasaki", model: "KLX-250", year: 1996 },
  { make: "Kawasaki", model: "KLX-250", year: 1997 },
  { make: "Kawasaki", model: "KLX-250", year: 1998 },
  { make: "Kawasaki", model: "KLX-250", year: 1999 },
  { make: "Kawasaki", model: "KLX-250", year: 2000 },
  { make: "Kawasaki", model: "KLX-250", year: 2001 },
  { make: "Kawasaki", model: "KLX-250", year: 2002 },
  { make: "Kawasaki", model: "KLX-250", year: 2003 },
  { make: "Kawasaki", model: "KLX-250", year: 2004 },
  { make: "Kawasaki", model: "KLX-250", year: 2005 },
  { make: "Kawasaki", model: "KLX-250", year: 2006 },
  { make: "Kawasaki", model: "KLX-250", year: 2007 },
  { make: "Kawasaki", model: "KLX-250", year: 2008 },
  { make: "Kawasaki", model: "KLX-250", year: 2009 },
  { make: "Kawasaki", model: "KLX-250", year: 2010 },
  { make: "Kawasaki", model: "KLX-250", year: 2011 },
  { make: "Kawasaki", model: "KLX-250", year: 2012 },
  { make: "Kawasaki", model: "KLX-250", year: 2013 },
  { make: "Kawasaki", model: "KLX-250", year: 2014 },
  // Kawasaki - KLX-400R
  { make: "Kawasaki", model: "KLX-400R", year: 2003 },
  { make: "Kawasaki", model: "KLX-400R", year: 2004 },
  { make: "Kawasaki", model: "KLX-400R", year: 2005 },
  { make: "Kawasaki", model: "KLX-400R", year: 2006 },
  { make: "Kawasaki", model: "KLX-400R", year: 2007 },
  // Kawasaki - KLX-450R
  { make: "Kawasaki", model: "KLX-450R", year: 2008 },
  { make: "Kawasaki", model: "KLX-450R", year: 2009 },
  { make: "Kawasaki", model: "KLX-450R", year: 2010 },
  { make: "Kawasaki", model: "KLX-450R", year: 2011 },
  { make: "Kawasaki", model: "KLX-450R", year: 2012 },
  { make: "Kawasaki", model: "KLX-450R", year: 2013 },
  // Kawasaki - KLX110
  { make: "Kawasaki", model: "KLX110", year: 2002 },
  { make: "Kawasaki", model: "KLX110", year: 2003 },
  { make: "Kawasaki", model: "KLX110", year: 2004 },
  { make: "Kawasaki", model: "KLX110", year: 2005 },
  { make: "Kawasaki", model: "KLX110", year: 2006 },
  { make: "Kawasaki", model: "KLX110", year: 2007 },
  { make: "Kawasaki", model: "KLX110", year: 2008 },
  { make: "Kawasaki", model: "KLX110", year: 2009 },
  { make: "Kawasaki", model: "KLX110", year: 2010 },
  { make: "Kawasaki", model: "KLX110", year: 2011 },
  { make: "Kawasaki", model: "KLX110", year: 2012 },
  { make: "Kawasaki", model: "KLX110", year: 2013 },
  { make: "Kawasaki", model: "KLX110", year: 2014 },
  { make: "Kawasaki", model: "KLX110", year: 2015 },
  { make: "Kawasaki", model: "KLX110", year: 2016 },
  { make: "Kawasaki", model: "KLX110", year: 2017 },
  { make: "Kawasaki", model: "KLX110", year: 2018 },
  { make: "Kawasaki", model: "KLX110", year: 2019 },
  { make: "Kawasaki", model: "KLX110", year: 2020 },
  { make: "Kawasaki", model: "KLX110", year: 2021 },
  { make: "Kawasaki", model: "KLX110", year: 2022 },
  // Kawasaki - KLX110L
  { make: "Kawasaki", model: "KLX110L", year: 2010 },
  { make: "Kawasaki", model: "KLX110L", year: 2011 },
  { make: "Kawasaki", model: "KLX110L", year: 2012 },
  { make: "Kawasaki", model: "KLX110L", year: 2013 },
  { make: "Kawasaki", model: "KLX110L", year: 2014 },
  { make: "Kawasaki", model: "KLX110L", year: 2015 },
  { make: "Kawasaki", model: "KLX110L", year: 2016 },
  { make: "Kawasaki", model: "KLX110L", year: 2017 },
  { make: "Kawasaki", model: "KLX110L", year: 2018 },
  { make: "Kawasaki", model: "KLX110L", year: 2019 },
  { make: "Kawasaki", model: "KLX110L", year: 2020 },
  // Kawasaki - KLX110R
  { make: "Kawasaki", model: "KLX110R", year: 2002 },
  { make: "Kawasaki", model: "KLX110R", year: 2003 },
  { make: "Kawasaki", model: "KLX110R", year: 2004 },
  { make: "Kawasaki", model: "KLX110R", year: 2005 },
  { make: "Kawasaki", model: "KLX110R", year: 2006 },
  { make: "Kawasaki", model: "KLX110R", year: 2007 },
  { make: "Kawasaki", model: "KLX110R", year: 2008 },
  { make: "Kawasaki", model: "KLX110R", year: 2009 },
  { make: "Kawasaki", model: "KLX110R", year: 2010 },
  { make: "Kawasaki", model: "KLX110R", year: 2011 },
  { make: "Kawasaki", model: "KLX110R", year: 2012 },
  { make: "Kawasaki", model: "KLX110R", year: 2013 },
  { make: "Kawasaki", model: "KLX110R", year: 2014 },
  { make: "Kawasaki", model: "KLX110R", year: 2015 },
  { make: "Kawasaki", model: "KLX110R", year: 2016 },
  { make: "Kawasaki", model: "KLX110R", year: 2017 },
  { make: "Kawasaki", model: "KLX110R", year: 2018 },
  { make: "Kawasaki", model: "KLX110R", year: 2019 },
  { make: "Kawasaki", model: "KLX110R", year: 2020 },
  { make: "Kawasaki", model: "KLX110R", year: 2021 },
  { make: "Kawasaki", model: "KLX110R", year: 2022 },
  { make: "Kawasaki", model: "KLX110R", year: 2023 },
  { make: "Kawasaki", model: "KLX110R", year: 2024 },
  { make: "Kawasaki", model: "KLX110R", year: 2025 },
  { make: "Kawasaki", model: "KLX110R", year: 2026 },
  // Kawasaki - KLX110R L
  { make: "Kawasaki", model: "KLX110R L", year: 2010 },
  { make: "Kawasaki", model: "KLX110R L", year: 2011 },
  { make: "Kawasaki", model: "KLX110R L", year: 2012 },
  { make: "Kawasaki", model: "KLX110R L", year: 2013 },
  { make: "Kawasaki", model: "KLX110R L", year: 2014 },
  { make: "Kawasaki", model: "KLX110R L", year: 2015 },
  { make: "Kawasaki", model: "KLX110R L", year: 2016 },
  { make: "Kawasaki", model: "KLX110R L", year: 2017 },
  { make: "Kawasaki", model: "KLX110R L", year: 2018 },
  { make: "Kawasaki", model: "KLX110R L", year: 2019 },
  { make: "Kawasaki", model: "KLX110R L", year: 2020 },
  { make: "Kawasaki", model: "KLX110R L", year: 2021 },
  { make: "Kawasaki", model: "KLX110R L", year: 2022 },
  { make: "Kawasaki", model: "KLX110R L", year: 2023 },
  { make: "Kawasaki", model: "KLX110R L", year: 2024 },
  { make: "Kawasaki", model: "KLX110R L", year: 2025 },
  { make: "Kawasaki", model: "KLX110R L", year: 2026 },
  // Kawasaki - KLX125
  { make: "Kawasaki", model: "KLX125", year: 2003 },
  { make: "Kawasaki", model: "KLX125", year: 2004 },
  { make: "Kawasaki", model: "KLX125", year: 2005 },
  { make: "Kawasaki", model: "KLX125", year: 2006 },
  // Kawasaki - KLX125R
  { make: "Kawasaki", model: "KLX125R", year: 2003 },
  { make: "Kawasaki", model: "KLX125R", year: 2004 },
  // Kawasaki - KLX140
  { make: "Kawasaki", model: "KLX140", year: 2008 },
  { make: "Kawasaki", model: "KLX140", year: 2009 },
  { make: "Kawasaki", model: "KLX140", year: 2010 },
  { make: "Kawasaki", model: "KLX140", year: 2011 },
  { make: "Kawasaki", model: "KLX140", year: 2012 },
  { make: "Kawasaki", model: "KLX140", year: 2013 },
  { make: "Kawasaki", model: "KLX140", year: 2014 },
  { make: "Kawasaki", model: "KLX140", year: 2015 },
  { make: "Kawasaki", model: "KLX140", year: 2016 },
  { make: "Kawasaki", model: "KLX140", year: 2017 },
  { make: "Kawasaki", model: "KLX140", year: 2018 },
  { make: "Kawasaki", model: "KLX140", year: 2019 },
  { make: "Kawasaki", model: "KLX140", year: 2020 },
  { make: "Kawasaki", model: "KLX140", year: 2021 },
  // Kawasaki - KLX140F
  { make: "Kawasaki", model: "KLX140F", year: 2021 },
  // Kawasaki - KLX140G
  { make: "Kawasaki", model: "KLX140G", year: 2017 },
  { make: "Kawasaki", model: "KLX140G", year: 2018 },
  { make: "Kawasaki", model: "KLX140G", year: 2019 },
  { make: "Kawasaki", model: "KLX140G", year: 2020 },
  // Kawasaki - KLX140L
  { make: "Kawasaki", model: "KLX140L", year: 2008 },
  { make: "Kawasaki", model: "KLX140L", year: 2009 },
  { make: "Kawasaki", model: "KLX140L", year: 2010 },
  { make: "Kawasaki", model: "KLX140L", year: 2011 },
  { make: "Kawasaki", model: "KLX140L", year: 2012 },
  { make: "Kawasaki", model: "KLX140L", year: 2013 },
  { make: "Kawasaki", model: "KLX140L", year: 2014 },
  { make: "Kawasaki", model: "KLX140L", year: 2015 },
  { make: "Kawasaki", model: "KLX140L", year: 2016 },
  { make: "Kawasaki", model: "KLX140L", year: 2017 },
  { make: "Kawasaki", model: "KLX140L", year: 2018 },
  { make: "Kawasaki", model: "KLX140L", year: 2019 },
  { make: "Kawasaki", model: "KLX140L", year: 2020 },
  { make: "Kawasaki", model: "KLX140L", year: 2021 },
  // Kawasaki - KLX140R
  { make: "Kawasaki", model: "KLX140R", year: 2008 },
  { make: "Kawasaki", model: "KLX140R", year: 2009 },
  { make: "Kawasaki", model: "KLX140R", year: 2010 },
  { make: "Kawasaki", model: "KLX140R", year: 2011 },
  { make: "Kawasaki", model: "KLX140R", year: 2012 },
  { make: "Kawasaki", model: "KLX140R", year: 2013 },
  { make: "Kawasaki", model: "KLX140R", year: 2014 },
  { make: "Kawasaki", model: "KLX140R", year: 2015 },
  { make: "Kawasaki", model: "KLX140R", year: 2016 },
  { make: "Kawasaki", model: "KLX140R", year: 2017 },
  { make: "Kawasaki", model: "KLX140R", year: 2018 },
  { make: "Kawasaki", model: "KLX140R", year: 2019 },
  { make: "Kawasaki", model: "KLX140R", year: 2020 },
  { make: "Kawasaki", model: "KLX140R", year: 2021 },
  { make: "Kawasaki", model: "KLX140R", year: 2022 },
  { make: "Kawasaki", model: "KLX140R", year: 2023 },
  { make: "Kawasaki", model: "KLX140R", year: 2024 },
  { make: "Kawasaki", model: "KLX140R", year: 2025 },
  { make: "Kawasaki", model: "KLX140R", year: 2026 },
  // Kawasaki - KLX140R F
  { make: "Kawasaki", model: "KLX140R F", year: 2017 },
  { make: "Kawasaki", model: "KLX140R F", year: 2018 },
  { make: "Kawasaki", model: "KLX140R F", year: 2019 },
  { make: "Kawasaki", model: "KLX140R F", year: 2020 },
  { make: "Kawasaki", model: "KLX140R F", year: 2021 },
  { make: "Kawasaki", model: "KLX140R F", year: 2022 },
  { make: "Kawasaki", model: "KLX140R F", year: 2023 },
  { make: "Kawasaki", model: "KLX140R F", year: 2024 },
  { make: "Kawasaki", model: "KLX140R F", year: 2025 },
  { make: "Kawasaki", model: "KLX140R F", year: 2026 },
  // Kawasaki - KLX140R L
  { make: "Kawasaki", model: "KLX140R L", year: 2008 },
  { make: "Kawasaki", model: "KLX140R L", year: 2009 },
  { make: "Kawasaki", model: "KLX140R L", year: 2010 },
  { make: "Kawasaki", model: "KLX140R L", year: 2011 },
  { make: "Kawasaki", model: "KLX140R L", year: 2012 },
  { make: "Kawasaki", model: "KLX140R L", year: 2013 },
  { make: "Kawasaki", model: "KLX140R L", year: 2014 },
  { make: "Kawasaki", model: "KLX140R L", year: 2015 },
  { make: "Kawasaki", model: "KLX140R L", year: 2016 },
  { make: "Kawasaki", model: "KLX140R L", year: 2017 },
  { make: "Kawasaki", model: "KLX140R L", year: 2018 },
  { make: "Kawasaki", model: "KLX140R L", year: 2019 },
  { make: "Kawasaki", model: "KLX140R L", year: 2020 },
  { make: "Kawasaki", model: "KLX140R L", year: 2021 },
  { make: "Kawasaki", model: "KLX140R L", year: 2022 },
  { make: "Kawasaki", model: "KLX140R L", year: 2023 },
  { make: "Kawasaki", model: "KLX140R L", year: 2024 },
  { make: "Kawasaki", model: "KLX140R L", year: 2025 },
  { make: "Kawasaki", model: "KLX140R L", year: 2026 },
  // Kawasaki - KLX230
  { make: "Kawasaki", model: "KLX230", year: 2020 },
  { make: "Kawasaki", model: "KLX230", year: 2021 },
  { make: "Kawasaki", model: "KLX230", year: 2022 },
  { make: "Kawasaki", model: "KLX230", year: 2023 },
  { make: "Kawasaki", model: "KLX230", year: 2024 },
  { make: "Kawasaki", model: "KLX230", year: 2025 },
  { make: "Kawasaki", model: "KLX230", year: 2026 },
  // Kawasaki - KLX230R
  { make: "Kawasaki", model: "KLX230R", year: 2020 },
  { make: "Kawasaki", model: "KLX230R", year: 2021 },
  { make: "Kawasaki", model: "KLX230R", year: 2022 },
  { make: "Kawasaki", model: "KLX230R", year: 2023 },
  { make: "Kawasaki", model: "KLX230R", year: 2024 },
  { make: "Kawasaki", model: "KLX230R", year: 2025 },
  { make: "Kawasaki", model: "KLX230R", year: 2026 },
  // Kawasaki - KLX250
  { make: "Kawasaki", model: "KLX250", year: 2018 },
  { make: "Kawasaki", model: "KLX250", year: 2019 },
  { make: "Kawasaki", model: "KLX250", year: 2020 },
  // Kawasaki - KLX250 Camo
  { make: "Kawasaki", model: "KLX250 Camo", year: 2018 },
  { make: "Kawasaki", model: "KLX250 Camo", year: 2019 },
  { make: "Kawasaki", model: "KLX250 Camo", year: 2020 },
  // Kawasaki - KLX250S
  { make: "Kawasaki", model: "KLX250S", year: 2006 },
  { make: "Kawasaki", model: "KLX250S", year: 2009 },
  { make: "Kawasaki", model: "KLX250S", year: 2010 },
  { make: "Kawasaki", model: "KLX250S", year: 2012 },
  { make: "Kawasaki", model: "KLX250S", year: 2013 },
  { make: "Kawasaki", model: "KLX250S", year: 2014 },
  { make: "Kawasaki", model: "KLX250S", year: 2015 },
  // Kawasaki - KLX250SF
  { make: "Kawasaki", model: "KLX250SF", year: 2009 },
  { make: "Kawasaki", model: "KLX250SF", year: 2010 },
  // Kawasaki - KLX300
  { make: "Kawasaki", model: "KLX300", year: 1997 },
  { make: "Kawasaki", model: "KLX300", year: 1998 },
  { make: "Kawasaki", model: "KLX300", year: 1999 },
  { make: "Kawasaki", model: "KLX300", year: 2000 },
  { make: "Kawasaki", model: "KLX300", year: 2001 },
  { make: "Kawasaki", model: "KLX300", year: 2002 },
  { make: "Kawasaki", model: "KLX300", year: 2003 },
  { make: "Kawasaki", model: "KLX300", year: 2004 },
  { make: "Kawasaki", model: "KLX300", year: 2005 },
  { make: "Kawasaki", model: "KLX300", year: 2006 },
  { make: "Kawasaki", model: "KLX300", year: 2007 },
  { make: "Kawasaki", model: "KLX300", year: 2008 },
  { make: "Kawasaki", model: "KLX300", year: 2009 },
  { make: "Kawasaki", model: "KLX300", year: 2010 },
  { make: "Kawasaki", model: "KLX300", year: 2011 },
  { make: "Kawasaki", model: "KLX300", year: 2012 },
  { make: "Kawasaki", model: "KLX300", year: 2013 },
  { make: "Kawasaki", model: "KLX300", year: 2014 },
  { make: "Kawasaki", model: "KLX300", year: 2015 },
  { make: "Kawasaki", model: "KLX300", year: 2016 },
  { make: "Kawasaki", model: "KLX300", year: 2017 },
  { make: "Kawasaki", model: "KLX300", year: 2018 },
  { make: "Kawasaki", model: "KLX300", year: 2019 },
  { make: "Kawasaki", model: "KLX300", year: 2020 },
  { make: "Kawasaki", model: "KLX300", year: 2021 },
  { make: "Kawasaki", model: "KLX300", year: 2022 },
  { make: "Kawasaki", model: "KLX300", year: 2023 },
  { make: "Kawasaki", model: "KLX300", year: 2024 },
  { make: "Kawasaki", model: "KLX300", year: 2025 },
  { make: "Kawasaki", model: "KLX300", year: 2026 },
  // Kawasaki - KLX300R
  { make: "Kawasaki", model: "KLX300R", year: 1997 },
  { make: "Kawasaki", model: "KLX300R", year: 1998 },
  { make: "Kawasaki", model: "KLX300R", year: 1999 },
  { make: "Kawasaki", model: "KLX300R", year: 2000 },
  { make: "Kawasaki", model: "KLX300R", year: 2001 },
  { make: "Kawasaki", model: "KLX300R", year: 2002 },
  { make: "Kawasaki", model: "KLX300R", year: 2003 },
  { make: "Kawasaki", model: "KLX300R", year: 2004 },
  { make: "Kawasaki", model: "KLX300R", year: 2005 },
  { make: "Kawasaki", model: "KLX300R", year: 2006 },
  { make: "Kawasaki", model: "KLX300R", year: 2007 },
  { make: "Kawasaki", model: "KLX300R", year: 2008 },
  { make: "Kawasaki", model: "KLX300R", year: 2009 },
  { make: "Kawasaki", model: "KLX300R", year: 2010 },
  { make: "Kawasaki", model: "KLX300R", year: 2011 },
  { make: "Kawasaki", model: "KLX300R", year: 2012 },
  { make: "Kawasaki", model: "KLX300R", year: 2013 },
  { make: "Kawasaki", model: "KLX300R", year: 2014 },
  { make: "Kawasaki", model: "KLX300R", year: 2015 },
  { make: "Kawasaki", model: "KLX300R", year: 2016 },
  { make: "Kawasaki", model: "KLX300R", year: 2017 },
  { make: "Kawasaki", model: "KLX300R", year: 2018 },
  { make: "Kawasaki", model: "KLX300R", year: 2019 },
  { make: "Kawasaki", model: "KLX300R", year: 2020 },
  { make: "Kawasaki", model: "KLX300R", year: 2021 },
  { make: "Kawasaki", model: "KLX300R", year: 2022 },
  { make: "Kawasaki", model: "KLX300R", year: 2023 },
  { make: "Kawasaki", model: "KLX300R", year: 2024 },
  { make: "Kawasaki", model: "KLX300R", year: 2025 },
  { make: "Kawasaki", model: "KLX300R", year: 2026 },
  // Kawasaki - KLX400SR
  { make: "Kawasaki", model: "KLX400SR", year: 2003 },
  { make: "Kawasaki", model: "KLX400SR", year: 2004 },
  // Kawasaki - KLX450F
  { make: "Kawasaki", model: "KLX450F", year: 2016 },
  { make: "Kawasaki", model: "KLX450F", year: 2017 },
  { make: "Kawasaki", model: "KLX450F", year: 2018 },
  // Kawasaki - KLX450R
  { make: "Kawasaki", model: "KLX450R", year: 2008 },
  { make: "Kawasaki", model: "KLX450R", year: 2009 },
  // Kawasaki - KRF750 Teryx 4x4
  { make: "Kawasaki", model: "KRF750 Teryx 4x4", year: 2008 },
  { make: "Kawasaki", model: "KRF750 Teryx 4x4", year: 2009 },
  // Kawasaki - KRF750 Teryx 4X4 Single
  { make: "Kawasaki", model: "KRF750 Teryx 4X4 Single", year: 2008 },
  { make: "Kawasaki", model: "KRF750 Teryx 4X4 Single", year: 2009 },
  // Kawasaki - KRF750 Teryx FI 4x4
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4", year: 2009 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4", year: 2010 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4", year: 2011 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4", year: 2012 },
  // Kawasaki - KRF750 Teryx FI 4x4 LE
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 LE", year: 2011 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 LE", year: 2012 },
  // Kawasaki - KRF750 Teryx FI 4x4 Sport
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 Sport", year: 2009 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 Sport", year: 2010 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 Sport", year: 2011 },
  { make: "Kawasaki", model: "KRF750 Teryx FI 4x4 Sport", year: 2012 },
  // Kawasaki - KRF750 Teryx NRA Outdoors
  { make: "Kawasaki", model: "KRF750 Teryx NRA Outdoors", year: 2008 },
  { make: "Kawasaki", model: "KRF750 Teryx NRA Outdoors", year: 2009 },
  // Kawasaki - KRT750 Teryx4 4x4
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4", year: 2012 },
  // Kawasaki - KRT750 Teryx4 4X4 Dual
  { make: "Kawasaki", model: "KRT750 Teryx4 4X4 Dual", year: 2012 },
  // Kawasaki - KRT750 Teryx4 4x4 EPS
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS", year: 2012 },
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS", year: 2013 },
  // Kawasaki - KRT750 Teryx4 4x4 EPS Camo
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS Camo", year: 2013 },
  // Kawasaki - KRT750 Teryx4 4x4 EPS LE
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS LE", year: 2012 },
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS LE", year: 2013 },
  // Kawasaki - KRT750 Teryx4 4x4 EPS LE Camo
  { make: "Kawasaki", model: "KRT750 Teryx4 4x4 EPS LE Camo", year: 2012 },
  // Kawasaki - KX-250F
  { make: "Kawasaki", model: "KX-250F", year: 2006 },
  { make: "Kawasaki", model: "KX-250F", year: 2007 },
  { make: "Kawasaki", model: "KX-250F", year: 2008 },
  { make: "Kawasaki", model: "KX-250F", year: 2009 },
  { make: "Kawasaki", model: "KX-250F", year: 2010 },
  { make: "Kawasaki", model: "KX-250F", year: 2011 },
  { make: "Kawasaki", model: "KX-250F", year: 2012 },
  { make: "Kawasaki", model: "KX-250F", year: 2013 },
  { make: "Kawasaki", model: "KX-250F", year: 2021 },
  { make: "Kawasaki", model: "KX-250F", year: 2022 },
  { make: "Kawasaki", model: "KX-250F", year: 2023 },
  // Kawasaki - KX-450F
  { make: "Kawasaki", model: "KX-450F", year: 2006 },
  { make: "Kawasaki", model: "KX-450F", year: 2007 },
  { make: "Kawasaki", model: "KX-450F", year: 2008 },
  { make: "Kawasaki", model: "KX-450F", year: 2009 },
  { make: "Kawasaki", model: "KX-450F", year: 2010 },
  { make: "Kawasaki", model: "KX-450F", year: 2011 },
  { make: "Kawasaki", model: "KX-450F", year: 2012 },
  { make: "Kawasaki", model: "KX-450F", year: 2013 },
  { make: "Kawasaki", model: "KX-450F", year: 2014 },
  { make: "Kawasaki", model: "KX-450F", year: 2015 },
  { make: "Kawasaki", model: "KX-450F", year: 2019 },
  { make: "Kawasaki", model: "KX-450F", year: 2020 },
  { make: "Kawasaki", model: "KX-450F", year: 2021 },
  { make: "Kawasaki", model: "KX-450F", year: 2022 },
  { make: "Kawasaki", model: "KX-450F", year: 2023 },
  // Kawasaki - KX65
  { make: "Kawasaki", model: "KX65", year: 2000 },
  { make: "Kawasaki", model: "KX65", year: 2001 },
  { make: "Kawasaki", model: "KX65", year: 2002 },
  { make: "Kawasaki", model: "KX65", year: 2003 },
  { make: "Kawasaki", model: "KX65", year: 2004 },
  { make: "Kawasaki", model: "KX65", year: 2005 },
  { make: "Kawasaki", model: "KX65", year: 2006 },
  { make: "Kawasaki", model: "KX65", year: 2007 },
  { make: "Kawasaki", model: "KX65", year: 2008 },
  { make: "Kawasaki", model: "KX65", year: 2009 },
  { make: "Kawasaki", model: "KX65", year: 2010 },
  { make: "Kawasaki", model: "KX65", year: 2011 },
  { make: "Kawasaki", model: "KX65", year: 2012 },
  { make: "Kawasaki", model: "KX65", year: 2013 },
  { make: "Kawasaki", model: "KX65", year: 2014 },
  { make: "Kawasaki", model: "KX65", year: 2015 },
  { make: "Kawasaki", model: "KX65", year: 2016 },
  { make: "Kawasaki", model: "KX65", year: 2017 },
  { make: "Kawasaki", model: "KX65", year: 2018 },
  { make: "Kawasaki", model: "KX65", year: 2019 },
  { make: "Kawasaki", model: "KX65", year: 2020 },
  { make: "Kawasaki", model: "KX65", year: 2021 },
  { make: "Kawasaki", model: "KX65", year: 2022 },
  { make: "Kawasaki", model: "KX65", year: 2023 },
  { make: "Kawasaki", model: "KX65", year: 2024 },
  { make: "Kawasaki", model: "KX65", year: 2025 },
  { make: "Kawasaki", model: "KX65", year: 2026 },
  // Kawasaki - KX80
  { make: "Kawasaki", model: "KX80", year: 1998 },
  { make: "Kawasaki", model: "KX80", year: 1999 },
  { make: "Kawasaki", model: "KX80", year: 2000 },
  // Kawasaki - KX85
  { make: "Kawasaki", model: "KX85", year: 2001 },
  { make: "Kawasaki", model: "KX85", year: 2002 },
  { make: "Kawasaki", model: "KX85", year: 2003 },
  { make: "Kawasaki", model: "KX85", year: 2004 },
  { make: "Kawasaki", model: "KX85", year: 2005 },
  { make: "Kawasaki", model: "KX85", year: 2006 },
  { make: "Kawasaki", model: "KX85", year: 2007 },
  { make: "Kawasaki", model: "KX85", year: 2008 },
  { make: "Kawasaki", model: "KX85", year: 2009 },
  { make: "Kawasaki", model: "KX85", year: 2010 },
  { make: "Kawasaki", model: "KX85", year: 2011 },
  { make: "Kawasaki", model: "KX85", year: 2012 },
  { make: "Kawasaki", model: "KX85", year: 2013 },
  { make: "Kawasaki", model: "KX85", year: 2014 },
  { make: "Kawasaki", model: "KX85", year: 2015 },
  { make: "Kawasaki", model: "KX85", year: 2016 },
  { make: "Kawasaki", model: "KX85", year: 2017 },
  { make: "Kawasaki", model: "KX85", year: 2018 },
  { make: "Kawasaki", model: "KX85", year: 2019 },
  { make: "Kawasaki", model: "KX85", year: 2020 },
  { make: "Kawasaki", model: "KX85", year: 2021 },
  { make: "Kawasaki", model: "KX85", year: 2022 },
  { make: "Kawasaki", model: "KX85", year: 2023 },
  { make: "Kawasaki", model: "KX85", year: 2024 },
  { make: "Kawasaki", model: "KX85", year: 2025 },
  { make: "Kawasaki", model: "KX85", year: 2026 },
  // Kawasaki - KX100
  { make: "Kawasaki", model: "KX100", year: 1995 },
  { make: "Kawasaki", model: "KX100", year: 1996 },
  { make: "Kawasaki", model: "KX100", year: 1997 },
  { make: "Kawasaki", model: "KX100", year: 1998 },
  { make: "Kawasaki", model: "KX100", year: 1999 },
  { make: "Kawasaki", model: "KX100", year: 2000 },
  { make: "Kawasaki", model: "KX100", year: 2001 },
  { make: "Kawasaki", model: "KX100", year: 2002 },
  { make: "Kawasaki", model: "KX100", year: 2003 },
  { make: "Kawasaki", model: "KX100", year: 2004 },
  { make: "Kawasaki", model: "KX100", year: 2005 },
  { make: "Kawasaki", model: "KX100", year: 2006 },
  { make: "Kawasaki", model: "KX100", year: 2007 },
  { make: "Kawasaki", model: "KX100", year: 2008 },
  { make: "Kawasaki", model: "KX100", year: 2009 },
  { make: "Kawasaki", model: "KX100", year: 2010 },
  { make: "Kawasaki", model: "KX100", year: 2011 },
  { make: "Kawasaki", model: "KX100", year: 2012 },
  { make: "Kawasaki", model: "KX100", year: 2013 },
  { make: "Kawasaki", model: "KX100", year: 2014 },
  { make: "Kawasaki", model: "KX100", year: 2015 },
  { make: "Kawasaki", model: "KX100", year: 2016 },
  { make: "Kawasaki", model: "KX100", year: 2017 },
  { make: "Kawasaki", model: "KX100", year: 2018 },
  { make: "Kawasaki", model: "KX100", year: 2019 },
  { make: "Kawasaki", model: "KX100", year: 2020 },
  { make: "Kawasaki", model: "KX100", year: 2021 },
  // Kawasaki - KX112
  { make: "Kawasaki", model: "KX112", year: 2022 },
  { make: "Kawasaki", model: "KX112", year: 2023 },
  { make: "Kawasaki", model: "KX112", year: 2024 },
  { make: "Kawasaki", model: "KX112", year: 2025 },
  { make: "Kawasaki", model: "KX112", year: 2026 },
  // Kawasaki - KX125
  { make: "Kawasaki", model: "KX125", year: 1995 },
  { make: "Kawasaki", model: "KX125", year: 1996 },
  { make: "Kawasaki", model: "KX125", year: 1997 },
  { make: "Kawasaki", model: "KX125", year: 1998 },
  { make: "Kawasaki", model: "KX125", year: 1999 },
  { make: "Kawasaki", model: "KX125", year: 2000 },
  { make: "Kawasaki", model: "KX125", year: 2001 },
  { make: "Kawasaki", model: "KX125", year: 2002 },
  { make: "Kawasaki", model: "KX125", year: 2003 },
  { make: "Kawasaki", model: "KX125", year: 2004 },
  { make: "Kawasaki", model: "KX125", year: 2005 },
  { make: "Kawasaki", model: "KX125", year: 2006 },
  { make: "Kawasaki", model: "KX125", year: 2007 },
  // Kawasaki - KX250
  { make: "Kawasaki", model: "KX250", year: 1974 },
  { make: "Kawasaki", model: "KX250", year: 1975 },
  { make: "Kawasaki", model: "KX250", year: 1976 },
  { make: "Kawasaki", model: "KX250", year: 1977 },
  { make: "Kawasaki", model: "KX250", year: 1978 },
  { make: "Kawasaki", model: "KX250", year: 1979 },
  { make: "Kawasaki", model: "KX250", year: 1980 },
  { make: "Kawasaki", model: "KX250", year: 1981 },
  { make: "Kawasaki", model: "KX250", year: 1982 },
  { make: "Kawasaki", model: "KX250", year: 1983 },
  { make: "Kawasaki", model: "KX250", year: 1984 },
  { make: "Kawasaki", model: "KX250", year: 1985 },
  { make: "Kawasaki", model: "KX250", year: 1986 },
  { make: "Kawasaki", model: "KX250", year: 1987 },
  { make: "Kawasaki", model: "KX250", year: 1988 },
  { make: "Kawasaki", model: "KX250", year: 1989 },
  { make: "Kawasaki", model: "KX250", year: 1990 },
  { make: "Kawasaki", model: "KX250", year: 1991 },
  { make: "Kawasaki", model: "KX250", year: 1992 },
  { make: "Kawasaki", model: "KX250", year: 1993 },
  { make: "Kawasaki", model: "KX250", year: 1994 },
  { make: "Kawasaki", model: "KX250", year: 1995 },
  { make: "Kawasaki", model: "KX250", year: 1996 },
  { make: "Kawasaki", model: "KX250", year: 1997 },
  { make: "Kawasaki", model: "KX250", year: 1998 },
  { make: "Kawasaki", model: "KX250", year: 1999 },
  { make: "Kawasaki", model: "KX250", year: 2000 },
  { make: "Kawasaki", model: "KX250", year: 2001 },
  { make: "Kawasaki", model: "KX250", year: 2002 },
  { make: "Kawasaki", model: "KX250", year: 2003 },
  { make: "Kawasaki", model: "KX250", year: 2004 },
  { make: "Kawasaki", model: "KX250", year: 2005 },
  { make: "Kawasaki", model: "KX250", year: 2006 },
  { make: "Kawasaki", model: "KX250", year: 2007 },
  { make: "Kawasaki", model: "KX250", year: 2008 },
  { make: "Kawasaki", model: "KX250", year: 2009 },
  { make: "Kawasaki", model: "KX250", year: 2010 },
  { make: "Kawasaki", model: "KX250", year: 2011 },
  { make: "Kawasaki", model: "KX250", year: 2012 },
  { make: "Kawasaki", model: "KX250", year: 2013 },
  { make: "Kawasaki", model: "KX250", year: 2014 },
  { make: "Kawasaki", model: "KX250", year: 2015 },
  { make: "Kawasaki", model: "KX250", year: 2016 },
  { make: "Kawasaki", model: "KX250", year: 2017 },
  { make: "Kawasaki", model: "KX250", year: 2018 },
  { make: "Kawasaki", model: "KX250", year: 2019 },
  { make: "Kawasaki", model: "KX250", year: 2020 },
  { make: "Kawasaki", model: "KX250", year: 2021 },
  { make: "Kawasaki", model: "KX250", year: 2022 },
  { make: "Kawasaki", model: "KX250", year: 2023 },
  { make: "Kawasaki", model: "KX250", year: 2024 },
  { make: "Kawasaki", model: "KX250", year: 2025 },
  { make: "Kawasaki", model: "KX250", year: 2026 },
  // Kawasaki - KX250F
  { make: "Kawasaki", model: "KX250F", year: 2004 },
  { make: "Kawasaki", model: "KX250F", year: 2005 },
  { make: "Kawasaki", model: "KX250F", year: 2006 },
  { make: "Kawasaki", model: "KX250F", year: 2007 },
  { make: "Kawasaki", model: "KX250F", year: 2008 },
  { make: "Kawasaki", model: "KX250F", year: 2009 },
  { make: "Kawasaki", model: "KX250F", year: 2010 },
  { make: "Kawasaki", model: "KX250F", year: 2011 },
  { make: "Kawasaki", model: "KX250F", year: 2012 },
  { make: "Kawasaki", model: "KX250F", year: 2013 },
  { make: "Kawasaki", model: "KX250F", year: 2014 },
  { make: "Kawasaki", model: "KX250F", year: 2015 },
  { make: "Kawasaki", model: "KX250F", year: 2016 },
  { make: "Kawasaki", model: "KX250F", year: 2017 },
  { make: "Kawasaki", model: "KX250F", year: 2018 },
  { make: "Kawasaki", model: "KX250F", year: 2019 },
  { make: "Kawasaki", model: "KX250F", year: 2020 },
  { make: "Kawasaki", model: "KX250F", year: 2021 },
  { make: "Kawasaki", model: "KX250F", year: 2022 },
  { make: "Kawasaki", model: "KX250F", year: 2025 },
  { make: "Kawasaki", model: "KX250F", year: 2026 },
  // Kawasaki - KX250X
  { make: "Kawasaki", model: "KX250X", year: 2021 },
  { make: "Kawasaki", model: "KX250X", year: 2022 },
  { make: "Kawasaki", model: "KX250X", year: 2023 },
  { make: "Kawasaki", model: "KX250X", year: 2024 },
  { make: "Kawasaki", model: "KX250X", year: 2025 },
  { make: "Kawasaki", model: "KX250X", year: 2026 },
  // Kawasaki - KX450
  { make: "Kawasaki", model: "KX450", year: 2006 },
  { make: "Kawasaki", model: "KX450", year: 2007 },
  { make: "Kawasaki", model: "KX450", year: 2008 },
  { make: "Kawasaki", model: "KX450", year: 2009 },
  { make: "Kawasaki", model: "KX450", year: 2010 },
  { make: "Kawasaki", model: "KX450", year: 2011 },
  { make: "Kawasaki", model: "KX450", year: 2012 },
  { make: "Kawasaki", model: "KX450", year: 2013 },
  { make: "Kawasaki", model: "KX450", year: 2014 },
  { make: "Kawasaki", model: "KX450", year: 2015 },
  { make: "Kawasaki", model: "KX450", year: 2016 },
  { make: "Kawasaki", model: "KX450", year: 2017 },
  { make: "Kawasaki", model: "KX450", year: 2018 },
  { make: "Kawasaki", model: "KX450", year: 2019 },
  { make: "Kawasaki", model: "KX450", year: 2020 },
  { make: "Kawasaki", model: "KX450", year: 2021 },
  { make: "Kawasaki", model: "KX450", year: 2022 },
  { make: "Kawasaki", model: "KX450", year: 2023 },
  { make: "Kawasaki", model: "KX450", year: 2024 },
  { make: "Kawasaki", model: "KX450", year: 2025 },
  { make: "Kawasaki", model: "KX450", year: 2026 },
  // Kawasaki - KX450F
  { make: "Kawasaki", model: "KX450F", year: 2006 },
  { make: "Kawasaki", model: "KX450F", year: 2007 },
  { make: "Kawasaki", model: "KX450F", year: 2008 },
  { make: "Kawasaki", model: "KX450F", year: 2009 },
  { make: "Kawasaki", model: "KX450F", year: 2010 },
  { make: "Kawasaki", model: "KX450F", year: 2011 },
  { make: "Kawasaki", model: "KX450F", year: 2012 },
  { make: "Kawasaki", model: "KX450F", year: 2013 },
  { make: "Kawasaki", model: "KX450F", year: 2014 },
  { make: "Kawasaki", model: "KX450F", year: 2015 },
  { make: "Kawasaki", model: "KX450F", year: 2016 },
  { make: "Kawasaki", model: "KX450F", year: 2017 },
  { make: "Kawasaki", model: "KX450F", year: 2018 },
  { make: "Kawasaki", model: "KX450F", year: 2019 },
  { make: "Kawasaki", model: "KX450F", year: 2020 },
  { make: "Kawasaki", model: "KX450F", year: 2021 },
  { make: "Kawasaki", model: "KX450F", year: 2022 },
  { make: "Kawasaki", model: "KX450F", year: 2023 },
  { make: "Kawasaki", model: "KX450F", year: 2024 },
  { make: "Kawasaki", model: "KX450F", year: 2025 },
  { make: "Kawasaki", model: "KX450F", year: 2026 },
  // Kawasaki - KX450X
  { make: "Kawasaki", model: "KX450X", year: 2019 },
  { make: "Kawasaki", model: "KX450X", year: 2020 },
  { make: "Kawasaki", model: "KX450X", year: 2021 },
  { make: "Kawasaki", model: "KX450X", year: 2022 },
  { make: "Kawasaki", model: "KX450X", year: 2023 },
  { make: "Kawasaki", model: "KX450X", year: 2024 },
  { make: "Kawasaki", model: "KX450X", year: 2025 },
  { make: "Kawasaki", model: "KX450X", year: 2026 },
  // Kawasaki - KX500
  { make: "Kawasaki", model: "KX500", year: 1988 },
  { make: "Kawasaki", model: "KX500", year: 1989 },
  { make: "Kawasaki", model: "KX500", year: 1990 },
  { make: "Kawasaki", model: "KX500", year: 1991 },
  { make: "Kawasaki", model: "KX500", year: 1992 },
  { make: "Kawasaki", model: "KX500", year: 1993 },
  { make: "Kawasaki", model: "KX500", year: 1994 },
  { make: "Kawasaki", model: "KX500", year: 1995 },
  { make: "Kawasaki", model: "KX500", year: 1996 },
  { make: "Kawasaki", model: "KX500", year: 1997 },
  { make: "Kawasaki", model: "KX500", year: 1998 },
  { make: "Kawasaki", model: "KX500", year: 1999 },
  { make: "Kawasaki", model: "KX500", year: 2000 },
  { make: "Kawasaki", model: "KX500", year: 2001 },
  { make: "Kawasaki", model: "KX500", year: 2002 },
  { make: "Kawasaki", model: "KX500", year: 2003 },
  { make: "Kawasaki", model: "KX500", year: 2004 },
  // Kawasaki - Ninja 7/Z7 Hybrid
  { make: "Kawasaki", model: "Ninja 7/Z7 Hybrid", year: 2024 },
  { make: "Kawasaki", model: "Ninja 7/Z7 Hybrid", year: 2025 },
  { make: "Kawasaki", model: "Ninja 7/Z7 Hybrid", year: 2026 },
  // Kawasaki - Ninja 125
  { make: "Kawasaki", model: "Ninja 125", year: 2019 },
  { make: "Kawasaki", model: "Ninja 125", year: 2020 },
  { make: "Kawasaki", model: "Ninja 125", year: 2021 },
  { make: "Kawasaki", model: "Ninja 125", year: 2022 },
  // Kawasaki - Ninja 250R
  { make: "Kawasaki", model: "Ninja 250R", year: 2008 },
  { make: "Kawasaki", model: "Ninja 250R", year: 2009 },
  { make: "Kawasaki", model: "Ninja 250R", year: 2010 },
  { make: "Kawasaki", model: "Ninja 250R", year: 2011 },
  { make: "Kawasaki", model: "Ninja 250R", year: 2012 },
  // Kawasaki - Ninja 300
  { make: "Kawasaki", model: "Ninja 300", year: 2012 },
  { make: "Kawasaki", model: "Ninja 300", year: 2013 },
  { make: "Kawasaki", model: "Ninja 300", year: 2014 },
  { make: "Kawasaki", model: "Ninja 300", year: 2015 },
  { make: "Kawasaki", model: "Ninja 300", year: 2016 },
  { make: "Kawasaki", model: "Ninja 300", year: 2017 },
  // Kawasaki - Ninja 300 ABS
  { make: "Kawasaki", model: "Ninja 300 ABS", year: 2013 },
  { make: "Kawasaki", model: "Ninja 300 ABS", year: 2014 },
  { make: "Kawasaki", model: "Ninja 300 ABS", year: 2015 },
  { make: "Kawasaki", model: "Ninja 300 ABS", year: 2016 },
  { make: "Kawasaki", model: "Ninja 300 ABS", year: 2017 },
  // Kawasaki - Ninja 300 SE
  { make: "Kawasaki", model: "Ninja 300 SE", year: 2013 },
  { make: "Kawasaki", model: "Ninja 300 SE", year: 2014 },
  { make: "Kawasaki", model: "Ninja 300 SE", year: 2015 },
  { make: "Kawasaki", model: "Ninja 300 SE", year: 2016 },
  // Kawasaki - Ninja 400
  { make: "Kawasaki", model: "Ninja 400", year: 2018 },
  { make: "Kawasaki", model: "Ninja 400", year: 2019 },
  { make: "Kawasaki", model: "Ninja 400", year: 2020 },
  { make: "Kawasaki", model: "Ninja 400", year: 2021 },
  { make: "Kawasaki", model: "Ninja 400", year: 2022 },
  { make: "Kawasaki", model: "Ninja 400", year: 2023 },
  { make: "Kawasaki", model: "Ninja 400", year: 2024 },
  // Kawasaki - Ninja 400 ABS
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2018 },
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2019 },
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2020 },
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2021 },
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2022 },
  { make: "Kawasaki", model: "Ninja 400 ABS", year: 2023 },
  // Kawasaki - Ninja 400 EX400
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2018 },
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2019 },
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2020 },
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2021 },
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2022 },
  { make: "Kawasaki", model: "Ninja 400 EX400", year: 2023 },
  // Kawasaki - Ninja 400/500
  { make: "Kawasaki", model: "Ninja 400/500", year: 2018 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2019 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2020 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2021 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2022 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2023 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2024 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2025 },
  { make: "Kawasaki", model: "Ninja 400/500", year: 2026 },
  // Kawasaki - Ninja 500
  { make: "Kawasaki", model: "Ninja 500", year: 2018 },
  { make: "Kawasaki", model: "Ninja 500", year: 2019 },
  { make: "Kawasaki", model: "Ninja 500", year: 2020 },
  { make: "Kawasaki", model: "Ninja 500", year: 2021 },
  { make: "Kawasaki", model: "Ninja 500", year: 2022 },
  { make: "Kawasaki", model: "Ninja 500", year: 2023 },
  { make: "Kawasaki", model: "Ninja 500", year: 2024 },
  { make: "Kawasaki", model: "Ninja 500", year: 2025 },
  { make: "Kawasaki", model: "Ninja 500", year: 2026 },
  // Kawasaki - Ninja 650
  { make: "Kawasaki", model: "Ninja 650", year: 2006 },
  { make: "Kawasaki", model: "Ninja 650", year: 2007 },
  { make: "Kawasaki", model: "Ninja 650", year: 2008 },
  { make: "Kawasaki", model: "Ninja 650", year: 2009 },
  { make: "Kawasaki", model: "Ninja 650", year: 2010 },
  { make: "Kawasaki", model: "Ninja 650", year: 2011 },
  { make: "Kawasaki", model: "Ninja 650", year: 2012 },
  { make: "Kawasaki", model: "Ninja 650", year: 2013 },
  { make: "Kawasaki", model: "Ninja 650", year: 2014 },
  { make: "Kawasaki", model: "Ninja 650", year: 2015 },
  { make: "Kawasaki", model: "Ninja 650", year: 2016 },
  { make: "Kawasaki", model: "Ninja 650", year: 2017 },
  { make: "Kawasaki", model: "Ninja 650", year: 2018 },
  { make: "Kawasaki", model: "Ninja 650", year: 2019 },
  { make: "Kawasaki", model: "Ninja 650", year: 2020 },
  { make: "Kawasaki", model: "Ninja 650", year: 2021 },
  { make: "Kawasaki", model: "Ninja 650", year: 2022 },
  { make: "Kawasaki", model: "Ninja 650", year: 2023 },
  { make: "Kawasaki", model: "Ninja 650", year: 2024 },
  { make: "Kawasaki", model: "Ninja 650", year: 2025 },
  { make: "Kawasaki", model: "Ninja 650", year: 2026 },
  { make: "Kawasaki", model: "Ninja 650", year: 2027 },
  // Kawasaki - Ninja 1000 SX 1100 SX
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2020 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2021 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2022 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2023 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2024 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2025 },
  { make: "Kawasaki", model: "Ninja 1000 SX 1100 SX", year: 2026 },
  // Kawasaki - Ninja 1000 SX 14337STU
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2020 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2021 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2022 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2023 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2024 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2025 },
  { make: "Kawasaki", model: "Ninja 1000 SX 14337STU", year: 2026 },
  // Kawasaki - Ninja 1000 SX 15602BU
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2020 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2021 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2022 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2023 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2024 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2025 },
  { make: "Kawasaki", model: "Ninja 1000 SX 15602BU", year: 2026 },
  // Kawasaki - Ninja 1000 SX Nxt
  { make: "Kawasaki", model: "Ninja 1000 SX Nxt", year: 2020 },
  // Kawasaki - Ninja 1000SX
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2020 },
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2021 },
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2022 },
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2023 },
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2024 },
  { make: "Kawasaki", model: "Ninja 1000SX", year: 2025 },
  // Kawasaki - Ninja 1000SX/1100SX
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2020 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2021 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2022 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2023 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2024 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2025 },
  { make: "Kawasaki", model: "Ninja 1000SX/1100SX", year: 2026 },
  // Kawasaki - Ninja 1100 SX
  { make: "Kawasaki", model: "Ninja 1100 SX", year: 2025 },
  // Kawasaki - Ninja 1100SX
  { make: "Kawasaki", model: "Ninja 1100SX", year: 2025 },
  { make: "Kawasaki", model: "Ninja 1100SX", year: 2026 },
  { make: "Kawasaki", model: "Ninja 1100SX", year: 2027 },
  // Kawasaki - Ninja H2 SX
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2021 },
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2022 },
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2023 },
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2024 },
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2025 },
  { make: "Kawasaki", model: "Ninja H2 SX", year: 2026 },
  // Kawasaki - Ninja H2 SX SE
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2021 },
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2022 },
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2023 },
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2024 },
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2025 },
  { make: "Kawasaki", model: "Ninja H2 SX SE", year: 2026 },
  // Kawasaki - Ninja Zx 4R
  { make: "Kawasaki", model: "Ninja Zx 4R", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 4R", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 4R", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 4R", year: 2026 },
  // Kawasaki - Ninja Zx 4R Grid O
  { make: "Kawasaki", model: "Ninja Zx 4R Grid O", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 4R Grid O", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 4R Grid O", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 4R Grid O", year: 2026 },
  // Kawasaki - Ninja Zx 4RR
  { make: "Kawasaki", model: "Ninja Zx 4RR", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 4RR", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 4RR", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 4RR", year: 2026 },
  // Kawasaki - Ninja Zx 6R
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2005 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2006 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2007 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2008 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2009 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2010 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2011 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2012 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2013 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2014 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2015 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 6R", year: 2027 },
  // Kawasaki - Ninja Zx 6R Grid O
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2009 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2010 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2011 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2012 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2013 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2014 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2015 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 6R Grid O", year: 2027 },
  // Kawasaki - Ninja Zx 6R Streetfighter
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2009 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2010 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2011 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2012 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2013 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2014 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2015 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 6R Streetfighter", year: 2027 },
  // Kawasaki - Ninja Zx 10R
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2006 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2007 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2008 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2009 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2010 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2011 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2012 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2013 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2014 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2015 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 10R", year: 2027 },
  // Kawasaki - Ninja Zx 10R Gp
  { make: "Kawasaki", model: "Ninja Zx 10R Gp", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 10R Gp", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 10R Gp", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 10R Gp", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 10R Gp", year: 2020 },
  // Kawasaki - Ninja Zx 10R Green Street
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 10R Green Street", year: 2027 },
  // Kawasaki - Ninja Zx 10R Grid O
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2016 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2026 },
  { make: "Kawasaki", model: "Ninja Zx 10R Grid O", year: 2027 },
  // Kawasaki - Ninja Zx 10RR
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2017 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2018 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2019 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 10RR", year: 2024 },
  // Kawasaki - Ninja Zx 25R
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2020 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2021 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2022 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2023 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2024 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2025 },
  { make: "Kawasaki", model: "Ninja Zx 25R", year: 2026 },
  // Kawasaki - Ninja ZX-14R
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2012 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2013 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2014 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2015 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2016 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2017 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2018 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2019 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2020 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2021 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2022 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2023 },
  { make: "Kawasaki", model: "Ninja ZX-14R", year: 2024 },
  // Kawasaki - Teryx 750
  { make: "Kawasaki", model: "Teryx 750", year: 2008 },
  { make: "Kawasaki", model: "Teryx 750", year: 2009 },
  { make: "Kawasaki", model: "Teryx 750", year: 2010 },
  { make: "Kawasaki", model: "Teryx 750", year: 2011 },
  { make: "Kawasaki", model: "Teryx 750", year: 2012 },
  { make: "Kawasaki", model: "Teryx 750", year: 2013 },
  // Kawasaki - Versys 650
  { make: "Kawasaki", model: "Versys 650", year: 2007 },
  { make: "Kawasaki", model: "Versys 650", year: 2008 },
  { make: "Kawasaki", model: "Versys 650", year: 2009 },
  { make: "Kawasaki", model: "Versys 650", year: 2010 },
  { make: "Kawasaki", model: "Versys 650", year: 2011 },
  { make: "Kawasaki", model: "Versys 650", year: 2012 },
  { make: "Kawasaki", model: "Versys 650", year: 2013 },
  { make: "Kawasaki", model: "Versys 650", year: 2014 },
  { make: "Kawasaki", model: "Versys 650", year: 2015 },
  { make: "Kawasaki", model: "Versys 650", year: 2016 },
  { make: "Kawasaki", model: "Versys 650", year: 2017 },
  { make: "Kawasaki", model: "Versys 650", year: 2018 },
  { make: "Kawasaki", model: "Versys 650", year: 2019 },
  { make: "Kawasaki", model: "Versys 650", year: 2020 },
  { make: "Kawasaki", model: "Versys 650", year: 2021 },
  { make: "Kawasaki", model: "Versys 650", year: 2022 },
  { make: "Kawasaki", model: "Versys 650", year: 2023 },
  { make: "Kawasaki", model: "Versys 650", year: 2024 },
  { make: "Kawasaki", model: "Versys 650", year: 2025 },
  { make: "Kawasaki", model: "Versys 650", year: 2026 },
  // Kawasaki - Versys 1000
  { make: "Kawasaki", model: "Versys 1000", year: 2019 },
  { make: "Kawasaki", model: "Versys 1000", year: 2020 },
  { make: "Kawasaki", model: "Versys 1000", year: 2021 },
  { make: "Kawasaki", model: "Versys 1000", year: 2022 },
  { make: "Kawasaki", model: "Versys 1000", year: 2023 },
  { make: "Kawasaki", model: "Versys 1000", year: 2024 },
  { make: "Kawasaki", model: "Versys 1000", year: 2025 },
  { make: "Kawasaki", model: "Versys 1000", year: 2026 },
  // Kawasaki - Versys 1000 15623BU
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2019 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2020 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2021 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2022 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2023 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2024 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2025 },
  { make: "Kawasaki", model: "Versys 1000 15623BU", year: 2026 },
  // Kawasaki - Versys 1000 15623U
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2019 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2020 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2021 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2022 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2023 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2024 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2025 },
  { make: "Kawasaki", model: "Versys 1000 15623U", year: 2026 },
  // Kawasaki - Versys 1000 LT / SE LT+
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2019 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2020 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2021 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2022 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2023 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2024 },
  { make: "Kawasaki", model: "Versys 1000 LT / SE LT+", year: 2025 },
  // Kawasaki - Versys 1000 SE LT+
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2019 },
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2020 },
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2021 },
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2022 },
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2023 },
  { make: "Kawasaki", model: "Versys 1000 SE LT+", year: 2024 },
  // Kawasaki - Versys-X 300
  { make: "Kawasaki", model: "Versys-X 300", year: 2017 },
  { make: "Kawasaki", model: "Versys-X 300", year: 2018 },
  { make: "Kawasaki", model: "Versys-X 300", year: 2019 },
  { make: "Kawasaki", model: "Versys-X 300", year: 2020 },
  { make: "Kawasaki", model: "Versys-X 300", year: 2021 },
  { make: "Kawasaki", model: "Versys-X 300", year: 2022 },
  // Kawasaki - Versys-X 300 ABS
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2017 },
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2018 },
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2019 },
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2020 },
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2021 },
  { make: "Kawasaki", model: "Versys-X 300 ABS", year: 2022 },
  // Kawasaki - Vulcan S
  { make: "Kawasaki", model: "Vulcan S", year: 2015 },
  { make: "Kawasaki", model: "Vulcan S", year: 2016 },
  { make: "Kawasaki", model: "Vulcan S", year: 2017 },
  { make: "Kawasaki", model: "Vulcan S", year: 2018 },
  { make: "Kawasaki", model: "Vulcan S", year: 2019 },
  { make: "Kawasaki", model: "Vulcan S", year: 2020 },
  { make: "Kawasaki", model: "Vulcan S", year: 2021 },
  { make: "Kawasaki", model: "Vulcan S", year: 2022 },
  { make: "Kawasaki", model: "Vulcan S", year: 2023 },
  { make: "Kawasaki", model: "Vulcan S", year: 2024 },
  { make: "Kawasaki", model: "Vulcan S", year: 2025 },
  { make: "Kawasaki", model: "Vulcan S", year: 2026 },
  // Kawasaki - Vulcan S 650
  { make: "Kawasaki", model: "Vulcan S 650", year: 2017 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2018 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2019 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2020 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2021 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2022 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2023 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2024 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2025 },
  { make: "Kawasaki", model: "Vulcan S 650", year: 2026 },
  // Kawasaki - W800
  { make: "Kawasaki", model: "W800", year: 2011 },
  { make: "Kawasaki", model: "W800", year: 2012 },
  { make: "Kawasaki", model: "W800", year: 2013 },
  { make: "Kawasaki", model: "W800", year: 2014 },
  { make: "Kawasaki", model: "W800", year: 2015 },
  { make: "Kawasaki", model: "W800", year: 2016 },
  { make: "Kawasaki", model: "W800", year: 2017 },
  { make: "Kawasaki", model: "W800", year: 2018 },
  { make: "Kawasaki", model: "W800", year: 2019 },
  { make: "Kawasaki", model: "W800", year: 2020 },
  { make: "Kawasaki", model: "W800", year: 2021 },
  { make: "Kawasaki", model: "W800", year: 2022 },
  { make: "Kawasaki", model: "W800", year: 2023 },
  { make: "Kawasaki", model: "W800", year: 2024 },
  { make: "Kawasaki", model: "W800", year: 2025 },
  { make: "Kawasaki", model: "W800", year: 2026 },
  // Kawasaki - Z H2
  { make: "Kawasaki", model: "Z H2", year: 2020 },
  { make: "Kawasaki", model: "Z H2", year: 2021 },
  { make: "Kawasaki", model: "Z H2", year: 2022 },
  { make: "Kawasaki", model: "Z H2", year: 2023 },
  { make: "Kawasaki", model: "Z H2", year: 2024 },
  { make: "Kawasaki", model: "Z H2", year: 2025 },
  { make: "Kawasaki", model: "Z H2", year: 2026 },
  // Kawasaki - Z-750
  { make: "Kawasaki", model: "Z-750", year: 2004 },
  { make: "Kawasaki", model: "Z-750", year: 2005 },
  { make: "Kawasaki", model: "Z-750", year: 2006 },
  { make: "Kawasaki", model: "Z-750", year: 2007 },
  { make: "Kawasaki", model: "Z-750", year: 2008 },
  { make: "Kawasaki", model: "Z-750", year: 2009 },
  { make: "Kawasaki", model: "Z-750", year: 2010 },
  { make: "Kawasaki", model: "Z-750", year: 2011 },
  { make: "Kawasaki", model: "Z-750", year: 2012 },
  // Kawasaki - Z-800 E
  { make: "Kawasaki", model: "Z-800 E", year: 2013 },
  { make: "Kawasaki", model: "Z-800 E", year: 2014 },
  { make: "Kawasaki", model: "Z-800 E", year: 2015 },
  { make: "Kawasaki", model: "Z-800 E", year: 2016 },
  // Kawasaki - Z-900
  { make: "Kawasaki", model: "Z-900", year: 2017 },
  { make: "Kawasaki", model: "Z-900", year: 2018 },
  { make: "Kawasaki", model: "Z-900", year: 2019 },
  { make: "Kawasaki", model: "Z-900", year: 2020 },
  { make: "Kawasaki", model: "Z-900", year: 2021 },
  { make: "Kawasaki", model: "Z-900", year: 2022 },
  { make: "Kawasaki", model: "Z-900", year: 2023 },
  { make: "Kawasaki", model: "Z-900", year: 2024 },
  { make: "Kawasaki", model: "Z-900", year: 2025 },
  // Kawasaki - Z-900 RS
  { make: "Kawasaki", model: "Z-900 RS", year: 2022 },
  { make: "Kawasaki", model: "Z-900 RS", year: 2023 },
  { make: "Kawasaki", model: "Z-900 RS", year: 2024 },
  // Kawasaki - Z125
  { make: "Kawasaki", model: "Z125", year: 2016 },
  { make: "Kawasaki", model: "Z125", year: 2017 },
  { make: "Kawasaki", model: "Z125", year: 2018 },
  { make: "Kawasaki", model: "Z125", year: 2019 },
  { make: "Kawasaki", model: "Z125", year: 2020 },
  { make: "Kawasaki", model: "Z125", year: 2021 },
  { make: "Kawasaki", model: "Z125", year: 2022 },
  { make: "Kawasaki", model: "Z125", year: 2023 },
  { make: "Kawasaki", model: "Z125", year: 2024 },
  { make: "Kawasaki", model: "Z125", year: 2025 },
  { make: "Kawasaki", model: "Z125", year: 2026 },
  { make: "Kawasaki", model: "Z125", year: 2027 },
  // Kawasaki - Z125 Pro
  { make: "Kawasaki", model: "Z125 Pro", year: 2017 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2018 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2019 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2020 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2021 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2022 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2023 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2024 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2025 },
  { make: "Kawasaki", model: "Z125 Pro", year: 2026 },
  // Kawasaki - Z250
  { make: "Kawasaki", model: "Z250", year: 2013 },
  { make: "Kawasaki", model: "Z250", year: 2014 },
  { make: "Kawasaki", model: "Z250", year: 2015 },
  { make: "Kawasaki", model: "Z250", year: 2016 },
  { make: "Kawasaki", model: "Z250", year: 2017 },
  // Kawasaki - Z300
  { make: "Kawasaki", model: "Z300", year: 2013 },
  { make: "Kawasaki", model: "Z300", year: 2014 },
  { make: "Kawasaki", model: "Z300", year: 2015 },
  { make: "Kawasaki", model: "Z300", year: 2016 },
  { make: "Kawasaki", model: "Z300", year: 2017 },
  // Kawasaki - Z400
  { make: "Kawasaki", model: "Z400", year: 2018 },
  { make: "Kawasaki", model: "Z400", year: 2019 },
  { make: "Kawasaki", model: "Z400", year: 2020 },
  { make: "Kawasaki", model: "Z400", year: 2021 },
  { make: "Kawasaki", model: "Z400", year: 2022 },
  { make: "Kawasaki", model: "Z400", year: 2023 },
  { make: "Kawasaki", model: "Z400", year: 2024 },
  // Kawasaki - Z400 ABS
  { make: "Kawasaki", model: "Z400 ABS", year: 2018 },
  { make: "Kawasaki", model: "Z400 ABS", year: 2019 },
  { make: "Kawasaki", model: "Z400 ABS", year: 2020 },
  { make: "Kawasaki", model: "Z400 ABS", year: 2021 },
  { make: "Kawasaki", model: "Z400 ABS", year: 2022 },
  { make: "Kawasaki", model: "Z400 ABS", year: 2023 },
  // Kawasaki - Z650
  { make: "Kawasaki", model: "Z650", year: 2017 },
  { make: "Kawasaki", model: "Z650", year: 2018 },
  { make: "Kawasaki", model: "Z650", year: 2019 },
  { make: "Kawasaki", model: "Z650", year: 2020 },
  { make: "Kawasaki", model: "Z650", year: 2021 },
  { make: "Kawasaki", model: "Z650", year: 2022 },
  { make: "Kawasaki", model: "Z650", year: 2023 },
  { make: "Kawasaki", model: "Z650", year: 2024 },
  { make: "Kawasaki", model: "Z650", year: 2025 },
  { make: "Kawasaki", model: "Z650", year: 2026 },
  // Kawasaki - Z650RS
  { make: "Kawasaki", model: "Z650RS", year: 2022 },
  { make: "Kawasaki", model: "Z650RS", year: 2023 },
  { make: "Kawasaki", model: "Z650RS", year: 2024 },
  // Kawasaki - Z800
  { make: "Kawasaki", model: "Z800", year: 2013 },
  { make: "Kawasaki", model: "Z800", year: 2014 },
  { make: "Kawasaki", model: "Z800", year: 2015 },
  { make: "Kawasaki", model: "Z800", year: 2016 },
  // Kawasaki - Z800 ABS
  { make: "Kawasaki", model: "Z800 ABS", year: 2013 },
  { make: "Kawasaki", model: "Z800 ABS", year: 2014 },
  { make: "Kawasaki", model: "Z800 ABS", year: 2015 },
  { make: "Kawasaki", model: "Z800 ABS", year: 2016 },
  // Kawasaki - Z900
  { make: "Kawasaki", model: "Z900", year: 2017 },
  { make: "Kawasaki", model: "Z900", year: 2018 },
  { make: "Kawasaki", model: "Z900", year: 2019 },
  { make: "Kawasaki", model: "Z900", year: 2020 },
  { make: "Kawasaki", model: "Z900", year: 2021 },
  { make: "Kawasaki", model: "Z900", year: 2022 },
  { make: "Kawasaki", model: "Z900", year: 2023 },
  { make: "Kawasaki", model: "Z900", year: 2024 },
  { make: "Kawasaki", model: "Z900", year: 2025 },
  { make: "Kawasaki", model: "Z900", year: 2026 },
  { make: "Kawasaki", model: "Z900", year: 2027 },
  // Kawasaki - Z900 A2
  { make: "Kawasaki", model: "Z900 A2", year: 2017 },
  { make: "Kawasaki", model: "Z900 A2", year: 2018 },
  { make: "Kawasaki", model: "Z900 A2", year: 2019 },
  { make: "Kawasaki", model: "Z900 A2", year: 2020 },
  { make: "Kawasaki", model: "Z900 A2", year: 2021 },
  { make: "Kawasaki", model: "Z900 A2", year: 2022 },
  { make: "Kawasaki", model: "Z900 A2", year: 2023 },
  { make: "Kawasaki", model: "Z900 A2", year: 2024 },
  // Kawasaki - Z900 Grid O
  { make: "Kawasaki", model: "Z900 Grid O", year: 2020 },
  { make: "Kawasaki", model: "Z900 Grid O", year: 2021 },
  { make: "Kawasaki", model: "Z900 Grid O", year: 2022 },
  { make: "Kawasaki", model: "Z900 Grid O", year: 2023 },
  { make: "Kawasaki", model: "Z900 Grid O", year: 2024 },
  // Kawasaki - Z900 S K9SO11 Hzc
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2020 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2021 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2022 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2023 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2024 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2025 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzc", year: 2026 },
  // Kawasaki - Z900 S K9SO11 Hzt
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2020 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2021 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2022 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2023 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2024 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2025 },
  { make: "Kawasaki", model: "Z900 S K9SO11 Hzt", year: 2026 },
  // Kawasaki - Z900 S K9SO12 Aszt
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2020 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2021 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2022 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2023 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2024 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2025 },
  { make: "Kawasaki", model: "Z900 S K9SO12 Aszt", year: 2026 },
  // Kawasaki - Z900E
  { make: "Kawasaki", model: "Z900E", year: 2017 },
  { make: "Kawasaki", model: "Z900E", year: 2018 },
  // Kawasaki - Z900RS
  { make: "Kawasaki", model: "Z900RS", year: 2017 },
  { make: "Kawasaki", model: "Z900RS", year: 2018 },
  { make: "Kawasaki", model: "Z900RS", year: 2019 },
  { make: "Kawasaki", model: "Z900RS", year: 2020 },
  { make: "Kawasaki", model: "Z900RS", year: 2021 },
  { make: "Kawasaki", model: "Z900RS", year: 2022 },
  { make: "Kawasaki", model: "Z900RS", year: 2023 },
  { make: "Kawasaki", model: "Z900RS", year: 2024 },
  { make: "Kawasaki", model: "Z900RS", year: 2025 },
  { make: "Kawasaki", model: "Z900RS", year: 2026 },
  { make: "Kawasaki", model: "Z900RS", year: 2027 },
  // Kawasaki - Z900RS 15216B
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2018 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2019 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2020 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2021 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2022 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2023 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2024 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2025 },
  { make: "Kawasaki", model: "Z900RS 15216B", year: 2026 },
  // Kawasaki - Z1000
  { make: "Kawasaki", model: "Z1000", year: 2010 },
  { make: "Kawasaki", model: "Z1000", year: 2011 },
  { make: "Kawasaki", model: "Z1000", year: 2012 },
  { make: "Kawasaki", model: "Z1000", year: 2013 },
  { make: "Kawasaki", model: "Z1000", year: 2014 },
  { make: "Kawasaki", model: "Z1000", year: 2015 },
  { make: "Kawasaki", model: "Z1000", year: 2016 },
  { make: "Kawasaki", model: "Z1000", year: 2017 },
  { make: "Kawasaki", model: "Z1000", year: 2018 },
  { make: "Kawasaki", model: "Z1000", year: 2019 },
  { make: "Kawasaki", model: "Z1000", year: 2020 },
  { make: "Kawasaki", model: "Z1000", year: 2021 },
  // Kawasaki - Z1100
  { make: "Kawasaki", model: "Z1100", year: 2025 },
  { make: "Kawasaki", model: "Z1100", year: 2026 },
  // Kawasaki - ZH2
  { make: "Kawasaki", model: "ZH2", year: 2020 },
  { make: "Kawasaki", model: "ZH2", year: 2021 },
  { make: "Kawasaki", model: "ZH2", year: 2022 },
  { make: "Kawasaki", model: "ZH2", year: 2023 },
  { make: "Kawasaki", model: "ZH2", year: 2024 },
  { make: "Kawasaki", model: "ZH2", year: 2025 },
  { make: "Kawasaki", model: "ZH2", year: 2026 },
  { make: "Kawasaki", model: "ZH2", year: 2027 },
  // Kawasaki - ZX-4R
  { make: "Kawasaki", model: "ZX-4R", year: 2023 },
  { make: "Kawasaki", model: "ZX-4R", year: 2024 },
  { make: "Kawasaki", model: "ZX-4R", year: 2025 },
  { make: "Kawasaki", model: "ZX-4R", year: 2026 },
  { make: "Kawasaki", model: "ZX-4R", year: 2027 },
  // Kawasaki - ZX-4R 15409SBU
  { make: "Kawasaki", model: "ZX-4R 15409SBU", year: 2023 },
  { make: "Kawasaki", model: "ZX-4R 15409SBU", year: 2024 },
  { make: "Kawasaki", model: "ZX-4R 15409SBU", year: 2025 },
  { make: "Kawasaki", model: "ZX-4R 15409SBU", year: 2026 },
  // Kawasaki - ZX-4R 15409STU
  { make: "Kawasaki", model: "ZX-4R 15409STU", year: 2023 },
  { make: "Kawasaki", model: "ZX-4R 15409STU", year: 2024 },
  { make: "Kawasaki", model: "ZX-4R 15409STU", year: 2025 },
  { make: "Kawasaki", model: "ZX-4R 15409STU", year: 2026 },
  // Kawasaki - ZX-4RR
  { make: "Kawasaki", model: "ZX-4RR", year: 2023 },
  { make: "Kawasaki", model: "ZX-4RR", year: 2024 },
  { make: "Kawasaki", model: "ZX-4RR", year: 2025 },
  { make: "Kawasaki", model: "ZX-4RR", year: 2026 },
  // Kawasaki - ZX-6R
  { make: "Kawasaki", model: "ZX-6R", year: 1995 },
  { make: "Kawasaki", model: "ZX-6R", year: 1996 },
  { make: "Kawasaki", model: "ZX-6R", year: 1997 },
  { make: "Kawasaki", model: "ZX-6R", year: 1998 },
  { make: "Kawasaki", model: "ZX-6R", year: 1999 },
  { make: "Kawasaki", model: "ZX-6R", year: 2000 },
  { make: "Kawasaki", model: "ZX-6R", year: 2001 },
  { make: "Kawasaki", model: "ZX-6R", year: 2002 },
  { make: "Kawasaki", model: "ZX-6R", year: 2003 },
  { make: "Kawasaki", model: "ZX-6R", year: 2004 },
  { make: "Kawasaki", model: "ZX-6R", year: 2005 },
  { make: "Kawasaki", model: "ZX-6R", year: 2006 },
  { make: "Kawasaki", model: "ZX-6R", year: 2007 },
  { make: "Kawasaki", model: "ZX-6R", year: 2008 },
  { make: "Kawasaki", model: "ZX-6R", year: 2009 },
  { make: "Kawasaki", model: "ZX-6R", year: 2010 },
  { make: "Kawasaki", model: "ZX-6R", year: 2011 },
  { make: "Kawasaki", model: "ZX-6R", year: 2012 },
  { make: "Kawasaki", model: "ZX-6R", year: 2013 },
  { make: "Kawasaki", model: "ZX-6R", year: 2014 },
  { make: "Kawasaki", model: "ZX-6R", year: 2015 },
  { make: "Kawasaki", model: "ZX-6R", year: 2016 },
  { make: "Kawasaki", model: "ZX-6R", year: 2017 },
  { make: "Kawasaki", model: "ZX-6R", year: 2018 },
  { make: "Kawasaki", model: "ZX-6R", year: 2019 },
  { make: "Kawasaki", model: "ZX-6R", year: 2020 },
  { make: "Kawasaki", model: "ZX-6R", year: 2021 },
  { make: "Kawasaki", model: "ZX-6R", year: 2022 },
  { make: "Kawasaki", model: "ZX-6R", year: 2023 },
  { make: "Kawasaki", model: "ZX-6R", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R", year: 2026 },
  { make: "Kawasaki", model: "ZX-6R", year: 2027 },
  // Kawasaki - ZX-6R 636
  { make: "Kawasaki", model: "ZX-6R 636", year: 2009 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2010 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2011 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2012 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2013 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2014 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2015 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2016 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2017 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2018 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2019 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2020 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2021 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2022 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2023 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 636", year: 2025 },
  // Kawasaki - ZX-6R 14307EU
  { make: "Kawasaki", model: "ZX-6R 14307EU", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 14307EU", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 14307EU", year: 2026 },
  // Kawasaki - ZX-6R 15413SBU
  { make: "Kawasaki", model: "ZX-6R 15413SBU", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 15413SBU", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 15413SBU", year: 2026 },
  // Kawasaki - ZX-6R 15413STU
  { make: "Kawasaki", model: "ZX-6R 15413STU", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 15413STU", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 15413STU", year: 2026 },
  // Kawasaki - ZX-6R 15625BU
  { make: "Kawasaki", model: "ZX-6R 15625BU", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 15625BU", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 15625BU", year: 2026 },
  // Kawasaki - ZX-6R 15625TU
  { make: "Kawasaki", model: "ZX-6R 15625TU", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 15625TU", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 15625TU", year: 2026 },
  // Kawasaki - ZX-6R 15625U
  { make: "Kawasaki", model: "ZX-6R 15625U", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R 15625U", year: 2025 },
  { make: "Kawasaki", model: "ZX-6R 15625U", year: 2026 },
  // Kawasaki - ZX-6R 80048
  { make: "Kawasaki", model: "ZX-6R 80048", year: 2024 },
  // Kawasaki - ZX-6R Vs 6
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2019 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2020 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2021 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2022 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2023 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2024 },
  { make: "Kawasaki", model: "ZX-6R Vs 6", year: 2025 },
  // Kawasaki - ZX-10R
  { make: "Kawasaki", model: "ZX-10R", year: 2004 },
  { make: "Kawasaki", model: "ZX-10R", year: 2005 },
  { make: "Kawasaki", model: "ZX-10R", year: 2006 },
  { make: "Kawasaki", model: "ZX-10R", year: 2007 },
  { make: "Kawasaki", model: "ZX-10R", year: 2008 },
  { make: "Kawasaki", model: "ZX-10R", year: 2009 },
  { make: "Kawasaki", model: "ZX-10R", year: 2010 },
  { make: "Kawasaki", model: "ZX-10R", year: 2011 },
  { make: "Kawasaki", model: "ZX-10R", year: 2012 },
  { make: "Kawasaki", model: "ZX-10R", year: 2013 },
  { make: "Kawasaki", model: "ZX-10R", year: 2014 },
  { make: "Kawasaki", model: "ZX-10R", year: 2015 },
  { make: "Kawasaki", model: "ZX-10R", year: 2016 },
  { make: "Kawasaki", model: "ZX-10R", year: 2017 },
  { make: "Kawasaki", model: "ZX-10R", year: 2018 },
  { make: "Kawasaki", model: "ZX-10R", year: 2019 },
  { make: "Kawasaki", model: "ZX-10R", year: 2020 },
  { make: "Kawasaki", model: "ZX-10R", year: 2021 },
  { make: "Kawasaki", model: "ZX-10R", year: 2022 },
  { make: "Kawasaki", model: "ZX-10R", year: 2023 },
  { make: "Kawasaki", model: "ZX-10R", year: 2024 },
  { make: "Kawasaki", model: "ZX-10R", year: 2025 },
  { make: "Kawasaki", model: "ZX-10R", year: 2026 },
  { make: "Kawasaki", model: "ZX-10R", year: 2027 },
  // Kawasaki - ZX-10RR
  { make: "Kawasaki", model: "ZX-10RR", year: 2017 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2018 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2019 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2020 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2021 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2022 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2023 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2024 },
  { make: "Kawasaki", model: "ZX-10RR", year: 2025 },
  // Kawasaki - ZX-14
  { make: "Kawasaki", model: "ZX-14", year: 2012 },
  { make: "Kawasaki", model: "ZX-14", year: 2013 },
  { make: "Kawasaki", model: "ZX-14", year: 2014 },
  { make: "Kawasaki", model: "ZX-14", year: 2015 },
  { make: "Kawasaki", model: "ZX-14", year: 2016 },
  { make: "Kawasaki", model: "ZX-14", year: 2017 },
  { make: "Kawasaki", model: "ZX-14", year: 2018 },
  { make: "Kawasaki", model: "ZX-14", year: 2019 },
  { make: "Kawasaki", model: "ZX-14", year: 2020 },
  // Kawasaki - ZX10R
  { make: "Kawasaki", model: "ZX10R", year: 2011 },
  { make: "Kawasaki", model: "ZX10R", year: 2012 },
  { make: "Kawasaki", model: "ZX10R", year: 2013 },
  { make: "Kawasaki", model: "ZX10R", year: 2014 },
  { make: "Kawasaki", model: "ZX10R", year: 2015 },
  { make: "Kawasaki", model: "ZX10R", year: 2016 },
  { make: "Kawasaki", model: "ZX10R", year: 2017 },
  { make: "Kawasaki", model: "ZX10R", year: 2018 },
  { make: "Kawasaki", model: "ZX10R", year: 2019 },
  { make: "Kawasaki", model: "ZX10R", year: 2020 },
  // Kawasaki - ZX10R Gloss
  { make: "Kawasaki", model: "ZX10R Gloss", year: 2011 },
  { make: "Kawasaki", model: "ZX10R Gloss", year: 2012 },
  { make: "Kawasaki", model: "ZX10R Gloss", year: 2013 },
  { make: "Kawasaki", model: "ZX10R Gloss", year: 2014 },
  { make: "Kawasaki", model: "ZX10R Gloss", year: 2015 },
  // Kawasaki - ZX10R Matt
  { make: "Kawasaki", model: "ZX10R Matt", year: 2011 },
  { make: "Kawasaki", model: "ZX10R Matt", year: 2012 },
  { make: "Kawasaki", model: "ZX10R Matt", year: 2013 },
  { make: "Kawasaki", model: "ZX10R Matt", year: 2014 },
  { make: "Kawasaki", model: "ZX10R Matt", year: 2015 },
  // Kawasaki - ZX10RR
  { make: "Kawasaki", model: "ZX10RR", year: 2021 },
  { make: "Kawasaki", model: "ZX10RR", year: 2022 },
  { make: "Kawasaki", model: "ZX10RR", year: 2023 },
  { make: "Kawasaki", model: "ZX10RR", year: 2024 },
  { make: "Kawasaki", model: "ZX10RR", year: 2025 },
  // Kawasaki - ZX14
  { make: "Kawasaki", model: "ZX14", year: 2006 },
  { make: "Kawasaki", model: "ZX14", year: 2007 },
  { make: "Kawasaki", model: "ZX14", year: 2008 },
  { make: "Kawasaki", model: "ZX14", year: 2009 },
  { make: "Kawasaki", model: "ZX14", year: 2010 },
  { make: "Kawasaki", model: "ZX14", year: 2011 },
  // Kawasaki - ZZR1400
  { make: "Kawasaki", model: "ZZR1400", year: 2012 },
  { make: "Kawasaki", model: "ZZR1400", year: 2013 },
  { make: "Kawasaki", model: "ZZR1400", year: 2014 },
  { make: "Kawasaki", model: "ZZR1400", year: 2015 },
  { make: "Kawasaki", model: "ZZR1400", year: 2016 },
  { make: "Kawasaki", model: "ZZR1400", year: 2017 },
  { make: "Kawasaki", model: "ZZR1400", year: 2018 },
  { make: "Kawasaki", model: "ZZR1400", year: 2019 },
  { make: "Kawasaki", model: "ZZR1400", year: 2020 },
  { make: "Kawasaki", model: "ZZR1400", year: 2021 },
  { make: "Kawasaki", model: "ZZR1400", year: 2022 },
  // Kove
  // Kove - 450 Rally
  { make: "Kove", model: "450 Rally", year: 2023 },
  { make: "Kove", model: "450 Rally", year: 2024 },
  // Kove - 450 Rally High
  { make: "Kove", model: "450 Rally High", year: 2023 },
  { make: "Kove", model: "450 Rally High", year: 2024 },
  // Kove - 450 Rally Low
  { make: "Kove", model: "450 Rally Low", year: 2023 },
  { make: "Kove", model: "450 Rally Low", year: 2024 },
  // Kove - 450 Rally Low/High
  { make: "Kove", model: "450 Rally Low/High", year: 2023 },
  { make: "Kove", model: "450 Rally Low/High", year: 2024 },
  // KTM
  // KTM - 50 SX
  { make: "KTM", model: "50 SX", year: 1998 },
  { make: "KTM", model: "50 SX", year: 1999 },
  { make: "KTM", model: "50 SX", year: 2000 },
  { make: "KTM", model: "50 SX", year: 2001 },
  { make: "KTM", model: "50 SX", year: 2002 },
  { make: "KTM", model: "50 SX", year: 2003 },
  { make: "KTM", model: "50 SX", year: 2004 },
  { make: "KTM", model: "50 SX", year: 2005 },
  { make: "KTM", model: "50 SX", year: 2006 },
  { make: "KTM", model: "50 SX", year: 2007 },
  { make: "KTM", model: "50 SX", year: 2008 },
  { make: "KTM", model: "50 SX", year: 2009 },
  { make: "KTM", model: "50 SX", year: 2010 },
  { make: "KTM", model: "50 SX", year: 2011 },
  { make: "KTM", model: "50 SX", year: 2012 },
  { make: "KTM", model: "50 SX", year: 2013 },
  { make: "KTM", model: "50 SX", year: 2014 },
  { make: "KTM", model: "50 SX", year: 2015 },
  { make: "KTM", model: "50 SX", year: 2016 },
  { make: "KTM", model: "50 SX", year: 2017 },
  { make: "KTM", model: "50 SX", year: 2018 },
  { make: "KTM", model: "50 SX", year: 2019 },
  { make: "KTM", model: "50 SX", year: 2020 },
  { make: "KTM", model: "50 SX", year: 2021 },
  { make: "KTM", model: "50 SX", year: 2022 },
  { make: "KTM", model: "50 SX", year: 2023 },
  { make: "KTM", model: "50 SX", year: 2024 },
  { make: "KTM", model: "50 SX", year: 2025 },
  { make: "KTM", model: "50 SX", year: 2026 },
  // KTM - 65 SX
  { make: "KTM", model: "65 SX", year: 1998 },
  { make: "KTM", model: "65 SX", year: 1999 },
  { make: "KTM", model: "65 SX", year: 2000 },
  { make: "KTM", model: "65 SX", year: 2001 },
  { make: "KTM", model: "65 SX", year: 2002 },
  { make: "KTM", model: "65 SX", year: 2003 },
  { make: "KTM", model: "65 SX", year: 2004 },
  { make: "KTM", model: "65 SX", year: 2005 },
  { make: "KTM", model: "65 SX", year: 2006 },
  { make: "KTM", model: "65 SX", year: 2007 },
  { make: "KTM", model: "65 SX", year: 2008 },
  { make: "KTM", model: "65 SX", year: 2009 },
  { make: "KTM", model: "65 SX", year: 2010 },
  { make: "KTM", model: "65 SX", year: 2011 },
  { make: "KTM", model: "65 SX", year: 2012 },
  { make: "KTM", model: "65 SX", year: 2013 },
  { make: "KTM", model: "65 SX", year: 2014 },
  { make: "KTM", model: "65 SX", year: 2015 },
  { make: "KTM", model: "65 SX", year: 2016 },
  { make: "KTM", model: "65 SX", year: 2017 },
  { make: "KTM", model: "65 SX", year: 2018 },
  { make: "KTM", model: "65 SX", year: 2019 },
  { make: "KTM", model: "65 SX", year: 2020 },
  { make: "KTM", model: "65 SX", year: 2021 },
  { make: "KTM", model: "65 SX", year: 2022 },
  { make: "KTM", model: "65 SX", year: 2023 },
  { make: "KTM", model: "65 SX", year: 2024 },
  { make: "KTM", model: "65 SX", year: 2025 },
  { make: "KTM", model: "65 SX", year: 2026 },
  // KTM - 65 XC
  { make: "KTM", model: "65 XC", year: 2009 },
  // KTM - 65SX
  { make: "KTM", model: "65SX", year: 2009 },
  { make: "KTM", model: "65SX", year: 2010 },
  { make: "KTM", model: "65SX", year: 2011 },
  { make: "KTM", model: "65SX", year: 2012 },
  { make: "KTM", model: "65SX", year: 2013 },
  { make: "KTM", model: "65SX", year: 2014 },
  { make: "KTM", model: "65SX", year: 2015 },
  { make: "KTM", model: "65SX", year: 2016 },
  { make: "KTM", model: "65SX", year: 2017 },
  { make: "KTM", model: "65SX", year: 2018 },
  { make: "KTM", model: "65SX", year: 2019 },
  { make: "KTM", model: "65SX", year: 2020 },
  { make: "KTM", model: "65SX", year: 2021 },
  { make: "KTM", model: "65SX", year: 2022 },
  { make: "KTM", model: "65SX", year: 2023 },
  // KTM - 85 SX
  { make: "KTM", model: "85 SX", year: 2003 },
  { make: "KTM", model: "85 SX", year: 2004 },
  { make: "KTM", model: "85 SX", year: 2005 },
  { make: "KTM", model: "85 SX", year: 2006 },
  { make: "KTM", model: "85 SX", year: 2007 },
  { make: "KTM", model: "85 SX", year: 2008 },
  { make: "KTM", model: "85 SX", year: 2009 },
  { make: "KTM", model: "85 SX", year: 2010 },
  { make: "KTM", model: "85 SX", year: 2011 },
  { make: "KTM", model: "85 SX", year: 2012 },
  { make: "KTM", model: "85 SX", year: 2013 },
  { make: "KTM", model: "85 SX", year: 2014 },
  { make: "KTM", model: "85 SX", year: 2015 },
  { make: "KTM", model: "85 SX", year: 2016 },
  { make: "KTM", model: "85 SX", year: 2017 },
  { make: "KTM", model: "85 SX", year: 2018 },
  { make: "KTM", model: "85 SX", year: 2019 },
  { make: "KTM", model: "85 SX", year: 2020 },
  { make: "KTM", model: "85 SX", year: 2021 },
  { make: "KTM", model: "85 SX", year: 2022 },
  { make: "KTM", model: "85 SX", year: 2023 },
  { make: "KTM", model: "85 SX", year: 2024 },
  { make: "KTM", model: "85 SX", year: 2025 },
  { make: "KTM", model: "85 SX", year: 2026 },
  // KTM - 85 XC
  { make: "KTM", model: "85 XC", year: 2008 },
  { make: "KTM", model: "85 XC", year: 2009 },
  // KTM - 85XC
  { make: "KTM", model: "85XC", year: 2008 },
  { make: "KTM", model: "85XC", year: 2009 },
  // KTM - 105 SX
  { make: "KTM", model: "105 SX", year: 2007 },
  { make: "KTM", model: "105 SX", year: 2008 },
  { make: "KTM", model: "105 SX", year: 2009 },
  { make: "KTM", model: "105 SX", year: 2010 },
  { make: "KTM", model: "105 SX", year: 2011 },
  // KTM - 105 XC
  { make: "KTM", model: "105 XC", year: 2008 },
  { make: "KTM", model: "105 XC", year: 2009 },
  { make: "KTM", model: "105 XC", year: 2010 },
  // KTM - 105SX
  { make: "KTM", model: "105SX", year: 2007 },
  { make: "KTM", model: "105SX", year: 2008 },
  { make: "KTM", model: "105SX", year: 2009 },
  { make: "KTM", model: "105SX", year: 2010 },
  { make: "KTM", model: "105SX", year: 2011 },
  { make: "KTM", model: "105SX", year: 2012 },
  { make: "KTM", model: "105SX", year: 2018 },
  { make: "KTM", model: "105SX", year: 2019 },
  { make: "KTM", model: "105SX", year: 2020 },
  { make: "KTM", model: "105SX", year: 2021 },
  { make: "KTM", model: "105SX", year: 2022 },
  { make: "KTM", model: "105SX", year: 2023 },
  { make: "KTM", model: "105SX", year: 2024 },
  // KTM - 105XC
  { make: "KTM", model: "105XC", year: 2008 },
  { make: "KTM", model: "105XC", year: 2009 },
  { make: "KTM", model: "105XC", year: 2010 },
  { make: "KTM", model: "105XC", year: 2011 },
  { make: "KTM", model: "105XC", year: 2012 },
  // KTM - 125 Duke 11KW Euro 4
  { make: "KTM", model: "125 Duke 11KW Euro 4", year: 2018 },
  // KTM - 125 Enduro
  { make: "KTM", model: "125 Enduro", year: 2025 },
  { make: "KTM", model: "125 Enduro", year: 2026 },
  // KTM - 125 SX
  { make: "KTM", model: "125 SX", year: 1998 },
  { make: "KTM", model: "125 SX", year: 1999 },
  { make: "KTM", model: "125 SX", year: 2000 },
  { make: "KTM", model: "125 SX", year: 2001 },
  { make: "KTM", model: "125 SX", year: 2002 },
  { make: "KTM", model: "125 SX", year: 2003 },
  { make: "KTM", model: "125 SX", year: 2004 },
  { make: "KTM", model: "125 SX", year: 2005 },
  { make: "KTM", model: "125 SX", year: 2006 },
  { make: "KTM", model: "125 SX", year: 2007 },
  { make: "KTM", model: "125 SX", year: 2008 },
  { make: "KTM", model: "125 SX", year: 2009 },
  { make: "KTM", model: "125 SX", year: 2010 },
  { make: "KTM", model: "125 SX", year: 2011 },
  { make: "KTM", model: "125 SX", year: 2012 },
  { make: "KTM", model: "125 SX", year: 2013 },
  { make: "KTM", model: "125 SX", year: 2014 },
  { make: "KTM", model: "125 SX", year: 2015 },
  { make: "KTM", model: "125 SX", year: 2016 },
  { make: "KTM", model: "125 SX", year: 2017 },
  { make: "KTM", model: "125 SX", year: 2018 },
  { make: "KTM", model: "125 SX", year: 2019 },
  { make: "KTM", model: "125 SX", year: 2020 },
  { make: "KTM", model: "125 SX", year: 2021 },
  { make: "KTM", model: "125 SX", year: 2022 },
  { make: "KTM", model: "125 SX", year: 2023 },
  { make: "KTM", model: "125 SX", year: 2024 },
  { make: "KTM", model: "125 SX", year: 2025 },
  { make: "KTM", model: "125 SX", year: 2026 },
  // KTM - 125 XC
  { make: "KTM", model: "125 XC", year: 2021 },
  { make: "KTM", model: "125 XC", year: 2022 },
  { make: "KTM", model: "125 XC", year: 2023 },
  { make: "KTM", model: "125 XC", year: 2024 },
  { make: "KTM", model: "125 XC", year: 2025 },
  { make: "KTM", model: "125 XC", year: 2026 },
  // KTM - 125 XC-W
  { make: "KTM", model: "125 XC-W", year: 2019 },
  // KTM - 125SX
  { make: "KTM", model: "125SX", year: 1998 },
  { make: "KTM", model: "125SX", year: 1999 },
  { make: "KTM", model: "125SX", year: 2000 },
  { make: "KTM", model: "125SX", year: 2001 },
  { make: "KTM", model: "125SX", year: 2002 },
  { make: "KTM", model: "125SX", year: 2003 },
  { make: "KTM", model: "125SX", year: 2004 },
  { make: "KTM", model: "125SX", year: 2005 },
  { make: "KTM", model: "125SX", year: 2006 },
  { make: "KTM", model: "125SX", year: 2007 },
  { make: "KTM", model: "125SX", year: 2008 },
  { make: "KTM", model: "125SX", year: 2009 },
  { make: "KTM", model: "125SX", year: 2010 },
  { make: "KTM", model: "125SX", year: 2012 },
  { make: "KTM", model: "125SX", year: 2013 },
  { make: "KTM", model: "125SX", year: 2014 },
  { make: "KTM", model: "125SX", year: 2015 },
  { make: "KTM", model: "125SX", year: 2016 },
  { make: "KTM", model: "125SX", year: 2017 },
  { make: "KTM", model: "125SX", year: 2018 },
  { make: "KTM", model: "125SX", year: 2019 },
  { make: "KTM", model: "125SX", year: 2020 },
  { make: "KTM", model: "125SX", year: 2021 },
  { make: "KTM", model: "125SX", year: 2022 },
  // KTM - 125XC
  { make: "KTM", model: "125XC", year: 2022 },
  // KTM - 144 SX
  { make: "KTM", model: "144 SX", year: 2007 },
  { make: "KTM", model: "144 SX", year: 2008 },
  // KTM - 144SX
  { make: "KTM", model: "144SX", year: 2007 },
  { make: "KTM", model: "144SX", year: 2008 },
  // KTM - 150 SX
  { make: "KTM", model: "150 SX", year: 2008 },
  { make: "KTM", model: "150 SX", year: 2009 },
  { make: "KTM", model: "150 SX", year: 2010 },
  { make: "KTM", model: "150 SX", year: 2011 },
  { make: "KTM", model: "150 SX", year: 2012 },
  { make: "KTM", model: "150 SX", year: 2013 },
  { make: "KTM", model: "150 SX", year: 2014 },
  { make: "KTM", model: "150 SX", year: 2015 },
  { make: "KTM", model: "150 SX", year: 2016 },
  { make: "KTM", model: "150 SX", year: 2017 },
  { make: "KTM", model: "150 SX", year: 2018 },
  { make: "KTM", model: "150 SX", year: 2019 },
  { make: "KTM", model: "150 SX", year: 2020 },
  { make: "KTM", model: "150 SX", year: 2021 },
  { make: "KTM", model: "150 SX", year: 2022 },
  { make: "KTM", model: "150 SX", year: 2023 },
  { make: "KTM", model: "150 SX", year: 2024 },
  { make: "KTM", model: "150 SX", year: 2025 },
  { make: "KTM", model: "150 SX", year: 2026 },
  // KTM - 150 XC
  { make: "KTM", model: "150 XC", year: 2011 },
  { make: "KTM", model: "150 XC", year: 2012 },
  { make: "KTM", model: "150 XC", year: 2013 },
  { make: "KTM", model: "150 XC", year: 2014 },
  // KTM - 150 XC-W
  { make: "KTM", model: "150 XC-W", year: 2017 },
  { make: "KTM", model: "150 XC-W", year: 2018 },
  { make: "KTM", model: "150 XC-W", year: 2019 },
  { make: "KTM", model: "150 XC-W", year: 2020 },
  { make: "KTM", model: "150 XC-W", year: 2021 },
  { make: "KTM", model: "150 XC-W", year: 2022 },
  { make: "KTM", model: "150 XC-W", year: 2023 },
  { make: "KTM", model: "150 XC-W", year: 2024 },
  { make: "KTM", model: "150 XC-W", year: 2025 },
  { make: "KTM", model: "150 XC-W", year: 2026 },
  // KTM - 150 XC-W TPI
  { make: "KTM", model: "150 XC-W TPI", year: 2020 },
  { make: "KTM", model: "150 XC-W TPI", year: 2021 },
  // KTM - 150SX
  { make: "KTM", model: "150SX", year: 2009 },
  { make: "KTM", model: "150SX", year: 2010 },
  { make: "KTM", model: "150SX", year: 2011 },
  { make: "KTM", model: "150SX", year: 2012 },
  { make: "KTM", model: "150SX", year: 2013 },
  { make: "KTM", model: "150SX", year: 2014 },
  { make: "KTM", model: "150SX", year: 2015 },
  { make: "KTM", model: "150SX", year: 2016 },
  { make: "KTM", model: "150SX", year: 2017 },
  { make: "KTM", model: "150SX", year: 2018 },
  { make: "KTM", model: "150SX", year: 2019 },
  { make: "KTM", model: "150SX", year: 2020 },
  { make: "KTM", model: "150SX", year: 2021 },
  { make: "KTM", model: "150SX", year: 2022 },
  // KTM - 150XC
  { make: "KTM", model: "150XC", year: 2010 },
  { make: "KTM", model: "150XC", year: 2011 },
  { make: "KTM", model: "150XC", year: 2012 },
  { make: "KTM", model: "150XC", year: 2013 },
  { make: "KTM", model: "150XC", year: 2014 },
  { make: "KTM", model: "150XC", year: 2015 },
  // KTM - 200 EXC
  { make: "KTM", model: "200 EXC", year: 1998 },
  { make: "KTM", model: "200 EXC", year: 1999 },
  { make: "KTM", model: "200 EXC", year: 2000 },
  { make: "KTM", model: "200 EXC", year: 2001 },
  { make: "KTM", model: "200 EXC", year: 2002 },
  { make: "KTM", model: "200 EXC", year: 2003 },
  { make: "KTM", model: "200 EXC", year: 2004 },
  { make: "KTM", model: "200 EXC", year: 2005 },
  { make: "KTM", model: "200 EXC", year: 2006 },
  { make: "KTM", model: "200 EXC", year: 2007 },
  { make: "KTM", model: "200 EXC", year: 2008 },
  { make: "KTM", model: "200 EXC", year: 2009 },
  { make: "KTM", model: "200 EXC", year: 2010 },
  // KTM - 200 MXC
  { make: "KTM", model: "200 MXC", year: 1998 },
  { make: "KTM", model: "200 MXC", year: 1999 },
  { make: "KTM", model: "200 MXC", year: 2000 },
  { make: "KTM", model: "200 MXC", year: 2001 },
  { make: "KTM", model: "200 MXC", year: 2002 },
  { make: "KTM", model: "200 MXC", year: 2003 },
  { make: "KTM", model: "200 MXC", year: 2004 },
  { make: "KTM", model: "200 MXC", year: 2005 },
  // KTM - 200 SX
  { make: "KTM", model: "200 SX", year: 1998 },
  { make: "KTM", model: "200 SX", year: 1999 },
  { make: "KTM", model: "200 SX", year: 2000 },
  { make: "KTM", model: "200 SX", year: 2001 },
  { make: "KTM", model: "200 SX", year: 2002 },
  { make: "KTM", model: "200 SX", year: 2003 },
  { make: "KTM", model: "200 SX", year: 2004 },
  // KTM - 200 XC
  { make: "KTM", model: "200 XC", year: 2006 },
  { make: "KTM", model: "200 XC", year: 2007 },
  { make: "KTM", model: "200 XC", year: 2008 },
  { make: "KTM", model: "200 XC", year: 2009 },
  // KTM - 200 XC-W
  { make: "KTM", model: "200 XC-W", year: 2006 },
  { make: "KTM", model: "200 XC-W", year: 2007 },
  { make: "KTM", model: "200 XC-W", year: 2008 },
  { make: "KTM", model: "200 XC-W", year: 2009 },
  { make: "KTM", model: "200 XC-W", year: 2010 },
  { make: "KTM", model: "200 XC-W", year: 2011 },
  { make: "KTM", model: "200 XC-W", year: 2012 },
  { make: "KTM", model: "200 XC-W", year: 2013 },
  { make: "KTM", model: "200 XC-W", year: 2014 },
  { make: "KTM", model: "200 XC-W", year: 2015 },
  { make: "KTM", model: "200 XC-W", year: 2016 },
  // KTM - 200 Xcw
  { make: "KTM", model: "200 Xcw", year: 2006 },
  { make: "KTM", model: "200 Xcw", year: 2007 },
  { make: "KTM", model: "200 Xcw", year: 2008 },
  { make: "KTM", model: "200 Xcw", year: 2009 },
  { make: "KTM", model: "200 Xcw", year: 2010 },
  // KTM - 200SX
  { make: "KTM", model: "200SX", year: 2003 },
  { make: "KTM", model: "200SX", year: 2004 },
  // KTM - 250 Duke
  { make: "KTM", model: "250 Duke", year: 2015 },
  { make: "KTM", model: "250 Duke", year: 2016 },
  { make: "KTM", model: "250 Duke", year: 2017 },
  { make: "KTM", model: "250 Duke", year: 2018 },
  { make: "KTM", model: "250 Duke", year: 2019 },
  { make: "KTM", model: "250 Duke", year: 2020 },
  { make: "KTM", model: "250 Duke", year: 2021 },
  { make: "KTM", model: "250 Duke", year: 2022 },
  { make: "KTM", model: "250 Duke", year: 2023 },
  { make: "KTM", model: "250 Duke", year: 2024 },
  { make: "KTM", model: "250 Duke", year: 2025 },
  { make: "KTM", model: "250 Duke", year: 2026 },
  // KTM - 250 EXC
  { make: "KTM", model: "250 EXC", year: 1990 },
  { make: "KTM", model: "250 EXC", year: 1991 },
  { make: "KTM", model: "250 EXC", year: 1992 },
  { make: "KTM", model: "250 EXC", year: 1993 },
  { make: "KTM", model: "250 EXC", year: 1994 },
  { make: "KTM", model: "250 EXC", year: 1995 },
  { make: "KTM", model: "250 EXC", year: 1996 },
  { make: "KTM", model: "250 EXC", year: 1997 },
  { make: "KTM", model: "250 EXC", year: 1998 },
  { make: "KTM", model: "250 EXC", year: 1999 },
  { make: "KTM", model: "250 EXC", year: 2000 },
  { make: "KTM", model: "250 EXC", year: 2001 },
  { make: "KTM", model: "250 EXC", year: 2002 },
  { make: "KTM", model: "250 EXC", year: 2003 },
  { make: "KTM", model: "250 EXC", year: 2004 },
  { make: "KTM", model: "250 EXC", year: 2005 },
  { make: "KTM", model: "250 EXC", year: 2006 },
  { make: "KTM", model: "250 EXC", year: 2007 },
  { make: "KTM", model: "250 EXC", year: 2008 },
  { make: "KTM", model: "250 EXC", year: 2009 },
  { make: "KTM", model: "250 EXC", year: 2010 },
  // KTM - 250 EXC Tpi
  { make: "KTM", model: "250 EXC Tpi", year: 2018 },
  { make: "KTM", model: "250 EXC Tpi", year: 2019 },
  // KTM - 250 EXC-F
  { make: "KTM", model: "250 EXC-F", year: 2007 },
  { make: "KTM", model: "250 EXC-F", year: 2008 },
  { make: "KTM", model: "250 EXC-F", year: 2009 },
  { make: "KTM", model: "250 EXC-F", year: 2010 },
  { make: "KTM", model: "250 EXC-F", year: 2011 },
  { make: "KTM", model: "250 EXC-F", year: 2012 },
  { make: "KTM", model: "250 EXC-F", year: 2013 },
  { make: "KTM", model: "250 EXC-F", year: 2014 },
  { make: "KTM", model: "250 EXC-F", year: 2015 },
  { make: "KTM", model: "250 EXC-F", year: 2016 },
  { make: "KTM", model: "250 EXC-F", year: 2017 },
  { make: "KTM", model: "250 EXC-F", year: 2018 },
  { make: "KTM", model: "250 EXC-F", year: 2019 },
  { make: "KTM", model: "250 EXC-F", year: 2020 },
  { make: "KTM", model: "250 EXC-F", year: 2021 },
  { make: "KTM", model: "250 EXC-F", year: 2022 },
  { make: "KTM", model: "250 EXC-F", year: 2023 },
  { make: "KTM", model: "250 EXC-F", year: 2024 },
  { make: "KTM", model: "250 EXC-F", year: 2025 },
  { make: "KTM", model: "250 EXC-F", year: 2026 },
  // KTM - 250 MXC
  { make: "KTM", model: "250 MXC", year: 1994 },
  { make: "KTM", model: "250 MXC", year: 1995 },
  { make: "KTM", model: "250 MXC", year: 1996 },
  { make: "KTM", model: "250 MXC", year: 1997 },
  { make: "KTM", model: "250 MXC", year: 1998 },
  { make: "KTM", model: "250 MXC", year: 1999 },
  { make: "KTM", model: "250 MXC", year: 2000 },
  { make: "KTM", model: "250 MXC", year: 2001 },
  { make: "KTM", model: "250 MXC", year: 2002 },
  { make: "KTM", model: "250 MXC", year: 2003 },
  { make: "KTM", model: "250 MXC", year: 2004 },
  { make: "KTM", model: "250 MXC", year: 2005 },
  // KTM - 250 SX
  { make: "KTM", model: "250 SX", year: 1991 },
  { make: "KTM", model: "250 SX", year: 1992 },
  { make: "KTM", model: "250 SX", year: 1993 },
  { make: "KTM", model: "250 SX", year: 1994 },
  { make: "KTM", model: "250 SX", year: 1995 },
  { make: "KTM", model: "250 SX", year: 1996 },
  { make: "KTM", model: "250 SX", year: 1997 },
  { make: "KTM", model: "250 SX", year: 1998 },
  { make: "KTM", model: "250 SX", year: 1999 },
  { make: "KTM", model: "250 SX", year: 2000 },
  { make: "KTM", model: "250 SX", year: 2001 },
  { make: "KTM", model: "250 SX", year: 2002 },
  { make: "KTM", model: "250 SX", year: 2003 },
  { make: "KTM", model: "250 SX", year: 2004 },
  { make: "KTM", model: "250 SX", year: 2005 },
  { make: "KTM", model: "250 SX", year: 2006 },
  { make: "KTM", model: "250 SX", year: 2007 },
  { make: "KTM", model: "250 SX", year: 2008 },
  { make: "KTM", model: "250 SX", year: 2009 },
  { make: "KTM", model: "250 SX", year: 2010 },
  { make: "KTM", model: "250 SX", year: 2011 },
  { make: "KTM", model: "250 SX", year: 2012 },
  { make: "KTM", model: "250 SX", year: 2013 },
  { make: "KTM", model: "250 SX", year: 2014 },
  { make: "KTM", model: "250 SX", year: 2015 },
  { make: "KTM", model: "250 SX", year: 2016 },
  { make: "KTM", model: "250 SX", year: 2017 },
  { make: "KTM", model: "250 SX", year: 2018 },
  { make: "KTM", model: "250 SX", year: 2019 },
  { make: "KTM", model: "250 SX", year: 2020 },
  { make: "KTM", model: "250 SX", year: 2021 },
  { make: "KTM", model: "250 SX", year: 2022 },
  { make: "KTM", model: "250 SX", year: 2023 },
  { make: "KTM", model: "250 SX", year: 2024 },
  { make: "KTM", model: "250 SX", year: 2025 },
  { make: "KTM", model: "250 SX", year: 2026 },
  // KTM - 250 SX-F
  { make: "KTM", model: "250 SX-F", year: 2005 },
  { make: "KTM", model: "250 SX-F", year: 2006 },
  { make: "KTM", model: "250 SX-F", year: 2007 },
  { make: "KTM", model: "250 SX-F", year: 2008 },
  { make: "KTM", model: "250 SX-F", year: 2009 },
  { make: "KTM", model: "250 SX-F", year: 2010 },
  { make: "KTM", model: "250 SX-F", year: 2011 },
  { make: "KTM", model: "250 SX-F", year: 2012 },
  { make: "KTM", model: "250 SX-F", year: 2013 },
  { make: "KTM", model: "250 SX-F", year: 2014 },
  { make: "KTM", model: "250 SX-F", year: 2015 },
  { make: "KTM", model: "250 SX-F", year: 2016 },
  { make: "KTM", model: "250 SX-F", year: 2017 },
  { make: "KTM", model: "250 SX-F", year: 2018 },
  { make: "KTM", model: "250 SX-F", year: 2019 },
  { make: "KTM", model: "250 SX-F", year: 2020 },
  { make: "KTM", model: "250 SX-F", year: 2021 },
  { make: "KTM", model: "250 SX-F", year: 2022 },
  { make: "KTM", model: "250 SX-F", year: 2023 },
  { make: "KTM", model: "250 SX-F", year: 2024 },
  { make: "KTM", model: "250 SX-F", year: 2025 },
  { make: "KTM", model: "250 SX-F", year: 2026 },
  // KTM - 250 SX-F Factory Edition
  { make: "KTM", model: "250 SX-F Factory Edition", year: 2015 },
  { make: "KTM", model: "250 SX-F Factory Edition", year: 2016 },
  { make: "KTM", model: "250 SX-F Factory Edition", year: 2017 },
  // KTM - 250 XC
  { make: "KTM", model: "250 XC", year: 2006 },
  { make: "KTM", model: "250 XC", year: 2007 },
  { make: "KTM", model: "250 XC", year: 2008 },
  { make: "KTM", model: "250 XC", year: 2009 },
  { make: "KTM", model: "250 XC", year: 2010 },
  { make: "KTM", model: "250 XC", year: 2011 },
  { make: "KTM", model: "250 XC", year: 2012 },
  { make: "KTM", model: "250 XC", year: 2013 },
  { make: "KTM", model: "250 XC", year: 2014 },
  { make: "KTM", model: "250 XC", year: 2015 },
  { make: "KTM", model: "250 XC", year: 2016 },
  { make: "KTM", model: "250 XC", year: 2017 },
  { make: "KTM", model: "250 XC", year: 2018 },
  { make: "KTM", model: "250 XC", year: 2019 },
  { make: "KTM", model: "250 XC", year: 2020 },
  { make: "KTM", model: "250 XC", year: 2021 },
  { make: "KTM", model: "250 XC", year: 2022 },
  { make: "KTM", model: "250 XC", year: 2023 },
  { make: "KTM", model: "250 XC", year: 2024 },
  { make: "KTM", model: "250 XC", year: 2025 },
  { make: "KTM", model: "250 XC", year: 2026 },
  // KTM - 250 XC TPI
  { make: "KTM", model: "250 XC TPI", year: 2020 },
  { make: "KTM", model: "250 XC TPI", year: 2021 },
  { make: "KTM", model: "250 XC TPI", year: 2022 },
  // KTM - 250 XC W E
  { make: "KTM", model: "250 XC W E", year: 2008 },
  { make: "KTM", model: "250 XC W E", year: 2009 },
  // KTM - 250 XC-F
  { make: "KTM", model: "250 XC-F", year: 2007 },
  { make: "KTM", model: "250 XC-F", year: 2008 },
  { make: "KTM", model: "250 XC-F", year: 2009 },
  { make: "KTM", model: "250 XC-F", year: 2010 },
  { make: "KTM", model: "250 XC-F", year: 2011 },
  { make: "KTM", model: "250 XC-F", year: 2012 },
  { make: "KTM", model: "250 XC-F", year: 2013 },
  { make: "KTM", model: "250 XC-F", year: 2014 },
  { make: "KTM", model: "250 XC-F", year: 2015 },
  { make: "KTM", model: "250 XC-F", year: 2016 },
  { make: "KTM", model: "250 XC-F", year: 2017 },
  { make: "KTM", model: "250 XC-F", year: 2018 },
  { make: "KTM", model: "250 XC-F", year: 2019 },
  { make: "KTM", model: "250 XC-F", year: 2020 },
  { make: "KTM", model: "250 XC-F", year: 2021 },
  { make: "KTM", model: "250 XC-F", year: 2022 },
  { make: "KTM", model: "250 XC-F", year: 2023 },
  { make: "KTM", model: "250 XC-F", year: 2024 },
  { make: "KTM", model: "250 XC-F", year: 2025 },
  { make: "KTM", model: "250 XC-F", year: 2026 },
  // KTM - 250 XC-W
  { make: "KTM", model: "250 XC-W", year: 2006 },
  { make: "KTM", model: "250 XC-W", year: 2007 },
  { make: "KTM", model: "250 XC-W", year: 2008 },
  { make: "KTM", model: "250 XC-W", year: 2009 },
  { make: "KTM", model: "250 XC-W", year: 2010 },
  { make: "KTM", model: "250 XC-W", year: 2011 },
  { make: "KTM", model: "250 XC-W", year: 2012 },
  { make: "KTM", model: "250 XC-W", year: 2013 },
  { make: "KTM", model: "250 XC-W", year: 2014 },
  { make: "KTM", model: "250 XC-W", year: 2015 },
  { make: "KTM", model: "250 XC-W", year: 2016 },
  { make: "KTM", model: "250 XC-W", year: 2017 },
  { make: "KTM", model: "250 XC-W", year: 2018 },
  { make: "KTM", model: "250 XC-W", year: 2019 },
  { make: "KTM", model: "250 XC-W", year: 2020 },
  { make: "KTM", model: "250 XC-W", year: 2021 },
  { make: "KTM", model: "250 XC-W", year: 2022 },
  { make: "KTM", model: "250 XC-W", year: 2023 },
  { make: "KTM", model: "250 XC-W", year: 2024 },
  { make: "KTM", model: "250 XC-W", year: 2025 },
  { make: "KTM", model: "250 XC-W", year: 2026 },
  // KTM - 250 XC-W TPI
  { make: "KTM", model: "250 XC-W TPI", year: 2018 },
  { make: "KTM", model: "250 XC-W TPI", year: 2019 },
  { make: "KTM", model: "250 XC-W TPI", year: 2020 },
  { make: "KTM", model: "250 XC-W TPI", year: 2021 },
  { make: "KTM", model: "250 XC-W TPI", year: 2022 },
  // KTM - 250 XCF-W
  { make: "KTM", model: "250 XCF-W", year: 2007 },
  { make: "KTM", model: "250 XCF-W", year: 2008 },
  { make: "KTM", model: "250 XCF-W", year: 2009 },
  { make: "KTM", model: "250 XCF-W", year: 2010 },
  { make: "KTM", model: "250 XCF-W", year: 2011 },
  { make: "KTM", model: "250 XCF-W", year: 2012 },
  { make: "KTM", model: "250 XCF-W", year: 2013 },
  { make: "KTM", model: "250 XCF-W", year: 2014 },
  { make: "KTM", model: "250 XCF-W", year: 2015 },
  { make: "KTM", model: "250 XCF-W", year: 2016 },
  // KTM - 300 EXC
  { make: "KTM", model: "300 EXC", year: 1990 },
  { make: "KTM", model: "300 EXC", year: 1991 },
  { make: "KTM", model: "300 EXC", year: 1992 },
  { make: "KTM", model: "300 EXC", year: 1993 },
  { make: "KTM", model: "300 EXC", year: 1994 },
  { make: "KTM", model: "300 EXC", year: 1995 },
  { make: "KTM", model: "300 EXC", year: 1996 },
  { make: "KTM", model: "300 EXC", year: 1997 },
  { make: "KTM", model: "300 EXC", year: 1998 },
  { make: "KTM", model: "300 EXC", year: 1999 },
  { make: "KTM", model: "300 EXC", year: 2000 },
  { make: "KTM", model: "300 EXC", year: 2001 },
  { make: "KTM", model: "300 EXC", year: 2002 },
  { make: "KTM", model: "300 EXC", year: 2003 },
  { make: "KTM", model: "300 EXC", year: 2004 },
  { make: "KTM", model: "300 EXC", year: 2005 },
  { make: "KTM", model: "300 EXC", year: 2006 },
  { make: "KTM", model: "300 EXC", year: 2007 },
  { make: "KTM", model: "300 EXC", year: 2009 },
  { make: "KTM", model: "300 EXC", year: 2010 },
  // KTM - 300 EXC Tpi
  { make: "KTM", model: "300 EXC Tpi", year: 2018 },
  { make: "KTM", model: "300 EXC Tpi", year: 2019 },
  // KTM - 300 EXC Tpi Erzbergrodeo
  { make: "KTM", model: "300 EXC Tpi Erzbergrodeo", year: 2020 },
  { make: "KTM", model: "300 EXC Tpi Erzbergrodeo", year: 2021 },
  // KTM - 300 MXC
  { make: "KTM", model: "300 MXC", year: 1990 },
  { make: "KTM", model: "300 MXC", year: 1991 },
  { make: "KTM", model: "300 MXC", year: 1992 },
  { make: "KTM", model: "300 MXC", year: 1993 },
  { make: "KTM", model: "300 MXC", year: 1994 },
  { make: "KTM", model: "300 MXC", year: 1995 },
  { make: "KTM", model: "300 MXC", year: 1996 },
  { make: "KTM", model: "300 MXC", year: 1997 },
  { make: "KTM", model: "300 MXC", year: 1998 },
  { make: "KTM", model: "300 MXC", year: 1999 },
  { make: "KTM", model: "300 MXC", year: 2000 },
  { make: "KTM", model: "300 MXC", year: 2001 },
  { make: "KTM", model: "300 MXC", year: 2002 },
  { make: "KTM", model: "300 MXC", year: 2003 },
  { make: "KTM", model: "300 MXC", year: 2004 },
  { make: "KTM", model: "300 MXC", year: 2005 },
  // KTM - 300 SX
  { make: "KTM", model: "300 SX", year: 1992 },
  { make: "KTM", model: "300 SX", year: 1993 },
  { make: "KTM", model: "300 SX", year: 1994 },
  { make: "KTM", model: "300 SX", year: 1995 },
  { make: "KTM", model: "300 SX", year: 1996 },
  { make: "KTM", model: "300 SX", year: 2023 },
  { make: "KTM", model: "300 SX", year: 2024 },
  { make: "KTM", model: "300 SX", year: 2025 },
  { make: "KTM", model: "300 SX", year: 2026 },
  // KTM - 300 XC
  { make: "KTM", model: "300 XC", year: 2006 },
  { make: "KTM", model: "300 XC", year: 2007 },
  { make: "KTM", model: "300 XC", year: 2008 },
  { make: "KTM", model: "300 XC", year: 2009 },
  { make: "KTM", model: "300 XC", year: 2010 },
  { make: "KTM", model: "300 XC", year: 2011 },
  { make: "KTM", model: "300 XC", year: 2012 },
  { make: "KTM", model: "300 XC", year: 2013 },
  { make: "KTM", model: "300 XC", year: 2014 },
  { make: "KTM", model: "300 XC", year: 2015 },
  { make: "KTM", model: "300 XC", year: 2016 },
  { make: "KTM", model: "300 XC", year: 2017 },
  { make: "KTM", model: "300 XC", year: 2018 },
  { make: "KTM", model: "300 XC", year: 2019 },
  { make: "KTM", model: "300 XC", year: 2020 },
  { make: "KTM", model: "300 XC", year: 2021 },
  { make: "KTM", model: "300 XC", year: 2022 },
  { make: "KTM", model: "300 XC", year: 2023 },
  { make: "KTM", model: "300 XC", year: 2024 },
  { make: "KTM", model: "300 XC", year: 2025 },
  { make: "KTM", model: "300 XC", year: 2026 },
  // KTM - 300 XC TPI
  { make: "KTM", model: "300 XC TPI", year: 2020 },
  { make: "KTM", model: "300 XC TPI", year: 2021 },
  { make: "KTM", model: "300 XC TPI", year: 2022 },
  // KTM - 300 XC W E
  { make: "KTM", model: "300 XC W E", year: 2008 },
  { make: "KTM", model: "300 XC W E", year: 2009 },
  // KTM - 300 XC-W
  { make: "KTM", model: "300 XC-W", year: 2006 },
  { make: "KTM", model: "300 XC-W", year: 2007 },
  { make: "KTM", model: "300 XC-W", year: 2008 },
  { make: "KTM", model: "300 XC-W", year: 2009 },
  { make: "KTM", model: "300 XC-W", year: 2010 },
  { make: "KTM", model: "300 XC-W", year: 2011 },
  { make: "KTM", model: "300 XC-W", year: 2012 },
  { make: "KTM", model: "300 XC-W", year: 2013 },
  { make: "KTM", model: "300 XC-W", year: 2014 },
  { make: "KTM", model: "300 XC-W", year: 2015 },
  { make: "KTM", model: "300 XC-W", year: 2016 },
  { make: "KTM", model: "300 XC-W", year: 2017 },
  { make: "KTM", model: "300 XC-W", year: 2018 },
  { make: "KTM", model: "300 XC-W", year: 2019 },
  { make: "KTM", model: "300 XC-W", year: 2020 },
  { make: "KTM", model: "300 XC-W", year: 2021 },
  { make: "KTM", model: "300 XC-W", year: 2022 },
  { make: "KTM", model: "300 XC-W", year: 2023 },
  { make: "KTM", model: "300 XC-W", year: 2024 },
  { make: "KTM", model: "300 XC-W", year: 2025 },
  { make: "KTM", model: "300 XC-W", year: 2026 },
  // KTM - 300 XC-W Six Days
  { make: "KTM", model: "300 XC-W Six Days", year: 2017 },
  { make: "KTM", model: "300 XC-W Six Days", year: 2018 },
  // KTM - 300 XC-W TPI
  { make: "KTM", model: "300 XC-W TPI", year: 2019 },
  { make: "KTM", model: "300 XC-W TPI", year: 2020 },
  { make: "KTM", model: "300 XC-W TPI", year: 2021 },
  { make: "KTM", model: "300 XC-W TPI", year: 2022 },
  // KTM - 350 EXC-F
  { make: "KTM", model: "350 EXC-F", year: 2012 },
  { make: "KTM", model: "350 EXC-F", year: 2013 },
  { make: "KTM", model: "350 EXC-F", year: 2014 },
  { make: "KTM", model: "350 EXC-F", year: 2015 },
  { make: "KTM", model: "350 EXC-F", year: 2016 },
  { make: "KTM", model: "350 EXC-F", year: 2017 },
  { make: "KTM", model: "350 EXC-F", year: 2018 },
  { make: "KTM", model: "350 EXC-F", year: 2019 },
  { make: "KTM", model: "350 EXC-F", year: 2020 },
  { make: "KTM", model: "350 EXC-F", year: 2021 },
  { make: "KTM", model: "350 EXC-F", year: 2022 },
  { make: "KTM", model: "350 EXC-F", year: 2023 },
  { make: "KTM", model: "350 EXC-F", year: 2024 },
  { make: "KTM", model: "350 EXC-F", year: 2025 },
  { make: "KTM", model: "350 EXC-F", year: 2026 },
  // KTM - 350 SX-F
  { make: "KTM", model: "350 SX-F", year: 2011 },
  { make: "KTM", model: "350 SX-F", year: 2012 },
  { make: "KTM", model: "350 SX-F", year: 2013 },
  { make: "KTM", model: "350 SX-F", year: 2014 },
  { make: "KTM", model: "350 SX-F", year: 2015 },
  { make: "KTM", model: "350 SX-F", year: 2016 },
  { make: "KTM", model: "350 SX-F", year: 2017 },
  { make: "KTM", model: "350 SX-F", year: 2018 },
  { make: "KTM", model: "350 SX-F", year: 2019 },
  { make: "KTM", model: "350 SX-F", year: 2020 },
  { make: "KTM", model: "350 SX-F", year: 2021 },
  { make: "KTM", model: "350 SX-F", year: 2022 },
  { make: "KTM", model: "350 SX-F", year: 2023 },
  { make: "KTM", model: "350 SX-F", year: 2024 },
  { make: "KTM", model: "350 SX-F", year: 2025 },
  { make: "KTM", model: "350 SX-F", year: 2026 },
  // KTM - 350 XC F Kailub Russell
  { make: "KTM", model: "350 XC F Kailub Russell", year: 2021 },
  // KTM - 350 XC-F
  { make: "KTM", model: "350 XC-F", year: 2011 },
  { make: "KTM", model: "350 XC-F", year: 2012 },
  { make: "KTM", model: "350 XC-F", year: 2013 },
  { make: "KTM", model: "350 XC-F", year: 2014 },
  { make: "KTM", model: "350 XC-F", year: 2015 },
  { make: "KTM", model: "350 XC-F", year: 2016 },
  { make: "KTM", model: "350 XC-F", year: 2017 },
  { make: "KTM", model: "350 XC-F", year: 2018 },
  { make: "KTM", model: "350 XC-F", year: 2019 },
  { make: "KTM", model: "350 XC-F", year: 2020 },
  { make: "KTM", model: "350 XC-F", year: 2021 },
  { make: "KTM", model: "350 XC-F", year: 2022 },
  { make: "KTM", model: "350 XC-F", year: 2023 },
  { make: "KTM", model: "350 XC-F", year: 2024 },
  { make: "KTM", model: "350 XC-F", year: 2025 },
  { make: "KTM", model: "350 XC-F", year: 2026 },
  // KTM - 350 XCF-W
  { make: "KTM", model: "350 XCF-W", year: 2012 },
  { make: "KTM", model: "350 XCF-W", year: 2013 },
  { make: "KTM", model: "350 XCF-W", year: 2014 },
  { make: "KTM", model: "350 XCF-W", year: 2015 },
  { make: "KTM", model: "350 XCF-W", year: 2016 },
  { make: "KTM", model: "350 XCF-W", year: 2020 },
  { make: "KTM", model: "350 XCF-W", year: 2021 },
  { make: "KTM", model: "350 XCF-W", year: 2022 },
  // KTM - 380 EXC
  { make: "KTM", model: "380 EXC", year: 1998 },
  { make: "KTM", model: "380 EXC", year: 1999 },
  { make: "KTM", model: "380 EXC", year: 2000 },
  { make: "KTM", model: "380 EXC", year: 2001 },
  { make: "KTM", model: "380 EXC", year: 2002 },
  // KTM - 380 Mxc
  { make: "KTM", model: "380 Mxc", year: 1998 },
  { make: "KTM", model: "380 Mxc", year: 1999 },
  { make: "KTM", model: "380 Mxc", year: 2000 },
  { make: "KTM", model: "380 Mxc", year: 2001 },
  { make: "KTM", model: "380 Mxc", year: 2002 },
  // KTM - 380 SX
  { make: "KTM", model: "380 SX", year: 1998 },
  { make: "KTM", model: "380 SX", year: 1999 },
  { make: "KTM", model: "380 SX", year: 2000 },
  { make: "KTM", model: "380 SX", year: 2001 },
  { make: "KTM", model: "380 SX", year: 2002 },
  // KTM - 390
  { make: "KTM", model: "390", year: 2017 },
  { make: "KTM", model: "390", year: 2018 },
  { make: "KTM", model: "390", year: 2019 },
  { make: "KTM", model: "390", year: 2020 },
  { make: "KTM", model: "390", year: 2021 },
  { make: "KTM", model: "390", year: 2022 },
  { make: "KTM", model: "390", year: 2023 },
  { make: "KTM", model: "390", year: 2024 },
  { make: "KTM", model: "390", year: 2025 },
  { make: "KTM", model: "390", year: 2026 },
  { make: "KTM", model: "390", year: 2027 },
  // KTM - 390 Adventure
  { make: "KTM", model: "390 Adventure", year: 2020 },
  { make: "KTM", model: "390 Adventure", year: 2021 },
  { make: "KTM", model: "390 Adventure", year: 2022 },
  { make: "KTM", model: "390 Adventure", year: 2023 },
  { make: "KTM", model: "390 Adventure", year: 2024 },
  { make: "KTM", model: "390 Adventure", year: 2025 },
  { make: "KTM", model: "390 Adventure", year: 2026 },
  // KTM - 390 Adventure 14346EU
  { make: "KTM", model: "390 Adventure 14346EU", year: 2017 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2018 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2019 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2020 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2021 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2022 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2023 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2024 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2025 },
  { make: "KTM", model: "390 Adventure 14346EU", year: 2026 },
  // KTM - 390 Adventure Euro 4
  { make: "KTM", model: "390 Adventure Euro 4", year: 2020 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2021 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2022 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2023 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2024 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2025 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2026 },
  { make: "KTM", model: "390 Adventure Euro 4", year: 2027 },
  // KTM - 390 Adventure Mesh Brushed
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2021 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2022 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2023 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2024 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2025 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2026 },
  { make: "KTM", model: "390 Adventure Mesh Brushed", year: 2027 },
  // KTM - 390 Duke
  { make: "KTM", model: "390 Duke", year: 2014 },
  { make: "KTM", model: "390 Duke", year: 2015 },
  { make: "KTM", model: "390 Duke", year: 2016 },
  { make: "KTM", model: "390 Duke", year: 2017 },
  { make: "KTM", model: "390 Duke", year: 2018 },
  { make: "KTM", model: "390 Duke", year: 2019 },
  { make: "KTM", model: "390 Duke", year: 2020 },
  { make: "KTM", model: "390 Duke", year: 2021 },
  { make: "KTM", model: "390 Duke", year: 2022 },
  { make: "KTM", model: "390 Duke", year: 2023 },
  { make: "KTM", model: "390 Duke", year: 2024 },
  { make: "KTM", model: "390 Duke", year: 2025 },
  { make: "KTM", model: "390 Duke", year: 2026 },
  { make: "KTM", model: "390 Duke", year: 2027 },
  // KTM - 400 XC-W
  { make: "KTM", model: "400 XC-W", year: 2009 },
  { make: "KTM", model: "400 XC-W", year: 2010 },
  // KTM - 400 Xcw
  { make: "KTM", model: "400 Xcw", year: 2009 },
  { make: "KTM", model: "400 Xcw", year: 2010 },
  // KTM - 450 EXC
  { make: "KTM", model: "450 EXC", year: 2004 },
  { make: "KTM", model: "450 EXC", year: 2005 },
  { make: "KTM", model: "450 EXC", year: 2006 },
  { make: "KTM", model: "450 EXC", year: 2009 },
  { make: "KTM", model: "450 EXC", year: 2010 },
  { make: "KTM", model: "450 EXC", year: 2011 },
  // KTM - 450 EXC F Six Days
  { make: "KTM", model: "450 EXC F Six Days", year: 2017 },
  { make: "KTM", model: "450 EXC F Six Days", year: 2018 },
  { make: "KTM", model: "450 EXC F Six Days", year: 2019 },
  // KTM - 450 EXC-F
  { make: "KTM", model: "450 EXC-F", year: 2003 },
  { make: "KTM", model: "450 EXC-F", year: 2004 },
  { make: "KTM", model: "450 EXC-F", year: 2005 },
  { make: "KTM", model: "450 EXC-F", year: 2006 },
  { make: "KTM", model: "450 EXC-F", year: 2007 },
  { make: "KTM", model: "450 EXC-F", year: 2008 },
  { make: "KTM", model: "450 EXC-F", year: 2009 },
  { make: "KTM", model: "450 EXC-F", year: 2010 },
  { make: "KTM", model: "450 EXC-F", year: 2011 },
  { make: "KTM", model: "450 EXC-F", year: 2012 },
  { make: "KTM", model: "450 EXC-F", year: 2013 },
  { make: "KTM", model: "450 EXC-F", year: 2014 },
  { make: "KTM", model: "450 EXC-F", year: 2015 },
  { make: "KTM", model: "450 EXC-F", year: 2016 },
  { make: "KTM", model: "450 EXC-F", year: 2017 },
  { make: "KTM", model: "450 EXC-F", year: 2018 },
  { make: "KTM", model: "450 EXC-F", year: 2019 },
  { make: "KTM", model: "450 EXC-F", year: 2020 },
  { make: "KTM", model: "450 EXC-F", year: 2021 },
  { make: "KTM", model: "450 EXC-F", year: 2022 },
  { make: "KTM", model: "450 EXC-F", year: 2023 },
  { make: "KTM", model: "450 EXC-F", year: 2024 },
  { make: "KTM", model: "450 EXC-F", year: 2025 },
  { make: "KTM", model: "450 EXC-F", year: 2026 },
  // KTM - 450 Excr
  { make: "KTM", model: "450 Excr", year: 2008 },
  // KTM - 450 MXC
  { make: "KTM", model: "450 MXC", year: 2004 },
  { make: "KTM", model: "450 MXC", year: 2005 },
  { make: "KTM", model: "450 MXC", year: 2006 },
  // KTM - 450 SMR
  { make: "KTM", model: "450 SMR", year: 2007 },
  { make: "KTM", model: "450 SMR", year: 2008 },
  { make: "KTM", model: "450 SMR", year: 2009 },
  { make: "KTM", model: "450 SMR", year: 2013 },
  // KTM - 450 SX
  { make: "KTM", model: "450 SX", year: 2004 },
  { make: "KTM", model: "450 SX", year: 2005 },
  { make: "KTM", model: "450 SX", year: 2006 },
  { make: "KTM", model: "450 SX", year: 2009 },
  { make: "KTM", model: "450 SX", year: 2010 },
  { make: "KTM", model: "450 SX", year: 2011 },
  { make: "KTM", model: "450 SX", year: 2012 },
  { make: "KTM", model: "450 SX", year: 2013 },
  // KTM - 450 SX-F
  { make: "KTM", model: "450 SX-F", year: 2003 },
  { make: "KTM", model: "450 SX-F", year: 2004 },
  { make: "KTM", model: "450 SX-F", year: 2005 },
  { make: "KTM", model: "450 SX-F", year: 2006 },
  { make: "KTM", model: "450 SX-F", year: 2007 },
  { make: "KTM", model: "450 SX-F", year: 2008 },
  { make: "KTM", model: "450 SX-F", year: 2009 },
  { make: "KTM", model: "450 SX-F", year: 2010 },
  { make: "KTM", model: "450 SX-F", year: 2011 },
  { make: "KTM", model: "450 SX-F", year: 2012 },
  { make: "KTM", model: "450 SX-F", year: 2013 },
  { make: "KTM", model: "450 SX-F", year: 2014 },
  { make: "KTM", model: "450 SX-F", year: 2015 },
  { make: "KTM", model: "450 SX-F", year: 2016 },
  { make: "KTM", model: "450 SX-F", year: 2017 },
  { make: "KTM", model: "450 SX-F", year: 2018 },
  { make: "KTM", model: "450 SX-F", year: 2019 },
  { make: "KTM", model: "450 SX-F", year: 2020 },
  { make: "KTM", model: "450 SX-F", year: 2021 },
  { make: "KTM", model: "450 SX-F", year: 2022 },
  { make: "KTM", model: "450 SX-F", year: 2023 },
  { make: "KTM", model: "450 SX-F", year: 2024 },
  { make: "KTM", model: "450 SX-F", year: 2025 },
  { make: "KTM", model: "450 SX-F", year: 2026 },
  // KTM - 450 SX-F Factory Edition
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2012 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2013 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2014 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2015 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2016 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2017 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2018 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2019 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2020 },
  { make: "KTM", model: "450 SX-F Factory Edition", year: 2021 },
  // KTM - 450 SXF Factory Edition
  { make: "KTM", model: "450 SXF Factory Edition", year: 2012 },
  { make: "KTM", model: "450 SXF Factory Edition", year: 2013 },
  { make: "KTM", model: "450 SXF Factory Edition", year: 2014 },
  // KTM - 450 XC
  { make: "KTM", model: "450 XC", year: 2006 },
  { make: "KTM", model: "450 XC", year: 2007 },
  { make: "KTM", model: "450 XC", year: 2008 },
  { make: "KTM", model: "450 XC", year: 2009 },
  { make: "KTM", model: "450 XC", year: 2010 },
  { make: "KTM", model: "450 XC", year: 2011 },
  { make: "KTM", model: "450 XC", year: 2012 },
  { make: "KTM", model: "450 XC", year: 2013 },
  // KTM - 450 XC-F
  { make: "KTM", model: "450 XC-F", year: 2007 },
  { make: "KTM", model: "450 XC-F", year: 2008 },
  { make: "KTM", model: "450 XC-F", year: 2009 },
  { make: "KTM", model: "450 XC-F", year: 2010 },
  { make: "KTM", model: "450 XC-F", year: 2011 },
  { make: "KTM", model: "450 XC-F", year: 2012 },
  { make: "KTM", model: "450 XC-F", year: 2013 },
  { make: "KTM", model: "450 XC-F", year: 2014 },
  { make: "KTM", model: "450 XC-F", year: 2015 },
  { make: "KTM", model: "450 XC-F", year: 2016 },
  { make: "KTM", model: "450 XC-F", year: 2017 },
  { make: "KTM", model: "450 XC-F", year: 2018 },
  { make: "KTM", model: "450 XC-F", year: 2019 },
  { make: "KTM", model: "450 XC-F", year: 2020 },
  { make: "KTM", model: "450 XC-F", year: 2021 },
  { make: "KTM", model: "450 XC-F", year: 2022 },
  { make: "KTM", model: "450 XC-F", year: 2023 },
  { make: "KTM", model: "450 XC-F", year: 2024 },
  { make: "KTM", model: "450 XC-F", year: 2025 },
  { make: "KTM", model: "450 XC-F", year: 2026 },
  // KTM - 450 XC-W
  { make: "KTM", model: "450 XC-W", year: 2008 },
  { make: "KTM", model: "450 XC-W", year: 2009 },
  { make: "KTM", model: "450 XC-W", year: 2010 },
  { make: "KTM", model: "450 XC-W", year: 2011 },
  { make: "KTM", model: "450 XC-W", year: 2012 },
  { make: "KTM", model: "450 XC-W", year: 2013 },
  { make: "KTM", model: "450 XC-W", year: 2014 },
  { make: "KTM", model: "450 XC-W", year: 2015 },
  { make: "KTM", model: "450 XC-W", year: 2016 },
  // KTM - 450 XCF
  { make: "KTM", model: "450 XCF", year: 2009 },
  // KTM - 450 XCF-W
  { make: "KTM", model: "450 XCF-W", year: 2023 },
  // KTM - 450 Xcrw
  { make: "KTM", model: "450 Xcrw", year: 2008 },
  // KTM - 450 Xcw
  { make: "KTM", model: "450 Xcw", year: 2007 },
  { make: "KTM", model: "450 Xcw", year: 2009 },
  { make: "KTM", model: "450 Xcw", year: 2010 },
  // KTM - 500 EXC
  { make: "KTM", model: "500 EXC", year: 2012 },
  { make: "KTM", model: "500 EXC", year: 2013 },
  { make: "KTM", model: "500 EXC", year: 2014 },
  { make: "KTM", model: "500 EXC", year: 2015 },
  { make: "KTM", model: "500 EXC", year: 2016 },
  // KTM - 500 EXC-F
  { make: "KTM", model: "500 EXC-F", year: 2012 },
  { make: "KTM", model: "500 EXC-F", year: 2013 },
  { make: "KTM", model: "500 EXC-F", year: 2014 },
  { make: "KTM", model: "500 EXC-F", year: 2015 },
  { make: "KTM", model: "500 EXC-F", year: 2016 },
  { make: "KTM", model: "500 EXC-F", year: 2017 },
  { make: "KTM", model: "500 EXC-F", year: 2018 },
  { make: "KTM", model: "500 EXC-F", year: 2019 },
  { make: "KTM", model: "500 EXC-F", year: 2020 },
  { make: "KTM", model: "500 EXC-F", year: 2021 },
  { make: "KTM", model: "500 EXC-F", year: 2022 },
  { make: "KTM", model: "500 EXC-F", year: 2023 },
  { make: "KTM", model: "500 EXC-F", year: 2024 },
  { make: "KTM", model: "500 EXC-F", year: 2025 },
  { make: "KTM", model: "500 EXC-F", year: 2026 },
  // KTM - 500 XC-W
  { make: "KTM", model: "500 XC-W", year: 2013 },
  { make: "KTM", model: "500 XC-W", year: 2014 },
  { make: "KTM", model: "500 XC-W", year: 2015 },
  { make: "KTM", model: "500 XC-W", year: 2016 },
  // KTM - 500 XCF-W
  { make: "KTM", model: "500 XCF-W", year: 2012 },
  { make: "KTM", model: "500 XCF-W", year: 2013 },
  { make: "KTM", model: "500 XCF-W", year: 2014 },
  { make: "KTM", model: "500 XCF-W", year: 2020 },
  { make: "KTM", model: "500 XCF-W", year: 2021 },
  { make: "KTM", model: "500 XCF-W", year: 2022 },
  { make: "KTM", model: "500 XCF-W", year: 2023 },
  // KTM - 505 SX-F
  { make: "KTM", model: "505 SX-F", year: 2008 },
  // KTM - 505 SXF
  { make: "KTM", model: "505 SXF", year: 2008 },
  // KTM - 505 XC-F
  { make: "KTM", model: "505 XC-F", year: 2008 },
  { make: "KTM", model: "505 XC-F", year: 2009 },
  // KTM - 505 XCF
  { make: "KTM", model: "505 XCF", year: 2008 },
  { make: "KTM", model: "505 XCF", year: 2009 },
  // KTM - 525 EXC
  { make: "KTM", model: "525 EXC", year: 2004 },
  { make: "KTM", model: "525 EXC", year: 2005 },
  { make: "KTM", model: "525 EXC", year: 2006 },
  // KTM - 525 MXC
  { make: "KTM", model: "525 MXC", year: 2004 },
  { make: "KTM", model: "525 MXC", year: 2005 },
  { make: "KTM", model: "525 MXC", year: 2006 },
  // KTM - 525 SX
  { make: "KTM", model: "525 SX", year: 2004 },
  { make: "KTM", model: "525 SX", year: 2005 },
  { make: "KTM", model: "525 SX", year: 2006 },
  // KTM - 525 XC
  { make: "KTM", model: "525 XC", year: 2006 },
  { make: "KTM", model: "525 XC", year: 2007 },
  // KTM - 525 XC-W
  { make: "KTM", model: "525 XC-W", year: 2007 },
  // KTM - 525 Xcw
  { make: "KTM", model: "525 Xcw", year: 2007 },
  // KTM - 530 EXC
  { make: "KTM", model: "530 EXC", year: 2009 },
  { make: "KTM", model: "530 EXC", year: 2010 },
  { make: "KTM", model: "530 EXC", year: 2011 },
  // KTM - 530 EXC-R
  { make: "KTM", model: "530 EXC-R", year: 2008 },
  // KTM - 530 Excr
  { make: "KTM", model: "530 Excr", year: 2008 },
  // KTM - 530 XC-W
  { make: "KTM", model: "530 XC-W", year: 2009 },
  { make: "KTM", model: "530 XC-W", year: 2010 },
  // KTM - 530 Xcrw
  { make: "KTM", model: "530 Xcrw", year: 2008 },
  // KTM - 530 Xcw
  { make: "KTM", model: "530 Xcw", year: 2009 },
  { make: "KTM", model: "530 Xcw", year: 2010 },
  // KTM - 690
  { make: "KTM", model: "690", year: 2009 },
  { make: "KTM", model: "690", year: 2010 },
  { make: "KTM", model: "690", year: 2011 },
  { make: "KTM", model: "690", year: 2012 },
  { make: "KTM", model: "690", year: 2013 },
  { make: "KTM", model: "690", year: 2014 },
  // KTM - 690 Duke
  { make: "KTM", model: "690 Duke", year: 2012 },
  { make: "KTM", model: "690 Duke", year: 2013 },
  { make: "KTM", model: "690 Duke", year: 2014 },
  { make: "KTM", model: "690 Duke", year: 2015 },
  { make: "KTM", model: "690 Duke", year: 2016 },
  { make: "KTM", model: "690 Duke", year: 2017 },
  { make: "KTM", model: "690 Duke", year: 2018 },
  { make: "KTM", model: "690 Duke", year: 2019 },
  // KTM - 690 Duke/R
  { make: "KTM", model: "690 Duke/R", year: 2012 },
  { make: "KTM", model: "690 Duke/R", year: 2013 },
  { make: "KTM", model: "690 Duke/R", year: 2014 },
  { make: "KTM", model: "690 Duke/R", year: 2015 },
  { make: "KTM", model: "690 Duke/R", year: 2016 },
  { make: "KTM", model: "690 Duke/R", year: 2017 },
  { make: "KTM", model: "690 Duke/R", year: 2018 },
  { make: "KTM", model: "690 Duke/R", year: 2019 },
  { make: "KTM", model: "690 Duke/R", year: 2020 },
  // KTM - 690 Enduro
  { make: "KTM", model: "690 Enduro", year: 2009 },
  { make: "KTM", model: "690 Enduro", year: 2010 },
  { make: "KTM", model: "690 Enduro", year: 2011 },
  { make: "KTM", model: "690 Enduro", year: 2012 },
  { make: "KTM", model: "690 Enduro", year: 2013 },
  { make: "KTM", model: "690 Enduro", year: 2014 },
  { make: "KTM", model: "690 Enduro", year: 2015 },
  { make: "KTM", model: "690 Enduro", year: 2016 },
  { make: "KTM", model: "690 Enduro", year: 2019 },
  // KTM - 690 Enduro R
  { make: "KTM", model: "690 Enduro R", year: 2009 },
  { make: "KTM", model: "690 Enduro R", year: 2010 },
  { make: "KTM", model: "690 Enduro R", year: 2011 },
  { make: "KTM", model: "690 Enduro R", year: 2012 },
  { make: "KTM", model: "690 Enduro R", year: 2013 },
  { make: "KTM", model: "690 Enduro R", year: 2014 },
  { make: "KTM", model: "690 Enduro R", year: 2015 },
  { make: "KTM", model: "690 Enduro R", year: 2016 },
  { make: "KTM", model: "690 Enduro R", year: 2017 },
  { make: "KTM", model: "690 Enduro R", year: 2018 },
  { make: "KTM", model: "690 Enduro R", year: 2019 },
  { make: "KTM", model: "690 Enduro R", year: 2020 },
  { make: "KTM", model: "690 Enduro R", year: 2021 },
  { make: "KTM", model: "690 Enduro R", year: 2022 },
  { make: "KTM", model: "690 Enduro R", year: 2023 },
  { make: "KTM", model: "690 Enduro R", year: 2024 },
  { make: "KTM", model: "690 Enduro R", year: 2025 },
  { make: "KTM", model: "690 Enduro R", year: 2026 },
  // KTM - 690 R Homologated Euro 4
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2009 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2010 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2011 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2012 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2013 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2014 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2015 },
  { make: "KTM", model: "690 R Homologated Euro 4", year: 2016 },
  // KTM - 690 SMC R
  { make: "KTM", model: "690 SMC R", year: 2012 },
  { make: "KTM", model: "690 SMC R", year: 2013 },
  { make: "KTM", model: "690 SMC R", year: 2014 },
  { make: "KTM", model: "690 SMC R", year: 2015 },
  { make: "KTM", model: "690 SMC R", year: 2016 },
  { make: "KTM", model: "690 SMC R", year: 2017 },
  { make: "KTM", model: "690 SMC R", year: 2018 },
  { make: "KTM", model: "690 SMC R", year: 2019 },
  { make: "KTM", model: "690 SMC R", year: 2020 },
  { make: "KTM", model: "690 SMC R", year: 2021 },
  { make: "KTM", model: "690 SMC R", year: 2022 },
  { make: "KTM", model: "690 SMC R", year: 2023 },
  { make: "KTM", model: "690 SMC R", year: 2024 },
  { make: "KTM", model: "690 SMC R", year: 2025 },
  { make: "KTM", model: "690 SMC R", year: 2026 },
  // KTM - 690 Smc R 690 Enduro
  { make: "KTM", model: "690 Smc R 690 Enduro", year: 2019 },
  // KTM - 700 Smc R 690 Enduro
  { make: "KTM", model: "700 Smc R 690 Enduro", year: 2019 },
  // KTM - 790 Adventure
  { make: "KTM", model: "790 Adventure", year: 2019 },
  { make: "KTM", model: "790 Adventure", year: 2020 },
  { make: "KTM", model: "790 Adventure", year: 2021 },
  { make: "KTM", model: "790 Adventure", year: 2022 },
  { make: "KTM", model: "790 Adventure", year: 2023 },
  { make: "KTM", model: "790 Adventure", year: 2024 },
  // KTM - 790 Adventure R Mod
  { make: "KTM", model: "790 Adventure R Mod", year: 2019 },
  // KTM - 790 Duke
  { make: "KTM", model: "790 Duke", year: 2018 },
  { make: "KTM", model: "790 Duke", year: 2019 },
  { make: "KTM", model: "790 Duke", year: 2020 },
  { make: "KTM", model: "790 Duke", year: 2021 },
  { make: "KTM", model: "790 Duke", year: 2022 },
  { make: "KTM", model: "790 Duke", year: 2023 },
  { make: "KTM", model: "790 Duke", year: 2024 },
  { make: "KTM", model: "790 Duke", year: 2025 },
  { make: "KTM", model: "790 Duke", year: 2026 },
  { make: "KTM", model: "790 Duke", year: 2027 },
  // KTM - 790 Duke 8094
  { make: "KTM", model: "790 Duke 8094", year: 2023 },
  { make: "KTM", model: "790 Duke 8094", year: 2024 },
  { make: "KTM", model: "790 Duke 8094", year: 2025 },
  // KTM - 790/890 Duke
  { make: "KTM", model: "790/890 Duke", year: 2023 },
  { make: "KTM", model: "790/890 Duke", year: 2024 },
  { make: "KTM", model: "790/890 Duke", year: 2025 },
  // KTM - 890
  { make: "KTM", model: "890", year: 2020 },
  { make: "KTM", model: "890", year: 2021 },
  { make: "KTM", model: "890", year: 2022 },
  { make: "KTM", model: "890", year: 2023 },
  { make: "KTM", model: "890", year: 2024 },
  { make: "KTM", model: "890", year: 2025 },
  { make: "KTM", model: "890", year: 2026 },
  { make: "KTM", model: "890", year: 2027 },
  // KTM - 890 Adventure
  { make: "KTM", model: "890 Adventure", year: 2021 },
  { make: "KTM", model: "890 Adventure", year: 2022 },
  { make: "KTM", model: "890 Adventure", year: 2023 },
  { make: "KTM", model: "890 Adventure", year: 2024 },
  // KTM - 890 Duke R
  { make: "KTM", model: "890 Duke R", year: 2020 },
  { make: "KTM", model: "890 Duke R", year: 2021 },
  { make: "KTM", model: "890 Duke R", year: 2022 },
  { make: "KTM", model: "890 Duke R", year: 2023 },
  { make: "KTM", model: "890 Duke R", year: 2024 },
  { make: "KTM", model: "890 Duke R", year: 2025 },
  { make: "KTM", model: "890 Duke R", year: 2026 },
  // KTM - 890 Smt
  { make: "KTM", model: "890 Smt", year: 2023 },
  { make: "KTM", model: "890 Smt", year: 2024 },
  { make: "KTM", model: "890 Smt", year: 2025 },
  // KTM - 950 Sm
  { make: "KTM", model: "950 Sm", year: 2006 },
  { make: "KTM", model: "950 Sm", year: 2007 },
  { make: "KTM", model: "950 Sm", year: 2008 },
  { make: "KTM", model: "950 Sm", year: 2009 },
  { make: "KTM", model: "950 Sm", year: 2010 },
  { make: "KTM", model: "950 Sm", year: 2011 },
  { make: "KTM", model: "950 Sm", year: 2012 },
  { make: "KTM", model: "950 Sm", year: 2013 },
  // KTM - 990 Duke
  { make: "KTM", model: "990 Duke", year: 2023 },
  { make: "KTM", model: "990 Duke", year: 2024 },
  { make: "KTM", model: "990 Duke", year: 2025 },
  { make: "KTM", model: "990 Duke", year: 2026 },
  // KTM - 990 Duke 15411STU
  { make: "KTM", model: "990 Duke 15411STU", year: 2023 },
  { make: "KTM", model: "990 Duke 15411STU", year: 2024 },
  { make: "KTM", model: "990 Duke 15411STU", year: 2025 },
  // KTM - 1050 Adventure
  { make: "KTM", model: "1050 Adventure", year: 2013 },
  { make: "KTM", model: "1050 Adventure", year: 2014 },
  { make: "KTM", model: "1050 Adventure", year: 2015 },
  { make: "KTM", model: "1050 Adventure", year: 2016 },
  // KTM - 1190 Adventure
  { make: "KTM", model: "1190 Adventure", year: 2013 },
  { make: "KTM", model: "1190 Adventure", year: 2014 },
  { make: "KTM", model: "1190 Adventure", year: 2015 },
  { make: "KTM", model: "1190 Adventure", year: 2016 },
  // KTM - 1190 Adventure / Adventure R
  { make: "KTM", model: "1190 Adventure / Adventure R", year: 2013 },
  { make: "KTM", model: "1190 Adventure / Adventure R", year: 2014 },
  { make: "KTM", model: "1190 Adventure / Adventure R", year: 2015 },
  { make: "KTM", model: "1190 Adventure / Adventure R", year: 2016 },
  // KTM - 1190 Adventure/R
  { make: "KTM", model: "1190 Adventure/R", year: 2013 },
  { make: "KTM", model: "1190 Adventure/R", year: 2014 },
  { make: "KTM", model: "1190 Adventure/R", year: 2015 },
  { make: "KTM", model: "1190 Adventure/R", year: 2016 },
  // KTM - 1290 Super Adventure
  { make: "KTM", model: "1290 Super Adventure", year: 2013 },
  { make: "KTM", model: "1290 Super Adventure", year: 2014 },
  { make: "KTM", model: "1290 Super Adventure", year: 2015 },
  { make: "KTM", model: "1290 Super Adventure", year: 2016 },
  { make: "KTM", model: "1290 Super Adventure", year: 2021 },
  { make: "KTM", model: "1290 Super Adventure", year: 2022 },
  { make: "KTM", model: "1290 Super Adventure", year: 2023 },
  { make: "KTM", model: "1290 Super Adventure", year: 2024 },
  // KTM - 1290 Super Adventure S
  { make: "KTM", model: "1290 Super Adventure S", year: 2017 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2018 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2019 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2020 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2021 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2022 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2023 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2024 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2025 },
  { make: "KTM", model: "1290 Super Adventure S", year: 2026 },
  // KTM - 1290 Super Duke
  { make: "KTM", model: "1290 Super Duke", year: 2013 },
  { make: "KTM", model: "1290 Super Duke", year: 2014 },
  { make: "KTM", model: "1290 Super Duke", year: 2015 },
  { make: "KTM", model: "1290 Super Duke", year: 2016 },
  { make: "KTM", model: "1290 Super Duke", year: 2017 },
  { make: "KTM", model: "1290 Super Duke", year: 2018 },
  { make: "KTM", model: "1290 Super Duke", year: 2019 },
  { make: "KTM", model: "1290 Super Duke", year: 2020 },
  { make: "KTM", model: "1290 Super Duke", year: 2021 },
  { make: "KTM", model: "1290 Super Duke", year: 2022 },
  { make: "KTM", model: "1290 Super Duke", year: 2023 },
  { make: "KTM", model: "1290 Super Duke", year: 2024 },
  { make: "KTM", model: "1290 Super Duke", year: 2025 },
  { make: "KTM", model: "1290 Super Duke", year: 2026 },
  { make: "KTM", model: "1290 Super Duke", year: 2027 },
  // KTM - 1290 Super Duke GT
  { make: "KTM", model: "1290 Super Duke GT", year: 2016 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2017 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2018 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2019 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2020 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2021 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2022 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2023 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2024 },
  { make: "KTM", model: "1290 Super Duke GT", year: 2025 },
  // KTM - 1290 Super Duke GT Euro
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2021 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2022 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2023 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2024 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2025 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2026 },
  { make: "KTM", model: "1290 Super Duke GT Euro", year: 2027 },
  // KTM - 1290 Super Duke R
  { make: "KTM", model: "1290 Super Duke R", year: 2014 },
  { make: "KTM", model: "1290 Super Duke R", year: 2015 },
  { make: "KTM", model: "1290 Super Duke R", year: 2016 },
  { make: "KTM", model: "1290 Super Duke R", year: 2017 },
  { make: "KTM", model: "1290 Super Duke R", year: 2018 },
  { make: "KTM", model: "1290 Super Duke R", year: 2019 },
  { make: "KTM", model: "1290 Super Duke R", year: 2020 },
  { make: "KTM", model: "1290 Super Duke R", year: 2021 },
  { make: "KTM", model: "1290 Super Duke R", year: 2022 },
  { make: "KTM", model: "1290 Super Duke R", year: 2023 },
  { make: "KTM", model: "1290 Super Duke R", year: 2024 },
  { make: "KTM", model: "1290 Super Duke R", year: 2025 },
  { make: "KTM", model: "1290 Super Duke R", year: 2026 },
  // KTM - 1290 Super Duke R Hypercone
  { make: "KTM", model: "1290 Super Duke R Hypercone", year: 2014 },
  // KTM - 1290 Super Duke R Nxt
  { make: "KTM", model: "1290 Super Duke R Nxt", year: 2020 },
  // KTM - 1290 Superadventure
  { make: "KTM", model: "1290 Superadventure", year: 2021 },
  { make: "KTM", model: "1290 Superadventure", year: 2022 },
  { make: "KTM", model: "1290 Superadventure", year: 2023 },
  { make: "KTM", model: "1290 Superadventure", year: 2024 },
  // KTM - 1290 Superduke
  { make: "KTM", model: "1290 Superduke", year: 2017 },
  { make: "KTM", model: "1290 Superduke", year: 2018 },
  { make: "KTM", model: "1290 Superduke", year: 2019 },
  { make: "KTM", model: "1290 Superduke", year: 2020 },
  { make: "KTM", model: "1290 Superduke", year: 2021 },
  { make: "KTM", model: "1290 Superduke", year: 2022 },
  { make: "KTM", model: "1290 Superduke", year: 2023 },
  { make: "KTM", model: "1290 Superduke", year: 2024 },
  // KTM - 1390
  { make: "KTM", model: "1390", year: 2020 },
  { make: "KTM", model: "1390", year: 2021 },
  { make: "KTM", model: "1390", year: 2022 },
  { make: "KTM", model: "1390", year: 2023 },
  { make: "KTM", model: "1390", year: 2024 },
  { make: "KTM", model: "1390", year: 2025 },
  { make: "KTM", model: "1390", year: 2026 },
  { make: "KTM", model: "1390", year: 2027 },
  // KTM - 1390 Super Duke
  { make: "KTM", model: "1390 Super Duke", year: 2024 },
  { make: "KTM", model: "1390 Super Duke", year: 2025 },
  { make: "KTM", model: "1390 Super Duke", year: 2026 },
  { make: "KTM", model: "1390 Super Duke", year: 2027 },
  // KTM - Duke 125
  { make: "KTM", model: "Duke 125", year: 2020 },
  { make: "KTM", model: "Duke 125", year: 2021 },
  { make: "KTM", model: "Duke 125", year: 2022 },
  { make: "KTM", model: "Duke 125", year: 2023 },
  { make: "KTM", model: "Duke 125", year: 2024 },
  // KTM - Duke 390
  { make: "KTM", model: "Duke 390", year: 2020 },
  { make: "KTM", model: "Duke 390", year: 2021 },
  { make: "KTM", model: "Duke 390", year: 2022 },
  { make: "KTM", model: "Duke 390", year: 2023 },
  { make: "KTM", model: "Duke 390", year: 2024 },
  { make: "KTM", model: "Duke 390", year: 2025 },
  // KTM - Duke 390 3399EU
  { make: "KTM", model: "Duke 390 3399EU", year: 2017 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2018 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2019 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2020 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2021 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2022 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2023 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2024 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2025 },
  { make: "KTM", model: "Duke 390 3399EU", year: 2026 },
  // KTM - Duke 390 14396EU
  { make: "KTM", model: "Duke 390 14396EU", year: 2017 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2018 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2019 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2020 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2021 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2022 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2023 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2024 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2025 },
  { make: "KTM", model: "Duke 390 14396EU", year: 2026 },
  // KTM - Duke 790
  { make: "KTM", model: "Duke 790", year: 2018 },
  { make: "KTM", model: "Duke 790", year: 2019 },
  { make: "KTM", model: "Duke 790", year: 2020 },
  { make: "KTM", model: "Duke 790", year: 2021 },
  { make: "KTM", model: "Duke 790", year: 2022 },
  { make: "KTM", model: "Duke 790", year: 2023 },
  { make: "KTM", model: "Duke 790", year: 2024 },
  // KTM - Duke 890R
  { make: "KTM", model: "Duke 890R", year: 2018 },
  { make: "KTM", model: "Duke 890R", year: 2019 },
  { make: "KTM", model: "Duke 890R", year: 2020 },
  // KTM - Duke 990
  { make: "KTM", model: "Duke 990", year: 2024 },
  { make: "KTM", model: "Duke 990", year: 2025 },
  { make: "KTM", model: "Duke 990", year: 2026 },
  // KTM - Rc 8C
  { make: "KTM", model: "Rc 8C", year: 2022 },
  { make: "KTM", model: "Rc 8C", year: 2023 },
  { make: "KTM", model: "Rc 8C", year: 2024 },
  // KTM - Rc 125
  { make: "KTM", model: "Rc 125", year: 2013 },
  { make: "KTM", model: "Rc 125", year: 2014 },
  { make: "KTM", model: "Rc 125", year: 2015 },
  { make: "KTM", model: "Rc 125", year: 2016 },
  // KTM - RC 390
  { make: "KTM", model: "RC 390", year: 2014 },
  { make: "KTM", model: "RC 390", year: 2015 },
  { make: "KTM", model: "RC 390", year: 2016 },
  { make: "KTM", model: "RC 390", year: 2017 },
  { make: "KTM", model: "RC 390", year: 2018 },
  { make: "KTM", model: "RC 390", year: 2019 },
  { make: "KTM", model: "RC 390", year: 2020 },
  { make: "KTM", model: "RC 390", year: 2021 },
  { make: "KTM", model: "RC 390", year: 2022 },
  { make: "KTM", model: "RC 390", year: 2023 },
  { make: "KTM", model: "RC 390", year: 2024 },
  { make: "KTM", model: "RC 390", year: 2025 },
  { make: "KTM", model: "RC 390", year: 2026 },
  { make: "KTM", model: "RC 390", year: 2027 },
  // KTM - RC8 1190
  { make: "KTM", model: "RC8 1190", year: 2008 },
  { make: "KTM", model: "RC8 1190", year: 2009 },
  { make: "KTM", model: "RC8 1190", year: 2010 },
  // KTM - RC8 1190 Clip Ons 51MM
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2009 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2010 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2011 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2012 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2013 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2014 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2015 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2016 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2017 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2018 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2019 },
  { make: "KTM", model: "RC8 1190 Clip Ons 51MM", year: 2020 },
  // KTM - RC8 1190R
  { make: "KTM", model: "RC8 1190R", year: 2011 },
  { make: "KTM", model: "RC8 1190R", year: 2012 },
  { make: "KTM", model: "RC8 1190R", year: 2013 },
  { make: "KTM", model: "RC8 1190R", year: 2014 },
  { make: "KTM", model: "RC8 1190R", year: 2015 },
  { make: "KTM", model: "RC8 1190R", year: 2016 },
  // KTM - Super Duke 1290
  { make: "KTM", model: "Super Duke 1290", year: 2020 },
  { make: "KTM", model: "Super Duke 1290", year: 2021 },
  { make: "KTM", model: "Super Duke 1290", year: 2022 },
  { make: "KTM", model: "Super Duke 1290", year: 2023 },
  { make: "KTM", model: "Super Duke 1290", year: 2024 },
  { make: "KTM", model: "Super Duke 1290", year: 2025 },
  { make: "KTM", model: "Super Duke 1290", year: 2026 },
  { make: "KTM", model: "Super Duke 1290", year: 2027 },
  // KTM - Superduke 1290
  { make: "KTM", model: "Superduke 1290", year: 2014 },
  { make: "KTM", model: "Superduke 1290", year: 2015 },
  { make: "KTM", model: "Superduke 1290", year: 2016 },
  { make: "KTM", model: "Superduke 1290", year: 2017 },
  { make: "KTM", model: "Superduke 1290", year: 2018 },
  { make: "KTM", model: "Superduke 1290", year: 2019 },
  { make: "KTM", model: "Superduke 1290", year: 2020 },
  { make: "KTM", model: "Superduke 1290", year: 2021 },
  { make: "KTM", model: "Superduke 1290", year: 2022 },
  { make: "KTM", model: "Superduke 1290", year: 2023 },
  { make: "KTM", model: "Superduke 1290", year: 2024 },
  { make: "KTM", model: "Superduke 1290", year: 2025 },
  { make: "KTM", model: "Superduke 1290", year: 2026 },
  { make: "KTM", model: "Superduke 1290", year: 2027 },
  // Kymco
  // Kymco - AK-550
  { make: "Kymco", model: "AK-550", year: 2017 },
  { make: "Kymco", model: "AK-550", year: 2018 },
  { make: "Kymco", model: "AK-550", year: 2019 },
  { make: "Kymco", model: "AK-550", year: 2020 },
  // Kymco - Downtown 300
  { make: "Kymco", model: "Downtown 300", year: 2009 },
  { make: "Kymco", model: "Downtown 300", year: 2010 },
  { make: "Kymco", model: "Downtown 300", year: 2011 },
  { make: "Kymco", model: "Downtown 300", year: 2012 },
  { make: "Kymco", model: "Downtown 300", year: 2013 },
  { make: "Kymco", model: "Downtown 300", year: 2014 },
  { make: "Kymco", model: "Downtown 300", year: 2015 },
  { make: "Kymco", model: "Downtown 300", year: 2016 },
  // Kymco - Downtown 350I
  { make: "Kymco", model: "Downtown 350I", year: 2016 },
  { make: "Kymco", model: "Downtown 350I", year: 2017 },
  { make: "Kymco", model: "Downtown 350I", year: 2018 },
  { make: "Kymco", model: "Downtown 350I", year: 2019 },
  // Kymco - K Xct 125 I
  { make: "Kymco", model: "K Xct 125 I", year: 2011 },
  { make: "Kymco", model: "K Xct 125 I", year: 2012 },
  { make: "Kymco", model: "K Xct 125 I", year: 2013 },
  { make: "Kymco", model: "K Xct 125 I", year: 2014 },
  { make: "Kymco", model: "K Xct 125 I", year: 2015 },
  // Kymco - People S 50 4-Stroke
  { make: "Kymco", model: "People S 50 4-Stroke", year: 2006 },
  { make: "Kymco", model: "People S 50 4-Stroke", year: 2007 },
  { make: "Kymco", model: "People S 50 4-Stroke", year: 2008 },
  // Kymco - X Town 300
  { make: "Kymco", model: "X Town 300", year: 2016 },
  { make: "Kymco", model: "X Town 300", year: 2017 },
  { make: "Kymco", model: "X Town 300", year: 2018 },
  { make: "Kymco", model: "X Town 300", year: 2019 },
  { make: "Kymco", model: "X Town 300", year: 2020 },
  // Kymco - Xciting 400I
  { make: "Kymco", model: "Xciting 400I", year: 2017 },
  { make: "Kymco", model: "Xciting 400I", year: 2018 },
  { make: "Kymco", model: "Xciting 400I", year: 2019 },
  // Moto Guzzi
  // Moto Guzzi - Stelvio
  { make: "Moto Guzzi", model: "Stelvio", year: 2024 },
  { make: "Moto Guzzi", model: "Stelvio", year: 2025 },
  { make: "Moto Guzzi", model: "Stelvio", year: 2026 },
  // Moto Guzzi - V7
  { make: "Moto Guzzi", model: "V7", year: 2008 },
  { make: "Moto Guzzi", model: "V7", year: 2009 },
  { make: "Moto Guzzi", model: "V7", year: 2010 },
  { make: "Moto Guzzi", model: "V7", year: 2011 },
  { make: "Moto Guzzi", model: "V7", year: 2012 },
  { make: "Moto Guzzi", model: "V7", year: 2013 },
  { make: "Moto Guzzi", model: "V7", year: 2014 },
  { make: "Moto Guzzi", model: "V7", year: 2015 },
  { make: "Moto Guzzi", model: "V7", year: 2016 },
  { make: "Moto Guzzi", model: "V7", year: 2017 },
  { make: "Moto Guzzi", model: "V7", year: 2018 },
  { make: "Moto Guzzi", model: "V7", year: 2019 },
  { make: "Moto Guzzi", model: "V7", year: 2020 },
  { make: "Moto Guzzi", model: "V7", year: 2021 },
  { make: "Moto Guzzi", model: "V7", year: 2022 },
  { make: "Moto Guzzi", model: "V7", year: 2023 },
  { make: "Moto Guzzi", model: "V7", year: 2024 },
  { make: "Moto Guzzi", model: "V7", year: 2025 },
  { make: "Moto Guzzi", model: "V7", year: 2026 },
  { make: "Moto Guzzi", model: "V7", year: 2027 },
  // Moto Guzzi - V7 Iii
  { make: "Moto Guzzi", model: "V7 Iii", year: 2017 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2018 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2019 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2020 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2021 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2022 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2023 },
  { make: "Moto Guzzi", model: "V7 Iii", year: 2024 },
  // Moto Guzzi - V7 Side Mount License
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2013 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2014 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2015 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2016 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2017 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2018 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2019 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2020 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2021 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2022 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2023 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2024 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2025 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2026 },
  { make: "Moto Guzzi", model: "V7 Side Mount License", year: 2027 },
  // Moto Guzzi - V85 TT
  { make: "Moto Guzzi", model: "V85 TT", year: 2019 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2020 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2021 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2022 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2023 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2024 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2025 },
  { make: "Moto Guzzi", model: "V85 TT", year: 2026 },
  // Moto Guzzi - V85 Tt 14348EBU
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2019 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2020 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2021 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2022 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2023 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2024 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2025 },
  { make: "Moto Guzzi", model: "V85 Tt 14348EBU", year: 2026 },
  // Moto Guzzi - V85 Tt 14454EBU
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2019 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2020 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2021 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2022 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2023 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2024 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2025 },
  { make: "Moto Guzzi", model: "V85 Tt 14454EBU", year: 2026 },
  // Moto Guzzi - V85 Tt S MG8SO2 Hftt
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2019 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2020 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2021 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2022 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2023 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2024 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2025 },
  { make: "Moto Guzzi", model: "V85 Tt S MG8SO2 Hftt", year: 2026 },
  // Moto Guzzi - V85TT
  { make: "Moto Guzzi", model: "V85TT", year: 2019 },
  { make: "Moto Guzzi", model: "V85TT", year: 2020 },
  { make: "Moto Guzzi", model: "V85TT", year: 2021 },
  { make: "Moto Guzzi", model: "V85TT", year: 2022 },
  { make: "Moto Guzzi", model: "V85TT", year: 2023 },
  // Moto Guzzi - V100 Mandello
  { make: "Moto Guzzi", model: "V100 Mandello", year: 2023 },
  { make: "Moto Guzzi", model: "V100 Mandello", year: 2024 },
  { make: "Moto Guzzi", model: "V100 Mandello", year: 2025 },
  { make: "Moto Guzzi", model: "V100 Mandello", year: 2026 },
  // Moto Morini
  // Moto Morini - Seiemmezzo 650 SCR/STR
  { make: "Moto Morini", model: "Seiemmezzo 650 SCR/STR", year: 2022 },
  { make: "Moto Morini", model: "Seiemmezzo 650 SCR/STR", year: 2023 },
  { make: "Moto Morini", model: "Seiemmezzo 650 SCR/STR", year: 2024 },
  { make: "Moto Morini", model: "Seiemmezzo 650 SCR/STR", year: 2025 },
  { make: "Moto Morini", model: "Seiemmezzo 650 SCR/STR", year: 2026 },
  // Moto Morini - Seiemmezzo SCR
  { make: "Moto Morini", model: "Seiemmezzo SCR", year: 2023 },
  { make: "Moto Morini", model: "Seiemmezzo SCR", year: 2024 },
  // Moto Morini - Seiemmezzo STR
  { make: "Moto Morini", model: "Seiemmezzo STR", year: 2023 },
  { make: "Moto Morini", model: "Seiemmezzo STR", year: 2024 },
  // Moto Morini - X-Cape 650
  { make: "Moto Morini", model: "X-Cape 650", year: 2021 },
  { make: "Moto Morini", model: "X-Cape 650", year: 2022 },
  { make: "Moto Morini", model: "X-Cape 650", year: 2023 },
  { make: "Moto Morini", model: "X-Cape 650", year: 2024 },
  { make: "Moto Morini", model: "X-Cape 650", year: 2025 },
  // Moto Morini - X-Cape 650 A2
  { make: "Moto Morini", model: "X-Cape 650 A2", year: 2021 },
  { make: "Moto Morini", model: "X-Cape 650 A2", year: 2022 },
  { make: "Moto Morini", model: "X-Cape 650 A2", year: 2023 },
  { make: "Moto Morini", model: "X-Cape 650 A2", year: 2024 },
  { make: "Moto Morini", model: "X-Cape 650 A2", year: 2025 },
  // MV Agusta
  // MV Agusta - Brutale 800
  { make: "MV Agusta", model: "Brutale 800", year: 2013 },
  { make: "MV Agusta", model: "Brutale 800", year: 2014 },
  { make: "MV Agusta", model: "Brutale 800", year: 2015 },
  { make: "MV Agusta", model: "Brutale 800", year: 2016 },
  { make: "MV Agusta", model: "Brutale 800", year: 2017 },
  { make: "MV Agusta", model: "Brutale 800", year: 2018 },
  { make: "MV Agusta", model: "Brutale 800", year: 2019 },
  { make: "MV Agusta", model: "Brutale 800", year: 2020 },
  { make: "MV Agusta", model: "Brutale 800", year: 2021 },
  { make: "MV Agusta", model: "Brutale 800", year: 2022 },
  { make: "MV Agusta", model: "Brutale 800", year: 2023 },
  { make: "MV Agusta", model: "Brutale 800", year: 2024 },
  { make: "MV Agusta", model: "Brutale 800", year: 2025 },
  { make: "MV Agusta", model: "Brutale 800", year: 2026 },
  // MV Agusta - Brutale 1000
  { make: "MV Agusta", model: "Brutale 1000", year: 2019 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2020 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2021 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2022 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2023 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2024 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2025 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2026 },
  { make: "MV Agusta", model: "Brutale 1000", year: 2027 },
  // MV Agusta - Brutale 1000 RR
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2020 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2021 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2022 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2023 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2024 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2025 },
  { make: "MV Agusta", model: "Brutale 1000 RR", year: 2026 },
  // MV Agusta - Brutale 1000 Side Mount License
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2019 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2020 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2021 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2022 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2023 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2024 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2025 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2026 },
  { make: "MV Agusta", model: "Brutale 1000 Side Mount License", year: 2027 },
  // MV Agusta - Dragster 800
  { make: "MV Agusta", model: "Dragster 800", year: 2015 },
  { make: "MV Agusta", model: "Dragster 800", year: 2016 },
  { make: "MV Agusta", model: "Dragster 800", year: 2017 },
  { make: "MV Agusta", model: "Dragster 800", year: 2018 },
  { make: "MV Agusta", model: "Dragster 800", year: 2019 },
  { make: "MV Agusta", model: "Dragster 800", year: 2020 },
  { make: "MV Agusta", model: "Dragster 800", year: 2021 },
  { make: "MV Agusta", model: "Dragster 800", year: 2022 },
  { make: "MV Agusta", model: "Dragster 800", year: 2023 },
  { make: "MV Agusta", model: "Dragster 800", year: 2024 },
  { make: "MV Agusta", model: "Dragster 800", year: 2025 },
  { make: "MV Agusta", model: "Dragster 800", year: 2026 },
  { make: "MV Agusta", model: "Dragster 800", year: 2027 },
  // MV Agusta - Dragster 800 Side Mount License
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2019 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2020 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2021 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2022 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2023 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2024 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2025 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2026 },
  { make: "MV Agusta", model: "Dragster 800 Side Mount License", year: 2027 },
  // MV Agusta - Euro5 Brutale Dragster Turismo Veloce
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2021 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2022 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2023 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2024 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2025 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2026 },
  { make: "MV Agusta", model: "Euro5 Brutale Dragster Turismo Veloce", year: 2027 },
  // MV Agusta - F3 675
  { make: "MV Agusta", model: "F3 675", year: 2012 },
  { make: "MV Agusta", model: "F3 675", year: 2013 },
  { make: "MV Agusta", model: "F3 675", year: 2014 },
  { make: "MV Agusta", model: "F3 675", year: 2015 },
  { make: "MV Agusta", model: "F3 675", year: 2016 },
  { make: "MV Agusta", model: "F3 675", year: 2017 },
  { make: "MV Agusta", model: "F3 675", year: 2018 },
  { make: "MV Agusta", model: "F3 675", year: 2019 },
  { make: "MV Agusta", model: "F3 675", year: 2020 },
  { make: "MV Agusta", model: "F3 675", year: 2021 },
  { make: "MV Agusta", model: "F3 675", year: 2022 },
  { make: "MV Agusta", model: "F3 675", year: 2023 },
  { make: "MV Agusta", model: "F3 675", year: 2024 },
  { make: "MV Agusta", model: "F3 675", year: 2025 },
  { make: "MV Agusta", model: "F3 675", year: 2026 },
  { make: "MV Agusta", model: "F3 675", year: 2027 },
  // MV Agusta - F3 800
  { make: "MV Agusta", model: "F3 800", year: 2013 },
  { make: "MV Agusta", model: "F3 800", year: 2014 },
  { make: "MV Agusta", model: "F3 800", year: 2015 },
  { make: "MV Agusta", model: "F3 800", year: 2016 },
  { make: "MV Agusta", model: "F3 800", year: 2017 },
  { make: "MV Agusta", model: "F3 800", year: 2018 },
  { make: "MV Agusta", model: "F3 800", year: 2019 },
  { make: "MV Agusta", model: "F3 800", year: 2020 },
  { make: "MV Agusta", model: "F3 800", year: 2021 },
  { make: "MV Agusta", model: "F3 800", year: 2022 },
  { make: "MV Agusta", model: "F3 800", year: 2023 },
  { make: "MV Agusta", model: "F3 800", year: 2024 },
  { make: "MV Agusta", model: "F3 800", year: 2025 },
  { make: "MV Agusta", model: "F3 800", year: 2026 },
  // MV Agusta - F4
  { make: "MV Agusta", model: "F4", year: 2010 },
  { make: "MV Agusta", model: "F4", year: 2011 },
  { make: "MV Agusta", model: "F4", year: 2012 },
  { make: "MV Agusta", model: "F4", year: 2013 },
  { make: "MV Agusta", model: "F4", year: 2014 },
  { make: "MV Agusta", model: "F4", year: 2015 },
  { make: "MV Agusta", model: "F4", year: 2016 },
  { make: "MV Agusta", model: "F4", year: 2017 },
  { make: "MV Agusta", model: "F4", year: 2018 },
  { make: "MV Agusta", model: "F4", year: 2019 },
  { make: "MV Agusta", model: "F4", year: 2020 },
  { make: "MV Agusta", model: "F4", year: 2021 },
  { make: "MV Agusta", model: "F4", year: 2022 },
  { make: "MV Agusta", model: "F4", year: 2023 },
  { make: "MV Agusta", model: "F4", year: 2024 },
  { make: "MV Agusta", model: "F4", year: 2025 },
  { make: "MV Agusta", model: "F4", year: 2026 },
  { make: "MV Agusta", model: "F4", year: 2027 },
  // MV Agusta - Superveloce 800
  { make: "MV Agusta", model: "Superveloce 800", year: 2020 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2021 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2022 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2023 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2024 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2025 },
  { make: "MV Agusta", model: "Superveloce 800", year: 2026 },
  // Piaggio
  // Piaggio - Beverly Cruiser 500
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2005 },
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2006 },
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2007 },
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2008 },
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2009 },
  { make: "Piaggio", model: "Beverly Cruiser 500", year: 2010 },
  // Piaggio - MP3 400 Rst
  { make: "Piaggio", model: "MP3 400 Rst", year: 2007 },
  { make: "Piaggio", model: "MP3 400 Rst", year: 2008 },
  { make: "Piaggio", model: "MP3 400 Rst", year: 2009 },
  { make: "Piaggio", model: "MP3 400 Rst", year: 2010 },
  // Piaggio - MP3 500
  { make: "Piaggio", model: "MP3 500", year: 2014 },
  { make: "Piaggio", model: "MP3 500", year: 2015 },
  { make: "Piaggio", model: "MP3 500", year: 2016 },
  // Piaggio - MP3 500LT
  { make: "Piaggio", model: "MP3 500LT", year: 2017 },
  { make: "Piaggio", model: "MP3 500LT", year: 2018 },
  { make: "Piaggio", model: "MP3 500LT", year: 2019 },
  // Polaris
  // Polaris - ACE-325
  { make: "Polaris", model: "ACE-325", year: 2014 },
  { make: "Polaris", model: "ACE-325", year: 2015 },
  { make: "Polaris", model: "ACE-325", year: 2016 },
  // Polaris - ACE-570
  { make: "Polaris", model: "ACE-570", year: 2015 },
  { make: "Polaris", model: "ACE-570", year: 2016 },
  { make: "Polaris", model: "ACE-570", year: 2017 },
  { make: "Polaris", model: "ACE-570", year: 2018 },
  { make: "Polaris", model: "ACE-570", year: 2019 },
  // Polaris - Diesel 455
  { make: "Polaris", model: "Diesel 455", year: 1999 },
  { make: "Polaris", model: "Diesel 455", year: 2000 },
  { make: "Polaris", model: "Diesel 455", year: 2001 },
  // Polaris - General 1000
  { make: "Polaris", model: "General 1000", year: 2016 },
  { make: "Polaris", model: "General 1000", year: 2017 },
  { make: "Polaris", model: "General 1000", year: 2018 },
  { make: "Polaris", model: "General 1000", year: 2019 },
  { make: "Polaris", model: "General 1000", year: 2020 },
  { make: "Polaris", model: "General 1000", year: 2021 },
  { make: "Polaris", model: "General 1000", year: 2022 },
  { make: "Polaris", model: "General 1000", year: 2023 },
  // Polaris - General 1000 Explorer
  { make: "Polaris", model: "General 1000 Explorer", year: 2016 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2017 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2018 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2019 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2020 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2021 },
  { make: "Polaris", model: "General 1000 Explorer", year: 2022 },
  // Polaris - General 1000 Explorer Series Dual
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2016 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2017 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2018 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2019 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2020 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2021 },
  { make: "Polaris", model: "General 1000 Explorer Series Dual", year: 2022 },
  // Polaris - Outlaw 110
  { make: "Polaris", model: "Outlaw 110", year: 2015 },
  { make: "Polaris", model: "Outlaw 110", year: 2016 },
  { make: "Polaris", model: "Outlaw 110", year: 2017 },
  { make: "Polaris", model: "Outlaw 110", year: 2018 },
  { make: "Polaris", model: "Outlaw 110", year: 2019 },
  { make: "Polaris", model: "Outlaw 110", year: 2020 },
  { make: "Polaris", model: "Outlaw 110", year: 2021 },
  { make: "Polaris", model: "Outlaw 110", year: 2022 },
  { make: "Polaris", model: "Outlaw 110", year: 2023 },
  { make: "Polaris", model: "Outlaw 110", year: 2024 },
  // Polaris - Outlaw 450 Mxr
  { make: "Polaris", model: "Outlaw 450 Mxr", year: 2008 },
  { make: "Polaris", model: "Outlaw 450 Mxr", year: 2009 },
  { make: "Polaris", model: "Outlaw 450 Mxr", year: 2010 },
  // Polaris - Outlaw 450 Mxr Evo
  { make: "Polaris", model: "Outlaw 450 Mxr Evo", year: 2008 },
  { make: "Polaris", model: "Outlaw 450 Mxr Evo", year: 2009 },
  { make: "Polaris", model: "Outlaw 450 Mxr Evo", year: 2010 },
  // Polaris - Ranger RZR 800
  { make: "Polaris", model: "Ranger RZR 800", year: 2008 },
  { make: "Polaris", model: "Ranger RZR 800", year: 2009 },
  { make: "Polaris", model: "Ranger RZR 800", year: 2010 },
  { make: "Polaris", model: "Ranger RZR 800", year: 2011 },
  { make: "Polaris", model: "Ranger RZR 800", year: 2012 },
  // Polaris - Ranger RZR 800 EPS
  { make: "Polaris", model: "Ranger RZR 800 EPS", year: 2010 },
  { make: "Polaris", model: "Ranger RZR 800 EPS", year: 2011 },
  // Polaris - Ranger RZR 800 S
  { make: "Polaris", model: "Ranger RZR 800 S", year: 2009 },
  { make: "Polaris", model: "Ranger RZR 800 S", year: 2010 },
  { make: "Polaris", model: "Ranger RZR 800 S", year: 2011 },
  // Polaris - Ranger Rzr 800 Single
  { make: "Polaris", model: "Ranger Rzr 800 Single", year: 2008 },
  { make: "Polaris", model: "Ranger Rzr 800 Single", year: 2009 },
  { make: "Polaris", model: "Ranger Rzr 800 Single", year: 2010 },
  { make: "Polaris", model: "Ranger Rzr 800 Single", year: 2011 },
  { make: "Polaris", model: "Ranger Rzr 800 Single", year: 2012 },
  // Polaris - Ranger RZR XP 900
  { make: "Polaris", model: "Ranger RZR XP 900", year: 2011 },
  { make: "Polaris", model: "Ranger RZR XP 900", year: 2012 },
  { make: "Polaris", model: "Ranger RZR XP 900", year: 2013 },
  // Polaris - Ranger XP 1000
  { make: "Polaris", model: "Ranger XP 1000", year: 2017 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2018 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2019 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2020 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2021 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2022 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2023 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2024 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2025 },
  { make: "Polaris", model: "Ranger XP 1000", year: 2026 },
  // Polaris - RZR Pro XP
  { make: "Polaris", model: "RZR Pro XP", year: 2020 },
  { make: "Polaris", model: "RZR Pro XP", year: 2021 },
  { make: "Polaris", model: "RZR Pro XP", year: 2022 },
  { make: "Polaris", model: "RZR Pro XP", year: 2023 },
  { make: "Polaris", model: "RZR Pro XP", year: 2024 },
  { make: "Polaris", model: "RZR Pro XP", year: 2025 },
  { make: "Polaris", model: "RZR Pro XP", year: 2026 },
  // Polaris - RZR Turbo S
  { make: "Polaris", model: "RZR Turbo S", year: 2021 },
  { make: "Polaris", model: "RZR Turbo S", year: 2022 },
  // Polaris - RZR Turbo S Lifted Lime LE
  { make: "Polaris", model: "RZR Turbo S Lifted Lime LE", year: 2021 },
  // Polaris - RZR Turbo S Velocity
  { make: "Polaris", model: "RZR Turbo S Velocity", year: 2021 },
  { make: "Polaris", model: "RZR Turbo S Velocity", year: 2022 },
  // Polaris - RZR Turbo S4
  { make: "Polaris", model: "RZR Turbo S4", year: 2021 },
  { make: "Polaris", model: "RZR Turbo S4", year: 2022 },
  // Polaris - RZR Turbo S4 Lifted Lime LE
  { make: "Polaris", model: "RZR Turbo S4 Lifted Lime LE", year: 2021 },
  // Polaris - RZR Turbo S4 Velocity
  { make: "Polaris", model: "RZR Turbo S4 Velocity", year: 2021 },
  { make: "Polaris", model: "RZR Turbo S4 Velocity", year: 2022 },
  // Polaris - RZR XP 4 1000 EPS
  { make: "Polaris", model: "RZR XP 4 1000 EPS", year: 2014 },
  { make: "Polaris", model: "RZR XP 4 1000 EPS", year: 2015 },
  { make: "Polaris", model: "RZR XP 4 1000 EPS", year: 2016 },
  { make: "Polaris", model: "RZR XP 4 1000 EPS", year: 2017 },
  // Polaris - Rzr Xp 900
  { make: "Polaris", model: "Rzr Xp 900", year: 2011 },
  { make: "Polaris", model: "Rzr Xp 900", year: 2012 },
  { make: "Polaris", model: "Rzr Xp 900", year: 2013 },
  // Polaris - RZR XP 1000
  { make: "Polaris", model: "RZR XP 1000", year: 2014 },
  { make: "Polaris", model: "RZR XP 1000", year: 2015 },
  { make: "Polaris", model: "RZR XP 1000", year: 2016 },
  { make: "Polaris", model: "RZR XP 1000", year: 2017 },
  { make: "Polaris", model: "RZR XP 1000", year: 2018 },
  { make: "Polaris", model: "RZR XP 1000", year: 2019 },
  { make: "Polaris", model: "RZR XP 1000", year: 2020 },
  { make: "Polaris", model: "RZR XP 1000", year: 2021 },
  { make: "Polaris", model: "RZR XP 1000", year: 2022 },
  { make: "Polaris", model: "RZR XP 1000", year: 2023 },
  { make: "Polaris", model: "RZR XP 1000", year: 2024 },
  { make: "Polaris", model: "RZR XP 1000", year: 2025 },
  { make: "Polaris", model: "RZR XP 1000", year: 2026 },
  // Polaris - RZR XP 1000 EPS
  { make: "Polaris", model: "RZR XP 1000 EPS", year: 2014 },
  { make: "Polaris", model: "RZR XP 1000 EPS", year: 2015 },
  { make: "Polaris", model: "RZR XP 1000 EPS", year: 2016 },
  { make: "Polaris", model: "RZR XP 1000 EPS", year: 2017 },
  // Polaris - RZR XP Turbo
  { make: "Polaris", model: "RZR XP Turbo", year: 2019 },
  { make: "Polaris", model: "RZR XP Turbo", year: 2020 },
  { make: "Polaris", model: "RZR XP Turbo", year: 2021 },
  // Polaris - RZR XP Turbo EPS
  { make: "Polaris", model: "RZR XP Turbo EPS", year: 2016 },
  { make: "Polaris", model: "RZR XP Turbo EPS", year: 2017 },
  { make: "Polaris", model: "RZR XP Turbo EPS", year: 2018 },
  { make: "Polaris", model: "RZR XP Turbo EPS", year: 2019 },
  // Polaris - RZR XP Turbo EPS DYNAMIX Edition
  { make: "Polaris", model: "RZR XP Turbo EPS DYNAMIX Edition", year: 2018 },
  { make: "Polaris", model: "RZR XP Turbo EPS DYNAMIX Edition", year: 2019 },
  // Polaris - RZR XP Turbo EPS Fox Edition
  { make: "Polaris", model: "RZR XP Turbo EPS Fox Edition", year: 2018 },
  // Polaris - RZR XP Turbo EPS LE
  { make: "Polaris", model: "RZR XP Turbo EPS LE", year: 2019 },
  // Polaris - RZR XP Turbo S
  { make: "Polaris", model: "RZR XP Turbo S", year: 2018 },
  { make: "Polaris", model: "RZR XP Turbo S", year: 2019 },
  { make: "Polaris", model: "RZR XP Turbo S", year: 2020 },
  // Polaris - RZR XP Turbo S Velocity
  { make: "Polaris", model: "RZR XP Turbo S Velocity", year: 2020 },
  // Polaris - RZR-570
  { make: "Polaris", model: "RZR-570", year: 2013 },
  { make: "Polaris", model: "RZR-570", year: 2014 },
  { make: "Polaris", model: "RZR-570", year: 2015 },
  { make: "Polaris", model: "RZR-570", year: 2016 },
  { make: "Polaris", model: "RZR-570", year: 2017 },
  // Polaris - RZR-800
  { make: "Polaris", model: "RZR-800", year: 2008 },
  { make: "Polaris", model: "RZR-800", year: 2009 },
  { make: "Polaris", model: "RZR-800", year: 2010 },
  { make: "Polaris", model: "RZR-800", year: 2011 },
  { make: "Polaris", model: "RZR-800", year: 2012 },
  { make: "Polaris", model: "RZR-800", year: 2013 },
  { make: "Polaris", model: "RZR-800", year: 2014 },
  // Polaris - RZR-XP900
  { make: "Polaris", model: "RZR-XP900", year: 2011 },
  { make: "Polaris", model: "RZR-XP900", year: 2012 },
  { make: "Polaris", model: "RZR-XP900", year: 2013 },
  // Polaris - Scrambler Xp 1000
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2014 },
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2015 },
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2016 },
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2017 },
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2018 },
  { make: "Polaris", model: "Scrambler Xp 1000", year: 2019 },
  // Polaris - Scrambler Xp 1000 Evo U
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2014 },
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2015 },
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2016 },
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2017 },
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2018 },
  { make: "Polaris", model: "Scrambler Xp 1000 Evo U", year: 2019 },
  // Polaris - Sportsman 500
  { make: "Polaris", model: "Sportsman 500", year: 2009 },
  { make: "Polaris", model: "Sportsman 500", year: 2010 },
  { make: "Polaris", model: "Sportsman 500", year: 2011 },
  { make: "Polaris", model: "Sportsman 500", year: 2012 },
  { make: "Polaris", model: "Sportsman 500", year: 2013 },
  { make: "Polaris", model: "Sportsman 500", year: 2014 },
  // Polaris - Sportsman 500 Ho
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2001 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2002 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2003 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2004 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2005 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2006 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2007 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2008 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2009 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2010 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2011 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2012 },
  { make: "Polaris", model: "Sportsman 500 Ho", year: 2013 },
  // Polaris - Sportsman 500 Ho Evo U
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2001 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2002 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2003 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2004 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2005 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2006 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2007 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2008 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2009 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2010 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2011 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2012 },
  { make: "Polaris", model: "Sportsman 500 Ho Evo U", year: 2013 },
  // Polaris - Sportsman 570
  { make: "Polaris", model: "Sportsman 570", year: 2014 },
  { make: "Polaris", model: "Sportsman 570", year: 2015 },
  { make: "Polaris", model: "Sportsman 570", year: 2016 },
  { make: "Polaris", model: "Sportsman 570", year: 2017 },
  { make: "Polaris", model: "Sportsman 570", year: 2018 },
  { make: "Polaris", model: "Sportsman 570", year: 2019 },
  { make: "Polaris", model: "Sportsman 570", year: 2020 },
  { make: "Polaris", model: "Sportsman 570", year: 2021 },
  { make: "Polaris", model: "Sportsman 570", year: 2022 },
  { make: "Polaris", model: "Sportsman 570", year: 2023 },
  { make: "Polaris", model: "Sportsman 570", year: 2024 },
  { make: "Polaris", model: "Sportsman 570", year: 2025 },
  { make: "Polaris", model: "Sportsman 570", year: 2026 },
  // Polaris - Sportsman 800
  { make: "Polaris", model: "Sportsman 800", year: 2005 },
  { make: "Polaris", model: "Sportsman 800", year: 2006 },
  { make: "Polaris", model: "Sportsman 800", year: 2007 },
  { make: "Polaris", model: "Sportsman 800", year: 2008 },
  // Polaris - Sportsman 850
  { make: "Polaris", model: "Sportsman 850", year: 2017 },
  { make: "Polaris", model: "Sportsman 850", year: 2018 },
  { make: "Polaris", model: "Sportsman 850", year: 2019 },
  { make: "Polaris", model: "Sportsman 850", year: 2020 },
  { make: "Polaris", model: "Sportsman 850", year: 2021 },
  { make: "Polaris", model: "Sportsman 850", year: 2022 },
  { make: "Polaris", model: "Sportsman 850", year: 2023 },
  // Polaris - Sportsman Xp 1000
  { make: "Polaris", model: "Sportsman Xp 1000", year: 2015 },
  { make: "Polaris", model: "Sportsman Xp 1000", year: 2016 },
  // Polaris - Sportsman Xp 1000 Evo U
  { make: "Polaris", model: "Sportsman Xp 1000 Evo U", year: 2015 },
  { make: "Polaris", model: "Sportsman Xp 1000 Evo U", year: 2016 },
  // Polaris - Sportsman Xp 1000 Touring
  { make: "Polaris", model: "Sportsman Xp 1000 Touring", year: 2015 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring", year: 2016 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring", year: 2017 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring", year: 2018 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring", year: 2019 },
  // Polaris - Sportsman Xp 1000 Touring Evo
  { make: "Polaris", model: "Sportsman Xp 1000 Touring Evo", year: 2015 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring Evo", year: 2016 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring Evo", year: 2017 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring Evo", year: 2018 },
  { make: "Polaris", model: "Sportsman Xp 1000 Touring Evo", year: 2019 },
  // Royal Enfield
  // Royal Enfield - Classic 350
  { make: "Royal Enfield", model: "Classic 350", year: 2021 },
  { make: "Royal Enfield", model: "Classic 350", year: 2022 },
  { make: "Royal Enfield", model: "Classic 350", year: 2023 },
  { make: "Royal Enfield", model: "Classic 350", year: 2024 },
  // Royal Enfield - Continental GT 650
  { make: "Royal Enfield", model: "Continental GT 650", year: 2019 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2020 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2021 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2022 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2023 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2024 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2025 },
  { make: "Royal Enfield", model: "Continental GT 650", year: 2026 },
  // Royal Enfield - Himalayan
  { make: "Royal Enfield", model: "Himalayan", year: 2018 },
  { make: "Royal Enfield", model: "Himalayan", year: 2019 },
  { make: "Royal Enfield", model: "Himalayan", year: 2020 },
  { make: "Royal Enfield", model: "Himalayan", year: 2021 },
  { make: "Royal Enfield", model: "Himalayan", year: 2022 },
  { make: "Royal Enfield", model: "Himalayan", year: 2023 },
  { make: "Royal Enfield", model: "Himalayan", year: 2024 },
  { make: "Royal Enfield", model: "Himalayan", year: 2025 },
  { make: "Royal Enfield", model: "Himalayan", year: 2026 },
  // Royal Enfield - Hunter 350
  { make: "Royal Enfield", model: "Hunter 350", year: 2022 },
  { make: "Royal Enfield", model: "Hunter 350", year: 2023 },
  { make: "Royal Enfield", model: "Hunter 350", year: 2024 },
  { make: "Royal Enfield", model: "Hunter 350", year: 2025 },
  // Royal Enfield - Interceptor 650
  { make: "Royal Enfield", model: "Interceptor 650", year: 2019 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2020 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2021 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2022 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2023 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2024 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2025 },
  { make: "Royal Enfield", model: "Interceptor 650", year: 2026 },
  // Royal Enfield - Meteor 350
  { make: "Royal Enfield", model: "Meteor 350", year: 2021 },
  { make: "Royal Enfield", model: "Meteor 350", year: 2022 },
  { make: "Royal Enfield", model: "Meteor 350", year: 2023 },
  { make: "Royal Enfield", model: "Meteor 350", year: 2024 },
  // Royal Enfield - Super Meteor 650
  { make: "Royal Enfield", model: "Super Meteor 650", year: 2023 },
  { make: "Royal Enfield", model: "Super Meteor 650", year: 2024 },
  { make: "Royal Enfield", model: "Super Meteor 650", year: 2025 },
  { make: "Royal Enfield", model: "Super Meteor 650", year: 2026 },
  // Sherco
  // Sherco - 125 SE
  { make: "Sherco", model: "125 SE", year: 2018 },
  { make: "Sherco", model: "125 SE", year: 2019 },
  { make: "Sherco", model: "125 SE", year: 2020 },
  { make: "Sherco", model: "125 SE", year: 2021 },
  { make: "Sherco", model: "125 SE", year: 2022 },
  { make: "Sherco", model: "125 SE", year: 2023 },
  { make: "Sherco", model: "125 SE", year: 2024 },
  { make: "Sherco", model: "125 SE", year: 2025 },
  { make: "Sherco", model: "125 SE", year: 2026 },
  // Sherco - 250 SE
  { make: "Sherco", model: "250 SE", year: 2010 },
  { make: "Sherco", model: "250 SE", year: 2011 },
  { make: "Sherco", model: "250 SE", year: 2012 },
  { make: "Sherco", model: "250 SE", year: 2013 },
  { make: "Sherco", model: "250 SE", year: 2014 },
  { make: "Sherco", model: "250 SE", year: 2015 },
  { make: "Sherco", model: "250 SE", year: 2016 },
  { make: "Sherco", model: "250 SE", year: 2017 },
  { make: "Sherco", model: "250 SE", year: 2018 },
  { make: "Sherco", model: "250 SE", year: 2019 },
  { make: "Sherco", model: "250 SE", year: 2020 },
  { make: "Sherco", model: "250 SE", year: 2021 },
  { make: "Sherco", model: "250 SE", year: 2022 },
  { make: "Sherco", model: "250 SE", year: 2023 },
  { make: "Sherco", model: "250 SE", year: 2024 },
  { make: "Sherco", model: "250 SE", year: 2025 },
  { make: "Sherco", model: "250 SE", year: 2026 },
  // Sherco - 250 SEF
  { make: "Sherco", model: "250 SEF", year: 2010 },
  { make: "Sherco", model: "250 SEF", year: 2011 },
  { make: "Sherco", model: "250 SEF", year: 2012 },
  { make: "Sherco", model: "250 SEF", year: 2013 },
  { make: "Sherco", model: "250 SEF", year: 2014 },
  { make: "Sherco", model: "250 SEF", year: 2015 },
  { make: "Sherco", model: "250 SEF", year: 2016 },
  { make: "Sherco", model: "250 SEF", year: 2017 },
  { make: "Sherco", model: "250 SEF", year: 2018 },
  { make: "Sherco", model: "250 SEF", year: 2019 },
  { make: "Sherco", model: "250 SEF", year: 2020 },
  { make: "Sherco", model: "250 SEF", year: 2021 },
  { make: "Sherco", model: "250 SEF", year: 2022 },
  { make: "Sherco", model: "250 SEF", year: 2023 },
  { make: "Sherco", model: "250 SEF", year: 2024 },
  { make: "Sherco", model: "250 SEF", year: 2025 },
  { make: "Sherco", model: "250 SEF", year: 2026 },
  // Sherco - 300 SE
  { make: "Sherco", model: "300 SE", year: 2010 },
  { make: "Sherco", model: "300 SE", year: 2011 },
  { make: "Sherco", model: "300 SE", year: 2012 },
  { make: "Sherco", model: "300 SE", year: 2013 },
  { make: "Sherco", model: "300 SE", year: 2014 },
  { make: "Sherco", model: "300 SE", year: 2015 },
  { make: "Sherco", model: "300 SE", year: 2016 },
  { make: "Sherco", model: "300 SE", year: 2017 },
  { make: "Sherco", model: "300 SE", year: 2018 },
  { make: "Sherco", model: "300 SE", year: 2019 },
  { make: "Sherco", model: "300 SE", year: 2020 },
  { make: "Sherco", model: "300 SE", year: 2021 },
  { make: "Sherco", model: "300 SE", year: 2022 },
  { make: "Sherco", model: "300 SE", year: 2023 },
  { make: "Sherco", model: "300 SE", year: 2024 },
  { make: "Sherco", model: "300 SE", year: 2025 },
  { make: "Sherco", model: "300 SE", year: 2026 },
  // Sherco - 300 SEF
  { make: "Sherco", model: "300 SEF", year: 2010 },
  { make: "Sherco", model: "300 SEF", year: 2011 },
  { make: "Sherco", model: "300 SEF", year: 2012 },
  { make: "Sherco", model: "300 SEF", year: 2013 },
  { make: "Sherco", model: "300 SEF", year: 2014 },
  { make: "Sherco", model: "300 SEF", year: 2015 },
  { make: "Sherco", model: "300 SEF", year: 2016 },
  { make: "Sherco", model: "300 SEF", year: 2017 },
  { make: "Sherco", model: "300 SEF", year: 2018 },
  { make: "Sherco", model: "300 SEF", year: 2019 },
  { make: "Sherco", model: "300 SEF", year: 2020 },
  { make: "Sherco", model: "300 SEF", year: 2021 },
  { make: "Sherco", model: "300 SEF", year: 2022 },
  { make: "Sherco", model: "300 SEF", year: 2023 },
  { make: "Sherco", model: "300 SEF", year: 2024 },
  { make: "Sherco", model: "300 SEF", year: 2025 },
  { make: "Sherco", model: "300 SEF", year: 2026 },
  // Sherco - 450 SEF
  { make: "Sherco", model: "450 SEF", year: 2010 },
  { make: "Sherco", model: "450 SEF", year: 2011 },
  { make: "Sherco", model: "450 SEF", year: 2012 },
  { make: "Sherco", model: "450 SEF", year: 2013 },
  { make: "Sherco", model: "450 SEF", year: 2014 },
  { make: "Sherco", model: "450 SEF", year: 2015 },
  { make: "Sherco", model: "450 SEF", year: 2016 },
  { make: "Sherco", model: "450 SEF", year: 2017 },
  { make: "Sherco", model: "450 SEF", year: 2018 },
  { make: "Sherco", model: "450 SEF", year: 2019 },
  { make: "Sherco", model: "450 SEF", year: 2020 },
  { make: "Sherco", model: "450 SEF", year: 2021 },
  { make: "Sherco", model: "450 SEF", year: 2022 },
  { make: "Sherco", model: "450 SEF", year: 2023 },
  { make: "Sherco", model: "450 SEF", year: 2024 },
  { make: "Sherco", model: "450 SEF", year: 2025 },
  { make: "Sherco", model: "450 SEF", year: 2026 },
  // Sherco - 500 SEF
  { make: "Sherco", model: "500 SEF", year: 2010 },
  { make: "Sherco", model: "500 SEF", year: 2011 },
  { make: "Sherco", model: "500 SEF", year: 2012 },
  { make: "Sherco", model: "500 SEF", year: 2013 },
  { make: "Sherco", model: "500 SEF", year: 2014 },
  { make: "Sherco", model: "500 SEF", year: 2015 },
  { make: "Sherco", model: "500 SEF", year: 2016 },
  { make: "Sherco", model: "500 SEF", year: 2017 },
  { make: "Sherco", model: "500 SEF", year: 2018 },
  { make: "Sherco", model: "500 SEF", year: 2019 },
  { make: "Sherco", model: "500 SEF", year: 2020 },
  { make: "Sherco", model: "500 SEF", year: 2021 },
  { make: "Sherco", model: "500 SEF", year: 2022 },
  { make: "Sherco", model: "500 SEF", year: 2023 },
  { make: "Sherco", model: "500 SEF", year: 2024 },
  { make: "Sherco", model: "500 SEF", year: 2025 },
  { make: "Sherco", model: "500 SEF", year: 2026 },
  // Star Motorcycles
  // Star Motorcycles - VMAX 1700
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2009 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2010 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2011 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2012 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2013 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2014 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2015 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2016 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2017 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2018 },
  { make: "Star Motorcycles", model: "VMAX 1700", year: 2019 },
  // Suzuki
  // Suzuki - Bandit 650
  { make: "Suzuki", model: "Bandit 650", year: 2007 },
  { make: "Suzuki", model: "Bandit 650", year: 2008 },
  { make: "Suzuki", model: "Bandit 650", year: 2009 },
  { make: "Suzuki", model: "Bandit 650", year: 2010 },
  { make: "Suzuki", model: "Bandit 650", year: 2011 },
  { make: "Suzuki", model: "Bandit 650", year: 2012 },
  { make: "Suzuki", model: "Bandit 650", year: 2013 },
  // Suzuki - Bandit 1250
  { make: "Suzuki", model: "Bandit 1250", year: 2007 },
  { make: "Suzuki", model: "Bandit 1250", year: 2008 },
  { make: "Suzuki", model: "Bandit 1250", year: 2009 },
  { make: "Suzuki", model: "Bandit 1250", year: 2010 },
  { make: "Suzuki", model: "Bandit 1250", year: 2011 },
  { make: "Suzuki", model: "Bandit 1250", year: 2012 },
  { make: "Suzuki", model: "Bandit 1250", year: 2013 },
  { make: "Suzuki", model: "Bandit 1250", year: 2014 },
  { make: "Suzuki", model: "Bandit 1250", year: 2015 },
  { make: "Suzuki", model: "Bandit 1250", year: 2016 },
  // Suzuki - Boulevard C50
  { make: "Suzuki", model: "Boulevard C50", year: 2005 },
  { make: "Suzuki", model: "Boulevard C50", year: 2006 },
  { make: "Suzuki", model: "Boulevard C50", year: 2007 },
  { make: "Suzuki", model: "Boulevard C50", year: 2008 },
  { make: "Suzuki", model: "Boulevard C50", year: 2009 },
  { make: "Suzuki", model: "Boulevard C50", year: 2010 },
  { make: "Suzuki", model: "Boulevard C50", year: 2011 },
  { make: "Suzuki", model: "Boulevard C50", year: 2012 },
  { make: "Suzuki", model: "Boulevard C50", year: 2013 },
  { make: "Suzuki", model: "Boulevard C50", year: 2014 },
  { make: "Suzuki", model: "Boulevard C50", year: 2015 },
  { make: "Suzuki", model: "Boulevard C50", year: 2016 },
  { make: "Suzuki", model: "Boulevard C50", year: 2017 },
  { make: "Suzuki", model: "Boulevard C50", year: 2018 },
  { make: "Suzuki", model: "Boulevard C50", year: 2019 },
  { make: "Suzuki", model: "Boulevard C50", year: 2020 },
  { make: "Suzuki", model: "Boulevard C50", year: 2021 },
  { make: "Suzuki", model: "Boulevard C50", year: 2022 },
  { make: "Suzuki", model: "Boulevard C50", year: 2023 },
  { make: "Suzuki", model: "Boulevard C50", year: 2024 },
  { make: "Suzuki", model: "Boulevard C50", year: 2025 },
  { make: "Suzuki", model: "Boulevard C50", year: 2026 },
  // Suzuki - Boulevard M109R
  { make: "Suzuki", model: "Boulevard M109R", year: 2006 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2007 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2008 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2009 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2010 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2011 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2012 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2013 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2014 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2015 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2016 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2017 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2018 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2019 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2020 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2021 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2022 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2023 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2024 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2025 },
  { make: "Suzuki", model: "Boulevard M109R", year: 2026 },
  // Suzuki - Burgman 400
  { make: "Suzuki", model: "Burgman 400", year: 2003 },
  { make: "Suzuki", model: "Burgman 400", year: 2004 },
  { make: "Suzuki", model: "Burgman 400", year: 2005 },
  { make: "Suzuki", model: "Burgman 400", year: 2006 },
  { make: "Suzuki", model: "Burgman 400", year: 2007 },
  { make: "Suzuki", model: "Burgman 400", year: 2008 },
  { make: "Suzuki", model: "Burgman 400", year: 2009 },
  { make: "Suzuki", model: "Burgman 400", year: 2010 },
  { make: "Suzuki", model: "Burgman 400", year: 2011 },
  { make: "Suzuki", model: "Burgman 400", year: 2012 },
  { make: "Suzuki", model: "Burgman 400", year: 2013 },
  { make: "Suzuki", model: "Burgman 400", year: 2014 },
  { make: "Suzuki", model: "Burgman 400", year: 2015 },
  { make: "Suzuki", model: "Burgman 400", year: 2016 },
  { make: "Suzuki", model: "Burgman 400", year: 2017 },
  { make: "Suzuki", model: "Burgman 400", year: 2018 },
  { make: "Suzuki", model: "Burgman 400", year: 2019 },
  { make: "Suzuki", model: "Burgman 400", year: 2020 },
  { make: "Suzuki", model: "Burgman 400", year: 2021 },
  { make: "Suzuki", model: "Burgman 400", year: 2022 },
  { make: "Suzuki", model: "Burgman 400", year: 2023 },
  { make: "Suzuki", model: "Burgman 400", year: 2024 },
  { make: "Suzuki", model: "Burgman 400", year: 2025 },
  { make: "Suzuki", model: "Burgman 400", year: 2026 },
  // Suzuki - DL-1000 V Strom V Strom 1000
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2014 },
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2015 },
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2016 },
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2017 },
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2018 },
  { make: "Suzuki", model: "DL-1000 V Strom V Strom 1000", year: 2019 },
  // Suzuki - DL1000 V Strom
  { make: "Suzuki", model: "DL1000 V Strom", year: 2002 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2003 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2004 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2005 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2006 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2007 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2008 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2009 },
  { make: "Suzuki", model: "DL1000 V Strom", year: 2010 },
  // Suzuki - DR Z 400E
  { make: "Suzuki", model: "DR Z 400E", year: 2000 },
  { make: "Suzuki", model: "DR Z 400E", year: 2001 },
  { make: "Suzuki", model: "DR Z 400E", year: 2002 },
  { make: "Suzuki", model: "DR Z 400E", year: 2003 },
  { make: "Suzuki", model: "DR Z 400E", year: 2004 },
  { make: "Suzuki", model: "DR Z 400E", year: 2005 },
  { make: "Suzuki", model: "DR Z 400E", year: 2006 },
  { make: "Suzuki", model: "DR Z 400E", year: 2007 },
  // Suzuki - DR-350
  { make: "Suzuki", model: "DR-350", year: 1990 },
  { make: "Suzuki", model: "DR-350", year: 1991 },
  { make: "Suzuki", model: "DR-350", year: 1992 },
  { make: "Suzuki", model: "DR-350", year: 1993 },
  { make: "Suzuki", model: "DR-350", year: 1994 },
  { make: "Suzuki", model: "DR-350", year: 1995 },
  // Suzuki - DR-600
  { make: "Suzuki", model: "DR-600", year: 1985 },
  { make: "Suzuki", model: "DR-600", year: 1986 },
  { make: "Suzuki", model: "DR-600", year: 1987 },
  // Suzuki - DR-650
  { make: "Suzuki", model: "DR-650", year: 2001 },
  { make: "Suzuki", model: "DR-650", year: 2002 },
  { make: "Suzuki", model: "DR-650", year: 2003 },
  { make: "Suzuki", model: "DR-650", year: 2004 },
  { make: "Suzuki", model: "DR-650", year: 2005 },
  { make: "Suzuki", model: "DR-650", year: 2006 },
  { make: "Suzuki", model: "DR-650", year: 2007 },
  { make: "Suzuki", model: "DR-650", year: 2008 },
  { make: "Suzuki", model: "DR-650", year: 2009 },
  { make: "Suzuki", model: "DR-650", year: 2010 },
  { make: "Suzuki", model: "DR-650", year: 2011 },
  { make: "Suzuki", model: "DR-650", year: 2012 },
  { make: "Suzuki", model: "DR-650", year: 2013 },
  { make: "Suzuki", model: "DR-650", year: 2014 },
  { make: "Suzuki", model: "DR-650", year: 2015 },
  { make: "Suzuki", model: "DR-650", year: 2016 },
  { make: "Suzuki", model: "DR-650", year: 2017 },
  { make: "Suzuki", model: "DR-650", year: 2018 },
  // Suzuki - DR-Z110
  { make: "Suzuki", model: "DR-Z110", year: 2003 },
  { make: "Suzuki", model: "DR-Z110", year: 2004 },
  { make: "Suzuki", model: "DR-Z110", year: 2005 },
  // Suzuki - DR-Z125
  { make: "Suzuki", model: "DR-Z125", year: 2003 },
  { make: "Suzuki", model: "DR-Z125", year: 2004 },
  { make: "Suzuki", model: "DR-Z125", year: 2005 },
  { make: "Suzuki", model: "DR-Z125", year: 2006 },
  { make: "Suzuki", model: "DR-Z125", year: 2007 },
  { make: "Suzuki", model: "DR-Z125", year: 2008 },
  { make: "Suzuki", model: "DR-Z125", year: 2009 },
  { make: "Suzuki", model: "DR-Z125", year: 2012 },
  { make: "Suzuki", model: "DR-Z125", year: 2013 },
  { make: "Suzuki", model: "DR-Z125", year: 2014 },
  // Suzuki - DR-Z125L
  { make: "Suzuki", model: "DR-Z125L", year: 2003 },
  { make: "Suzuki", model: "DR-Z125L", year: 2004 },
  { make: "Suzuki", model: "DR-Z125L", year: 2005 },
  { make: "Suzuki", model: "DR-Z125L", year: 2006 },
  { make: "Suzuki", model: "DR-Z125L", year: 2007 },
  { make: "Suzuki", model: "DR-Z125L", year: 2008 },
  { make: "Suzuki", model: "DR-Z125L", year: 2009 },
  { make: "Suzuki", model: "DR-Z125L", year: 2010 },
  { make: "Suzuki", model: "DR-Z125L", year: 2011 },
  { make: "Suzuki", model: "DR-Z125L", year: 2012 },
  { make: "Suzuki", model: "DR-Z125L", year: 2013 },
  { make: "Suzuki", model: "DR-Z125L", year: 2014 },
  { make: "Suzuki", model: "DR-Z125L", year: 2015 },
  { make: "Suzuki", model: "DR-Z125L", year: 2016 },
  { make: "Suzuki", model: "DR-Z125L", year: 2017 },
  { make: "Suzuki", model: "DR-Z125L", year: 2018 },
  { make: "Suzuki", model: "DR-Z125L", year: 2019 },
  { make: "Suzuki", model: "DR-Z125L", year: 2020 },
  { make: "Suzuki", model: "DR-Z125L", year: 2021 },
  { make: "Suzuki", model: "DR-Z125L", year: 2022 },
  { make: "Suzuki", model: "DR-Z125L", year: 2023 },
  { make: "Suzuki", model: "DR-Z125L", year: 2024 },
  { make: "Suzuki", model: "DR-Z125L", year: 2025 },
  { make: "Suzuki", model: "DR-Z125L", year: 2026 },
  // Suzuki - DR-Z400
  { make: "Suzuki", model: "DR-Z400", year: 2000 },
  { make: "Suzuki", model: "DR-Z400", year: 2001 },
  { make: "Suzuki", model: "DR-Z400", year: 2002 },
  { make: "Suzuki", model: "DR-Z400", year: 2003 },
  { make: "Suzuki", model: "DR-Z400", year: 2004 },
  { make: "Suzuki", model: "DR-Z400", year: 2005 },
  { make: "Suzuki", model: "DR-Z400", year: 2006 },
  { make: "Suzuki", model: "DR-Z400", year: 2007 },
  { make: "Suzuki", model: "DR-Z400", year: 2008 },
  { make: "Suzuki", model: "DR-Z400", year: 2009 },
  { make: "Suzuki", model: "DR-Z400", year: 2010 },
  { make: "Suzuki", model: "DR-Z400", year: 2011 },
  { make: "Suzuki", model: "DR-Z400", year: 2012 },
  { make: "Suzuki", model: "DR-Z400", year: 2013 },
  { make: "Suzuki", model: "DR-Z400", year: 2014 },
  { make: "Suzuki", model: "DR-Z400", year: 2015 },
  { make: "Suzuki", model: "DR-Z400", year: 2016 },
  { make: "Suzuki", model: "DR-Z400", year: 2017 },
  // Suzuki - DR-Z400E
  { make: "Suzuki", model: "DR-Z400E", year: 2000 },
  { make: "Suzuki", model: "DR-Z400E", year: 2001 },
  { make: "Suzuki", model: "DR-Z400E", year: 2002 },
  { make: "Suzuki", model: "DR-Z400E", year: 2003 },
  { make: "Suzuki", model: "DR-Z400E", year: 2004 },
  { make: "Suzuki", model: "DR-Z400E", year: 2005 },
  { make: "Suzuki", model: "DR-Z400E", year: 2006 },
  { make: "Suzuki", model: "DR-Z400E", year: 2007 },
  { make: "Suzuki", model: "DR-Z400E", year: 2008 },
  { make: "Suzuki", model: "DR-Z400E", year: 2009 },
  { make: "Suzuki", model: "DR-Z400E", year: 2010 },
  { make: "Suzuki", model: "DR-Z400E", year: 2011 },
  { make: "Suzuki", model: "DR-Z400E", year: 2012 },
  { make: "Suzuki", model: "DR-Z400E", year: 2013 },
  { make: "Suzuki", model: "DR-Z400E", year: 2014 },
  { make: "Suzuki", model: "DR-Z400E", year: 2015 },
  { make: "Suzuki", model: "DR-Z400E", year: 2016 },
  { make: "Suzuki", model: "DR-Z400E", year: 2017 },
  { make: "Suzuki", model: "DR-Z400E", year: 2018 },
  // Suzuki - DR-Z400S
  { make: "Suzuki", model: "DR-Z400S", year: 2000 },
  { make: "Suzuki", model: "DR-Z400S", year: 2001 },
  { make: "Suzuki", model: "DR-Z400S", year: 2002 },
  { make: "Suzuki", model: "DR-Z400S", year: 2003 },
  { make: "Suzuki", model: "DR-Z400S", year: 2004 },
  { make: "Suzuki", model: "DR-Z400S", year: 2005 },
  { make: "Suzuki", model: "DR-Z400S", year: 2006 },
  { make: "Suzuki", model: "DR-Z400S", year: 2007 },
  { make: "Suzuki", model: "DR-Z400S", year: 2008 },
  { make: "Suzuki", model: "DR-Z400S", year: 2009 },
  { make: "Suzuki", model: "DR-Z400S", year: 2010 },
  { make: "Suzuki", model: "DR-Z400S", year: 2011 },
  { make: "Suzuki", model: "DR-Z400S", year: 2012 },
  { make: "Suzuki", model: "DR-Z400S", year: 2013 },
  { make: "Suzuki", model: "DR-Z400S", year: 2014 },
  { make: "Suzuki", model: "DR-Z400S", year: 2015 },
  { make: "Suzuki", model: "DR-Z400S", year: 2016 },
  { make: "Suzuki", model: "DR-Z400S", year: 2017 },
  { make: "Suzuki", model: "DR-Z400S", year: 2018 },
  { make: "Suzuki", model: "DR-Z400S", year: 2019 },
  { make: "Suzuki", model: "DR-Z400S", year: 2020 },
  { make: "Suzuki", model: "DR-Z400S", year: 2021 },
  { make: "Suzuki", model: "DR-Z400S", year: 2022 },
  { make: "Suzuki", model: "DR-Z400S", year: 2023 },
  { make: "Suzuki", model: "DR-Z400S", year: 2024 },
  { make: "Suzuki", model: "DR-Z400S", year: 2025 },
  { make: "Suzuki", model: "DR-Z400S", year: 2026 },
  // Suzuki - DR-Z400SM
  { make: "Suzuki", model: "DR-Z400SM", year: 2005 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2006 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2007 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2008 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2009 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2010 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2011 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2012 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2013 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2014 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2015 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2016 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2017 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2018 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2019 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2020 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2021 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2022 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2023 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2024 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2025 },
  { make: "Suzuki", model: "DR-Z400SM", year: 2026 },
  // Suzuki - DR200S
  { make: "Suzuki", model: "DR200S", year: 1986 },
  { make: "Suzuki", model: "DR200S", year: 1987 },
  { make: "Suzuki", model: "DR200S", year: 1988 },
  { make: "Suzuki", model: "DR200S", year: 1996 },
  { make: "Suzuki", model: "DR200S", year: 1997 },
  { make: "Suzuki", model: "DR200S", year: 1998 },
  { make: "Suzuki", model: "DR200S", year: 1999 },
  { make: "Suzuki", model: "DR200S", year: 2000 },
  { make: "Suzuki", model: "DR200S", year: 2001 },
  { make: "Suzuki", model: "DR200S", year: 2002 },
  { make: "Suzuki", model: "DR200S", year: 2003 },
  { make: "Suzuki", model: "DR200S", year: 2004 },
  { make: "Suzuki", model: "DR200S", year: 2005 },
  { make: "Suzuki", model: "DR200S", year: 2006 },
  { make: "Suzuki", model: "DR200S", year: 2007 },
  { make: "Suzuki", model: "DR200S", year: 2008 },
  { make: "Suzuki", model: "DR200S", year: 2009 },
  { make: "Suzuki", model: "DR200S", year: 2010 },
  { make: "Suzuki", model: "DR200S", year: 2011 },
  { make: "Suzuki", model: "DR200S", year: 2012 },
  { make: "Suzuki", model: "DR200S", year: 2013 },
  { make: "Suzuki", model: "DR200S", year: 2014 },
  { make: "Suzuki", model: "DR200S", year: 2015 },
  { make: "Suzuki", model: "DR200S", year: 2016 },
  { make: "Suzuki", model: "DR200S", year: 2017 },
  { make: "Suzuki", model: "DR200S", year: 2018 },
  { make: "Suzuki", model: "DR200S", year: 2019 },
  { make: "Suzuki", model: "DR200S", year: 2020 },
  // Suzuki - DR650S
  { make: "Suzuki", model: "DR650S", year: 1990 },
  { make: "Suzuki", model: "DR650S", year: 1991 },
  { make: "Suzuki", model: "DR650S", year: 1992 },
  { make: "Suzuki", model: "DR650S", year: 1993 },
  { make: "Suzuki", model: "DR650S", year: 1994 },
  { make: "Suzuki", model: "DR650S", year: 1995 },
  { make: "Suzuki", model: "DR650S", year: 1996 },
  { make: "Suzuki", model: "DR650S", year: 1997 },
  { make: "Suzuki", model: "DR650S", year: 1998 },
  { make: "Suzuki", model: "DR650S", year: 1999 },
  { make: "Suzuki", model: "DR650S", year: 2000 },
  { make: "Suzuki", model: "DR650S", year: 2001 },
  { make: "Suzuki", model: "DR650S", year: 2002 },
  { make: "Suzuki", model: "DR650S", year: 2003 },
  { make: "Suzuki", model: "DR650S", year: 2004 },
  { make: "Suzuki", model: "DR650S", year: 2005 },
  { make: "Suzuki", model: "DR650S", year: 2006 },
  { make: "Suzuki", model: "DR650S", year: 2007 },
  { make: "Suzuki", model: "DR650S", year: 2008 },
  { make: "Suzuki", model: "DR650S", year: 2009 },
  { make: "Suzuki", model: "DR650S", year: 2010 },
  { make: "Suzuki", model: "DR650S", year: 2011 },
  { make: "Suzuki", model: "DR650S", year: 2012 },
  { make: "Suzuki", model: "DR650S", year: 2013 },
  { make: "Suzuki", model: "DR650S", year: 2014 },
  { make: "Suzuki", model: "DR650S", year: 2015 },
  { make: "Suzuki", model: "DR650S", year: 2016 },
  { make: "Suzuki", model: "DR650S", year: 2017 },
  { make: "Suzuki", model: "DR650S", year: 2018 },
  { make: "Suzuki", model: "DR650S", year: 2019 },
  { make: "Suzuki", model: "DR650S", year: 2020 },
  { make: "Suzuki", model: "DR650S", year: 2021 },
  { make: "Suzuki", model: "DR650S", year: 2022 },
  { make: "Suzuki", model: "DR650S", year: 2023 },
  { make: "Suzuki", model: "DR650S", year: 2024 },
  { make: "Suzuki", model: "DR650S", year: 2025 },
  { make: "Suzuki", model: "DR650S", year: 2026 },
  // Suzuki - DR650SE
  { make: "Suzuki", model: "DR650SE", year: 1997 },
  { make: "Suzuki", model: "DR650SE", year: 1998 },
  { make: "Suzuki", model: "DR650SE", year: 1999 },
  { make: "Suzuki", model: "DR650SE", year: 2000 },
  { make: "Suzuki", model: "DR650SE", year: 2001 },
  { make: "Suzuki", model: "DR650SE", year: 2002 },
  { make: "Suzuki", model: "DR650SE", year: 2003 },
  { make: "Suzuki", model: "DR650SE", year: 2004 },
  { make: "Suzuki", model: "DR650SE", year: 2005 },
  { make: "Suzuki", model: "DR650SE", year: 2006 },
  { make: "Suzuki", model: "DR650SE", year: 2007 },
  { make: "Suzuki", model: "DR650SE", year: 2008 },
  { make: "Suzuki", model: "DR650SE", year: 2009 },
  { make: "Suzuki", model: "DR650SE", year: 2010 },
  { make: "Suzuki", model: "DR650SE", year: 2011 },
  { make: "Suzuki", model: "DR650SE", year: 2012 },
  { make: "Suzuki", model: "DR650SE", year: 2013 },
  { make: "Suzuki", model: "DR650SE", year: 2014 },
  { make: "Suzuki", model: "DR650SE", year: 2015 },
  { make: "Suzuki", model: "DR650SE", year: 2016 },
  { make: "Suzuki", model: "DR650SE", year: 2017 },
  { make: "Suzuki", model: "DR650SE", year: 2018 },
  { make: "Suzuki", model: "DR650SE", year: 2019 },
  { make: "Suzuki", model: "DR650SE", year: 2020 },
  { make: "Suzuki", model: "DR650SE", year: 2021 },
  { make: "Suzuki", model: "DR650SE", year: 2022 },
  // Suzuki - DRZ110
  { make: "Suzuki", model: "DRZ110", year: 2003 },
  { make: "Suzuki", model: "DRZ110", year: 2004 },
  { make: "Suzuki", model: "DRZ110", year: 2005 },
  { make: "Suzuki", model: "DRZ110", year: 2006 },
  { make: "Suzuki", model: "DRZ110", year: 2007 },
  { make: "Suzuki", model: "DRZ110", year: 2008 },
  // Suzuki - DRZ125
  { make: "Suzuki", model: "DRZ125", year: 2003 },
  { make: "Suzuki", model: "DRZ125", year: 2004 },
  { make: "Suzuki", model: "DRZ125", year: 2005 },
  { make: "Suzuki", model: "DRZ125", year: 2006 },
  { make: "Suzuki", model: "DRZ125", year: 2007 },
  { make: "Suzuki", model: "DRZ125", year: 2008 },
  { make: "Suzuki", model: "DRZ125", year: 2009 },
  { make: "Suzuki", model: "DRZ125", year: 2010 },
  { make: "Suzuki", model: "DRZ125", year: 2011 },
  { make: "Suzuki", model: "DRZ125", year: 2012 },
  { make: "Suzuki", model: "DRZ125", year: 2013 },
  { make: "Suzuki", model: "DRZ125", year: 2014 },
  { make: "Suzuki", model: "DRZ125", year: 2015 },
  { make: "Suzuki", model: "DRZ125", year: 2016 },
  // Suzuki - DRZ125L
  { make: "Suzuki", model: "DRZ125L", year: 2017 },
  { make: "Suzuki", model: "DRZ125L", year: 2018 },
  { make: "Suzuki", model: "DRZ125L", year: 2019 },
  { make: "Suzuki", model: "DRZ125L", year: 2020 },
  { make: "Suzuki", model: "DRZ125L", year: 2021 },
  // Suzuki - DRZ400
  { make: "Suzuki", model: "DRZ400", year: 2006 },
  { make: "Suzuki", model: "DRZ400", year: 2007 },
  { make: "Suzuki", model: "DRZ400", year: 2010 },
  { make: "Suzuki", model: "DRZ400", year: 2011 },
  { make: "Suzuki", model: "DRZ400", year: 2012 },
  { make: "Suzuki", model: "DRZ400", year: 2013 },
  { make: "Suzuki", model: "DRZ400", year: 2014 },
  { make: "Suzuki", model: "DRZ400", year: 2015 },
  { make: "Suzuki", model: "DRZ400", year: 2016 },
  { make: "Suzuki", model: "DRZ400", year: 2017 },
  { make: "Suzuki", model: "DRZ400", year: 2018 },
  { make: "Suzuki", model: "DRZ400", year: 2019 },
  { make: "Suzuki", model: "DRZ400", year: 2020 },
  { make: "Suzuki", model: "DRZ400", year: 2021 },
  { make: "Suzuki", model: "DRZ400", year: 2022 },
  { make: "Suzuki", model: "DRZ400", year: 2023 },
  { make: "Suzuki", model: "DRZ400", year: 2024 },
  { make: "Suzuki", model: "DRZ400", year: 2025 },
  { make: "Suzuki", model: "DRZ400", year: 2026 },
  { make: "Suzuki", model: "DRZ400", year: 2027 },
  // Suzuki - DRZ400S
  { make: "Suzuki", model: "DRZ400S", year: 2000 },
  { make: "Suzuki", model: "DRZ400S", year: 2001 },
  { make: "Suzuki", model: "DRZ400S", year: 2002 },
  { make: "Suzuki", model: "DRZ400S", year: 2003 },
  { make: "Suzuki", model: "DRZ400S", year: 2004 },
  { make: "Suzuki", model: "DRZ400S", year: 2005 },
  { make: "Suzuki", model: "DRZ400S", year: 2006 },
  { make: "Suzuki", model: "DRZ400S", year: 2007 },
  { make: "Suzuki", model: "DRZ400S", year: 2008 },
  { make: "Suzuki", model: "DRZ400S", year: 2009 },
  { make: "Suzuki", model: "DRZ400S", year: 2010 },
  { make: "Suzuki", model: "DRZ400S", year: 2011 },
  { make: "Suzuki", model: "DRZ400S", year: 2012 },
  { make: "Suzuki", model: "DRZ400S", year: 2013 },
  { make: "Suzuki", model: "DRZ400S", year: 2014 },
  { make: "Suzuki", model: "DRZ400S", year: 2015 },
  { make: "Suzuki", model: "DRZ400S", year: 2016 },
  { make: "Suzuki", model: "DRZ400S", year: 2017 },
  { make: "Suzuki", model: "DRZ400S", year: 2018 },
  { make: "Suzuki", model: "DRZ400S", year: 2019 },
  { make: "Suzuki", model: "DRZ400S", year: 2020 },
  { make: "Suzuki", model: "DRZ400S", year: 2021 },
  { make: "Suzuki", model: "DRZ400S", year: 2022 },
  // Suzuki - DRZ400SM
  { make: "Suzuki", model: "DRZ400SM", year: 2005 },
  { make: "Suzuki", model: "DRZ400SM", year: 2006 },
  { make: "Suzuki", model: "DRZ400SM", year: 2007 },
  { make: "Suzuki", model: "DRZ400SM", year: 2008 },
  { make: "Suzuki", model: "DRZ400SM", year: 2009 },
  { make: "Suzuki", model: "DRZ400SM", year: 2010 },
  { make: "Suzuki", model: "DRZ400SM", year: 2011 },
  { make: "Suzuki", model: "DRZ400SM", year: 2012 },
  { make: "Suzuki", model: "DRZ400SM", year: 2013 },
  { make: "Suzuki", model: "DRZ400SM", year: 2014 },
  { make: "Suzuki", model: "DRZ400SM", year: 2015 },
  { make: "Suzuki", model: "DRZ400SM", year: 2016 },
  { make: "Suzuki", model: "DRZ400SM", year: 2017 },
  { make: "Suzuki", model: "DRZ400SM", year: 2018 },
  { make: "Suzuki", model: "DRZ400SM", year: 2019 },
  { make: "Suzuki", model: "DRZ400SM", year: 2020 },
  { make: "Suzuki", model: "DRZ400SM", year: 2021 },
  // Suzuki - Gladius 650
  { make: "Suzuki", model: "Gladius 650", year: 2009 },
  { make: "Suzuki", model: "Gladius 650", year: 2010 },
  { make: "Suzuki", model: "Gladius 650", year: 2011 },
  { make: "Suzuki", model: "Gladius 650", year: 2012 },
  { make: "Suzuki", model: "Gladius 650", year: 2013 },
  { make: "Suzuki", model: "Gladius 650", year: 2014 },
  { make: "Suzuki", model: "Gladius 650", year: 2015 },
  // Suzuki - GSF-1250
  { make: "Suzuki", model: "GSF-1250", year: 2007 },
  { make: "Suzuki", model: "GSF-1250", year: 2008 },
  { make: "Suzuki", model: "GSF-1250", year: 2009 },
  { make: "Suzuki", model: "GSF-1250", year: 2010 },
  { make: "Suzuki", model: "GSF-1250", year: 2011 },
  { make: "Suzuki", model: "GSF-1250", year: 2012 },
  // Suzuki - GSR-750
  { make: "Suzuki", model: "GSR-750", year: 2010 },
  { make: "Suzuki", model: "GSR-750", year: 2011 },
  { make: "Suzuki", model: "GSR-750", year: 2012 },
  { make: "Suzuki", model: "GSR-750", year: 2013 },
  { make: "Suzuki", model: "GSR-750", year: 2014 },
  { make: "Suzuki", model: "GSR-750", year: 2015 },
  { make: "Suzuki", model: "GSR-750", year: 2016 },
  // Suzuki - GSX R 600
  { make: "Suzuki", model: "GSX R 600", year: 2006 },
  { make: "Suzuki", model: "GSX R 600", year: 2007 },
  { make: "Suzuki", model: "GSX R 600", year: 2008 },
  { make: "Suzuki", model: "GSX R 600", year: 2009 },
  { make: "Suzuki", model: "GSX R 600", year: 2010 },
  { make: "Suzuki", model: "GSX R 600", year: 2011 },
  { make: "Suzuki", model: "GSX R 600", year: 2012 },
  { make: "Suzuki", model: "GSX R 600", year: 2013 },
  { make: "Suzuki", model: "GSX R 600", year: 2014 },
  { make: "Suzuki", model: "GSX R 600", year: 2015 },
  { make: "Suzuki", model: "GSX R 600", year: 2016 },
  { make: "Suzuki", model: "GSX R 600", year: 2017 },
  { make: "Suzuki", model: "GSX R 600", year: 2018 },
  { make: "Suzuki", model: "GSX R 600", year: 2019 },
  { make: "Suzuki", model: "GSX R 600", year: 2020 },
  { make: "Suzuki", model: "GSX R 600", year: 2021 },
  { make: "Suzuki", model: "GSX R 600", year: 2022 },
  { make: "Suzuki", model: "GSX R 600", year: 2023 },
  { make: "Suzuki", model: "GSX R 600", year: 2024 },
  { make: "Suzuki", model: "GSX R 600", year: 2025 },
  { make: "Suzuki", model: "GSX R 600", year: 2026 },
  { make: "Suzuki", model: "GSX R 600", year: 2027 },
  // Suzuki - GSX R 600 I E
  { make: "Suzuki", model: "GSX R 600 I E", year: 2006 },
  { make: "Suzuki", model: "GSX R 600 I E", year: 2007 },
  // Suzuki - GSX R 750 I E
  { make: "Suzuki", model: "GSX R 750 I E", year: 2006 },
  { make: "Suzuki", model: "GSX R 750 I E", year: 2007 },
  // Suzuki - GSX R 1000
  { make: "Suzuki", model: "GSX R 1000", year: 2005 },
  { make: "Suzuki", model: "GSX R 1000", year: 2006 },
  { make: "Suzuki", model: "GSX R 1000", year: 2007 },
  { make: "Suzuki", model: "GSX R 1000", year: 2008 },
  { make: "Suzuki", model: "GSX R 1000", year: 2009 },
  { make: "Suzuki", model: "GSX R 1000", year: 2010 },
  { make: "Suzuki", model: "GSX R 1000", year: 2011 },
  { make: "Suzuki", model: "GSX R 1000", year: 2012 },
  { make: "Suzuki", model: "GSX R 1000", year: 2013 },
  { make: "Suzuki", model: "GSX R 1000", year: 2014 },
  { make: "Suzuki", model: "GSX R 1000", year: 2015 },
  { make: "Suzuki", model: "GSX R 1000", year: 2016 },
  { make: "Suzuki", model: "GSX R 1000", year: 2017 },
  { make: "Suzuki", model: "GSX R 1000", year: 2018 },
  { make: "Suzuki", model: "GSX R 1000", year: 2019 },
  { make: "Suzuki", model: "GSX R 1000", year: 2020 },
  { make: "Suzuki", model: "GSX R 1000", year: 2021 },
  { make: "Suzuki", model: "GSX R 1000", year: 2022 },
  { make: "Suzuki", model: "GSX R 1000", year: 2023 },
  { make: "Suzuki", model: "GSX R 1000", year: 2024 },
  { make: "Suzuki", model: "GSX R 1000", year: 2025 },
  { make: "Suzuki", model: "GSX R 1000", year: 2026 },
  { make: "Suzuki", model: "GSX R 1000", year: 2027 },
  // Suzuki - GSX R 1000 Gp
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2017 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2018 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2019 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2020 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2021 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2022 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2023 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2024 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2025 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2026 },
  { make: "Suzuki", model: "GSX R 1000 Gp", year: 2027 },
  // Suzuki - GSX R 1000R
  { make: "Suzuki", model: "GSX R 1000R", year: 2017 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2018 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2019 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2020 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2021 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2022 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2023 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2024 },
  { make: "Suzuki", model: "GSX R 1000R", year: 2025 },
  // Suzuki - GSX S 750 GSX S 750 Z
  { make: "Suzuki", model: "GSX S 750 GSX S 750 Z", year: 2018 },
  // Suzuki - GSX S 1000
  { make: "Suzuki", model: "GSX S 1000", year: 2021 },
  { make: "Suzuki", model: "GSX S 1000", year: 2022 },
  { make: "Suzuki", model: "GSX S 1000", year: 2023 },
  { make: "Suzuki", model: "GSX S 1000", year: 2024 },
  // Suzuki - GSX-8R
  { make: "Suzuki", model: "GSX-8R", year: 2023 },
  { make: "Suzuki", model: "GSX-8R", year: 2024 },
  { make: "Suzuki", model: "GSX-8R", year: 2025 },
  { make: "Suzuki", model: "GSX-8R", year: 2026 },
  { make: "Suzuki", model: "GSX-8R", year: 2027 },
  // Suzuki - GSX-8S
  { make: "Suzuki", model: "GSX-8S", year: 2022 },
  { make: "Suzuki", model: "GSX-8S", year: 2023 },
  { make: "Suzuki", model: "GSX-8S", year: 2024 },
  { make: "Suzuki", model: "GSX-8S", year: 2025 },
  { make: "Suzuki", model: "GSX-8S", year: 2026 },
  { make: "Suzuki", model: "GSX-8S", year: 2027 },
  // Suzuki - GSX-250R
  { make: "Suzuki", model: "GSX-250R", year: 2017 },
  { make: "Suzuki", model: "GSX-250R", year: 2018 },
  { make: "Suzuki", model: "GSX-250R", year: 2019 },
  { make: "Suzuki", model: "GSX-250R", year: 2020 },
  { make: "Suzuki", model: "GSX-250R", year: 2021 },
  // Suzuki - GSX-600F Katana
  { make: "Suzuki", model: "GSX-600F Katana", year: 1998 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 1999 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2000 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2001 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2002 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2003 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2004 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2005 },
  { make: "Suzuki", model: "GSX-600F Katana", year: 2006 },
  // Suzuki - GSX-650 F
  { make: "Suzuki", model: "GSX-650 F", year: 2007 },
  { make: "Suzuki", model: "GSX-650 F", year: 2008 },
  { make: "Suzuki", model: "GSX-650 F", year: 2009 },
  { make: "Suzuki", model: "GSX-650 F", year: 2010 },
  { make: "Suzuki", model: "GSX-650 F", year: 2011 },
  { make: "Suzuki", model: "GSX-650 F", year: 2012 },
  { make: "Suzuki", model: "GSX-650 F", year: 2013 },
  { make: "Suzuki", model: "GSX-650 F", year: 2014 },
  { make: "Suzuki", model: "GSX-650 F", year: 2015 },
  // Suzuki - GSX-1000R
  { make: "Suzuki", model: "GSX-1000R", year: 2017 },
  { make: "Suzuki", model: "GSX-1000R", year: 2018 },
  { make: "Suzuki", model: "GSX-1000R", year: 2019 },
  { make: "Suzuki", model: "GSX-1000R", year: 2020 },
  { make: "Suzuki", model: "GSX-1000R", year: 2021 },
  { make: "Suzuki", model: "GSX-1000R", year: 2022 },
  { make: "Suzuki", model: "GSX-1000R", year: 2023 },
  { make: "Suzuki", model: "GSX-1000R", year: 2024 },
  { make: "Suzuki", model: "GSX-1000R", year: 2025 },
  { make: "Suzuki", model: "GSX-1000R", year: 2026 },
  { make: "Suzuki", model: "GSX-1000R", year: 2027 },
  // Suzuki - GSX-1250 Fa
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2010 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2011 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2012 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2013 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2014 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2015 },
  { make: "Suzuki", model: "GSX-1250 Fa", year: 2016 },
  // Suzuki - GSX-1300
  { make: "Suzuki", model: "GSX-1300", year: 1999 },
  { make: "Suzuki", model: "GSX-1300", year: 2000 },
  { make: "Suzuki", model: "GSX-1300", year: 2001 },
  { make: "Suzuki", model: "GSX-1300", year: 2002 },
  { make: "Suzuki", model: "GSX-1300", year: 2003 },
  { make: "Suzuki", model: "GSX-1300", year: 2004 },
  { make: "Suzuki", model: "GSX-1300", year: 2005 },
  { make: "Suzuki", model: "GSX-1300", year: 2006 },
  { make: "Suzuki", model: "GSX-1300", year: 2007 },
  // Suzuki - GSX-R600
  { make: "Suzuki", model: "GSX-R600", year: 1992 },
  { make: "Suzuki", model: "GSX-R600", year: 1993 },
  { make: "Suzuki", model: "GSX-R600", year: 1994 },
  { make: "Suzuki", model: "GSX-R600", year: 1995 },
  { make: "Suzuki", model: "GSX-R600", year: 1996 },
  { make: "Suzuki", model: "GSX-R600", year: 1997 },
  { make: "Suzuki", model: "GSX-R600", year: 1998 },
  { make: "Suzuki", model: "GSX-R600", year: 1999 },
  { make: "Suzuki", model: "GSX-R600", year: 2000 },
  { make: "Suzuki", model: "GSX-R600", year: 2001 },
  { make: "Suzuki", model: "GSX-R600", year: 2002 },
  { make: "Suzuki", model: "GSX-R600", year: 2003 },
  { make: "Suzuki", model: "GSX-R600", year: 2004 },
  { make: "Suzuki", model: "GSX-R600", year: 2005 },
  { make: "Suzuki", model: "GSX-R600", year: 2006 },
  { make: "Suzuki", model: "GSX-R600", year: 2007 },
  { make: "Suzuki", model: "GSX-R600", year: 2008 },
  { make: "Suzuki", model: "GSX-R600", year: 2009 },
  { make: "Suzuki", model: "GSX-R600", year: 2010 },
  { make: "Suzuki", model: "GSX-R600", year: 2011 },
  { make: "Suzuki", model: "GSX-R600", year: 2012 },
  { make: "Suzuki", model: "GSX-R600", year: 2013 },
  { make: "Suzuki", model: "GSX-R600", year: 2014 },
  { make: "Suzuki", model: "GSX-R600", year: 2015 },
  { make: "Suzuki", model: "GSX-R600", year: 2016 },
  { make: "Suzuki", model: "GSX-R600", year: 2017 },
  { make: "Suzuki", model: "GSX-R600", year: 2018 },
  { make: "Suzuki", model: "GSX-R600", year: 2019 },
  { make: "Suzuki", model: "GSX-R600", year: 2020 },
  { make: "Suzuki", model: "GSX-R600", year: 2021 },
  { make: "Suzuki", model: "GSX-R600", year: 2022 },
  { make: "Suzuki", model: "GSX-R600", year: 2023 },
  { make: "Suzuki", model: "GSX-R600", year: 2024 },
  { make: "Suzuki", model: "GSX-R600", year: 2025 },
  { make: "Suzuki", model: "GSX-R600", year: 2026 },
  { make: "Suzuki", model: "GSX-R600", year: 2027 },
  // Suzuki - GSX-R600 GSX R750
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2006 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2007 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2011 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2012 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2013 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2014 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2015 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2016 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2017 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2018 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2019 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2020 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2021 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2022 },
  { make: "Suzuki", model: "GSX-R600 GSX R750", year: 2023 },
  // Suzuki - GSX-R600 I E
  { make: "Suzuki", model: "GSX-R600 I E", year: 2006 },
  { make: "Suzuki", model: "GSX-R600 I E", year: 2007 },
  // Suzuki - GSX-R750
  { make: "Suzuki", model: "GSX-R750", year: 1985 },
  { make: "Suzuki", model: "GSX-R750", year: 1986 },
  { make: "Suzuki", model: "GSX-R750", year: 1987 },
  { make: "Suzuki", model: "GSX-R750", year: 1988 },
  { make: "Suzuki", model: "GSX-R750", year: 1989 },
  { make: "Suzuki", model: "GSX-R750", year: 1990 },
  { make: "Suzuki", model: "GSX-R750", year: 1991 },
  { make: "Suzuki", model: "GSX-R750", year: 1992 },
  { make: "Suzuki", model: "GSX-R750", year: 1993 },
  { make: "Suzuki", model: "GSX-R750", year: 1994 },
  { make: "Suzuki", model: "GSX-R750", year: 1995 },
  { make: "Suzuki", model: "GSX-R750", year: 1996 },
  { make: "Suzuki", model: "GSX-R750", year: 1997 },
  { make: "Suzuki", model: "GSX-R750", year: 1998 },
  { make: "Suzuki", model: "GSX-R750", year: 1999 },
  { make: "Suzuki", model: "GSX-R750", year: 2000 },
  { make: "Suzuki", model: "GSX-R750", year: 2001 },
  { make: "Suzuki", model: "GSX-R750", year: 2002 },
  { make: "Suzuki", model: "GSX-R750", year: 2003 },
  { make: "Suzuki", model: "GSX-R750", year: 2004 },
  { make: "Suzuki", model: "GSX-R750", year: 2005 },
  { make: "Suzuki", model: "GSX-R750", year: 2006 },
  { make: "Suzuki", model: "GSX-R750", year: 2007 },
  { make: "Suzuki", model: "GSX-R750", year: 2008 },
  { make: "Suzuki", model: "GSX-R750", year: 2009 },
  { make: "Suzuki", model: "GSX-R750", year: 2010 },
  { make: "Suzuki", model: "GSX-R750", year: 2011 },
  { make: "Suzuki", model: "GSX-R750", year: 2012 },
  { make: "Suzuki", model: "GSX-R750", year: 2013 },
  { make: "Suzuki", model: "GSX-R750", year: 2014 },
  { make: "Suzuki", model: "GSX-R750", year: 2015 },
  { make: "Suzuki", model: "GSX-R750", year: 2016 },
  { make: "Suzuki", model: "GSX-R750", year: 2017 },
  { make: "Suzuki", model: "GSX-R750", year: 2018 },
  { make: "Suzuki", model: "GSX-R750", year: 2019 },
  { make: "Suzuki", model: "GSX-R750", year: 2020 },
  { make: "Suzuki", model: "GSX-R750", year: 2021 },
  { make: "Suzuki", model: "GSX-R750", year: 2022 },
  { make: "Suzuki", model: "GSX-R750", year: 2023 },
  { make: "Suzuki", model: "GSX-R750", year: 2024 },
  { make: "Suzuki", model: "GSX-R750", year: 2025 },
  { make: "Suzuki", model: "GSX-R750", year: 2026 },
  // Suzuki - GSX-R750 I E
  { make: "Suzuki", model: "GSX-R750 I E", year: 2006 },
  { make: "Suzuki", model: "GSX-R750 I E", year: 2007 },
  // Suzuki - GSX-R1000
  { make: "Suzuki", model: "GSX-R1000", year: 2001 },
  { make: "Suzuki", model: "GSX-R1000", year: 2002 },
  { make: "Suzuki", model: "GSX-R1000", year: 2003 },
  { make: "Suzuki", model: "GSX-R1000", year: 2004 },
  { make: "Suzuki", model: "GSX-R1000", year: 2005 },
  { make: "Suzuki", model: "GSX-R1000", year: 2006 },
  { make: "Suzuki", model: "GSX-R1000", year: 2007 },
  { make: "Suzuki", model: "GSX-R1000", year: 2008 },
  { make: "Suzuki", model: "GSX-R1000", year: 2009 },
  { make: "Suzuki", model: "GSX-R1000", year: 2010 },
  { make: "Suzuki", model: "GSX-R1000", year: 2011 },
  { make: "Suzuki", model: "GSX-R1000", year: 2012 },
  { make: "Suzuki", model: "GSX-R1000", year: 2013 },
  { make: "Suzuki", model: "GSX-R1000", year: 2014 },
  { make: "Suzuki", model: "GSX-R1000", year: 2015 },
  { make: "Suzuki", model: "GSX-R1000", year: 2016 },
  { make: "Suzuki", model: "GSX-R1000", year: 2017 },
  { make: "Suzuki", model: "GSX-R1000", year: 2018 },
  { make: "Suzuki", model: "GSX-R1000", year: 2019 },
  { make: "Suzuki", model: "GSX-R1000", year: 2020 },
  { make: "Suzuki", model: "GSX-R1000", year: 2021 },
  { make: "Suzuki", model: "GSX-R1000", year: 2022 },
  { make: "Suzuki", model: "GSX-R1000", year: 2023 },
  { make: "Suzuki", model: "GSX-R1000", year: 2024 },
  { make: "Suzuki", model: "GSX-R1000", year: 2025 },
  { make: "Suzuki", model: "GSX-R1000", year: 2026 },
  { make: "Suzuki", model: "GSX-R1000", year: 2027 },
  // Suzuki - GSX-R1000 Gp
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2017 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2018 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2019 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2020 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2021 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2022 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2023 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2024 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2025 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2026 },
  { make: "Suzuki", model: "GSX-R1000 Gp", year: 2027 },
  // Suzuki - GSX-R1000 GSX R1000R
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2017 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2018 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2019 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2020 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2021 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2022 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2023 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2024 },
  { make: "Suzuki", model: "GSX-R1000 GSX R1000R", year: 2025 },
  // Suzuki - GSX-R1000R
  { make: "Suzuki", model: "GSX-R1000R", year: 2017 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2018 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2019 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2020 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2021 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2022 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2023 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2024 },
  { make: "Suzuki", model: "GSX-R1000R", year: 2025 },
  // Suzuki - GSX-S750
  { make: "Suzuki", model: "GSX-S750", year: 2015 },
  { make: "Suzuki", model: "GSX-S750", year: 2016 },
  { make: "Suzuki", model: "GSX-S750", year: 2017 },
  { make: "Suzuki", model: "GSX-S750", year: 2018 },
  { make: "Suzuki", model: "GSX-S750", year: 2019 },
  { make: "Suzuki", model: "GSX-S750", year: 2020 },
  { make: "Suzuki", model: "GSX-S750", year: 2021 },
  // Suzuki - GSX-S750 GSX S 750 Z
  { make: "Suzuki", model: "GSX-S750 GSX S 750 Z", year: 2018 },
  // Suzuki - GSX-S750/Z ABS
  { make: "Suzuki", model: "GSX-S750/Z ABS", year: 2017 },
  { make: "Suzuki", model: "GSX-S750/Z ABS", year: 2018 },
  { make: "Suzuki", model: "GSX-S750/Z ABS", year: 2019 },
  { make: "Suzuki", model: "GSX-S750/Z ABS", year: 2020 },
  // Suzuki - GSX-S750/Z ABS A2
  { make: "Suzuki", model: "GSX-S750/Z ABS A2", year: 2017 },
  { make: "Suzuki", model: "GSX-S750/Z ABS A2", year: 2018 },
  { make: "Suzuki", model: "GSX-S750/Z ABS A2", year: 2019 },
  { make: "Suzuki", model: "GSX-S750/Z ABS A2", year: 2020 },
  // Suzuki - GSX-S750Z
  { make: "Suzuki", model: "GSX-S750Z", year: 2017 },
  { make: "Suzuki", model: "GSX-S750Z", year: 2018 },
  { make: "Suzuki", model: "GSX-S750Z", year: 2019 },
  { make: "Suzuki", model: "GSX-S750Z", year: 2020 },
  // Suzuki - GSX-S750Z ABS
  { make: "Suzuki", model: "GSX-S750Z ABS", year: 2017 },
  { make: "Suzuki", model: "GSX-S750Z ABS", year: 2018 },
  { make: "Suzuki", model: "GSX-S750Z ABS", year: 2019 },
  { make: "Suzuki", model: "GSX-S750Z ABS", year: 2020 },
  // Suzuki - GSX-S950
  { make: "Suzuki", model: "GSX-S950", year: 2021 },
  { make: "Suzuki", model: "GSX-S950", year: 2022 },
  { make: "Suzuki", model: "GSX-S950", year: 2023 },
  // Suzuki - GSX-S1000
  { make: "Suzuki", model: "GSX-S1000", year: 2015 },
  { make: "Suzuki", model: "GSX-S1000", year: 2016 },
  { make: "Suzuki", model: "GSX-S1000", year: 2017 },
  { make: "Suzuki", model: "GSX-S1000", year: 2018 },
  { make: "Suzuki", model: "GSX-S1000", year: 2019 },
  { make: "Suzuki", model: "GSX-S1000", year: 2020 },
  { make: "Suzuki", model: "GSX-S1000", year: 2021 },
  { make: "Suzuki", model: "GSX-S1000", year: 2022 },
  { make: "Suzuki", model: "GSX-S1000", year: 2023 },
  { make: "Suzuki", model: "GSX-S1000", year: 2024 },
  { make: "Suzuki", model: "GSX-S1000", year: 2025 },
  { make: "Suzuki", model: "GSX-S1000", year: 2026 },
  // Suzuki - GSX-S1000GT
  { make: "Suzuki", model: "GSX-S1000GT", year: 2022 },
  { make: "Suzuki", model: "GSX-S1000GT", year: 2023 },
  { make: "Suzuki", model: "GSX-S1000GT", year: 2024 },
  { make: "Suzuki", model: "GSX-S1000GT", year: 2025 },
  { make: "Suzuki", model: "GSX-S1000GT", year: 2026 },
  // Suzuki - GSX-S1000GX
  { make: "Suzuki", model: "GSX-S1000GX", year: 2022 },
  { make: "Suzuki", model: "GSX-S1000GX", year: 2023 },
  { make: "Suzuki", model: "GSX-S1000GX", year: 2024 },
  { make: "Suzuki", model: "GSX-S1000GX", year: 2025 },
  { make: "Suzuki", model: "GSX-S1000GX", year: 2026 },
  // Suzuki - GSX250R
  { make: "Suzuki", model: "GSX250R", year: 2017 },
  { make: "Suzuki", model: "GSX250R", year: 2018 },
  { make: "Suzuki", model: "GSX250R", year: 2019 },
  { make: "Suzuki", model: "GSX250R", year: 2020 },
  { make: "Suzuki", model: "GSX250R", year: 2021 },
  // Suzuki - GSX1300R Hayabusa
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2021 },
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2022 },
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2023 },
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2024 },
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2025 },
  { make: "Suzuki", model: "GSX1300R Hayabusa", year: 2026 },
  // Suzuki - GSXR-1000
  { make: "Suzuki", model: "GSXR-1000", year: 2009 },
  { make: "Suzuki", model: "GSXR-1000", year: 2010 },
  { make: "Suzuki", model: "GSXR-1000", year: 2011 },
  { make: "Suzuki", model: "GSXR-1000", year: 2012 },
  { make: "Suzuki", model: "GSXR-1000", year: 2013 },
  { make: "Suzuki", model: "GSXR-1000", year: 2014 },
  { make: "Suzuki", model: "GSXR-1000", year: 2015 },
  { make: "Suzuki", model: "GSXR-1000", year: 2016 },
  { make: "Suzuki", model: "GSXR-1000", year: 2017 },
  { make: "Suzuki", model: "GSXR-1000", year: 2018 },
  { make: "Suzuki", model: "GSXR-1000", year: 2019 },
  { make: "Suzuki", model: "GSXR-1000", year: 2020 },
  { make: "Suzuki", model: "GSXR-1000", year: 2021 },
  { make: "Suzuki", model: "GSXR-1000", year: 2022 },
  { make: "Suzuki", model: "GSXR-1000", year: 2023 },
  { make: "Suzuki", model: "GSXR-1000", year: 2024 },
  { make: "Suzuki", model: "GSXR-1000", year: 2025 },
  { make: "Suzuki", model: "GSXR-1000", year: 2026 },
  { make: "Suzuki", model: "GSXR-1000", year: 2027 },
  // Suzuki - Gsxr600 1000
  { make: "Suzuki", model: "Gsxr600 1000", year: 2005 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2006 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2007 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2008 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2009 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2010 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2011 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2012 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2013 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2014 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2015 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2016 },
  { make: "Suzuki", model: "Gsxr600 1000", year: 2017 },
  // Suzuki - Gsxr1000r
  { make: "Suzuki", model: "Gsxr1000r", year: 2017 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2018 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2019 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2020 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2021 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2022 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2023 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2024 },
  { make: "Suzuki", model: "Gsxr1000r", year: 2025 },
  // Suzuki - Hayabusa
  { make: "Suzuki", model: "Hayabusa", year: 1999 },
  { make: "Suzuki", model: "Hayabusa", year: 2000 },
  { make: "Suzuki", model: "Hayabusa", year: 2001 },
  { make: "Suzuki", model: "Hayabusa", year: 2002 },
  { make: "Suzuki", model: "Hayabusa", year: 2003 },
  { make: "Suzuki", model: "Hayabusa", year: 2004 },
  { make: "Suzuki", model: "Hayabusa", year: 2005 },
  { make: "Suzuki", model: "Hayabusa", year: 2006 },
  { make: "Suzuki", model: "Hayabusa", year: 2007 },
  { make: "Suzuki", model: "Hayabusa", year: 2008 },
  { make: "Suzuki", model: "Hayabusa", year: 2009 },
  { make: "Suzuki", model: "Hayabusa", year: 2010 },
  { make: "Suzuki", model: "Hayabusa", year: 2011 },
  { make: "Suzuki", model: "Hayabusa", year: 2012 },
  { make: "Suzuki", model: "Hayabusa", year: 2013 },
  { make: "Suzuki", model: "Hayabusa", year: 2014 },
  { make: "Suzuki", model: "Hayabusa", year: 2015 },
  { make: "Suzuki", model: "Hayabusa", year: 2016 },
  { make: "Suzuki", model: "Hayabusa", year: 2017 },
  { make: "Suzuki", model: "Hayabusa", year: 2018 },
  { make: "Suzuki", model: "Hayabusa", year: 2019 },
  { make: "Suzuki", model: "Hayabusa", year: 2020 },
  { make: "Suzuki", model: "Hayabusa", year: 2021 },
  { make: "Suzuki", model: "Hayabusa", year: 2022 },
  { make: "Suzuki", model: "Hayabusa", year: 2023 },
  { make: "Suzuki", model: "Hayabusa", year: 2024 },
  { make: "Suzuki", model: "Hayabusa", year: 2025 },
  { make: "Suzuki", model: "Hayabusa", year: 2026 },
  // Suzuki - Hayabusa 1300 Gen 3
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2022 },
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2023 },
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2024 },
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2025 },
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2026 },
  { make: "Suzuki", model: "Hayabusa 1300 Gen 3", year: 2027 },
  // Suzuki - Katana
  { make: "Suzuki", model: "Katana", year: 1998 },
  { make: "Suzuki", model: "Katana", year: 1999 },
  { make: "Suzuki", model: "Katana", year: 2000 },
  { make: "Suzuki", model: "Katana", year: 2001 },
  { make: "Suzuki", model: "Katana", year: 2002 },
  { make: "Suzuki", model: "Katana", year: 2003 },
  { make: "Suzuki", model: "Katana", year: 2004 },
  { make: "Suzuki", model: "Katana", year: 2005 },
  { make: "Suzuki", model: "Katana", year: 2006 },
  { make: "Suzuki", model: "Katana", year: 2019 },
  { make: "Suzuki", model: "Katana", year: 2020 },
  { make: "Suzuki", model: "Katana", year: 2021 },
  { make: "Suzuki", model: "Katana", year: 2022 },
  { make: "Suzuki", model: "Katana", year: 2023 },
  { make: "Suzuki", model: "Katana", year: 2024 },
  { make: "Suzuki", model: "Katana", year: 2025 },
  { make: "Suzuki", model: "Katana", year: 2026 },
  // Suzuki - Lt R 450 Quadracer
  { make: "Suzuki", model: "Lt R 450 Quadracer", year: 2006 },
  { make: "Suzuki", model: "Lt R 450 Quadracer", year: 2007 },
  { make: "Suzuki", model: "Lt R 450 Quadracer", year: 2008 },
  { make: "Suzuki", model: "Lt R 450 Quadracer", year: 2009 },
  { make: "Suzuki", model: "Lt R 450 Quadracer", year: 2010 },
  // Suzuki - Lt R 450 Quadracer Evo
  { make: "Suzuki", model: "Lt R 450 Quadracer Evo", year: 2006 },
  { make: "Suzuki", model: "Lt R 450 Quadracer Evo", year: 2007 },
  { make: "Suzuki", model: "Lt R 450 Quadracer Evo", year: 2008 },
  { make: "Suzuki", model: "Lt R 450 Quadracer Evo", year: 2009 },
  { make: "Suzuki", model: "Lt R 450 Quadracer Evo", year: 2010 },
  // Suzuki - LT-R450 Quadracer
  { make: "Suzuki", model: "LT-R450 Quadracer", year: 2006 },
  { make: "Suzuki", model: "LT-R450 Quadracer", year: 2007 },
  { make: "Suzuki", model: "LT-R450 Quadracer", year: 2008 },
  { make: "Suzuki", model: "LT-R450 Quadracer", year: 2009 },
  { make: "Suzuki", model: "LT-R450 Quadracer", year: 2010 },
  // Suzuki - LT-R450 Quadracer Evo
  { make: "Suzuki", model: "LT-R450 Quadracer Evo", year: 2006 },
  { make: "Suzuki", model: "LT-R450 Quadracer Evo", year: 2007 },
  { make: "Suzuki", model: "LT-R450 Quadracer Evo", year: 2008 },
  { make: "Suzuki", model: "LT-R450 Quadracer Evo", year: 2009 },
  { make: "Suzuki", model: "LT-R450 Quadracer Evo", year: 2010 },
  // Suzuki - LT80
  { make: "Suzuki", model: "LT80", year: 1987 },
  { make: "Suzuki", model: "LT80", year: 1988 },
  { make: "Suzuki", model: "LT80", year: 1989 },
  { make: "Suzuki", model: "LT80", year: 1990 },
  { make: "Suzuki", model: "LT80", year: 1991 },
  { make: "Suzuki", model: "LT80", year: 1992 },
  { make: "Suzuki", model: "LT80", year: 1993 },
  { make: "Suzuki", model: "LT80", year: 1994 },
  { make: "Suzuki", model: "LT80", year: 1995 },
  { make: "Suzuki", model: "LT80", year: 1996 },
  { make: "Suzuki", model: "LT80", year: 1997 },
  { make: "Suzuki", model: "LT80", year: 1998 },
  { make: "Suzuki", model: "LT80", year: 1999 },
  { make: "Suzuki", model: "LT80", year: 2000 },
  { make: "Suzuki", model: "LT80", year: 2001 },
  { make: "Suzuki", model: "LT80", year: 2002 },
  { make: "Suzuki", model: "LT80", year: 2003 },
  { make: "Suzuki", model: "LT80", year: 2004 },
  { make: "Suzuki", model: "LT80", year: 2005 },
  { make: "Suzuki", model: "LT80", year: 2006 },
  // Suzuki - LT80 QuadSport
  { make: "Suzuki", model: "LT80 QuadSport", year: 1987 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1988 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1989 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1990 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1991 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1992 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1993 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1994 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1995 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1996 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1997 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1998 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 1999 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2000 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2001 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2002 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2003 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2004 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2005 },
  { make: "Suzuki", model: "LT80 QuadSport", year: 2006 },
  // Suzuki - LT250R
  { make: "Suzuki", model: "LT250R", year: 1985 },
  { make: "Suzuki", model: "LT250R", year: 1986 },
  // Suzuki - LT250R QuadRacer
  { make: "Suzuki", model: "LT250R QuadRacer", year: 1985 },
  { make: "Suzuki", model: "LT250R QuadRacer", year: 1986 },
  // Suzuki - LTZ400
  { make: "Suzuki", model: "LTZ400", year: 2003 },
  { make: "Suzuki", model: "LTZ400", year: 2004 },
  { make: "Suzuki", model: "LTZ400", year: 2005 },
  { make: "Suzuki", model: "LTZ400", year: 2006 },
  { make: "Suzuki", model: "LTZ400", year: 2007 },
  { make: "Suzuki", model: "LTZ400", year: 2008 },
  { make: "Suzuki", model: "LTZ400", year: 2009 },
  { make: "Suzuki", model: "LTZ400", year: 2010 },
  { make: "Suzuki", model: "LTZ400", year: 2011 },
  { make: "Suzuki", model: "LTZ400", year: 2012 },
  { make: "Suzuki", model: "LTZ400", year: 2013 },
  { make: "Suzuki", model: "LTZ400", year: 2014 },
  // Suzuki - M109R
  { make: "Suzuki", model: "M109R", year: 2006 },
  { make: "Suzuki", model: "M109R", year: 2007 },
  { make: "Suzuki", model: "M109R", year: 2008 },
  { make: "Suzuki", model: "M109R", year: 2009 },
  { make: "Suzuki", model: "M109R", year: 2010 },
  { make: "Suzuki", model: "M109R", year: 2011 },
  { make: "Suzuki", model: "M109R", year: 2012 },
  { make: "Suzuki", model: "M109R", year: 2013 },
  { make: "Suzuki", model: "M109R", year: 2014 },
  { make: "Suzuki", model: "M109R", year: 2015 },
  { make: "Suzuki", model: "M109R", year: 2016 },
  { make: "Suzuki", model: "M109R", year: 2017 },
  { make: "Suzuki", model: "M109R", year: 2018 },
  { make: "Suzuki", model: "M109R", year: 2019 },
  { make: "Suzuki", model: "M109R", year: 2020 },
  { make: "Suzuki", model: "M109R", year: 2021 },
  { make: "Suzuki", model: "M109R", year: 2022 },
  { make: "Suzuki", model: "M109R", year: 2023 },
  { make: "Suzuki", model: "M109R", year: 2024 },
  { make: "Suzuki", model: "M109R", year: 2025 },
  { make: "Suzuki", model: "M109R", year: 2026 },
  { make: "Suzuki", model: "M109R", year: 2027 },
  // Suzuki - RM Z 250
  { make: "Suzuki", model: "RM Z 250", year: 2007 },
  { make: "Suzuki", model: "RM Z 250", year: 2008 },
  { make: "Suzuki", model: "RM Z 250", year: 2009 },
  { make: "Suzuki", model: "RM Z 250", year: 2011 },
  { make: "Suzuki", model: "RM Z 250", year: 2012 },
  { make: "Suzuki", model: "RM Z 250", year: 2013 },
  { make: "Suzuki", model: "RM Z 250", year: 2014 },
  { make: "Suzuki", model: "RM Z 250", year: 2015 },
  { make: "Suzuki", model: "RM Z 250", year: 2016 },
  // Suzuki - RM Z 450
  { make: "Suzuki", model: "RM Z 450", year: 2008 },
  { make: "Suzuki", model: "RM Z 450", year: 2009 },
  { make: "Suzuki", model: "RM Z 450", year: 2010 },
  { make: "Suzuki", model: "RM Z 450", year: 2011 },
  { make: "Suzuki", model: "RM Z 450", year: 2012 },
  { make: "Suzuki", model: "RM Z 450", year: 2013 },
  { make: "Suzuki", model: "RM Z 450", year: 2014 },
  { make: "Suzuki", model: "RM Z 450", year: 2015 },
  { make: "Suzuki", model: "RM Z 450", year: 2016 },
  // Suzuki - RM-Z250
  { make: "Suzuki", model: "RM-Z250", year: 2004 },
  { make: "Suzuki", model: "RM-Z250", year: 2005 },
  { make: "Suzuki", model: "RM-Z250", year: 2006 },
  { make: "Suzuki", model: "RM-Z250", year: 2007 },
  { make: "Suzuki", model: "RM-Z250", year: 2008 },
  { make: "Suzuki", model: "RM-Z250", year: 2009 },
  { make: "Suzuki", model: "RM-Z250", year: 2010 },
  { make: "Suzuki", model: "RM-Z250", year: 2011 },
  { make: "Suzuki", model: "RM-Z250", year: 2012 },
  { make: "Suzuki", model: "RM-Z250", year: 2013 },
  { make: "Suzuki", model: "RM-Z250", year: 2014 },
  { make: "Suzuki", model: "RM-Z250", year: 2015 },
  { make: "Suzuki", model: "RM-Z250", year: 2016 },
  { make: "Suzuki", model: "RM-Z250", year: 2017 },
  { make: "Suzuki", model: "RM-Z250", year: 2018 },
  { make: "Suzuki", model: "RM-Z250", year: 2019 },
  { make: "Suzuki", model: "RM-Z250", year: 2020 },
  { make: "Suzuki", model: "RM-Z250", year: 2021 },
  { make: "Suzuki", model: "RM-Z250", year: 2022 },
  { make: "Suzuki", model: "RM-Z250", year: 2023 },
  { make: "Suzuki", model: "RM-Z250", year: 2024 },
  { make: "Suzuki", model: "RM-Z250", year: 2025 },
  { make: "Suzuki", model: "RM-Z250", year: 2026 },
  // Suzuki - RM-Z450
  { make: "Suzuki", model: "RM-Z450", year: 2005 },
  { make: "Suzuki", model: "RM-Z450", year: 2006 },
  { make: "Suzuki", model: "RM-Z450", year: 2007 },
  { make: "Suzuki", model: "RM-Z450", year: 2008 },
  { make: "Suzuki", model: "RM-Z450", year: 2009 },
  { make: "Suzuki", model: "RM-Z450", year: 2010 },
  { make: "Suzuki", model: "RM-Z450", year: 2011 },
  { make: "Suzuki", model: "RM-Z450", year: 2012 },
  { make: "Suzuki", model: "RM-Z450", year: 2013 },
  { make: "Suzuki", model: "RM-Z450", year: 2014 },
  { make: "Suzuki", model: "RM-Z450", year: 2015 },
  { make: "Suzuki", model: "RM-Z450", year: 2016 },
  { make: "Suzuki", model: "RM-Z450", year: 2017 },
  { make: "Suzuki", model: "RM-Z450", year: 2018 },
  { make: "Suzuki", model: "RM-Z450", year: 2019 },
  { make: "Suzuki", model: "RM-Z450", year: 2020 },
  { make: "Suzuki", model: "RM-Z450", year: 2021 },
  { make: "Suzuki", model: "RM-Z450", year: 2022 },
  { make: "Suzuki", model: "RM-Z450", year: 2023 },
  { make: "Suzuki", model: "RM-Z450", year: 2024 },
  { make: "Suzuki", model: "RM-Z450", year: 2025 },
  { make: "Suzuki", model: "RM-Z450", year: 2026 },
  // Suzuki - RM65
  { make: "Suzuki", model: "RM65", year: 2003 },
  { make: "Suzuki", model: "RM65", year: 2004 },
  { make: "Suzuki", model: "RM65", year: 2005 },
  // Suzuki - RM80
  { make: "Suzuki", model: "RM80", year: 1989 },
  { make: "Suzuki", model: "RM80", year: 1990 },
  { make: "Suzuki", model: "RM80", year: 1991 },
  { make: "Suzuki", model: "RM80", year: 1992 },
  { make: "Suzuki", model: "RM80", year: 1993 },
  { make: "Suzuki", model: "RM80", year: 1994 },
  { make: "Suzuki", model: "RM80", year: 1995 },
  { make: "Suzuki", model: "RM80", year: 1996 },
  { make: "Suzuki", model: "RM80", year: 1997 },
  { make: "Suzuki", model: "RM80", year: 1998 },
  { make: "Suzuki", model: "RM80", year: 1999 },
  { make: "Suzuki", model: "RM80", year: 2000 },
  { make: "Suzuki", model: "RM80", year: 2001 },
  // Suzuki - RM85
  { make: "Suzuki", model: "RM85", year: 2002 },
  { make: "Suzuki", model: "RM85", year: 2003 },
  { make: "Suzuki", model: "RM85", year: 2004 },
  { make: "Suzuki", model: "RM85", year: 2005 },
  { make: "Suzuki", model: "RM85", year: 2006 },
  { make: "Suzuki", model: "RM85", year: 2007 },
  { make: "Suzuki", model: "RM85", year: 2008 },
  { make: "Suzuki", model: "RM85", year: 2009 },
  { make: "Suzuki", model: "RM85", year: 2010 },
  { make: "Suzuki", model: "RM85", year: 2011 },
  { make: "Suzuki", model: "RM85", year: 2012 },
  { make: "Suzuki", model: "RM85", year: 2013 },
  { make: "Suzuki", model: "RM85", year: 2014 },
  { make: "Suzuki", model: "RM85", year: 2015 },
  { make: "Suzuki", model: "RM85", year: 2016 },
  { make: "Suzuki", model: "RM85", year: 2017 },
  { make: "Suzuki", model: "RM85", year: 2018 },
  { make: "Suzuki", model: "RM85", year: 2019 },
  { make: "Suzuki", model: "RM85", year: 2020 },
  { make: "Suzuki", model: "RM85", year: 2021 },
  { make: "Suzuki", model: "RM85", year: 2022 },
  { make: "Suzuki", model: "RM85", year: 2023 },
  { make: "Suzuki", model: "RM85", year: 2024 },
  { make: "Suzuki", model: "RM85", year: 2025 },
  { make: "Suzuki", model: "RM85", year: 2026 },
  // Suzuki - RM100
  { make: "Suzuki", model: "RM100", year: 2003 },
  { make: "Suzuki", model: "RM100", year: 2004 },
  // Suzuki - RM125
  { make: "Suzuki", model: "RM125", year: 1996 },
  { make: "Suzuki", model: "RM125", year: 1997 },
  { make: "Suzuki", model: "RM125", year: 1998 },
  { make: "Suzuki", model: "RM125", year: 1999 },
  { make: "Suzuki", model: "RM125", year: 2000 },
  { make: "Suzuki", model: "RM125", year: 2001 },
  { make: "Suzuki", model: "RM125", year: 2002 },
  { make: "Suzuki", model: "RM125", year: 2003 },
  { make: "Suzuki", model: "RM125", year: 2004 },
  { make: "Suzuki", model: "RM125", year: 2005 },
  { make: "Suzuki", model: "RM125", year: 2006 },
  { make: "Suzuki", model: "RM125", year: 2007 },
  // Suzuki - RM250
  { make: "Suzuki", model: "RM250", year: 1996 },
  { make: "Suzuki", model: "RM250", year: 1997 },
  { make: "Suzuki", model: "RM250", year: 1998 },
  { make: "Suzuki", model: "RM250", year: 1999 },
  { make: "Suzuki", model: "RM250", year: 2000 },
  { make: "Suzuki", model: "RM250", year: 2001 },
  { make: "Suzuki", model: "RM250", year: 2002 },
  { make: "Suzuki", model: "RM250", year: 2003 },
  { make: "Suzuki", model: "RM250", year: 2004 },
  { make: "Suzuki", model: "RM250", year: 2005 },
  { make: "Suzuki", model: "RM250", year: 2006 },
  { make: "Suzuki", model: "RM250", year: 2007 },
  { make: "Suzuki", model: "RM250", year: 2008 },
  // Suzuki - RMZ250
  { make: "Suzuki", model: "RMZ250", year: 2004 },
  { make: "Suzuki", model: "RMZ250", year: 2005 },
  { make: "Suzuki", model: "RMZ250", year: 2006 },
  { make: "Suzuki", model: "RMZ250", year: 2019 },
  { make: "Suzuki", model: "RMZ250", year: 2020 },
  { make: "Suzuki", model: "RMZ250", year: 2021 },
  { make: "Suzuki", model: "RMZ250", year: 2022 },
  { make: "Suzuki", model: "RMZ250", year: 2023 },
  { make: "Suzuki", model: "RMZ250", year: 2024 },
  { make: "Suzuki", model: "RMZ250", year: 2025 },
  { make: "Suzuki", model: "RMZ250", year: 2026 },
  // Suzuki - RMZ450
  { make: "Suzuki", model: "RMZ450", year: 2018 },
  { make: "Suzuki", model: "RMZ450", year: 2019 },
  { make: "Suzuki", model: "RMZ450", year: 2020 },
  { make: "Suzuki", model: "RMZ450", year: 2021 },
  { make: "Suzuki", model: "RMZ450", year: 2022 },
  { make: "Suzuki", model: "RMZ450", year: 2023 },
  { make: "Suzuki", model: "RMZ450", year: 2024 },
  { make: "Suzuki", model: "RMZ450", year: 2025 },
  { make: "Suzuki", model: "RMZ450", year: 2026 },
  // Suzuki - SV-650
  { make: "Suzuki", model: "SV-650", year: 1999 },
  { make: "Suzuki", model: "SV-650", year: 2000 },
  { make: "Suzuki", model: "SV-650", year: 2001 },
  { make: "Suzuki", model: "SV-650", year: 2002 },
  { make: "Suzuki", model: "SV-650", year: 2003 },
  { make: "Suzuki", model: "SV-650", year: 2004 },
  { make: "Suzuki", model: "SV-650", year: 2005 },
  { make: "Suzuki", model: "SV-650", year: 2006 },
  { make: "Suzuki", model: "SV-650", year: 2007 },
  { make: "Suzuki", model: "SV-650", year: 2008 },
  { make: "Suzuki", model: "SV-650", year: 2009 },
  { make: "Suzuki", model: "SV-650", year: 2010 },
  { make: "Suzuki", model: "SV-650", year: 2011 },
  { make: "Suzuki", model: "SV-650", year: 2012 },
  { make: "Suzuki", model: "SV-650", year: 2013 },
  { make: "Suzuki", model: "SV-650", year: 2016 },
  { make: "Suzuki", model: "SV-650", year: 2017 },
  { make: "Suzuki", model: "SV-650", year: 2018 },
  { make: "Suzuki", model: "SV-650", year: 2019 },
  { make: "Suzuki", model: "SV-650", year: 2020 },
  { make: "Suzuki", model: "SV-650", year: 2021 },
  // Suzuki - SV650
  { make: "Suzuki", model: "SV650", year: 1999 },
  { make: "Suzuki", model: "SV650", year: 2000 },
  { make: "Suzuki", model: "SV650", year: 2001 },
  { make: "Suzuki", model: "SV650", year: 2002 },
  { make: "Suzuki", model: "SV650", year: 2003 },
  { make: "Suzuki", model: "SV650", year: 2004 },
  { make: "Suzuki", model: "SV650", year: 2005 },
  { make: "Suzuki", model: "SV650", year: 2006 },
  { make: "Suzuki", model: "SV650", year: 2007 },
  { make: "Suzuki", model: "SV650", year: 2008 },
  { make: "Suzuki", model: "SV650", year: 2009 },
  { make: "Suzuki", model: "SV650", year: 2010 },
  { make: "Suzuki", model: "SV650", year: 2011 },
  { make: "Suzuki", model: "SV650", year: 2012 },
  { make: "Suzuki", model: "SV650", year: 2013 },
  { make: "Suzuki", model: "SV650", year: 2014 },
  { make: "Suzuki", model: "SV650", year: 2015 },
  { make: "Suzuki", model: "SV650", year: 2016 },
  { make: "Suzuki", model: "SV650", year: 2017 },
  { make: "Suzuki", model: "SV650", year: 2018 },
  { make: "Suzuki", model: "SV650", year: 2019 },
  { make: "Suzuki", model: "SV650", year: 2020 },
  { make: "Suzuki", model: "SV650", year: 2021 },
  { make: "Suzuki", model: "SV650", year: 2022 },
  { make: "Suzuki", model: "SV650", year: 2023 },
  { make: "Suzuki", model: "SV650", year: 2024 },
  { make: "Suzuki", model: "SV650", year: 2025 },
  { make: "Suzuki", model: "SV650", year: 2026 },
  // Suzuki - SV650 SV650X
  { make: "Suzuki", model: "SV650 SV650X", year: 2017 },
  // Suzuki - V Strom 800 De
  { make: "Suzuki", model: "V Strom 800 De", year: 2023 },
  { make: "Suzuki", model: "V Strom 800 De", year: 2024 },
  { make: "Suzuki", model: "V Strom 800 De", year: 2025 },
  // Suzuki - V Strom 800DE E5
  { make: "Suzuki", model: "V Strom 800DE E5", year: 2025 },
  // Suzuki - V Strom 1000
  { make: "Suzuki", model: "V Strom 1000", year: 2017 },
  { make: "Suzuki", model: "V Strom 1000", year: 2018 },
  { make: "Suzuki", model: "V Strom 1000", year: 2019 },
  { make: "Suzuki", model: "V Strom 1000", year: 2020 },
  { make: "Suzuki", model: "V Strom 1000", year: 2021 },
  { make: "Suzuki", model: "V Strom 1000", year: 2022 },
  { make: "Suzuki", model: "V Strom 1000", year: 2023 },
  { make: "Suzuki", model: "V Strom 1000", year: 2024 },
  { make: "Suzuki", model: "V Strom 1000", year: 2025 },
  // Suzuki - V Strom 1000 V Strom 1000XT Euro
  { make: "Suzuki", model: "V Strom 1000 V Strom 1000XT Euro", year: 2017 },
  // Suzuki - V Strom 1050 15303B
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2020 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2021 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2022 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2023 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2024 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2025 },
  { make: "Suzuki", model: "V Strom 1050 15303B", year: 2026 },
  // Suzuki - V Strom 1050 15315BU
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2020 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2021 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2022 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2023 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2024 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2025 },
  { make: "Suzuki", model: "V Strom 1050 15315BU", year: 2026 },
  // Suzuki - V Strom 1050 15315U
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2020 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2021 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2022 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2023 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2024 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2025 },
  { make: "Suzuki", model: "V Strom 1050 15315U", year: 2026 },
  // Suzuki - V-Strom 650
  { make: "Suzuki", model: "V-Strom 650", year: 2004 },
  { make: "Suzuki", model: "V-Strom 650", year: 2005 },
  { make: "Suzuki", model: "V-Strom 650", year: 2006 },
  { make: "Suzuki", model: "V-Strom 650", year: 2007 },
  { make: "Suzuki", model: "V-Strom 650", year: 2008 },
  { make: "Suzuki", model: "V-Strom 650", year: 2009 },
  { make: "Suzuki", model: "V-Strom 650", year: 2010 },
  { make: "Suzuki", model: "V-Strom 650", year: 2011 },
  { make: "Suzuki", model: "V-Strom 650", year: 2012 },
  { make: "Suzuki", model: "V-Strom 650", year: 2013 },
  { make: "Suzuki", model: "V-Strom 650", year: 2014 },
  { make: "Suzuki", model: "V-Strom 650", year: 2015 },
  { make: "Suzuki", model: "V-Strom 650", year: 2016 },
  { make: "Suzuki", model: "V-Strom 650", year: 2017 },
  { make: "Suzuki", model: "V-Strom 650", year: 2018 },
  { make: "Suzuki", model: "V-Strom 650", year: 2019 },
  { make: "Suzuki", model: "V-Strom 650", year: 2020 },
  { make: "Suzuki", model: "V-Strom 650", year: 2021 },
  { make: "Suzuki", model: "V-Strom 650", year: 2022 },
  { make: "Suzuki", model: "V-Strom 650", year: 2023 },
  { make: "Suzuki", model: "V-Strom 650", year: 2024 },
  { make: "Suzuki", model: "V-Strom 650", year: 2025 },
  { make: "Suzuki", model: "V-Strom 650", year: 2026 },
  // Suzuki - V-Strom 800DE
  { make: "Suzuki", model: "V-Strom 800DE", year: 2023 },
  { make: "Suzuki", model: "V-Strom 800DE", year: 2024 },
  { make: "Suzuki", model: "V-Strom 800DE", year: 2025 },
  { make: "Suzuki", model: "V-Strom 800DE", year: 2026 },
  // Suzuki - V-Strom 1050
  { make: "Suzuki", model: "V-Strom 1050", year: 2020 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2021 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2022 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2023 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2024 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2025 },
  { make: "Suzuki", model: "V-Strom 1050", year: 2026 },
  // Suzuki - Z90 Quadsport
  { make: "Suzuki", model: "Z90 Quadsport", year: 2008 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2009 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2010 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2011 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2012 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2013 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2014 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2015 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2016 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2017 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2018 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2019 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2020 },
  { make: "Suzuki", model: "Z90 Quadsport", year: 2021 },
  // Triumph
  // Triumph - 675 Daytona
  { make: "Triumph", model: "675 Daytona", year: 2006 },
  { make: "Triumph", model: "675 Daytona", year: 2007 },
  { make: "Triumph", model: "675 Daytona", year: 2008 },
  { make: "Triumph", model: "675 Daytona", year: 2009 },
  { make: "Triumph", model: "675 Daytona", year: 2010 },
  { make: "Triumph", model: "675 Daytona", year: 2011 },
  { make: "Triumph", model: "675 Daytona", year: 2012 },
  { make: "Triumph", model: "675 Daytona", year: 2013 },
  { make: "Triumph", model: "675 Daytona", year: 2014 },
  { make: "Triumph", model: "675 Daytona", year: 2015 },
  { make: "Triumph", model: "675 Daytona", year: 2016 },
  { make: "Triumph", model: "675 Daytona", year: 2017 },
  // Triumph - 765 Daytona 675
  { make: "Triumph", model: "765 Daytona 675", year: 2013 },
  { make: "Triumph", model: "765 Daytona 675", year: 2014 },
  { make: "Triumph", model: "765 Daytona 675", year: 2015 },
  { make: "Triumph", model: "765 Daytona 675", year: 2016 },
  { make: "Triumph", model: "765 Daytona 675", year: 2017 },
  { make: "Triumph", model: "765 Daytona 675", year: 2018 },
  { make: "Triumph", model: "765 Daytona 675", year: 2019 },
  { make: "Triumph", model: "765 Daytona 675", year: 2020 },
  { make: "Triumph", model: "765 Daytona 675", year: 2021 },
  { make: "Triumph", model: "765 Daytona 675", year: 2022 },
  { make: "Triumph", model: "765 Daytona 675", year: 2023 },
  { make: "Triumph", model: "765 Daytona 675", year: 2024 },
  { make: "Triumph", model: "765 Daytona 675", year: 2025 },
  { make: "Triumph", model: "765 Daytona 675", year: 2026 },
  { make: "Triumph", model: "765 Daytona 675", year: 2027 },
  // Triumph - 800 Tiger XC
  { make: "Triumph", model: "800 Tiger XC", year: 2011 },
  { make: "Triumph", model: "800 Tiger XC", year: 2012 },
  { make: "Triumph", model: "800 Tiger XC", year: 2013 },
  { make: "Triumph", model: "800 Tiger XC", year: 2014 },
  { make: "Triumph", model: "800 Tiger XC", year: 2015 },
  { make: "Triumph", model: "800 Tiger XC", year: 2016 },
  // Triumph - 865 Thruxton
  { make: "Triumph", model: "865 Thruxton", year: 2007 },
  { make: "Triumph", model: "865 Thruxton", year: 2008 },
  { make: "Triumph", model: "865 Thruxton", year: 2009 },
  { make: "Triumph", model: "865 Thruxton", year: 2010 },
  { make: "Triumph", model: "865 Thruxton", year: 2011 },
  { make: "Triumph", model: "865 Thruxton", year: 2012 },
  { make: "Triumph", model: "865 Thruxton", year: 2013 },
  { make: "Triumph", model: "865 Thruxton", year: 2014 },
  { make: "Triumph", model: "865 Thruxton", year: 2015 },
  // Triumph - 1050 Tiger
  { make: "Triumph", model: "1050 Tiger", year: 2007 },
  { make: "Triumph", model: "1050 Tiger", year: 2008 },
  { make: "Triumph", model: "1050 Tiger", year: 2009 },
  { make: "Triumph", model: "1050 Tiger", year: 2010 },
  { make: "Triumph", model: "1050 Tiger", year: 2011 },
  { make: "Triumph", model: "1050 Tiger", year: 2012 },
  { make: "Triumph", model: "1050 Tiger", year: 2013 },
  { make: "Triumph", model: "1050 Tiger", year: 2014 },
  // Triumph - Bobber Side Mount License Plate 2
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2017 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2018 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2019 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2020 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2021 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2022 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2023 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2024 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2025 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2026 },
  { make: "Triumph", model: "Bobber Side Mount License Plate 2", year: 2027 },
  // Triumph - Bonneville Bobber Euro 4 Custom
  { make: "Triumph", model: "Bonneville Bobber Euro 4 Custom", year: 2017 },
  // Triumph - Bonneville T 120 Bonneville Euro
  { make: "Triumph", model: "Bonneville T 120 Bonneville Euro", year: 2018 },
  // Triumph - Bonneville T100
  { make: "Triumph", model: "Bonneville T100", year: 2016 },
  { make: "Triumph", model: "Bonneville T100", year: 2017 },
  { make: "Triumph", model: "Bonneville T100", year: 2018 },
  { make: "Triumph", model: "Bonneville T100", year: 2019 },
  { make: "Triumph", model: "Bonneville T100", year: 2020 },
  // Triumph - Bonneville T120
  { make: "Triumph", model: "Bonneville T120", year: 2016 },
  { make: "Triumph", model: "Bonneville T120", year: 2017 },
  { make: "Triumph", model: "Bonneville T120", year: 2018 },
  { make: "Triumph", model: "Bonneville T120", year: 2019 },
  { make: "Triumph", model: "Bonneville T120", year: 2020 },
  // Triumph - Bonneville T120 Black
  { make: "Triumph", model: "Bonneville T120 Black", year: 2016 },
  { make: "Triumph", model: "Bonneville T120 Black", year: 2017 },
  { make: "Triumph", model: "Bonneville T120 Black", year: 2018 },
  { make: "Triumph", model: "Bonneville T120 Black", year: 2019 },
  { make: "Triumph", model: "Bonneville T120 Black", year: 2020 },
  // Triumph - Daytona 660
  { make: "Triumph", model: "Daytona 660", year: 2024 },
  { make: "Triumph", model: "Daytona 660", year: 2025 },
  { make: "Triumph", model: "Daytona 660", year: 2026 },
  // Triumph - Daytona 675
  { make: "Triumph", model: "Daytona 675", year: 2006 },
  { make: "Triumph", model: "Daytona 675", year: 2007 },
  { make: "Triumph", model: "Daytona 675", year: 2008 },
  { make: "Triumph", model: "Daytona 675", year: 2009 },
  { make: "Triumph", model: "Daytona 675", year: 2010 },
  { make: "Triumph", model: "Daytona 675", year: 2013 },
  { make: "Triumph", model: "Daytona 675", year: 2014 },
  { make: "Triumph", model: "Daytona 675", year: 2015 },
  { make: "Triumph", model: "Daytona 675", year: 2016 },
  { make: "Triumph", model: "Daytona 675", year: 2017 },
  { make: "Triumph", model: "Daytona 675", year: 2018 },
  { make: "Triumph", model: "Daytona 675", year: 2019 },
  { make: "Triumph", model: "Daytona 675", year: 2020 },
  { make: "Triumph", model: "Daytona 675", year: 2021 },
  { make: "Triumph", model: "Daytona 675", year: 2022 },
  { make: "Triumph", model: "Daytona 675", year: 2023 },
  { make: "Triumph", model: "Daytona 675", year: 2024 },
  { make: "Triumph", model: "Daytona 675", year: 2025 },
  { make: "Triumph", model: "Daytona 675", year: 2026 },
  { make: "Triumph", model: "Daytona 675", year: 2027 },
  // Triumph - Daytona 675 Street
  { make: "Triumph", model: "Daytona 675 Street", year: 2007 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2008 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2009 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2010 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2011 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2012 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2013 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2014 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2015 },
  { make: "Triumph", model: "Daytona 675 Street", year: 2016 },
  // Triumph - Daytona 675R
  { make: "Triumph", model: "Daytona 675R", year: 2011 },
  { make: "Triumph", model: "Daytona 675R", year: 2012 },
  // Triumph - Daytona 765 Moto2
  { make: "Triumph", model: "Daytona 765 Moto2", year: 2020 },
  // Triumph - Daytona 765 Moto2 Grid O
  { make: "Triumph", model: "Daytona 765 Moto2 Grid O", year: 2020 },
  // Triumph - Scrambler
  { make: "Triumph", model: "Scrambler", year: 2006 },
  { make: "Triumph", model: "Scrambler", year: 2007 },
  { make: "Triumph", model: "Scrambler", year: 2008 },
  { make: "Triumph", model: "Scrambler", year: 2009 },
  { make: "Triumph", model: "Scrambler", year: 2010 },
  { make: "Triumph", model: "Scrambler", year: 2011 },
  { make: "Triumph", model: "Scrambler", year: 2012 },
  { make: "Triumph", model: "Scrambler", year: 2013 },
  { make: "Triumph", model: "Scrambler", year: 2014 },
  { make: "Triumph", model: "Scrambler", year: 2015 },
  { make: "Triumph", model: "Scrambler", year: 2016 },
  // Triumph - Scrambler 1200 XC
  { make: "Triumph", model: "Scrambler 1200 XC", year: 2019 },
  { make: "Triumph", model: "Scrambler 1200 XC", year: 2020 },
  // Triumph - Scrambler 1200 XE
  { make: "Triumph", model: "Scrambler 1200 XE", year: 2019 },
  { make: "Triumph", model: "Scrambler 1200 XE", year: 2020 },
  // Triumph - Speed 400/Scrambler 400 X
  { make: "Triumph", model: "Speed 400/Scrambler 400 X", year: 2024 },
  { make: "Triumph", model: "Speed 400/Scrambler 400 X", year: 2025 },
  { make: "Triumph", model: "Speed 400/Scrambler 400 X", year: 2026 },
  // Triumph - Speed Triple 1200 RR/RS
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2021 },
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2022 },
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2023 },
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2024 },
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2025 },
  { make: "Triumph", model: "Speed Triple 1200 RR/RS", year: 2026 },
  // Triumph - Speed Triple 1200 RS
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2021 },
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2022 },
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2023 },
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2024 },
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2025 },
  { make: "Triumph", model: "Speed Triple 1200 RS", year: 2026 },
  // Triumph - Speed Twin 1200
  { make: "Triumph", model: "Speed Twin 1200", year: 2016 },
  { make: "Triumph", model: "Speed Twin 1200", year: 2017 },
  { make: "Triumph", model: "Speed Twin 1200", year: 2018 },
  { make: "Triumph", model: "Speed Twin 1200", year: 2019 },
  { make: "Triumph", model: "Speed Twin 1200", year: 2020 },
  // Triumph - Street Triple 765
  { make: "Triumph", model: "Street Triple 765", year: 2017 },
  { make: "Triumph", model: "Street Triple 765", year: 2018 },
  { make: "Triumph", model: "Street Triple 765", year: 2019 },
  { make: "Triumph", model: "Street Triple 765", year: 2020 },
  { make: "Triumph", model: "Street Triple 765", year: 2021 },
  { make: "Triumph", model: "Street Triple 765", year: 2022 },
  { make: "Triumph", model: "Street Triple 765", year: 2023 },
  { make: "Triumph", model: "Street Triple 765", year: 2024 },
  { make: "Triumph", model: "Street Triple 765", year: 2025 },
  { make: "Triumph", model: "Street Triple 765", year: 2026 },
  // Triumph - Street Twin
  { make: "Triumph", model: "Street Twin", year: 2016 },
  { make: "Triumph", model: "Street Twin", year: 2017 },
  { make: "Triumph", model: "Street Twin", year: 2018 },
  { make: "Triumph", model: "Street Twin", year: 2019 },
  { make: "Triumph", model: "Street Twin", year: 2020 },
  // Triumph - TF-250 C
  { make: "Triumph", model: "TF-250 C", year: 2026 },
  // Triumph - TF-250 E
  { make: "Triumph", model: "TF-250 E", year: 2026 },
  // Triumph - TF-250 X
  { make: "Triumph", model: "TF-250 X", year: 2024 },
  { make: "Triumph", model: "TF-250 X", year: 2025 },
  { make: "Triumph", model: "TF-250 X", year: 2026 },
  // Triumph - Thruxton
  { make: "Triumph", model: "Thruxton", year: 2016 },
  { make: "Triumph", model: "Thruxton", year: 2017 },
  { make: "Triumph", model: "Thruxton", year: 2018 },
  { make: "Triumph", model: "Thruxton", year: 2019 },
  { make: "Triumph", model: "Thruxton", year: 2020 },
  { make: "Triumph", model: "Thruxton", year: 2021 },
  { make: "Triumph", model: "Thruxton", year: 2022 },
  { make: "Triumph", model: "Thruxton", year: 2023 },
  { make: "Triumph", model: "Thruxton", year: 2024 },
  { make: "Triumph", model: "Thruxton", year: 2025 },
  { make: "Triumph", model: "Thruxton", year: 2026 },
  { make: "Triumph", model: "Thruxton", year: 2027 },
  // Triumph - Thruxton 900
  { make: "Triumph", model: "Thruxton 900", year: 2004 },
  { make: "Triumph", model: "Thruxton 900", year: 2005 },
  { make: "Triumph", model: "Thruxton 900", year: 2006 },
  { make: "Triumph", model: "Thruxton 900", year: 2007 },
  { make: "Triumph", model: "Thruxton 900", year: 2008 },
  { make: "Triumph", model: "Thruxton 900", year: 2009 },
  { make: "Triumph", model: "Thruxton 900", year: 2010 },
  { make: "Triumph", model: "Thruxton 900", year: 2011 },
  { make: "Triumph", model: "Thruxton 900", year: 2012 },
  { make: "Triumph", model: "Thruxton 900", year: 2013 },
  { make: "Triumph", model: "Thruxton 900", year: 2014 },
  { make: "Triumph", model: "Thruxton 900", year: 2015 },
  // Triumph - Thruxton 1200
  { make: "Triumph", model: "Thruxton 1200", year: 2016 },
  { make: "Triumph", model: "Thruxton 1200", year: 2017 },
  { make: "Triumph", model: "Thruxton 1200", year: 2018 },
  { make: "Triumph", model: "Thruxton 1200", year: 2019 },
  { make: "Triumph", model: "Thruxton 1200", year: 2020 },
  // Triumph - Thruxton 1200 Euro 4 Tapered
  { make: "Triumph", model: "Thruxton 1200 Euro 4 Tapered", year: 2016 },
  // Triumph - Tiger 660
  { make: "Triumph", model: "Tiger 660", year: 2022 },
  { make: "Triumph", model: "Tiger 660", year: 2023 },
  { make: "Triumph", model: "Tiger 660", year: 2024 },
  // Triumph - Tiger 800
  { make: "Triumph", model: "Tiger 800", year: 2011 },
  { make: "Triumph", model: "Tiger 800", year: 2012 },
  { make: "Triumph", model: "Tiger 800", year: 2013 },
  { make: "Triumph", model: "Tiger 800", year: 2014 },
  { make: "Triumph", model: "Tiger 800", year: 2015 },
  { make: "Triumph", model: "Tiger 800", year: 2016 },
  // Triumph - Tiger 800 E5
  { make: "Triumph", model: "Tiger 800 E5", year: 2025 },
  // Triumph - Tiger 800 XC
  { make: "Triumph", model: "Tiger 800 XC", year: 2011 },
  { make: "Triumph", model: "Tiger 800 XC", year: 2012 },
  { make: "Triumph", model: "Tiger 800 XC", year: 2013 },
  { make: "Triumph", model: "Tiger 800 XC", year: 2014 },
  { make: "Triumph", model: "Tiger 800 XC", year: 2015 },
  { make: "Triumph", model: "Tiger 800 XC", year: 2016 },
  // Triumph - Tiger 800 XCA
  { make: "Triumph", model: "Tiger 800 XCA", year: 2011 },
  { make: "Triumph", model: "Tiger 800 XCA", year: 2012 },
  { make: "Triumph", model: "Tiger 800 XCA", year: 2013 },
  { make: "Triumph", model: "Tiger 800 XCA", year: 2014 },
  { make: "Triumph", model: "Tiger 800 XCA", year: 2015 },
  { make: "Triumph", model: "Tiger 800 XCA", year: 2016 },
  // Triumph - Tiger 800 XCX
  { make: "Triumph", model: "Tiger 800 XCX", year: 2011 },
  { make: "Triumph", model: "Tiger 800 XCX", year: 2012 },
  { make: "Triumph", model: "Tiger 800 XCX", year: 2013 },
  { make: "Triumph", model: "Tiger 800 XCX", year: 2014 },
  { make: "Triumph", model: "Tiger 800 XCX", year: 2015 },
  { make: "Triumph", model: "Tiger 800 XCX", year: 2016 },
  // Triumph - Tiger 800 XR
  { make: "Triumph", model: "Tiger 800 XR", year: 2011 },
  { make: "Triumph", model: "Tiger 800 XR", year: 2012 },
  { make: "Triumph", model: "Tiger 800 XR", year: 2013 },
  { make: "Triumph", model: "Tiger 800 XR", year: 2014 },
  { make: "Triumph", model: "Tiger 800 XR", year: 2015 },
  { make: "Triumph", model: "Tiger 800 XR", year: 2016 },
  // Triumph - Tiger 800 XRX
  { make: "Triumph", model: "Tiger 800 XRX", year: 2011 },
  { make: "Triumph", model: "Tiger 800 XRX", year: 2012 },
  { make: "Triumph", model: "Tiger 800 XRX", year: 2013 },
  { make: "Triumph", model: "Tiger 800 XRX", year: 2014 },
  { make: "Triumph", model: "Tiger 800 XRX", year: 2015 },
  { make: "Triumph", model: "Tiger 800 XRX", year: 2016 },
  // Triumph - Tiger 850
  { make: "Triumph", model: "Tiger 850", year: 2020 },
  { make: "Triumph", model: "Tiger 850", year: 2021 },
  { make: "Triumph", model: "Tiger 850", year: 2022 },
  { make: "Triumph", model: "Tiger 850", year: 2023 },
  { make: "Triumph", model: "Tiger 850", year: 2024 },
  // Triumph - Tiger 900
  { make: "Triumph", model: "Tiger 900", year: 2020 },
  { make: "Triumph", model: "Tiger 900", year: 2021 },
  { make: "Triumph", model: "Tiger 900", year: 2022 },
  { make: "Triumph", model: "Tiger 900", year: 2023 },
  { make: "Triumph", model: "Tiger 900", year: 2024 },
  { make: "Triumph", model: "Tiger 900", year: 2025 },
  { make: "Triumph", model: "Tiger 900", year: 2026 },
  // Triumph - Tiger 900 14450EBU
  { make: "Triumph", model: "Tiger 900 14450EBU", year: 2024 },
  { make: "Triumph", model: "Tiger 900 14450EBU", year: 2025 },
  { make: "Triumph", model: "Tiger 900 14450EBU", year: 2026 },
  // Triumph - Tiger 900 14450EU
  { make: "Triumph", model: "Tiger 900 14450EU", year: 2024 },
  { make: "Triumph", model: "Tiger 900 14450EU", year: 2025 },
  { make: "Triumph", model: "Tiger 900 14450EU", year: 2026 },
  // Triumph - Tiger 1200
  { make: "Triumph", model: "Tiger 1200", year: 2022 },
  { make: "Triumph", model: "Tiger 1200", year: 2023 },
  { make: "Triumph", model: "Tiger 1200", year: 2024 },
  // Triumph - Tiger 1200 GT
  { make: "Triumph", model: "Tiger 1200 GT", year: 2022 },
  { make: "Triumph", model: "Tiger 1200 GT", year: 2023 },
  { make: "Triumph", model: "Tiger 1200 GT", year: 2024 },
  // Triumph - Tiger 1200 GT Pro
  { make: "Triumph", model: "Tiger 1200 GT Pro", year: 2022 },
  { make: "Triumph", model: "Tiger 1200 GT Pro", year: 2023 },
  { make: "Triumph", model: "Tiger 1200 GT Pro", year: 2024 },
  // Triumph - Tiger 1200 Rally
  { make: "Triumph", model: "Tiger 1200 Rally", year: 2022 },
  { make: "Triumph", model: "Tiger 1200 Rally", year: 2023 },
  { make: "Triumph", model: "Tiger 1200 Rally", year: 2024 },
  // Triumph - Tiger 1200 Rally Pro
  { make: "Triumph", model: "Tiger 1200 Rally Pro", year: 2022 },
  { make: "Triumph", model: "Tiger 1200 Rally Pro", year: 2023 },
  { make: "Triumph", model: "Tiger 1200 Rally Pro", year: 2024 },
  // Triumph - Tiger Tiger 1200
  { make: "Triumph", model: "Tiger Tiger 1200", year: 2022 },
  { make: "Triumph", model: "Tiger Tiger 1200", year: 2023 },
  { make: "Triumph", model: "Tiger Tiger 1200", year: 2024 },
  // Triumph - Trident 660
  { make: "Triumph", model: "Trident 660", year: 2021 },
  { make: "Triumph", model: "Trident 660", year: 2022 },
  { make: "Triumph", model: "Trident 660", year: 2023 },
  { make: "Triumph", model: "Trident 660", year: 2024 },
  { make: "Triumph", model: "Trident 660", year: 2025 },
  { make: "Triumph", model: "Trident 660", year: 2026 },
  // Vespa
  // Vespa - GTS 125 Sport
  { make: "Vespa", model: "GTS 125 Sport", year: 1990 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1991 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1992 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1993 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1994 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1995 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1996 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1997 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1998 },
  { make: "Vespa", model: "GTS 125 Sport", year: 1999 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2000 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2001 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2002 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2003 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2004 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2005 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2006 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2007 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2008 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2009 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2010 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2011 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2012 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2013 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2014 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2015 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2016 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2017 },
  { make: "Vespa", model: "GTS 125 Sport", year: 2018 },
  // Vespa - GTS 250 i.e.
  { make: "Vespa", model: "GTS 250 i.e.", year: 1990 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1991 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1992 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1993 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1994 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1995 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1996 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1997 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1998 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 1999 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2000 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2001 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2002 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2003 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2004 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2005 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2006 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2007 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2008 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2009 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2010 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2011 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2012 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2013 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2014 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2015 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2016 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2017 },
  { make: "Vespa", model: "GTS 250 i.e.", year: 2018 },
  // Vespa - GTS 300
  { make: "Vespa", model: "GTS 300", year: 1990 },
  { make: "Vespa", model: "GTS 300", year: 1991 },
  { make: "Vespa", model: "GTS 300", year: 1992 },
  { make: "Vespa", model: "GTS 300", year: 1993 },
  { make: "Vespa", model: "GTS 300", year: 1994 },
  { make: "Vespa", model: "GTS 300", year: 1995 },
  { make: "Vespa", model: "GTS 300", year: 1996 },
  { make: "Vespa", model: "GTS 300", year: 1997 },
  { make: "Vespa", model: "GTS 300", year: 1998 },
  { make: "Vespa", model: "GTS 300", year: 1999 },
  { make: "Vespa", model: "GTS 300", year: 2000 },
  { make: "Vespa", model: "GTS 300", year: 2001 },
  { make: "Vespa", model: "GTS 300", year: 2002 },
  { make: "Vespa", model: "GTS 300", year: 2003 },
  { make: "Vespa", model: "GTS 300", year: 2004 },
  { make: "Vespa", model: "GTS 300", year: 2005 },
  { make: "Vespa", model: "GTS 300", year: 2006 },
  { make: "Vespa", model: "GTS 300", year: 2007 },
  { make: "Vespa", model: "GTS 300", year: 2008 },
  { make: "Vespa", model: "GTS 300", year: 2009 },
  { make: "Vespa", model: "GTS 300", year: 2010 },
  { make: "Vespa", model: "GTS 300", year: 2011 },
  { make: "Vespa", model: "GTS 300", year: 2012 },
  { make: "Vespa", model: "GTS 300", year: 2013 },
  { make: "Vespa", model: "GTS 300", year: 2014 },
  { make: "Vespa", model: "GTS 300", year: 2015 },
  { make: "Vespa", model: "GTS 300", year: 2016 },
  { make: "Vespa", model: "GTS 300", year: 2017 },
  { make: "Vespa", model: "GTS 300", year: 2018 },
  // Vespa - GTS-125
  { make: "Vespa", model: "GTS-125", year: 2017 },
  { make: "Vespa", model: "GTS-125", year: 2018 },
  { make: "Vespa", model: "GTS-125", year: 2021 },
  { make: "Vespa", model: "GTS-125", year: 2022 },
  { make: "Vespa", model: "GTS-125", year: 2023 },
  // Vespa - GTS-250
  { make: "Vespa", model: "GTS-250", year: 1990 },
  { make: "Vespa", model: "GTS-250", year: 1991 },
  { make: "Vespa", model: "GTS-250", year: 1992 },
  { make: "Vespa", model: "GTS-250", year: 1993 },
  { make: "Vespa", model: "GTS-250", year: 1994 },
  { make: "Vespa", model: "GTS-250", year: 1995 },
  { make: "Vespa", model: "GTS-250", year: 1996 },
  { make: "Vespa", model: "GTS-250", year: 1997 },
  { make: "Vespa", model: "GTS-250", year: 1998 },
  { make: "Vespa", model: "GTS-250", year: 1999 },
  { make: "Vespa", model: "GTS-250", year: 2000 },
  { make: "Vespa", model: "GTS-250", year: 2001 },
  { make: "Vespa", model: "GTS-250", year: 2002 },
  { make: "Vespa", model: "GTS-250", year: 2003 },
  { make: "Vespa", model: "GTS-250", year: 2004 },
  { make: "Vespa", model: "GTS-250", year: 2005 },
  { make: "Vespa", model: "GTS-250", year: 2006 },
  { make: "Vespa", model: "GTS-250", year: 2007 },
  { make: "Vespa", model: "GTS-250", year: 2008 },
  { make: "Vespa", model: "GTS-250", year: 2009 },
  { make: "Vespa", model: "GTS-250", year: 2010 },
  { make: "Vespa", model: "GTS-250", year: 2011 },
  { make: "Vespa", model: "GTS-250", year: 2012 },
  { make: "Vespa", model: "GTS-250", year: 2013 },
  { make: "Vespa", model: "GTS-250", year: 2014 },
  { make: "Vespa", model: "GTS-250", year: 2015 },
  { make: "Vespa", model: "GTS-250", year: 2016 },
  { make: "Vespa", model: "GTS-250", year: 2017 },
  { make: "Vespa", model: "GTS-250", year: 2018 },
  // Vespa - GTS-300 Hpe
  { make: "Vespa", model: "GTS-300 Hpe", year: 2019 },
  { make: "Vespa", model: "GTS-300 Hpe", year: 2020 },
  // Vespa - Primavera 125
  { make: "Vespa", model: "Primavera 125", year: 2021 },
  { make: "Vespa", model: "Primavera 125", year: 2022 },
  { make: "Vespa", model: "Primavera 125", year: 2023 },
  // Vespa - Primavera 125 3V
  { make: "Vespa", model: "Primavera 125 3V", year: 2021 },
  { make: "Vespa", model: "Primavera 125 3V", year: 2022 },
  { make: "Vespa", model: "Primavera 125 3V", year: 2023 },
  // Vespa - Primavera 150
  { make: "Vespa", model: "Primavera 150", year: 2021 },
  { make: "Vespa", model: "Primavera 150", year: 2022 },
  // Vespa - Sprint 125
  { make: "Vespa", model: "Sprint 125", year: 2021 },
  // Vespa - Sprint 125 3V
  { make: "Vespa", model: "Sprint 125 3V", year: 2021 },
  { make: "Vespa", model: "Sprint 125 3V", year: 2022 },
  { make: "Vespa", model: "Sprint 125 3V", year: 2023 },
  // Vespa - Sprint 150
  { make: "Vespa", model: "Sprint 150", year: 2021 },
  { make: "Vespa", model: "Sprint 150", year: 2022 },
  // Yamaha
  // Yamaha - Banshee
  { make: "Yamaha", model: "Banshee", year: 1987 },
  { make: "Yamaha", model: "Banshee", year: 1988 },
  { make: "Yamaha", model: "Banshee", year: 1989 },
  { make: "Yamaha", model: "Banshee", year: 1990 },
  { make: "Yamaha", model: "Banshee", year: 1991 },
  { make: "Yamaha", model: "Banshee", year: 1992 },
  { make: "Yamaha", model: "Banshee", year: 1993 },
  { make: "Yamaha", model: "Banshee", year: 1994 },
  { make: "Yamaha", model: "Banshee", year: 1995 },
  { make: "Yamaha", model: "Banshee", year: 1996 },
  { make: "Yamaha", model: "Banshee", year: 1997 },
  { make: "Yamaha", model: "Banshee", year: 1998 },
  { make: "Yamaha", model: "Banshee", year: 1999 },
  { make: "Yamaha", model: "Banshee", year: 2000 },
  { make: "Yamaha", model: "Banshee", year: 2001 },
  { make: "Yamaha", model: "Banshee", year: 2002 },
  { make: "Yamaha", model: "Banshee", year: 2003 },
  { make: "Yamaha", model: "Banshee", year: 2004 },
  { make: "Yamaha", model: "Banshee", year: 2005 },
  { make: "Yamaha", model: "Banshee", year: 2006 },
  // Yamaha - Banshee 2 Stroke
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1987 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1988 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1989 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1990 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1991 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1992 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1993 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1994 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1995 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1996 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1997 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1998 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 1999 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2000 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2001 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2002 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2003 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2004 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2005 },
  { make: "Yamaha", model: "Banshee 2 Stroke", year: 2006 },
  // Yamaha - Blaster
  { make: "Yamaha", model: "Blaster", year: 1988 },
  { make: "Yamaha", model: "Blaster", year: 1989 },
  { make: "Yamaha", model: "Blaster", year: 1990 },
  { make: "Yamaha", model: "Blaster", year: 1991 },
  { make: "Yamaha", model: "Blaster", year: 1992 },
  { make: "Yamaha", model: "Blaster", year: 1993 },
  { make: "Yamaha", model: "Blaster", year: 1994 },
  { make: "Yamaha", model: "Blaster", year: 1995 },
  { make: "Yamaha", model: "Blaster", year: 1996 },
  { make: "Yamaha", model: "Blaster", year: 1997 },
  { make: "Yamaha", model: "Blaster", year: 1998 },
  { make: "Yamaha", model: "Blaster", year: 1999 },
  { make: "Yamaha", model: "Blaster", year: 2000 },
  { make: "Yamaha", model: "Blaster", year: 2001 },
  { make: "Yamaha", model: "Blaster", year: 2002 },
  { make: "Yamaha", model: "Blaster", year: 2003 },
  { make: "Yamaha", model: "Blaster", year: 2004 },
  { make: "Yamaha", model: "Blaster", year: 2005 },
  { make: "Yamaha", model: "Blaster", year: 2006 },
  // Yamaha - Bolt R-Spec
  { make: "Yamaha", model: "Bolt R-Spec", year: 2014 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2015 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2016 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2017 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2018 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2019 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2020 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2021 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2022 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2023 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2024 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2025 },
  { make: "Yamaha", model: "Bolt R-Spec", year: 2026 },
  // Yamaha - FJ-09
  { make: "Yamaha", model: "FJ-09", year: 2015 },
  { make: "Yamaha", model: "FJ-09", year: 2016 },
  { make: "Yamaha", model: "FJ-09", year: 2017 },
  // Yamaha - FJR1300
  { make: "Yamaha", model: "FJR1300", year: 2012 },
  { make: "Yamaha", model: "FJR1300", year: 2013 },
  { make: "Yamaha", model: "FJR1300", year: 2014 },
  { make: "Yamaha", model: "FJR1300", year: 2015 },
  { make: "Yamaha", model: "FJR1300", year: 2016 },
  { make: "Yamaha", model: "FJR1300", year: 2017 },
  { make: "Yamaha", model: "FJR1300", year: 2018 },
  { make: "Yamaha", model: "FJR1300", year: 2019 },
  { make: "Yamaha", model: "FJR1300", year: 2020 },
  // Yamaha - FJR1300 / FJR1300A / FJR1300ES
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2002 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2003 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2004 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2005 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2006 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2007 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2008 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2009 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2010 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2011 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2012 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2013 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2014 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2015 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2016 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2017 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2018 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2019 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2020 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2021 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2022 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2023 },
  { make: "Yamaha", model: "FJR1300 / FJR1300A / FJR1300ES", year: 2024 },
  // Yamaha - FZ-07
  { make: "Yamaha", model: "FZ-07", year: 2015 },
  { make: "Yamaha", model: "FZ-07", year: 2016 },
  { make: "Yamaha", model: "FZ-07", year: 2017 },
  // Yamaha - FZ-09
  { make: "Yamaha", model: "FZ-09", year: 2014 },
  { make: "Yamaha", model: "FZ-09", year: 2015 },
  { make: "Yamaha", model: "FZ-09", year: 2016 },
  { make: "Yamaha", model: "FZ-09", year: 2017 },
  { make: "Yamaha", model: "FZ-09", year: 2018 },
  { make: "Yamaha", model: "FZ-09", year: 2019 },
  { make: "Yamaha", model: "FZ-09", year: 2020 },
  // Yamaha - FZ1
  { make: "Yamaha", model: "FZ1", year: 2006 },
  { make: "Yamaha", model: "FZ1", year: 2007 },
  { make: "Yamaha", model: "FZ1", year: 2008 },
  { make: "Yamaha", model: "FZ1", year: 2009 },
  { make: "Yamaha", model: "FZ1", year: 2010 },
  { make: "Yamaha", model: "FZ1", year: 2011 },
  { make: "Yamaha", model: "FZ1", year: 2012 },
  { make: "Yamaha", model: "FZ1", year: 2013 },
  { make: "Yamaha", model: "FZ1", year: 2014 },
  { make: "Yamaha", model: "FZ1", year: 2015 },
  { make: "Yamaha", model: "FZ1", year: 2016 },
  // Yamaha - FZ6R
  { make: "Yamaha", model: "FZ6R", year: 2009 },
  { make: "Yamaha", model: "FZ6R", year: 2010 },
  { make: "Yamaha", model: "FZ6R", year: 2011 },
  { make: "Yamaha", model: "FZ6R", year: 2012 },
  { make: "Yamaha", model: "FZ6R", year: 2013 },
  { make: "Yamaha", model: "FZ6R", year: 2014 },
  { make: "Yamaha", model: "FZ6R", year: 2015 },
  { make: "Yamaha", model: "FZ6R", year: 2016 },
  { make: "Yamaha", model: "FZ6R", year: 2017 },
  // Yamaha - MT-03
  { make: "Yamaha", model: "MT-03", year: 2015 },
  { make: "Yamaha", model: "MT-03", year: 2016 },
  { make: "Yamaha", model: "MT-03", year: 2017 },
  { make: "Yamaha", model: "MT-03", year: 2018 },
  { make: "Yamaha", model: "MT-03", year: 2019 },
  { make: "Yamaha", model: "MT-03", year: 2020 },
  { make: "Yamaha", model: "MT-03", year: 2021 },
  { make: "Yamaha", model: "MT-03", year: 2022 },
  { make: "Yamaha", model: "MT-03", year: 2023 },
  { make: "Yamaha", model: "MT-03", year: 2024 },
  { make: "Yamaha", model: "MT-03", year: 2025 },
  { make: "Yamaha", model: "MT-03", year: 2026 },
  // Yamaha - MT-07
  { make: "Yamaha", model: "MT-07", year: 2014 },
  { make: "Yamaha", model: "MT-07", year: 2015 },
  { make: "Yamaha", model: "MT-07", year: 2016 },
  { make: "Yamaha", model: "MT-07", year: 2017 },
  { make: "Yamaha", model: "MT-07", year: 2018 },
  { make: "Yamaha", model: "MT-07", year: 2019 },
  { make: "Yamaha", model: "MT-07", year: 2020 },
  { make: "Yamaha", model: "MT-07", year: 2021 },
  { make: "Yamaha", model: "MT-07", year: 2022 },
  { make: "Yamaha", model: "MT-07", year: 2023 },
  { make: "Yamaha", model: "MT-07", year: 2024 },
  { make: "Yamaha", model: "MT-07", year: 2025 },
  { make: "Yamaha", model: "MT-07", year: 2026 },
  { make: "Yamaha", model: "MT-07", year: 2027 },
  // Yamaha - MT-09
  { make: "Yamaha", model: "MT-09", year: 2013 },
  { make: "Yamaha", model: "MT-09", year: 2014 },
  { make: "Yamaha", model: "MT-09", year: 2015 },
  { make: "Yamaha", model: "MT-09", year: 2016 },
  { make: "Yamaha", model: "MT-09", year: 2017 },
  { make: "Yamaha", model: "MT-09", year: 2018 },
  { make: "Yamaha", model: "MT-09", year: 2019 },
  { make: "Yamaha", model: "MT-09", year: 2020 },
  { make: "Yamaha", model: "MT-09", year: 2021 },
  { make: "Yamaha", model: "MT-09", year: 2022 },
  { make: "Yamaha", model: "MT-09", year: 2023 },
  { make: "Yamaha", model: "MT-09", year: 2024 },
  { make: "Yamaha", model: "MT-09", year: 2025 },
  { make: "Yamaha", model: "MT-09", year: 2026 },
  { make: "Yamaha", model: "MT-09", year: 2027 },
  // Yamaha - MT-09 Side Mount License
  { make: "Yamaha", model: "MT-09 Side Mount License", year: 2017 },
  { make: "Yamaha", model: "MT-09 Side Mount License", year: 2018 },
  { make: "Yamaha", model: "MT-09 Side Mount License", year: 2019 },
  { make: "Yamaha", model: "MT-09 Side Mount License", year: 2020 },
  // Yamaha - MT-10
  { make: "Yamaha", model: "MT-10", year: 2015 },
  { make: "Yamaha", model: "MT-10", year: 2016 },
  { make: "Yamaha", model: "MT-10", year: 2017 },
  { make: "Yamaha", model: "MT-10", year: 2018 },
  { make: "Yamaha", model: "MT-10", year: 2019 },
  { make: "Yamaha", model: "MT-10", year: 2020 },
  { make: "Yamaha", model: "MT-10", year: 2021 },
  { make: "Yamaha", model: "MT-10", year: 2022 },
  { make: "Yamaha", model: "MT-10", year: 2023 },
  { make: "Yamaha", model: "MT-10", year: 2024 },
  { make: "Yamaha", model: "MT-10", year: 2025 },
  { make: "Yamaha", model: "MT-10", year: 2026 },
  { make: "Yamaha", model: "MT-10", year: 2027 },
  // Yamaha - MT-10 Euro 4 Nxt
  { make: "Yamaha", model: "MT-10 Euro 4 Nxt", year: 2016 },
  // Yamaha - Niken 850
  { make: "Yamaha", model: "Niken 850", year: 2018 },
  { make: "Yamaha", model: "Niken 850", year: 2019 },
  // Yamaha - PW-80
  { make: "Yamaha", model: "PW-80", year: 1991 },
  { make: "Yamaha", model: "PW-80", year: 1992 },
  { make: "Yamaha", model: "PW-80", year: 1993 },
  { make: "Yamaha", model: "PW-80", year: 1994 },
  { make: "Yamaha", model: "PW-80", year: 1995 },
  { make: "Yamaha", model: "PW-80", year: 1996 },
  { make: "Yamaha", model: "PW-80", year: 1997 },
  { make: "Yamaha", model: "PW-80", year: 1998 },
  { make: "Yamaha", model: "PW-80", year: 1999 },
  { make: "Yamaha", model: "PW-80", year: 2000 },
  { make: "Yamaha", model: "PW-80", year: 2001 },
  { make: "Yamaha", model: "PW-80", year: 2002 },
  { make: "Yamaha", model: "PW-80", year: 2003 },
  { make: "Yamaha", model: "PW-80", year: 2004 },
  { make: "Yamaha", model: "PW-80", year: 2005 },
  { make: "Yamaha", model: "PW-80", year: 2006 },
  // Yamaha - PW50
  { make: "Yamaha", model: "PW50", year: 1983 },
  { make: "Yamaha", model: "PW50", year: 1984 },
  { make: "Yamaha", model: "PW50", year: 1985 },
  { make: "Yamaha", model: "PW50", year: 1986 },
  { make: "Yamaha", model: "PW50", year: 1987 },
  { make: "Yamaha", model: "PW50", year: 1988 },
  { make: "Yamaha", model: "PW50", year: 1989 },
  { make: "Yamaha", model: "PW50", year: 1990 },
  { make: "Yamaha", model: "PW50", year: 1991 },
  { make: "Yamaha", model: "PW50", year: 1992 },
  { make: "Yamaha", model: "PW50", year: 1993 },
  { make: "Yamaha", model: "PW50", year: 1994 },
  { make: "Yamaha", model: "PW50", year: 1995 },
  { make: "Yamaha", model: "PW50", year: 1996 },
  { make: "Yamaha", model: "PW50", year: 1997 },
  { make: "Yamaha", model: "PW50", year: 1998 },
  { make: "Yamaha", model: "PW50", year: 1999 },
  { make: "Yamaha", model: "PW50", year: 2000 },
  { make: "Yamaha", model: "PW50", year: 2001 },
  { make: "Yamaha", model: "PW50", year: 2002 },
  { make: "Yamaha", model: "PW50", year: 2003 },
  { make: "Yamaha", model: "PW50", year: 2004 },
  { make: "Yamaha", model: "PW50", year: 2005 },
  { make: "Yamaha", model: "PW50", year: 2006 },
  { make: "Yamaha", model: "PW50", year: 2007 },
  { make: "Yamaha", model: "PW50", year: 2008 },
  { make: "Yamaha", model: "PW50", year: 2009 },
  { make: "Yamaha", model: "PW50", year: 2013 },
  { make: "Yamaha", model: "PW50", year: 2014 },
  { make: "Yamaha", model: "PW50", year: 2015 },
  { make: "Yamaha", model: "PW50", year: 2016 },
  { make: "Yamaha", model: "PW50", year: 2017 },
  { make: "Yamaha", model: "PW50", year: 2018 },
  { make: "Yamaha", model: "PW50", year: 2019 },
  { make: "Yamaha", model: "PW50", year: 2020 },
  { make: "Yamaha", model: "PW50", year: 2021 },
  // Yamaha - PW80
  { make: "Yamaha", model: "PW80", year: 1991 },
  { make: "Yamaha", model: "PW80", year: 1992 },
  { make: "Yamaha", model: "PW80", year: 1993 },
  { make: "Yamaha", model: "PW80", year: 1994 },
  { make: "Yamaha", model: "PW80", year: 1995 },
  { make: "Yamaha", model: "PW80", year: 1996 },
  { make: "Yamaha", model: "PW80", year: 1997 },
  { make: "Yamaha", model: "PW80", year: 1998 },
  { make: "Yamaha", model: "PW80", year: 1999 },
  { make: "Yamaha", model: "PW80", year: 2000 },
  { make: "Yamaha", model: "PW80", year: 2001 },
  { make: "Yamaha", model: "PW80", year: 2002 },
  { make: "Yamaha", model: "PW80", year: 2003 },
  { make: "Yamaha", model: "PW80", year: 2004 },
  { make: "Yamaha", model: "PW80", year: 2005 },
  { make: "Yamaha", model: "PW80", year: 2006 },
  // Yamaha - R1
  { make: "Yamaha", model: "R1", year: 1998 },
  { make: "Yamaha", model: "R1", year: 1999 },
  { make: "Yamaha", model: "R1", year: 2000 },
  { make: "Yamaha", model: "R1", year: 2001 },
  { make: "Yamaha", model: "R1", year: 2002 },
  { make: "Yamaha", model: "R1", year: 2003 },
  { make: "Yamaha", model: "R1", year: 2004 },
  { make: "Yamaha", model: "R1", year: 2005 },
  { make: "Yamaha", model: "R1", year: 2006 },
  { make: "Yamaha", model: "R1", year: 2007 },
  { make: "Yamaha", model: "R1", year: 2008 },
  { make: "Yamaha", model: "R1", year: 2009 },
  { make: "Yamaha", model: "R1", year: 2010 },
  { make: "Yamaha", model: "R1", year: 2011 },
  { make: "Yamaha", model: "R1", year: 2012 },
  { make: "Yamaha", model: "R1", year: 2013 },
  { make: "Yamaha", model: "R1", year: 2014 },
  { make: "Yamaha", model: "R1", year: 2015 },
  { make: "Yamaha", model: "R1", year: 2016 },
  { make: "Yamaha", model: "R1", year: 2017 },
  { make: "Yamaha", model: "R1", year: 2018 },
  { make: "Yamaha", model: "R1", year: 2019 },
  { make: "Yamaha", model: "R1", year: 2020 },
  { make: "Yamaha", model: "R1", year: 2021 },
  { make: "Yamaha", model: "R1", year: 2022 },
  { make: "Yamaha", model: "R1", year: 2023 },
  { make: "Yamaha", model: "R1", year: 2024 },
  { make: "Yamaha", model: "R1", year: 2025 },
  { make: "Yamaha", model: "R1", year: 2026 },
  { make: "Yamaha", model: "R1", year: 2027 },
  // Yamaha - R3
  { make: "Yamaha", model: "R3", year: 2015 },
  { make: "Yamaha", model: "R3", year: 2016 },
  { make: "Yamaha", model: "R3", year: 2017 },
  { make: "Yamaha", model: "R3", year: 2018 },
  { make: "Yamaha", model: "R3", year: 2019 },
  { make: "Yamaha", model: "R3", year: 2020 },
  { make: "Yamaha", model: "R3", year: 2021 },
  { make: "Yamaha", model: "R3", year: 2022 },
  { make: "Yamaha", model: "R3", year: 2023 },
  { make: "Yamaha", model: "R3", year: 2024 },
  { make: "Yamaha", model: "R3", year: 2025 },
  { make: "Yamaha", model: "R3", year: 2026 },
  { make: "Yamaha", model: "R3", year: 2027 },
  // Yamaha - R3 Clip Ons
  { make: "Yamaha", model: "R3 Clip Ons", year: 2019 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2020 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2021 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2022 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2023 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2024 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2025 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2026 },
  { make: "Yamaha", model: "R3 Clip Ons", year: 2027 },
  // Yamaha - R6
  { make: "Yamaha", model: "R6", year: 1999 },
  { make: "Yamaha", model: "R6", year: 2000 },
  { make: "Yamaha", model: "R6", year: 2001 },
  { make: "Yamaha", model: "R6", year: 2002 },
  { make: "Yamaha", model: "R6", year: 2003 },
  { make: "Yamaha", model: "R6", year: 2004 },
  { make: "Yamaha", model: "R6", year: 2005 },
  { make: "Yamaha", model: "R6", year: 2006 },
  { make: "Yamaha", model: "R6", year: 2007 },
  { make: "Yamaha", model: "R6", year: 2008 },
  { make: "Yamaha", model: "R6", year: 2009 },
  { make: "Yamaha", model: "R6", year: 2010 },
  { make: "Yamaha", model: "R6", year: 2011 },
  { make: "Yamaha", model: "R6", year: 2012 },
  { make: "Yamaha", model: "R6", year: 2013 },
  { make: "Yamaha", model: "R6", year: 2014 },
  { make: "Yamaha", model: "R6", year: 2015 },
  { make: "Yamaha", model: "R6", year: 2016 },
  { make: "Yamaha", model: "R6", year: 2017 },
  { make: "Yamaha", model: "R6", year: 2018 },
  { make: "Yamaha", model: "R6", year: 2019 },
  { make: "Yamaha", model: "R6", year: 2020 },
  { make: "Yamaha", model: "R6", year: 2021 },
  { make: "Yamaha", model: "R6", year: 2022 },
  { make: "Yamaha", model: "R6", year: 2023 },
  { make: "Yamaha", model: "R6", year: 2024 },
  { make: "Yamaha", model: "R6", year: 2025 },
  { make: "Yamaha", model: "R6", year: 2026 },
  { make: "Yamaha", model: "R6", year: 2027 },
  // Yamaha - R7
  { make: "Yamaha", model: "R7", year: 2021 },
  { make: "Yamaha", model: "R7", year: 2022 },
  { make: "Yamaha", model: "R7", year: 2023 },
  { make: "Yamaha", model: "R7", year: 2024 },
  { make: "Yamaha", model: "R7", year: 2025 },
  { make: "Yamaha", model: "R7", year: 2026 },
  { make: "Yamaha", model: "R7", year: 2027 },
  // Yamaha - R9
  { make: "Yamaha", model: "R9", year: 2024 },
  { make: "Yamaha", model: "R9", year: 2025 },
  { make: "Yamaha", model: "R9", year: 2026 },
  { make: "Yamaha", model: "R9", year: 2027 },
  // Yamaha - Raptor 125
  { make: "Yamaha", model: "Raptor 125", year: 2011 },
  { make: "Yamaha", model: "Raptor 125", year: 2012 },
  { make: "Yamaha", model: "Raptor 125", year: 2013 },
  // Yamaha - Raptor 250
  { make: "Yamaha", model: "Raptor 250", year: 2008 },
  { make: "Yamaha", model: "Raptor 250", year: 2009 },
  { make: "Yamaha", model: "Raptor 250", year: 2010 },
  { make: "Yamaha", model: "Raptor 250", year: 2011 },
  { make: "Yamaha", model: "Raptor 250", year: 2012 },
  { make: "Yamaha", model: "Raptor 250", year: 2013 },
  { make: "Yamaha", model: "Raptor 250", year: 2014 },
  { make: "Yamaha", model: "Raptor 250", year: 2015 },
  // Yamaha - Raptor 250R
  { make: "Yamaha", model: "Raptor 250R", year: 2011 },
  // Yamaha - Raptor 350
  { make: "Yamaha", model: "Raptor 350", year: 2005 },
  { make: "Yamaha", model: "Raptor 350", year: 2006 },
  { make: "Yamaha", model: "Raptor 350", year: 2007 },
  { make: "Yamaha", model: "Raptor 350", year: 2008 },
  { make: "Yamaha", model: "Raptor 350", year: 2009 },
  { make: "Yamaha", model: "Raptor 350", year: 2010 },
  { make: "Yamaha", model: "Raptor 350", year: 2011 },
  { make: "Yamaha", model: "Raptor 350", year: 2012 },
  { make: "Yamaha", model: "Raptor 350", year: 2013 },
  { make: "Yamaha", model: "Raptor 350", year: 2014 },
  { make: "Yamaha", model: "Raptor 350", year: 2015 },
  // Yamaha - Raptor 660
  { make: "Yamaha", model: "Raptor 660", year: 2001 },
  { make: "Yamaha", model: "Raptor 660", year: 2002 },
  { make: "Yamaha", model: "Raptor 660", year: 2003 },
  { make: "Yamaha", model: "Raptor 660", year: 2004 },
  { make: "Yamaha", model: "Raptor 660", year: 2005 },
  // Yamaha - Raptor 700
  { make: "Yamaha", model: "Raptor 700", year: 2006 },
  { make: "Yamaha", model: "Raptor 700", year: 2007 },
  { make: "Yamaha", model: "Raptor 700", year: 2008 },
  { make: "Yamaha", model: "Raptor 700", year: 2009 },
  { make: "Yamaha", model: "Raptor 700", year: 2010 },
  { make: "Yamaha", model: "Raptor 700", year: 2011 },
  { make: "Yamaha", model: "Raptor 700", year: 2012 },
  { make: "Yamaha", model: "Raptor 700", year: 2013 },
  { make: "Yamaha", model: "Raptor 700", year: 2014 },
  { make: "Yamaha", model: "Raptor 700", year: 2015 },
  { make: "Yamaha", model: "Raptor 700", year: 2016 },
  { make: "Yamaha", model: "Raptor 700", year: 2017 },
  { make: "Yamaha", model: "Raptor 700", year: 2018 },
  { make: "Yamaha", model: "Raptor 700", year: 2019 },
  { make: "Yamaha", model: "Raptor 700", year: 2020 },
  { make: "Yamaha", model: "Raptor 700", year: 2021 },
  { make: "Yamaha", model: "Raptor 700", year: 2022 },
  { make: "Yamaha", model: "Raptor 700", year: 2023 },
  { make: "Yamaha", model: "Raptor 700", year: 2024 },
  // Yamaha - Raptor 700 Evo R Dual
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2015 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2016 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2017 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2018 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2019 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2020 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2021 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2022 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2023 },
  { make: "Yamaha", model: "Raptor 700 Evo R Dual", year: 2024 },
  // Yamaha - Raptor 700 Head
  { make: "Yamaha", model: "Raptor 700 Head", year: 2015 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2016 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2017 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2018 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2019 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2020 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2021 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2022 },
  { make: "Yamaha", model: "Raptor 700 Head", year: 2023 },
  // Yamaha - Rhino 700
  { make: "Yamaha", model: "Rhino 700", year: 2008 },
  { make: "Yamaha", model: "Rhino 700", year: 2009 },
  { make: "Yamaha", model: "Rhino 700", year: 2010 },
  { make: "Yamaha", model: "Rhino 700", year: 2011 },
  { make: "Yamaha", model: "Rhino 700", year: 2012 },
  { make: "Yamaha", model: "Rhino 700", year: 2013 },
  { make: "Yamaha", model: "Rhino 700", year: 2014 },
  // Yamaha - Rhino 700 Efi
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2008 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2009 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2010 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2011 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2012 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2013 },
  { make: "Yamaha", model: "Rhino 700 Efi", year: 2014 },
  // Yamaha - SCR950
  { make: "Yamaha", model: "SCR950", year: 2017 },
  { make: "Yamaha", model: "SCR950", year: 2018 },
  { make: "Yamaha", model: "SCR950", year: 2019 },
  { make: "Yamaha", model: "SCR950", year: 2020 },
  // Yamaha - Star Vmax 1700
  { make: "Yamaha", model: "Star Vmax 1700", year: 2009 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2010 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2011 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2012 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2013 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2014 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2015 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2016 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2017 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2018 },
  { make: "Yamaha", model: "Star Vmax 1700", year: 2019 },
  // Yamaha - T Max 500
  { make: "Yamaha", model: "T Max 500", year: 2008 },
  { make: "Yamaha", model: "T Max 500", year: 2009 },
  // Yamaha - T Max 530
  { make: "Yamaha", model: "T Max 530", year: 2012 },
  { make: "Yamaha", model: "T Max 530", year: 2013 },
  { make: "Yamaha", model: "T Max 530", year: 2014 },
  { make: "Yamaha", model: "T Max 530", year: 2015 },
  { make: "Yamaha", model: "T Max 530", year: 2016 },
  { make: "Yamaha", model: "T Max 530", year: 2017 },
  { make: "Yamaha", model: "T Max 530", year: 2018 },
  { make: "Yamaha", model: "T Max 530", year: 2019 },
  { make: "Yamaha", model: "T Max 530", year: 2020 },
  // Yamaha - T N R 700
  { make: "Yamaha", model: "T N R 700", year: 2019 },
  { make: "Yamaha", model: "T N R 700", year: 2020 },
  { make: "Yamaha", model: "T N R 700", year: 2021 },
  { make: "Yamaha", model: "T N R 700", year: 2022 },
  { make: "Yamaha", model: "T N R 700", year: 2023 },
  { make: "Yamaha", model: "T N R 700", year: 2024 },
  { make: "Yamaha", model: "T N R 700", year: 2025 },
  { make: "Yamaha", model: "T N R 700", year: 2026 },
  // Yamaha - Tenere 700
  { make: "Yamaha", model: "Tenere 700", year: 2019 },
  { make: "Yamaha", model: "Tenere 700", year: 2020 },
  { make: "Yamaha", model: "Tenere 700", year: 2021 },
  { make: "Yamaha", model: "Tenere 700", year: 2022 },
  { make: "Yamaha", model: "Tenere 700", year: 2023 },
  { make: "Yamaha", model: "Tenere 700", year: 2024 },
  { make: "Yamaha", model: "Tenere 700", year: 2025 },
  { make: "Yamaha", model: "Tenere 700", year: 2026 },
  // Yamaha - Tenere 700 14330EU
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 14330EU", year: 2026 },
  // Yamaha - Tenere 700 14465EBU
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 14465EBU", year: 2026 },
  // Yamaha - Tenere 700 14465EU
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 14465EU", year: 2026 },
  // Yamaha - Tenere 700 15609BU
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 15609BU", year: 2026 },
  // Yamaha - Tenere 700 15609TU
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 15609TU", year: 2026 },
  // Yamaha - Tenere 700 80066
  { make: "Yamaha", model: "Tenere 700 80066", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 80066", year: 2026 },
  // Yamaha - Tenere 700 E Y7R3
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2019 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2020 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2021 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2022 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2023 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2024 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2025 },
  { make: "Yamaha", model: "Tenere 700 E Y7R3", year: 2026 },
  // Yamaha - TMAX
  { make: "Yamaha", model: "TMAX", year: 2001 },
  { make: "Yamaha", model: "TMAX", year: 2002 },
  { make: "Yamaha", model: "TMAX", year: 2003 },
  { make: "Yamaha", model: "TMAX", year: 2004 },
  { make: "Yamaha", model: "TMAX", year: 2005 },
  { make: "Yamaha", model: "TMAX", year: 2006 },
  { make: "Yamaha", model: "TMAX", year: 2007 },
  { make: "Yamaha", model: "TMAX", year: 2008 },
  { make: "Yamaha", model: "TMAX", year: 2009 },
  { make: "Yamaha", model: "TMAX", year: 2010 },
  { make: "Yamaha", model: "TMAX", year: 2011 },
  { make: "Yamaha", model: "TMAX", year: 2012 },
  { make: "Yamaha", model: "TMAX", year: 2013 },
  { make: "Yamaha", model: "TMAX", year: 2014 },
  { make: "Yamaha", model: "TMAX", year: 2015 },
  { make: "Yamaha", model: "TMAX", year: 2016 },
  { make: "Yamaha", model: "TMAX", year: 2017 },
  { make: "Yamaha", model: "TMAX", year: 2018 },
  { make: "Yamaha", model: "TMAX", year: 2019 },
  { make: "Yamaha", model: "TMAX", year: 2020 },
  { make: "Yamaha", model: "TMAX", year: 2021 },
  { make: "Yamaha", model: "TMAX", year: 2022 },
  { make: "Yamaha", model: "TMAX", year: 2023 },
  { make: "Yamaha", model: "TMAX", year: 2024 },
  { make: "Yamaha", model: "TMAX", year: 2025 },
  { make: "Yamaha", model: "TMAX", year: 2026 },
  // Yamaha - Tracer 7
  { make: "Yamaha", model: "Tracer 7", year: 2025 },
  // Yamaha - Tracer 9 GT
  { make: "Yamaha", model: "Tracer 9 GT", year: 2021 },
  { make: "Yamaha", model: "Tracer 9 GT", year: 2022 },
  { make: "Yamaha", model: "Tracer 9 GT", year: 2023 },
  { make: "Yamaha", model: "Tracer 9 GT", year: 2024 },
  { make: "Yamaha", model: "Tracer 9 GT", year: 2025 },
  { make: "Yamaha", model: "Tracer 9 GT", year: 2026 },
  // Yamaha - Tracer 700
  { make: "Yamaha", model: "Tracer 700", year: 2016 },
  { make: "Yamaha", model: "Tracer 700", year: 2017 },
  { make: "Yamaha", model: "Tracer 700", year: 2018 },
  { make: "Yamaha", model: "Tracer 700", year: 2019 },
  { make: "Yamaha", model: "Tracer 700", year: 2020 },
  { make: "Yamaha", model: "Tracer 700", year: 2021 },
  { make: "Yamaha", model: "Tracer 700", year: 2022 },
  { make: "Yamaha", model: "Tracer 700", year: 2023 },
  { make: "Yamaha", model: "Tracer 700", year: 2024 },
  // Yamaha - TT-600
  { make: "Yamaha", model: "TT-600", year: 1999 },
  { make: "Yamaha", model: "TT-600", year: 2000 },
  // Yamaha - TT-600 Xt 600 Tenere
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1986 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1987 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1988 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1989 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1990 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1991 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1992 },
  { make: "Yamaha", model: "TT-600 Xt 600 Tenere", year: 1993 },
  // Yamaha - TT-R50E
  { make: "Yamaha", model: "TT-R50E", year: 2006 },
  { make: "Yamaha", model: "TT-R50E", year: 2007 },
  { make: "Yamaha", model: "TT-R50E", year: 2008 },
  { make: "Yamaha", model: "TT-R50E", year: 2009 },
  { make: "Yamaha", model: "TT-R50E", year: 2010 },
  { make: "Yamaha", model: "TT-R50E", year: 2011 },
  { make: "Yamaha", model: "TT-R50E", year: 2012 },
  { make: "Yamaha", model: "TT-R50E", year: 2013 },
  { make: "Yamaha", model: "TT-R50E", year: 2014 },
  { make: "Yamaha", model: "TT-R50E", year: 2015 },
  { make: "Yamaha", model: "TT-R50E", year: 2016 },
  { make: "Yamaha", model: "TT-R50E", year: 2017 },
  { make: "Yamaha", model: "TT-R50E", year: 2018 },
  { make: "Yamaha", model: "TT-R50E", year: 2019 },
  { make: "Yamaha", model: "TT-R50E", year: 2020 },
  { make: "Yamaha", model: "TT-R50E", year: 2021 },
  { make: "Yamaha", model: "TT-R50E", year: 2022 },
  { make: "Yamaha", model: "TT-R50E", year: 2023 },
  { make: "Yamaha", model: "TT-R50E", year: 2024 },
  { make: "Yamaha", model: "TT-R50E", year: 2025 },
  { make: "Yamaha", model: "TT-R50E", year: 2026 },
  // Yamaha - TT-R110E
  { make: "Yamaha", model: "TT-R110E", year: 2008 },
  { make: "Yamaha", model: "TT-R110E", year: 2009 },
  { make: "Yamaha", model: "TT-R110E", year: 2010 },
  { make: "Yamaha", model: "TT-R110E", year: 2011 },
  { make: "Yamaha", model: "TT-R110E", year: 2012 },
  { make: "Yamaha", model: "TT-R110E", year: 2013 },
  { make: "Yamaha", model: "TT-R110E", year: 2014 },
  { make: "Yamaha", model: "TT-R110E", year: 2015 },
  { make: "Yamaha", model: "TT-R110E", year: 2016 },
  { make: "Yamaha", model: "TT-R110E", year: 2017 },
  { make: "Yamaha", model: "TT-R110E", year: 2018 },
  { make: "Yamaha", model: "TT-R110E", year: 2019 },
  { make: "Yamaha", model: "TT-R110E", year: 2020 },
  { make: "Yamaha", model: "TT-R110E", year: 2021 },
  { make: "Yamaha", model: "TT-R110E", year: 2022 },
  { make: "Yamaha", model: "TT-R110E", year: 2023 },
  { make: "Yamaha", model: "TT-R110E", year: 2024 },
  { make: "Yamaha", model: "TT-R110E", year: 2025 },
  { make: "Yamaha", model: "TT-R110E", year: 2026 },
  // Yamaha - TT-R125LE
  { make: "Yamaha", model: "TT-R125LE", year: 2000 },
  { make: "Yamaha", model: "TT-R125LE", year: 2001 },
  { make: "Yamaha", model: "TT-R125LE", year: 2002 },
  { make: "Yamaha", model: "TT-R125LE", year: 2003 },
  { make: "Yamaha", model: "TT-R125LE", year: 2004 },
  { make: "Yamaha", model: "TT-R125LE", year: 2005 },
  { make: "Yamaha", model: "TT-R125LE", year: 2006 },
  { make: "Yamaha", model: "TT-R125LE", year: 2007 },
  { make: "Yamaha", model: "TT-R125LE", year: 2008 },
  { make: "Yamaha", model: "TT-R125LE", year: 2009 },
  { make: "Yamaha", model: "TT-R125LE", year: 2010 },
  { make: "Yamaha", model: "TT-R125LE", year: 2011 },
  { make: "Yamaha", model: "TT-R125LE", year: 2012 },
  { make: "Yamaha", model: "TT-R125LE", year: 2013 },
  { make: "Yamaha", model: "TT-R125LE", year: 2014 },
  { make: "Yamaha", model: "TT-R125LE", year: 2015 },
  { make: "Yamaha", model: "TT-R125LE", year: 2016 },
  { make: "Yamaha", model: "TT-R125LE", year: 2017 },
  { make: "Yamaha", model: "TT-R125LE", year: 2018 },
  { make: "Yamaha", model: "TT-R125LE", year: 2019 },
  { make: "Yamaha", model: "TT-R125LE", year: 2020 },
  { make: "Yamaha", model: "TT-R125LE", year: 2021 },
  { make: "Yamaha", model: "TT-R125LE", year: 2022 },
  { make: "Yamaha", model: "TT-R125LE", year: 2023 },
  { make: "Yamaha", model: "TT-R125LE", year: 2024 },
  { make: "Yamaha", model: "TT-R125LE", year: 2025 },
  { make: "Yamaha", model: "TT-R125LE", year: 2026 },
  // Yamaha - TT-R230
  { make: "Yamaha", model: "TT-R230", year: 2005 },
  { make: "Yamaha", model: "TT-R230", year: 2006 },
  { make: "Yamaha", model: "TT-R230", year: 2007 },
  { make: "Yamaha", model: "TT-R230", year: 2008 },
  { make: "Yamaha", model: "TT-R230", year: 2009 },
  { make: "Yamaha", model: "TT-R230", year: 2010 },
  { make: "Yamaha", model: "TT-R230", year: 2011 },
  { make: "Yamaha", model: "TT-R230", year: 2012 },
  { make: "Yamaha", model: "TT-R230", year: 2013 },
  { make: "Yamaha", model: "TT-R230", year: 2014 },
  { make: "Yamaha", model: "TT-R230", year: 2015 },
  { make: "Yamaha", model: "TT-R230", year: 2016 },
  { make: "Yamaha", model: "TT-R230", year: 2017 },
  { make: "Yamaha", model: "TT-R230", year: 2018 },
  { make: "Yamaha", model: "TT-R230", year: 2019 },
  { make: "Yamaha", model: "TT-R230", year: 2020 },
  { make: "Yamaha", model: "TT-R230", year: 2021 },
  { make: "Yamaha", model: "TT-R230", year: 2022 },
  { make: "Yamaha", model: "TT-R230", year: 2023 },
  { make: "Yamaha", model: "TT-R230", year: 2024 },
  { make: "Yamaha", model: "TT-R230", year: 2025 },
  { make: "Yamaha", model: "TT-R230", year: 2026 },
  // Yamaha - TTR-110E
  { make: "Yamaha", model: "TTR-110E", year: 2008 },
  { make: "Yamaha", model: "TTR-110E", year: 2009 },
  { make: "Yamaha", model: "TTR-110E", year: 2010 },
  { make: "Yamaha", model: "TTR-110E", year: 2011 },
  { make: "Yamaha", model: "TTR-110E", year: 2012 },
  { make: "Yamaha", model: "TTR-110E", year: 2013 },
  { make: "Yamaha", model: "TTR-110E", year: 2014 },
  { make: "Yamaha", model: "TTR-110E", year: 2015 },
  { make: "Yamaha", model: "TTR-110E", year: 2016 },
  { make: "Yamaha", model: "TTR-110E", year: 2017 },
  { make: "Yamaha", model: "TTR-110E", year: 2018 },
  { make: "Yamaha", model: "TTR-110E", year: 2019 },
  { make: "Yamaha", model: "TTR-110E", year: 2020 },
  { make: "Yamaha", model: "TTR-110E", year: 2021 },
  { make: "Yamaha", model: "TTR-110E", year: 2022 },
  { make: "Yamaha", model: "TTR-110E", year: 2023 },
  // Yamaha - TTR-125
  { make: "Yamaha", model: "TTR-125", year: 2000 },
  { make: "Yamaha", model: "TTR-125", year: 2001 },
  { make: "Yamaha", model: "TTR-125", year: 2002 },
  { make: "Yamaha", model: "TTR-125", year: 2003 },
  { make: "Yamaha", model: "TTR-125", year: 2004 },
  { make: "Yamaha", model: "TTR-125", year: 2005 },
  { make: "Yamaha", model: "TTR-125", year: 2006 },
  { make: "Yamaha", model: "TTR-125", year: 2007 },
  { make: "Yamaha", model: "TTR-125", year: 2008 },
  { make: "Yamaha", model: "TTR-125", year: 2009 },
  { make: "Yamaha", model: "TTR-125", year: 2010 },
  { make: "Yamaha", model: "TTR-125", year: 2011 },
  { make: "Yamaha", model: "TTR-125", year: 2012 },
  { make: "Yamaha", model: "TTR-125", year: 2013 },
  { make: "Yamaha", model: "TTR-125", year: 2014 },
  { make: "Yamaha", model: "TTR-125", year: 2015 },
  { make: "Yamaha", model: "TTR-125", year: 2016 },
  { make: "Yamaha", model: "TTR-125", year: 2017 },
  { make: "Yamaha", model: "TTR-125", year: 2018 },
  { make: "Yamaha", model: "TTR-125", year: 2019 },
  { make: "Yamaha", model: "TTR-125", year: 2020 },
  { make: "Yamaha", model: "TTR-125", year: 2021 },
  { make: "Yamaha", model: "TTR-125", year: 2022 },
  { make: "Yamaha", model: "TTR-125", year: 2023 },
  // Yamaha - TTR-225
  { make: "Yamaha", model: "TTR-225", year: 1999 },
  { make: "Yamaha", model: "TTR-225", year: 2000 },
  { make: "Yamaha", model: "TTR-225", year: 2001 },
  { make: "Yamaha", model: "TTR-225", year: 2002 },
  { make: "Yamaha", model: "TTR-225", year: 2003 },
  { make: "Yamaha", model: "TTR-225", year: 2004 },
  { make: "Yamaha", model: "TTR-225", year: 2005 },
  // Yamaha - TTR-230
  { make: "Yamaha", model: "TTR-230", year: 2005 },
  { make: "Yamaha", model: "TTR-230", year: 2006 },
  { make: "Yamaha", model: "TTR-230", year: 2007 },
  { make: "Yamaha", model: "TTR-230", year: 2008 },
  { make: "Yamaha", model: "TTR-230", year: 2009 },
  { make: "Yamaha", model: "TTR-230", year: 2010 },
  { make: "Yamaha", model: "TTR-230", year: 2011 },
  { make: "Yamaha", model: "TTR-230", year: 2012 },
  { make: "Yamaha", model: "TTR-230", year: 2013 },
  { make: "Yamaha", model: "TTR-230", year: 2014 },
  { make: "Yamaha", model: "TTR-230", year: 2015 },
  { make: "Yamaha", model: "TTR-230", year: 2016 },
  { make: "Yamaha", model: "TTR-230", year: 2017 },
  { make: "Yamaha", model: "TTR-230", year: 2018 },
  { make: "Yamaha", model: "TTR-230", year: 2019 },
  { make: "Yamaha", model: "TTR-230", year: 2020 },
  { make: "Yamaha", model: "TTR-230", year: 2021 },
  { make: "Yamaha", model: "TTR-230", year: 2022 },
  { make: "Yamaha", model: "TTR-230", year: 2023 },
  // Yamaha - TTR50
  { make: "Yamaha", model: "TTR50", year: 2006 },
  { make: "Yamaha", model: "TTR50", year: 2007 },
  { make: "Yamaha", model: "TTR50", year: 2008 },
  { make: "Yamaha", model: "TTR50", year: 2009 },
  { make: "Yamaha", model: "TTR50", year: 2013 },
  { make: "Yamaha", model: "TTR50", year: 2014 },
  { make: "Yamaha", model: "TTR50", year: 2015 },
  { make: "Yamaha", model: "TTR50", year: 2016 },
  { make: "Yamaha", model: "TTR50", year: 2017 },
  { make: "Yamaha", model: "TTR50", year: 2018 },
  { make: "Yamaha", model: "TTR50", year: 2019 },
  { make: "Yamaha", model: "TTR50", year: 2020 },
  // Yamaha - TTR50E
  { make: "Yamaha", model: "TTR50E", year: 2021 },
  { make: "Yamaha", model: "TTR50E", year: 2022 },
  { make: "Yamaha", model: "TTR50E", year: 2023 },
  { make: "Yamaha", model: "TTR50E", year: 2024 },
  { make: "Yamaha", model: "TTR50E", year: 2025 },
  { make: "Yamaha", model: "TTR50E", year: 2026 },
  // Yamaha - TTR90
  { make: "Yamaha", model: "TTR90", year: 2000 },
  { make: "Yamaha", model: "TTR90", year: 2001 },
  { make: "Yamaha", model: "TTR90", year: 2002 },
  { make: "Yamaha", model: "TTR90", year: 2003 },
  { make: "Yamaha", model: "TTR90", year: 2004 },
  { make: "Yamaha", model: "TTR90", year: 2005 },
  { make: "Yamaha", model: "TTR90", year: 2006 },
  { make: "Yamaha", model: "TTR90", year: 2007 },
  // Yamaha - TTR110
  { make: "Yamaha", model: "TTR110", year: 2008 },
  { make: "Yamaha", model: "TTR110", year: 2009 },
  { make: "Yamaha", model: "TTR110", year: 2010 },
  { make: "Yamaha", model: "TTR110", year: 2011 },
  { make: "Yamaha", model: "TTR110", year: 2012 },
  { make: "Yamaha", model: "TTR110", year: 2013 },
  { make: "Yamaha", model: "TTR110", year: 2014 },
  { make: "Yamaha", model: "TTR110", year: 2015 },
  { make: "Yamaha", model: "TTR110", year: 2016 },
  { make: "Yamaha", model: "TTR110", year: 2017 },
  { make: "Yamaha", model: "TTR110", year: 2018 },
  { make: "Yamaha", model: "TTR110", year: 2019 },
  { make: "Yamaha", model: "TTR110", year: 2020 },
  { make: "Yamaha", model: "TTR110", year: 2021 },
  { make: "Yamaha", model: "TTR110", year: 2022 },
  { make: "Yamaha", model: "TTR110", year: 2023 },
  { make: "Yamaha", model: "TTR110", year: 2024 },
  { make: "Yamaha", model: "TTR110", year: 2025 },
  { make: "Yamaha", model: "TTR110", year: 2026 },
  // Yamaha - TTR110E
  { make: "Yamaha", model: "TTR110E", year: 2021 },
  { make: "Yamaha", model: "TTR110E", year: 2022 },
  { make: "Yamaha", model: "TTR110E", year: 2023 },
  { make: "Yamaha", model: "TTR110E", year: 2024 },
  { make: "Yamaha", model: "TTR110E", year: 2025 },
  { make: "Yamaha", model: "TTR110E", year: 2026 },
  // Yamaha - TTR125
  { make: "Yamaha", model: "TTR125", year: 2000 },
  { make: "Yamaha", model: "TTR125", year: 2001 },
  { make: "Yamaha", model: "TTR125", year: 2002 },
  { make: "Yamaha", model: "TTR125", year: 2003 },
  { make: "Yamaha", model: "TTR125", year: 2004 },
  { make: "Yamaha", model: "TTR125", year: 2005 },
  { make: "Yamaha", model: "TTR125", year: 2006 },
  { make: "Yamaha", model: "TTR125", year: 2007 },
  { make: "Yamaha", model: "TTR125", year: 2008 },
  { make: "Yamaha", model: "TTR125", year: 2009 },
  { make: "Yamaha", model: "TTR125", year: 2010 },
  { make: "Yamaha", model: "TTR125", year: 2011 },
  { make: "Yamaha", model: "TTR125", year: 2012 },
  { make: "Yamaha", model: "TTR125", year: 2013 },
  { make: "Yamaha", model: "TTR125", year: 2014 },
  { make: "Yamaha", model: "TTR125", year: 2015 },
  { make: "Yamaha", model: "TTR125", year: 2016 },
  { make: "Yamaha", model: "TTR125", year: 2017 },
  { make: "Yamaha", model: "TTR125", year: 2018 },
  { make: "Yamaha", model: "TTR125", year: 2019 },
  { make: "Yamaha", model: "TTR125", year: 2020 },
  // Yamaha - TTR125LE
  { make: "Yamaha", model: "TTR125LE", year: 2018 },
  { make: "Yamaha", model: "TTR125LE", year: 2019 },
  { make: "Yamaha", model: "TTR125LE", year: 2020 },
  { make: "Yamaha", model: "TTR125LE", year: 2021 },
  { make: "Yamaha", model: "TTR125LE", year: 2022 },
  { make: "Yamaha", model: "TTR125LE", year: 2023 },
  { make: "Yamaha", model: "TTR125LE", year: 2024 },
  { make: "Yamaha", model: "TTR125LE", year: 2025 },
  { make: "Yamaha", model: "TTR125LE", year: 2026 },
  // Yamaha - TTR230
  { make: "Yamaha", model: "TTR230", year: 2005 },
  { make: "Yamaha", model: "TTR230", year: 2006 },
  { make: "Yamaha", model: "TTR230", year: 2007 },
  { make: "Yamaha", model: "TTR230", year: 2008 },
  { make: "Yamaha", model: "TTR230", year: 2009 },
  { make: "Yamaha", model: "TTR230", year: 2010 },
  { make: "Yamaha", model: "TTR230", year: 2011 },
  { make: "Yamaha", model: "TTR230", year: 2012 },
  { make: "Yamaha", model: "TTR230", year: 2013 },
  { make: "Yamaha", model: "TTR230", year: 2014 },
  { make: "Yamaha", model: "TTR230", year: 2015 },
  { make: "Yamaha", model: "TTR230", year: 2016 },
  { make: "Yamaha", model: "TTR230", year: 2017 },
  { make: "Yamaha", model: "TTR230", year: 2018 },
  { make: "Yamaha", model: "TTR230", year: 2019 },
  { make: "Yamaha", model: "TTR230", year: 2020 },
  { make: "Yamaha", model: "TTR230", year: 2021 },
  { make: "Yamaha", model: "TTR230", year: 2022 },
  { make: "Yamaha", model: "TTR230", year: 2023 },
  { make: "Yamaha", model: "TTR230", year: 2024 },
  { make: "Yamaha", model: "TTR230", year: 2025 },
  { make: "Yamaha", model: "TTR230", year: 2026 },
  // Yamaha - Ttrl125
  { make: "Yamaha", model: "Ttrl125", year: 2000 },
  { make: "Yamaha", model: "Ttrl125", year: 2001 },
  { make: "Yamaha", model: "Ttrl125", year: 2002 },
  { make: "Yamaha", model: "Ttrl125", year: 2003 },
  { make: "Yamaha", model: "Ttrl125", year: 2004 },
  { make: "Yamaha", model: "Ttrl125", year: 2005 },
  { make: "Yamaha", model: "Ttrl125", year: 2006 },
  { make: "Yamaha", model: "Ttrl125", year: 2007 },
  { make: "Yamaha", model: "Ttrl125", year: 2008 },
  { make: "Yamaha", model: "Ttrl125", year: 2009 },
  { make: "Yamaha", model: "Ttrl125", year: 2010 },
  { make: "Yamaha", model: "Ttrl125", year: 2011 },
  { make: "Yamaha", model: "Ttrl125", year: 2012 },
  { make: "Yamaha", model: "Ttrl125", year: 2013 },
  { make: "Yamaha", model: "Ttrl125", year: 2014 },
  { make: "Yamaha", model: "Ttrl125", year: 2015 },
  { make: "Yamaha", model: "Ttrl125", year: 2016 },
  { make: "Yamaha", model: "Ttrl125", year: 2017 },
  // Yamaha - TW200
  { make: "Yamaha", model: "TW200", year: 1987 },
  { make: "Yamaha", model: "TW200", year: 1988 },
  { make: "Yamaha", model: "TW200", year: 1989 },
  { make: "Yamaha", model: "TW200", year: 1990 },
  { make: "Yamaha", model: "TW200", year: 1991 },
  { make: "Yamaha", model: "TW200", year: 1992 },
  { make: "Yamaha", model: "TW200", year: 1993 },
  { make: "Yamaha", model: "TW200", year: 1994 },
  { make: "Yamaha", model: "TW200", year: 1995 },
  { make: "Yamaha", model: "TW200", year: 1996 },
  { make: "Yamaha", model: "TW200", year: 1997 },
  { make: "Yamaha", model: "TW200", year: 1998 },
  { make: "Yamaha", model: "TW200", year: 1999 },
  { make: "Yamaha", model: "TW200", year: 2000 },
  { make: "Yamaha", model: "TW200", year: 2001 },
  { make: "Yamaha", model: "TW200", year: 2002 },
  { make: "Yamaha", model: "TW200", year: 2003 },
  { make: "Yamaha", model: "TW200", year: 2004 },
  { make: "Yamaha", model: "TW200", year: 2005 },
  { make: "Yamaha", model: "TW200", year: 2006 },
  { make: "Yamaha", model: "TW200", year: 2007 },
  { make: "Yamaha", model: "TW200", year: 2008 },
  { make: "Yamaha", model: "TW200", year: 2009 },
  { make: "Yamaha", model: "TW200", year: 2010 },
  { make: "Yamaha", model: "TW200", year: 2011 },
  { make: "Yamaha", model: "TW200", year: 2012 },
  { make: "Yamaha", model: "TW200", year: 2013 },
  { make: "Yamaha", model: "TW200", year: 2014 },
  { make: "Yamaha", model: "TW200", year: 2015 },
  { make: "Yamaha", model: "TW200", year: 2016 },
  { make: "Yamaha", model: "TW200", year: 2017 },
  { make: "Yamaha", model: "TW200", year: 2018 },
  { make: "Yamaha", model: "TW200", year: 2019 },
  { make: "Yamaha", model: "TW200", year: 2020 },
  { make: "Yamaha", model: "TW200", year: 2021 },
  { make: "Yamaha", model: "TW200", year: 2022 },
  { make: "Yamaha", model: "TW200", year: 2023 },
  { make: "Yamaha", model: "TW200", year: 2024 },
  { make: "Yamaha", model: "TW200", year: 2025 },
  { make: "Yamaha", model: "TW200", year: 2026 },
  // Yamaha - V Star 250
  { make: "Yamaha", model: "V Star 250", year: 2008 },
  { make: "Yamaha", model: "V Star 250", year: 2009 },
  { make: "Yamaha", model: "V Star 250", year: 2010 },
  { make: "Yamaha", model: "V Star 250", year: 2011 },
  { make: "Yamaha", model: "V Star 250", year: 2012 },
  { make: "Yamaha", model: "V Star 250", year: 2013 },
  { make: "Yamaha", model: "V Star 250", year: 2014 },
  { make: "Yamaha", model: "V Star 250", year: 2015 },
  { make: "Yamaha", model: "V Star 250", year: 2016 },
  { make: "Yamaha", model: "V Star 250", year: 2017 },
  { make: "Yamaha", model: "V Star 250", year: 2018 },
  { make: "Yamaha", model: "V Star 250", year: 2019 },
  { make: "Yamaha", model: "V Star 250", year: 2020 },
  { make: "Yamaha", model: "V Star 250", year: 2021 },
  { make: "Yamaha", model: "V Star 250", year: 2022 },
  { make: "Yamaha", model: "V Star 250", year: 2023 },
  { make: "Yamaha", model: "V Star 250", year: 2024 },
  { make: "Yamaha", model: "V Star 250", year: 2025 },
  { make: "Yamaha", model: "V Star 250", year: 2026 },
  // Yamaha - VMAX 1700
  { make: "Yamaha", model: "VMAX 1700", year: 2009 },
  { make: "Yamaha", model: "VMAX 1700", year: 2010 },
  { make: "Yamaha", model: "VMAX 1700", year: 2011 },
  { make: "Yamaha", model: "VMAX 1700", year: 2012 },
  { make: "Yamaha", model: "VMAX 1700", year: 2013 },
  { make: "Yamaha", model: "VMAX 1700", year: 2014 },
  { make: "Yamaha", model: "VMAX 1700", year: 2015 },
  { make: "Yamaha", model: "VMAX 1700", year: 2016 },
  { make: "Yamaha", model: "VMAX 1700", year: 2017 },
  { make: "Yamaha", model: "VMAX 1700", year: 2018 },
  { make: "Yamaha", model: "VMAX 1700", year: 2019 },
  // Yamaha - WR-125 X
  { make: "Yamaha", model: "WR-125 X", year: 2009 },
  { make: "Yamaha", model: "WR-125 X", year: 2010 },
  // Yamaha - WR-250X
  { make: "Yamaha", model: "WR-250X", year: 2008 },
  { make: "Yamaha", model: "WR-250X", year: 2009 },
  { make: "Yamaha", model: "WR-250X", year: 2010 },
  { make: "Yamaha", model: "WR-250X", year: 2011 },
  { make: "Yamaha", model: "WR-250X", year: 2012 },
  { make: "Yamaha", model: "WR-250X", year: 2013 },
  { make: "Yamaha", model: "WR-250X", year: 2014 },
  { make: "Yamaha", model: "WR-250X", year: 2015 },
  { make: "Yamaha", model: "WR-250X", year: 2016 },
  // Yamaha - WR-450F
  { make: "Yamaha", model: "WR-450F", year: 2007 },
  { make: "Yamaha", model: "WR-450F", year: 2008 },
  { make: "Yamaha", model: "WR-450F", year: 2009 },
  { make: "Yamaha", model: "WR-450F", year: 2010 },
  { make: "Yamaha", model: "WR-450F", year: 2011 },
  { make: "Yamaha", model: "WR-450F", year: 2012 },
  { make: "Yamaha", model: "WR-450F", year: 2013 },
  { make: "Yamaha", model: "WR-450F", year: 2014 },
  { make: "Yamaha", model: "WR-450F", year: 2015 },
  // Yamaha - WR250
  { make: "Yamaha", model: "WR250", year: 1994 },
  { make: "Yamaha", model: "WR250", year: 1995 },
  { make: "Yamaha", model: "WR250", year: 1996 },
  { make: "Yamaha", model: "WR250", year: 1997 },
  { make: "Yamaha", model: "WR250", year: 1998 },
  // Yamaha - WR250F
  { make: "Yamaha", model: "WR250F", year: 2001 },
  { make: "Yamaha", model: "WR250F", year: 2002 },
  { make: "Yamaha", model: "WR250F", year: 2003 },
  { make: "Yamaha", model: "WR250F", year: 2004 },
  { make: "Yamaha", model: "WR250F", year: 2005 },
  { make: "Yamaha", model: "WR250F", year: 2006 },
  { make: "Yamaha", model: "WR250F", year: 2007 },
  { make: "Yamaha", model: "WR250F", year: 2008 },
  { make: "Yamaha", model: "WR250F", year: 2009 },
  { make: "Yamaha", model: "WR250F", year: 2010 },
  { make: "Yamaha", model: "WR250F", year: 2011 },
  { make: "Yamaha", model: "WR250F", year: 2012 },
  { make: "Yamaha", model: "WR250F", year: 2013 },
  { make: "Yamaha", model: "WR250F", year: 2014 },
  { make: "Yamaha", model: "WR250F", year: 2015 },
  { make: "Yamaha", model: "WR250F", year: 2016 },
  { make: "Yamaha", model: "WR250F", year: 2017 },
  { make: "Yamaha", model: "WR250F", year: 2018 },
  { make: "Yamaha", model: "WR250F", year: 2019 },
  { make: "Yamaha", model: "WR250F", year: 2020 },
  { make: "Yamaha", model: "WR250F", year: 2021 },
  { make: "Yamaha", model: "WR250F", year: 2022 },
  { make: "Yamaha", model: "WR250F", year: 2023 },
  { make: "Yamaha", model: "WR250F", year: 2024 },
  { make: "Yamaha", model: "WR250F", year: 2025 },
  { make: "Yamaha", model: "WR250F", year: 2026 },
  // Yamaha - WR450F
  { make: "Yamaha", model: "WR450F", year: 2003 },
  { make: "Yamaha", model: "WR450F", year: 2004 },
  { make: "Yamaha", model: "WR450F", year: 2005 },
  { make: "Yamaha", model: "WR450F", year: 2006 },
  { make: "Yamaha", model: "WR450F", year: 2007 },
  { make: "Yamaha", model: "WR450F", year: 2008 },
  { make: "Yamaha", model: "WR450F", year: 2009 },
  { make: "Yamaha", model: "WR450F", year: 2010 },
  { make: "Yamaha", model: "WR450F", year: 2011 },
  { make: "Yamaha", model: "WR450F", year: 2012 },
  { make: "Yamaha", model: "WR450F", year: 2013 },
  { make: "Yamaha", model: "WR450F", year: 2014 },
  { make: "Yamaha", model: "WR450F", year: 2015 },
  { make: "Yamaha", model: "WR450F", year: 2016 },
  { make: "Yamaha", model: "WR450F", year: 2017 },
  { make: "Yamaha", model: "WR450F", year: 2018 },
  { make: "Yamaha", model: "WR450F", year: 2019 },
  { make: "Yamaha", model: "WR450F", year: 2020 },
  { make: "Yamaha", model: "WR450F", year: 2021 },
  { make: "Yamaha", model: "WR450F", year: 2022 },
  { make: "Yamaha", model: "WR450F", year: 2023 },
  { make: "Yamaha", model: "WR450F", year: 2024 },
  { make: "Yamaha", model: "WR450F", year: 2025 },
  { make: "Yamaha", model: "WR450F", year: 2026 },
  // Yamaha - X Max 125
  { make: "Yamaha", model: "X Max 125", year: 2018 },
  { make: "Yamaha", model: "X Max 125", year: 2019 },
  { make: "Yamaha", model: "X Max 125", year: 2020 },
  // Yamaha - X Max 250
  { make: "Yamaha", model: "X Max 250", year: 2009 },
  { make: "Yamaha", model: "X Max 250", year: 2010 },
  { make: "Yamaha", model: "X Max 250", year: 2011 },
  { make: "Yamaha", model: "X Max 250", year: 2012 },
  { make: "Yamaha", model: "X Max 250", year: 2013 },
  { make: "Yamaha", model: "X Max 250", year: 2014 },
  { make: "Yamaha", model: "X Max 250", year: 2015 },
  { make: "Yamaha", model: "X Max 250", year: 2016 },
  // Yamaha - X Max 300
  { make: "Yamaha", model: "X Max 300", year: 2017 },
  { make: "Yamaha", model: "X Max 300", year: 2018 },
  { make: "Yamaha", model: "X Max 300", year: 2019 },
  { make: "Yamaha", model: "X Max 300", year: 2020 },
  // Yamaha - X Max 400
  { make: "Yamaha", model: "X Max 400", year: 2013 },
  { make: "Yamaha", model: "X Max 400", year: 2014 },
  { make: "Yamaha", model: "X Max 400", year: 2015 },
  { make: "Yamaha", model: "X Max 400", year: 2016 },
  { make: "Yamaha", model: "X Max 400", year: 2017 },
  { make: "Yamaha", model: "X Max 400", year: 2018 },
  { make: "Yamaha", model: "X Max 400", year: 2019 },
  { make: "Yamaha", model: "X Max 400", year: 2020 },
  // Yamaha - XJ6
  { make: "Yamaha", model: "XJ6", year: 2009 },
  { make: "Yamaha", model: "XJ6", year: 2010 },
  // Yamaha - XJ6 Diversion
  { make: "Yamaha", model: "XJ6 Diversion", year: 2009 },
  { make: "Yamaha", model: "XJ6 Diversion", year: 2010 },
  // Yamaha - XJR-1300
  { make: "Yamaha", model: "XJR-1300", year: 2009 },
  { make: "Yamaha", model: "XJR-1300", year: 2010 },
  { make: "Yamaha", model: "XJR-1300", year: 2011 },
  { make: "Yamaha", model: "XJR-1300", year: 2012 },
  { make: "Yamaha", model: "XJR-1300", year: 2013 },
  { make: "Yamaha", model: "XJR-1300", year: 2014 },
  { make: "Yamaha", model: "XJR-1300", year: 2015 },
  { make: "Yamaha", model: "XJR-1300", year: 2016 },
  // Yamaha - XMAX
  { make: "Yamaha", model: "XMAX", year: 2018 },
  { make: "Yamaha", model: "XMAX", year: 2019 },
  { make: "Yamaha", model: "XMAX", year: 2020 },
  { make: "Yamaha", model: "XMAX", year: 2021 },
  { make: "Yamaha", model: "XMAX", year: 2022 },
  { make: "Yamaha", model: "XMAX", year: 2023 },
  { make: "Yamaha", model: "XMAX", year: 2024 },
  { make: "Yamaha", model: "XMAX", year: 2025 },
  { make: "Yamaha", model: "XMAX", year: 2026 },
  // Yamaha - XMAX-300
  { make: "Yamaha", model: "XMAX-300", year: 2017 },
  { make: "Yamaha", model: "XMAX-300", year: 2018 },
  { make: "Yamaha", model: "XMAX-300", year: 2019 },
  { make: "Yamaha", model: "XMAX-300", year: 2020 },
  // Yamaha - XSR-700
  { make: "Yamaha", model: "XSR-700", year: 2016 },
  { make: "Yamaha", model: "XSR-700", year: 2017 },
  { make: "Yamaha", model: "XSR-700", year: 2018 },
  { make: "Yamaha", model: "XSR-700", year: 2019 },
  { make: "Yamaha", model: "XSR-700", year: 2020 },
  { make: "Yamaha", model: "XSR-700", year: 2021 },
  { make: "Yamaha", model: "XSR-700", year: 2022 },
  { make: "Yamaha", model: "XSR-700", year: 2023 },
  { make: "Yamaha", model: "XSR-700", year: 2024 },
  { make: "Yamaha", model: "XSR-700", year: 2025 },
  { make: "Yamaha", model: "XSR-700", year: 2026 },
  { make: "Yamaha", model: "XSR-700", year: 2027 },
  // Yamaha - XSR-900
  { make: "Yamaha", model: "XSR-900", year: 2016 },
  { make: "Yamaha", model: "XSR-900", year: 2017 },
  { make: "Yamaha", model: "XSR-900", year: 2018 },
  { make: "Yamaha", model: "XSR-900", year: 2019 },
  { make: "Yamaha", model: "XSR-900", year: 2020 },
  { make: "Yamaha", model: "XSR-900", year: 2021 },
  { make: "Yamaha", model: "XSR-900", year: 2022 },
  { make: "Yamaha", model: "XSR-900", year: 2023 },
  { make: "Yamaha", model: "XSR-900", year: 2024 },
  { make: "Yamaha", model: "XSR-900", year: 2025 },
  { make: "Yamaha", model: "XSR-900", year: 2026 },
  { make: "Yamaha", model: "XSR-900", year: 2027 },
  // Yamaha - XSR700
  { make: "Yamaha", model: "XSR700", year: 2018 },
  { make: "Yamaha", model: "XSR700", year: 2019 },
  { make: "Yamaha", model: "XSR700", year: 2020 },
  { make: "Yamaha", model: "XSR700", year: 2021 },
  { make: "Yamaha", model: "XSR700", year: 2022 },
  { make: "Yamaha", model: "XSR700", year: 2023 },
  { make: "Yamaha", model: "XSR700", year: 2024 },
  { make: "Yamaha", model: "XSR700", year: 2025 },
  { make: "Yamaha", model: "XSR700", year: 2026 },
  // Yamaha - XSR900
  { make: "Yamaha", model: "XSR900", year: 2016 },
  { make: "Yamaha", model: "XSR900", year: 2017 },
  { make: "Yamaha", model: "XSR900", year: 2018 },
  { make: "Yamaha", model: "XSR900", year: 2019 },
  { make: "Yamaha", model: "XSR900", year: 2020 },
  { make: "Yamaha", model: "XSR900", year: 2021 },
  { make: "Yamaha", model: "XSR900", year: 2022 },
  { make: "Yamaha", model: "XSR900", year: 2023 },
  { make: "Yamaha", model: "XSR900", year: 2024 },
  { make: "Yamaha", model: "XSR900", year: 2025 },
  { make: "Yamaha", model: "XSR900", year: 2026 },
  // Yamaha - XT-600E
  { make: "Yamaha", model: "XT-600E", year: 1990 },
  { make: "Yamaha", model: "XT-600E", year: 1991 },
  { make: "Yamaha", model: "XT-600E", year: 1992 },
  { make: "Yamaha", model: "XT-600E", year: 1993 },
  { make: "Yamaha", model: "XT-600E", year: 1994 },
  // Yamaha - XT-660 X
  { make: "Yamaha", model: "XT-660 X", year: 2004 },
  { make: "Yamaha", model: "XT-660 X", year: 2005 },
  { make: "Yamaha", model: "XT-660 X", year: 2006 },
  { make: "Yamaha", model: "XT-660 X", year: 2007 },
  { make: "Yamaha", model: "XT-660 X", year: 2008 },
  { make: "Yamaha", model: "XT-660 X", year: 2009 },
  { make: "Yamaha", model: "XT-660 X", year: 2010 },
  { make: "Yamaha", model: "XT-660 X", year: 2011 },
  { make: "Yamaha", model: "XT-660 X", year: 2012 },
  { make: "Yamaha", model: "XT-660 X", year: 2013 },
  { make: "Yamaha", model: "XT-660 X", year: 2014 },
  { make: "Yamaha", model: "XT-660 X", year: 2015 },
  { make: "Yamaha", model: "XT-660 X", year: 2016 },
  // Yamaha - XT-1200 Z
  { make: "Yamaha", model: "XT-1200 Z", year: 2010 },
  { make: "Yamaha", model: "XT-1200 Z", year: 2011 },
  // Yamaha - XT-1200Z
  { make: "Yamaha", model: "XT-1200Z", year: 2010 },
  { make: "Yamaha", model: "XT-1200Z", year: 2011 },
  { make: "Yamaha", model: "XT-1200Z", year: 2012 },
  { make: "Yamaha", model: "XT-1200Z", year: 2013 },
  { make: "Yamaha", model: "XT-1200Z", year: 2014 },
  { make: "Yamaha", model: "XT-1200Z", year: 2015 },
  { make: "Yamaha", model: "XT-1200Z", year: 2016 },
  // Yamaha - XT250
  { make: "Yamaha", model: "XT250", year: 1980 },
  { make: "Yamaha", model: "XT250", year: 1981 },
  { make: "Yamaha", model: "XT250", year: 1982 },
  { make: "Yamaha", model: "XT250", year: 1983 },
  { make: "Yamaha", model: "XT250", year: 1984 },
  { make: "Yamaha", model: "XT250", year: 1985 },
  { make: "Yamaha", model: "XT250", year: 1986 },
  { make: "Yamaha", model: "XT250", year: 1987 },
  { make: "Yamaha", model: "XT250", year: 1988 },
  { make: "Yamaha", model: "XT250", year: 1989 },
  { make: "Yamaha", model: "XT250", year: 1990 },
  { make: "Yamaha", model: "XT250", year: 1991 },
  { make: "Yamaha", model: "XT250", year: 2008 },
  { make: "Yamaha", model: "XT250", year: 2009 },
  { make: "Yamaha", model: "XT250", year: 2010 },
  { make: "Yamaha", model: "XT250", year: 2011 },
  { make: "Yamaha", model: "XT250", year: 2012 },
  { make: "Yamaha", model: "XT250", year: 2013 },
  { make: "Yamaha", model: "XT250", year: 2014 },
  { make: "Yamaha", model: "XT250", year: 2015 },
  { make: "Yamaha", model: "XT250", year: 2016 },
  { make: "Yamaha", model: "XT250", year: 2017 },
  { make: "Yamaha", model: "XT250", year: 2018 },
  { make: "Yamaha", model: "XT250", year: 2019 },
  { make: "Yamaha", model: "XT250", year: 2020 },
  { make: "Yamaha", model: "XT250", year: 2021 },
  { make: "Yamaha", model: "XT250", year: 2022 },
  { make: "Yamaha", model: "XT250", year: 2023 },
  { make: "Yamaha", model: "XT250", year: 2024 },
  // Yamaha - XT1200Z Super Tenere
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2010 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2011 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2012 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2013 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2014 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2015 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2016 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2017 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2018 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2019 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2020 },
  { make: "Yamaha", model: "XT1200Z Super Tenere", year: 2021 },
  // Yamaha - XT1200ZE Super Tenere
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2010 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2011 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2012 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2013 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2014 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2015 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2016 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2017 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2018 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2019 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2020 },
  { make: "Yamaha", model: "XT1200ZE Super Tenere", year: 2021 },
  // Yamaha - XTZ-750 Supertenere
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1989 },
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1990 },
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1991 },
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1992 },
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1993 },
  { make: "Yamaha", model: "XTZ-750 Supertenere", year: 1994 },
  // Yamaha - XV950R Bolt
  { make: "Yamaha", model: "XV950R Bolt", year: 2014 },
  { make: "Yamaha", model: "XV950R Bolt", year: 2015 },
  { make: "Yamaha", model: "XV950R Bolt", year: 2016 },
  // Yamaha - YFM250R Raptor
  { make: "Yamaha", model: "YFM250R Raptor", year: 2011 },
  // Yamaha - YFM350FW
  { make: "Yamaha", model: "YFM350FW", year: 1987 },
  { make: "Yamaha", model: "YFM350FW", year: 1988 },
  { make: "Yamaha", model: "YFM350FW", year: 1989 },
  { make: "Yamaha", model: "YFM350FW", year: 1990 },
  { make: "Yamaha", model: "YFM350FW", year: 1991 },
  { make: "Yamaha", model: "YFM350FW", year: 1992 },
  { make: "Yamaha", model: "YFM350FW", year: 1993 },
  { make: "Yamaha", model: "YFM350FW", year: 1994 },
  { make: "Yamaha", model: "YFM350FW", year: 1995 },
  { make: "Yamaha", model: "YFM350FW", year: 1996 },
  { make: "Yamaha", model: "YFM350FW", year: 1997 },
  { make: "Yamaha", model: "YFM350FW", year: 1998 },
  { make: "Yamaha", model: "YFM350FW", year: 1999 },
  { make: "Yamaha", model: "YFM350FW", year: 2000 },
  // Yamaha - YFM350FW Big Bear 4x4
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1987 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1988 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1989 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1990 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1991 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1992 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1993 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1994 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1995 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1996 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1997 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1998 },
  { make: "Yamaha", model: "YFM350FW Big Bear 4x4", year: 1999 },
  // Yamaha - YFM400F Kodiak 4x4
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1993 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1994 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1995 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1996 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1997 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1998 },
  { make: "Yamaha", model: "YFM400F Kodiak 4x4", year: 1999 },
  // Yamaha - YFM550 Grizzly
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2009 },
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2010 },
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2011 },
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2012 },
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2013 },
  { make: "Yamaha", model: "YFM550 Grizzly", year: 2014 },
  // Yamaha - YFM660R Raptor
  { make: "Yamaha", model: "YFM660R Raptor", year: 2001 },
  { make: "Yamaha", model: "YFM660R Raptor", year: 2002 },
  { make: "Yamaha", model: "YFM660R Raptor", year: 2003 },
  { make: "Yamaha", model: "YFM660R Raptor", year: 2004 },
  { make: "Yamaha", model: "YFM660R Raptor", year: 2005 },
  // Yamaha - YFM700R Raptor
  { make: "Yamaha", model: "YFM700R Raptor", year: 2006 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2007 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2008 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2009 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2010 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2011 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2012 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2013 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2014 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2015 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2016 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2017 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2018 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2019 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2020 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2021 },
  { make: "Yamaha", model: "YFM700R Raptor", year: 2022 },
  // Yamaha - YFS200 Blaster
  { make: "Yamaha", model: "YFS200 Blaster", year: 1988 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1989 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1990 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1991 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1992 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1993 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1994 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1995 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1996 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1997 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1998 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 1999 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2000 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2001 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2002 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2003 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2004 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2005 },
  { make: "Yamaha", model: "YFS200 Blaster", year: 2006 },
  // Yamaha - YFZ-450
  { make: "Yamaha", model: "YFZ-450", year: 2012 },
  { make: "Yamaha", model: "YFZ-450", year: 2013 },
  // Yamaha - YFZ-450R
  { make: "Yamaha", model: "YFZ-450R", year: 2009 },
  { make: "Yamaha", model: "YFZ-450R", year: 2010 },
  { make: "Yamaha", model: "YFZ-450R", year: 2011 },
  { make: "Yamaha", model: "YFZ-450R", year: 2012 },
  { make: "Yamaha", model: "YFZ-450R", year: 2013 },
  { make: "Yamaha", model: "YFZ-450R", year: 2014 },
  { make: "Yamaha", model: "YFZ-450R", year: 2015 },
  { make: "Yamaha", model: "YFZ-450R", year: 2016 },
  { make: "Yamaha", model: "YFZ-450R", year: 2017 },
  { make: "Yamaha", model: "YFZ-450R", year: 2018 },
  { make: "Yamaha", model: "YFZ-450R", year: 2019 },
  { make: "Yamaha", model: "YFZ-450R", year: 2020 },
  { make: "Yamaha", model: "YFZ-450R", year: 2021 },
  { make: "Yamaha", model: "YFZ-450R", year: 2022 },
  { make: "Yamaha", model: "YFZ-450R", year: 2023 },
  // Yamaha - YFZ350 Banshee
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1987 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1988 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1989 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1990 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1991 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1992 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1993 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1994 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1995 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1996 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1997 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1998 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 1999 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2000 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2001 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2002 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2003 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2004 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2005 },
  { make: "Yamaha", model: "YFZ350 Banshee", year: 2006 },
  // Yamaha - YFZ450
  { make: "Yamaha", model: "YFZ450", year: 2004 },
  { make: "Yamaha", model: "YFZ450", year: 2005 },
  { make: "Yamaha", model: "YFZ450", year: 2006 },
  { make: "Yamaha", model: "YFZ450", year: 2007 },
  { make: "Yamaha", model: "YFZ450", year: 2008 },
  { make: "Yamaha", model: "YFZ450", year: 2009 },
  { make: "Yamaha", model: "YFZ450", year: 2012 },
  { make: "Yamaha", model: "YFZ450", year: 2013 },
  { make: "Yamaha", model: "YFZ450", year: 2014 },
  { make: "Yamaha", model: "YFZ450", year: 2015 },
  // Yamaha - YFZ450R
  { make: "Yamaha", model: "YFZ450R", year: 2009 },
  { make: "Yamaha", model: "YFZ450R", year: 2010 },
  { make: "Yamaha", model: "YFZ450R", year: 2011 },
  { make: "Yamaha", model: "YFZ450R", year: 2012 },
  { make: "Yamaha", model: "YFZ450R", year: 2013 },
  { make: "Yamaha", model: "YFZ450R", year: 2014 },
  { make: "Yamaha", model: "YFZ450R", year: 2015 },
  { make: "Yamaha", model: "YFZ450R", year: 2016 },
  { make: "Yamaha", model: "YFZ450R", year: 2017 },
  { make: "Yamaha", model: "YFZ450R", year: 2018 },
  { make: "Yamaha", model: "YFZ450R", year: 2019 },
  { make: "Yamaha", model: "YFZ450R", year: 2020 },
  { make: "Yamaha", model: "YFZ450R", year: 2021 },
  { make: "Yamaha", model: "YFZ450R", year: 2022 },
  { make: "Yamaha", model: "YFZ450R", year: 2023 },
  { make: "Yamaha", model: "YFZ450R", year: 2024 },
  { make: "Yamaha", model: "YFZ450R", year: 2025 },
  { make: "Yamaha", model: "YFZ450R", year: 2026 },
  // Yamaha - YFZ450X
  { make: "Yamaha", model: "YFZ450X", year: 2010 },
  { make: "Yamaha", model: "YFZ450X", year: 2011 },
  // Yamaha - YXR66F Rhino 660
  { make: "Yamaha", model: "YXR66F Rhino 660", year: 2004 },
  { make: "Yamaha", model: "YXR66F Rhino 660", year: 2005 },
  { make: "Yamaha", model: "YXR66F Rhino 660", year: 2006 },
  { make: "Yamaha", model: "YXR66F Rhino 660", year: 2007 },
  // Yamaha - YXR66F Rhino 660 Single
  { make: "Yamaha", model: "YXR66F Rhino 660 Single", year: 2004 },
  { make: "Yamaha", model: "YXR66F Rhino 660 Single", year: 2005 },
  { make: "Yamaha", model: "YXR66F Rhino 660 Single", year: 2006 },
  { make: "Yamaha", model: "YXR66F Rhino 660 Single", year: 2007 },
  // Yamaha - YXR700F Rhino 700 FI
  { make: "Yamaha", model: "YXR700F Rhino 700 FI", year: 2008 },
  { make: "Yamaha", model: "YXR700F Rhino 700 FI", year: 2009 },
  { make: "Yamaha", model: "YXR700F Rhino 700 FI", year: 2011 },
  { make: "Yamaha", model: "YXR700F Rhino 700 FI", year: 2012 },
  { make: "Yamaha", model: "YXR700F Rhino 700 FI", year: 2013 },
  // Yamaha - YXZ1000R
  { make: "Yamaha", model: "YXZ1000R", year: 2016 },
  { make: "Yamaha", model: "YXZ1000R", year: 2017 },
  { make: "Yamaha", model: "YXZ1000R", year: 2018 },
  { make: "Yamaha", model: "YXZ1000R", year: 2019 },
  // Yamaha - YXZ1000R 2 25IN Dual
  { make: "Yamaha", model: "YXZ1000R 2 25IN Dual", year: 2016 },
  { make: "Yamaha", model: "YXZ1000R 2 25IN Dual", year: 2017 },
  // Yamaha - YZ-250F
  { make: "Yamaha", model: "YZ-250F", year: 2006 },
  { make: "Yamaha", model: "YZ-250F", year: 2007 },
  { make: "Yamaha", model: "YZ-250F", year: 2008 },
  { make: "Yamaha", model: "YZ-250F", year: 2009 },
  { make: "Yamaha", model: "YZ-250F", year: 2010 },
  { make: "Yamaha", model: "YZ-250F", year: 2011 },
  { make: "Yamaha", model: "YZ-250F", year: 2012 },
  { make: "Yamaha", model: "YZ-250F", year: 2013 },
  { make: "Yamaha", model: "YZ-250F", year: 2019 },
  { make: "Yamaha", model: "YZ-250F", year: 2020 },
  { make: "Yamaha", model: "YZ-250F", year: 2021 },
  { make: "Yamaha", model: "YZ-250F", year: 2022 },
  // Yamaha - YZ-450 F
  { make: "Yamaha", model: "YZ-450 F", year: 2014 },
  { make: "Yamaha", model: "YZ-450 F", year: 2015 },
  { make: "Yamaha", model: "YZ-450 F", year: 2016 },
  { make: "Yamaha", model: "YZ-450 F", year: 2017 },
  // Yamaha - YZ-450F
  { make: "Yamaha", model: "YZ-450F", year: 2007 },
  { make: "Yamaha", model: "YZ-450F", year: 2008 },
  { make: "Yamaha", model: "YZ-450F", year: 2009 },
  { make: "Yamaha", model: "YZ-450F", year: 2010 },
  { make: "Yamaha", model: "YZ-450F", year: 2011 },
  { make: "Yamaha", model: "YZ-450F", year: 2012 },
  { make: "Yamaha", model: "YZ-450F", year: 2013 },
  { make: "Yamaha", model: "YZ-450F", year: 2020 },
  { make: "Yamaha", model: "YZ-450F", year: 2021 },
  { make: "Yamaha", model: "YZ-450F", year: 2022 },
  // Yamaha - YZ65
  { make: "Yamaha", model: "YZ65", year: 2018 },
  { make: "Yamaha", model: "YZ65", year: 2019 },
  { make: "Yamaha", model: "YZ65", year: 2020 },
  { make: "Yamaha", model: "YZ65", year: 2021 },
  { make: "Yamaha", model: "YZ65", year: 2022 },
  { make: "Yamaha", model: "YZ65", year: 2023 },
  { make: "Yamaha", model: "YZ65", year: 2024 },
  { make: "Yamaha", model: "YZ65", year: 2025 },
  { make: "Yamaha", model: "YZ65", year: 2026 },
  // Yamaha - YZ80
  { make: "Yamaha", model: "YZ80", year: 1993 },
  { make: "Yamaha", model: "YZ80", year: 1994 },
  { make: "Yamaha", model: "YZ80", year: 1995 },
  { make: "Yamaha", model: "YZ80", year: 1996 },
  { make: "Yamaha", model: "YZ80", year: 1997 },
  { make: "Yamaha", model: "YZ80", year: 1998 },
  { make: "Yamaha", model: "YZ80", year: 1999 },
  { make: "Yamaha", model: "YZ80", year: 2000 },
  { make: "Yamaha", model: "YZ80", year: 2001 },
  // Yamaha - YZ85
  { make: "Yamaha", model: "YZ85", year: 2002 },
  { make: "Yamaha", model: "YZ85", year: 2003 },
  { make: "Yamaha", model: "YZ85", year: 2004 },
  { make: "Yamaha", model: "YZ85", year: 2005 },
  { make: "Yamaha", model: "YZ85", year: 2006 },
  { make: "Yamaha", model: "YZ85", year: 2007 },
  { make: "Yamaha", model: "YZ85", year: 2008 },
  { make: "Yamaha", model: "YZ85", year: 2009 },
  { make: "Yamaha", model: "YZ85", year: 2010 },
  { make: "Yamaha", model: "YZ85", year: 2011 },
  { make: "Yamaha", model: "YZ85", year: 2012 },
  { make: "Yamaha", model: "YZ85", year: 2013 },
  { make: "Yamaha", model: "YZ85", year: 2014 },
  { make: "Yamaha", model: "YZ85", year: 2015 },
  { make: "Yamaha", model: "YZ85", year: 2016 },
  { make: "Yamaha", model: "YZ85", year: 2017 },
  { make: "Yamaha", model: "YZ85", year: 2018 },
  { make: "Yamaha", model: "YZ85", year: 2019 },
  { make: "Yamaha", model: "YZ85", year: 2020 },
  { make: "Yamaha", model: "YZ85", year: 2021 },
  { make: "Yamaha", model: "YZ85", year: 2022 },
  { make: "Yamaha", model: "YZ85", year: 2023 },
  { make: "Yamaha", model: "YZ85", year: 2024 },
  { make: "Yamaha", model: "YZ85", year: 2025 },
  { make: "Yamaha", model: "YZ85", year: 2026 },
  // Yamaha - YZ85LW
  { make: "Yamaha", model: "YZ85LW", year: 2022 },
  { make: "Yamaha", model: "YZ85LW", year: 2023 },
  { make: "Yamaha", model: "YZ85LW", year: 2024 },
  { make: "Yamaha", model: "YZ85LW", year: 2025 },
  { make: "Yamaha", model: "YZ85LW", year: 2026 },
  // Yamaha - YZ125
  { make: "Yamaha", model: "YZ125", year: 1974 },
  { make: "Yamaha", model: "YZ125", year: 1975 },
  { make: "Yamaha", model: "YZ125", year: 1976 },
  { make: "Yamaha", model: "YZ125", year: 1977 },
  { make: "Yamaha", model: "YZ125", year: 1978 },
  { make: "Yamaha", model: "YZ125", year: 1979 },
  { make: "Yamaha", model: "YZ125", year: 1980 },
  { make: "Yamaha", model: "YZ125", year: 1981 },
  { make: "Yamaha", model: "YZ125", year: 1982 },
  { make: "Yamaha", model: "YZ125", year: 1983 },
  { make: "Yamaha", model: "YZ125", year: 1984 },
  { make: "Yamaha", model: "YZ125", year: 1985 },
  { make: "Yamaha", model: "YZ125", year: 1986 },
  { make: "Yamaha", model: "YZ125", year: 1987 },
  { make: "Yamaha", model: "YZ125", year: 1988 },
  { make: "Yamaha", model: "YZ125", year: 1989 },
  { make: "Yamaha", model: "YZ125", year: 1990 },
  { make: "Yamaha", model: "YZ125", year: 1991 },
  { make: "Yamaha", model: "YZ125", year: 1992 },
  { make: "Yamaha", model: "YZ125", year: 1993 },
  { make: "Yamaha", model: "YZ125", year: 1994 },
  { make: "Yamaha", model: "YZ125", year: 1995 },
  { make: "Yamaha", model: "YZ125", year: 1996 },
  { make: "Yamaha", model: "YZ125", year: 1997 },
  { make: "Yamaha", model: "YZ125", year: 1998 },
  { make: "Yamaha", model: "YZ125", year: 1999 },
  { make: "Yamaha", model: "YZ125", year: 2000 },
  { make: "Yamaha", model: "YZ125", year: 2001 },
  { make: "Yamaha", model: "YZ125", year: 2002 },
  { make: "Yamaha", model: "YZ125", year: 2003 },
  { make: "Yamaha", model: "YZ125", year: 2004 },
  { make: "Yamaha", model: "YZ125", year: 2005 },
  { make: "Yamaha", model: "YZ125", year: 2006 },
  { make: "Yamaha", model: "YZ125", year: 2007 },
  { make: "Yamaha", model: "YZ125", year: 2008 },
  { make: "Yamaha", model: "YZ125", year: 2009 },
  { make: "Yamaha", model: "YZ125", year: 2010 },
  { make: "Yamaha", model: "YZ125", year: 2011 },
  { make: "Yamaha", model: "YZ125", year: 2012 },
  { make: "Yamaha", model: "YZ125", year: 2013 },
  { make: "Yamaha", model: "YZ125", year: 2014 },
  { make: "Yamaha", model: "YZ125", year: 2015 },
  { make: "Yamaha", model: "YZ125", year: 2016 },
  { make: "Yamaha", model: "YZ125", year: 2017 },
  { make: "Yamaha", model: "YZ125", year: 2018 },
  { make: "Yamaha", model: "YZ125", year: 2019 },
  { make: "Yamaha", model: "YZ125", year: 2020 },
  { make: "Yamaha", model: "YZ125", year: 2021 },
  { make: "Yamaha", model: "YZ125", year: 2022 },
  { make: "Yamaha", model: "YZ125", year: 2023 },
  { make: "Yamaha", model: "YZ125", year: 2024 },
  { make: "Yamaha", model: "YZ125", year: 2025 },
  { make: "Yamaha", model: "YZ125", year: 2026 },
  // Yamaha - YZ125X
  { make: "Yamaha", model: "YZ125X", year: 2020 },
  { make: "Yamaha", model: "YZ125X", year: 2021 },
  { make: "Yamaha", model: "YZ125X", year: 2022 },
  { make: "Yamaha", model: "YZ125X", year: 2023 },
  { make: "Yamaha", model: "YZ125X", year: 2024 },
  { make: "Yamaha", model: "YZ125X", year: 2025 },
  { make: "Yamaha", model: "YZ125X", year: 2026 },
  // Yamaha - YZ250
  { make: "Yamaha", model: "YZ250", year: 1974 },
  { make: "Yamaha", model: "YZ250", year: 1975 },
  { make: "Yamaha", model: "YZ250", year: 1976 },
  { make: "Yamaha", model: "YZ250", year: 1977 },
  { make: "Yamaha", model: "YZ250", year: 1978 },
  { make: "Yamaha", model: "YZ250", year: 1979 },
  { make: "Yamaha", model: "YZ250", year: 1980 },
  { make: "Yamaha", model: "YZ250", year: 1981 },
  { make: "Yamaha", model: "YZ250", year: 1982 },
  { make: "Yamaha", model: "YZ250", year: 1983 },
  { make: "Yamaha", model: "YZ250", year: 1984 },
  { make: "Yamaha", model: "YZ250", year: 1985 },
  { make: "Yamaha", model: "YZ250", year: 1986 },
  { make: "Yamaha", model: "YZ250", year: 1987 },
  { make: "Yamaha", model: "YZ250", year: 1988 },
  { make: "Yamaha", model: "YZ250", year: 1989 },
  { make: "Yamaha", model: "YZ250", year: 1990 },
  { make: "Yamaha", model: "YZ250", year: 1991 },
  { make: "Yamaha", model: "YZ250", year: 1992 },
  { make: "Yamaha", model: "YZ250", year: 1993 },
  { make: "Yamaha", model: "YZ250", year: 1994 },
  { make: "Yamaha", model: "YZ250", year: 1995 },
  { make: "Yamaha", model: "YZ250", year: 1996 },
  { make: "Yamaha", model: "YZ250", year: 1997 },
  { make: "Yamaha", model: "YZ250", year: 1998 },
  { make: "Yamaha", model: "YZ250", year: 1999 },
  { make: "Yamaha", model: "YZ250", year: 2000 },
  { make: "Yamaha", model: "YZ250", year: 2001 },
  { make: "Yamaha", model: "YZ250", year: 2002 },
  { make: "Yamaha", model: "YZ250", year: 2003 },
  { make: "Yamaha", model: "YZ250", year: 2004 },
  { make: "Yamaha", model: "YZ250", year: 2005 },
  { make: "Yamaha", model: "YZ250", year: 2006 },
  { make: "Yamaha", model: "YZ250", year: 2007 },
  { make: "Yamaha", model: "YZ250", year: 2008 },
  { make: "Yamaha", model: "YZ250", year: 2009 },
  { make: "Yamaha", model: "YZ250", year: 2010 },
  { make: "Yamaha", model: "YZ250", year: 2011 },
  { make: "Yamaha", model: "YZ250", year: 2012 },
  { make: "Yamaha", model: "YZ250", year: 2013 },
  { make: "Yamaha", model: "YZ250", year: 2014 },
  { make: "Yamaha", model: "YZ250", year: 2015 },
  { make: "Yamaha", model: "YZ250", year: 2016 },
  { make: "Yamaha", model: "YZ250", year: 2017 },
  { make: "Yamaha", model: "YZ250", year: 2018 },
  { make: "Yamaha", model: "YZ250", year: 2019 },
  { make: "Yamaha", model: "YZ250", year: 2020 },
  { make: "Yamaha", model: "YZ250", year: 2021 },
  { make: "Yamaha", model: "YZ250", year: 2022 },
  { make: "Yamaha", model: "YZ250", year: 2023 },
  { make: "Yamaha", model: "YZ250", year: 2024 },
  { make: "Yamaha", model: "YZ250", year: 2025 },
  { make: "Yamaha", model: "YZ250", year: 2026 },
  // Yamaha - YZ250F
  { make: "Yamaha", model: "YZ250F", year: 2001 },
  { make: "Yamaha", model: "YZ250F", year: 2002 },
  { make: "Yamaha", model: "YZ250F", year: 2003 },
  { make: "Yamaha", model: "YZ250F", year: 2004 },
  { make: "Yamaha", model: "YZ250F", year: 2005 },
  { make: "Yamaha", model: "YZ250F", year: 2006 },
  { make: "Yamaha", model: "YZ250F", year: 2007 },
  { make: "Yamaha", model: "YZ250F", year: 2008 },
  { make: "Yamaha", model: "YZ250F", year: 2009 },
  { make: "Yamaha", model: "YZ250F", year: 2010 },
  { make: "Yamaha", model: "YZ250F", year: 2011 },
  { make: "Yamaha", model: "YZ250F", year: 2012 },
  { make: "Yamaha", model: "YZ250F", year: 2013 },
  { make: "Yamaha", model: "YZ250F", year: 2014 },
  { make: "Yamaha", model: "YZ250F", year: 2015 },
  { make: "Yamaha", model: "YZ250F", year: 2016 },
  { make: "Yamaha", model: "YZ250F", year: 2017 },
  { make: "Yamaha", model: "YZ250F", year: 2018 },
  { make: "Yamaha", model: "YZ250F", year: 2019 },
  { make: "Yamaha", model: "YZ250F", year: 2020 },
  { make: "Yamaha", model: "YZ250F", year: 2021 },
  { make: "Yamaha", model: "YZ250F", year: 2022 },
  { make: "Yamaha", model: "YZ250F", year: 2023 },
  { make: "Yamaha", model: "YZ250F", year: 2024 },
  { make: "Yamaha", model: "YZ250F", year: 2025 },
  { make: "Yamaha", model: "YZ250F", year: 2026 },
  // Yamaha - YZ250FX
  { make: "Yamaha", model: "YZ250FX", year: 2015 },
  { make: "Yamaha", model: "YZ250FX", year: 2016 },
  { make: "Yamaha", model: "YZ250FX", year: 2017 },
  { make: "Yamaha", model: "YZ250FX", year: 2018 },
  { make: "Yamaha", model: "YZ250FX", year: 2019 },
  { make: "Yamaha", model: "YZ250FX", year: 2020 },
  { make: "Yamaha", model: "YZ250FX", year: 2021 },
  { make: "Yamaha", model: "YZ250FX", year: 2022 },
  { make: "Yamaha", model: "YZ250FX", year: 2023 },
  { make: "Yamaha", model: "YZ250FX", year: 2024 },
  { make: "Yamaha", model: "YZ250FX", year: 2025 },
  { make: "Yamaha", model: "YZ250FX", year: 2026 },
  // Yamaha - YZ250X
  { make: "Yamaha", model: "YZ250X", year: 2016 },
  { make: "Yamaha", model: "YZ250X", year: 2017 },
  { make: "Yamaha", model: "YZ250X", year: 2018 },
  { make: "Yamaha", model: "YZ250X", year: 2019 },
  { make: "Yamaha", model: "YZ250X", year: 2020 },
  { make: "Yamaha", model: "YZ250X", year: 2021 },
  { make: "Yamaha", model: "YZ250X", year: 2022 },
  { make: "Yamaha", model: "YZ250X", year: 2023 },
  { make: "Yamaha", model: "YZ250X", year: 2024 },
  { make: "Yamaha", model: "YZ250X", year: 2025 },
  { make: "Yamaha", model: "YZ250X", year: 2026 },
  // Yamaha - YZ450F
  { make: "Yamaha", model: "YZ450F", year: 2003 },
  { make: "Yamaha", model: "YZ450F", year: 2004 },
  { make: "Yamaha", model: "YZ450F", year: 2005 },
  { make: "Yamaha", model: "YZ450F", year: 2006 },
  { make: "Yamaha", model: "YZ450F", year: 2007 },
  { make: "Yamaha", model: "YZ450F", year: 2008 },
  { make: "Yamaha", model: "YZ450F", year: 2009 },
  { make: "Yamaha", model: "YZ450F", year: 2010 },
  { make: "Yamaha", model: "YZ450F", year: 2011 },
  { make: "Yamaha", model: "YZ450F", year: 2012 },
  { make: "Yamaha", model: "YZ450F", year: 2013 },
  { make: "Yamaha", model: "YZ450F", year: 2014 },
  { make: "Yamaha", model: "YZ450F", year: 2015 },
  { make: "Yamaha", model: "YZ450F", year: 2016 },
  { make: "Yamaha", model: "YZ450F", year: 2017 },
  { make: "Yamaha", model: "YZ450F", year: 2018 },
  { make: "Yamaha", model: "YZ450F", year: 2019 },
  { make: "Yamaha", model: "YZ450F", year: 2020 },
  { make: "Yamaha", model: "YZ450F", year: 2021 },
  { make: "Yamaha", model: "YZ450F", year: 2022 },
  { make: "Yamaha", model: "YZ450F", year: 2023 },
  { make: "Yamaha", model: "YZ450F", year: 2024 },
  { make: "Yamaha", model: "YZ450F", year: 2025 },
  { make: "Yamaha", model: "YZ450F", year: 2026 },
  // Yamaha - YZ450FX
  { make: "Yamaha", model: "YZ450FX", year: 2016 },
  { make: "Yamaha", model: "YZ450FX", year: 2017 },
  { make: "Yamaha", model: "YZ450FX", year: 2018 },
  { make: "Yamaha", model: "YZ450FX", year: 2019 },
  { make: "Yamaha", model: "YZ450FX", year: 2020 },
  { make: "Yamaha", model: "YZ450FX", year: 2021 },
  { make: "Yamaha", model: "YZ450FX", year: 2022 },
  { make: "Yamaha", model: "YZ450FX", year: 2023 },
  { make: "Yamaha", model: "YZ450FX", year: 2024 },
  { make: "Yamaha", model: "YZ450FX", year: 2025 },
  { make: "Yamaha", model: "YZ450FX", year: 2026 },
  // Yamaha - YZF R 125
  { make: "Yamaha", model: "YZF R 125", year: 2008 },
  { make: "Yamaha", model: "YZF R 125", year: 2009 },
  { make: "Yamaha", model: "YZF R 125", year: 2010 },
  { make: "Yamaha", model: "YZF R 125", year: 2011 },
  { make: "Yamaha", model: "YZF R 125", year: 2012 },
  { make: "Yamaha", model: "YZF R 125", year: 2013 },
  { make: "Yamaha", model: "YZF R 125", year: 2014 },
  // Yamaha - YZF-R1
  { make: "Yamaha", model: "YZF-R1", year: 2004 },
  { make: "Yamaha", model: "YZF-R1", year: 2005 },
  { make: "Yamaha", model: "YZF-R1", year: 2006 },
  { make: "Yamaha", model: "YZF-R1", year: 2007 },
  { make: "Yamaha", model: "YZF-R1", year: 2008 },
  { make: "Yamaha", model: "YZF-R1", year: 2009 },
  { make: "Yamaha", model: "YZF-R1", year: 2010 },
  { make: "Yamaha", model: "YZF-R1", year: 2011 },
  { make: "Yamaha", model: "YZF-R1", year: 2012 },
  { make: "Yamaha", model: "YZF-R1", year: 2013 },
  { make: "Yamaha", model: "YZF-R1", year: 2014 },
  { make: "Yamaha", model: "YZF-R1", year: 2015 },
  { make: "Yamaha", model: "YZF-R1", year: 2016 },
  { make: "Yamaha", model: "YZF-R1", year: 2017 },
  { make: "Yamaha", model: "YZF-R1", year: 2018 },
  { make: "Yamaha", model: "YZF-R1", year: 2019 },
  { make: "Yamaha", model: "YZF-R1", year: 2020 },
  { make: "Yamaha", model: "YZF-R1", year: 2021 },
  { make: "Yamaha", model: "YZF-R1", year: 2022 },
  { make: "Yamaha", model: "YZF-R1", year: 2023 },
  { make: "Yamaha", model: "YZF-R1", year: 2024 },
  { make: "Yamaha", model: "YZF-R1", year: 2025 },
  { make: "Yamaha", model: "YZF-R1", year: 2026 },
  { make: "Yamaha", model: "YZF-R1", year: 2027 },
  // Yamaha - YZF-R1 Gloss
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2009 },
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2010 },
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2011 },
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2012 },
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2013 },
  { make: "Yamaha", model: "YZF-R1 Gloss", year: 2014 },
  // Yamaha - YZF-R1 R1S R1M
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2015 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2016 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2017 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2018 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2019 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2020 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2021 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2022 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2023 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2024 },
  { make: "Yamaha", model: "YZF-R1 R1S R1M", year: 2025 },
  // Yamaha - YZF-R3
  { make: "Yamaha", model: "YZF-R3", year: 2015 },
  { make: "Yamaha", model: "YZF-R3", year: 2016 },
  { make: "Yamaha", model: "YZF-R3", year: 2017 },
  { make: "Yamaha", model: "YZF-R3", year: 2018 },
  { make: "Yamaha", model: "YZF-R3", year: 2019 },
  { make: "Yamaha", model: "YZF-R3", year: 2020 },
  { make: "Yamaha", model: "YZF-R3", year: 2021 },
  { make: "Yamaha", model: "YZF-R3", year: 2022 },
  { make: "Yamaha", model: "YZF-R3", year: 2023 },
  { make: "Yamaha", model: "YZF-R3", year: 2024 },
  { make: "Yamaha", model: "YZF-R3", year: 2025 },
  { make: "Yamaha", model: "YZF-R3", year: 2026 },
  // Yamaha - YZF-R3 15212BU
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2015 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2016 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2017 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2018 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2019 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2020 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2021 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2022 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2023 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2024 },
  { make: "Yamaha", model: "YZF-R3 15212BU", year: 2025 },
  // Yamaha - YZF-R6
  { make: "Yamaha", model: "YZF-R6", year: 1999 },
  { make: "Yamaha", model: "YZF-R6", year: 2000 },
  { make: "Yamaha", model: "YZF-R6", year: 2001 },
  { make: "Yamaha", model: "YZF-R6", year: 2002 },
  { make: "Yamaha", model: "YZF-R6", year: 2006 },
  { make: "Yamaha", model: "YZF-R6", year: 2007 },
  { make: "Yamaha", model: "YZF-R6", year: 2008 },
  { make: "Yamaha", model: "YZF-R6", year: 2009 },
  { make: "Yamaha", model: "YZF-R6", year: 2010 },
  { make: "Yamaha", model: "YZF-R6", year: 2011 },
  { make: "Yamaha", model: "YZF-R6", year: 2012 },
  { make: "Yamaha", model: "YZF-R6", year: 2013 },
  { make: "Yamaha", model: "YZF-R6", year: 2014 },
  { make: "Yamaha", model: "YZF-R6", year: 2015 },
  { make: "Yamaha", model: "YZF-R6", year: 2016 },
  { make: "Yamaha", model: "YZF-R6", year: 2017 },
  { make: "Yamaha", model: "YZF-R6", year: 2018 },
  { make: "Yamaha", model: "YZF-R6", year: 2019 },
  { make: "Yamaha", model: "YZF-R6", year: 2020 },
  { make: "Yamaha", model: "YZF-R6", year: 2021 },
  { make: "Yamaha", model: "YZF-R6", year: 2022 },
  { make: "Yamaha", model: "YZF-R6", year: 2023 },
  { make: "Yamaha", model: "YZF-R6", year: 2024 },
  { make: "Yamaha", model: "YZF-R6", year: 2025 },
  { make: "Yamaha", model: "YZF-R6", year: 2026 },
  { make: "Yamaha", model: "YZF-R6", year: 2027 },
  // Yamaha - YZF-R7
  { make: "Yamaha", model: "YZF-R7", year: 2021 },
  { make: "Yamaha", model: "YZF-R7", year: 2022 },
  { make: "Yamaha", model: "YZF-R7", year: 2023 },
  { make: "Yamaha", model: "YZF-R7", year: 2024 },
  { make: "Yamaha", model: "YZF-R7", year: 2025 },
  // Yamaha - YZF-R9
  { make: "Yamaha", model: "YZF-R9", year: 2025 },
  { make: "Yamaha", model: "YZF-R9", year: 2026 },
  // Yamaha - YZF-R9 15415BU
  { make: "Yamaha", model: "YZF-R9 15415BU", year: 2025 },
  { make: "Yamaha", model: "YZF-R9 15415BU", year: 2026 },
  // Yamaha - YZF-R9 15415CU
  { make: "Yamaha", model: "YZF-R9 15415CU", year: 2025 },
  { make: "Yamaha", model: "YZF-R9 15415CU", year: 2026 },
  // Yamaha - YZF-R9 15415TU
  { make: "Yamaha", model: "YZF-R9 15415TU", year: 2025 },
  { make: "Yamaha", model: "YZF-R9 15415TU", year: 2026 },
  // Yamaha - YZF-R9 80072
  { make: "Yamaha", model: "YZF-R9 80072", year: 2025 },
  { make: "Yamaha", model: "YZF-R9 80072", year: 2026 },
  // Yamaha - YZF-R25
  { make: "Yamaha", model: "YZF-R25", year: 2014 },
  { make: "Yamaha", model: "YZF-R25", year: 2015 },
  { make: "Yamaha", model: "YZF-R25", year: 2016 },
  { make: "Yamaha", model: "YZF-R25", year: 2017 },
  { make: "Yamaha", model: "YZF-R25", year: 2018 },
  { make: "Yamaha", model: "YZF-R25", year: 2019 },
  { make: "Yamaha", model: "YZF-R25", year: 2020 },
  { make: "Yamaha", model: "YZF-R25", year: 2021 },
  // Yamaha - YZF-R125
  { make: "Yamaha", model: "YZF-R125", year: 2008 },
  { make: "Yamaha", model: "YZF-R125", year: 2009 },
  { make: "Yamaha", model: "YZF-R125", year: 2010 },
  { make: "Yamaha", model: "YZF-R125", year: 2011 },
  { make: "Yamaha", model: "YZF-R125", year: 2012 },
  { make: "Yamaha", model: "YZF-R125", year: 2013 },
  { make: "Yamaha", model: "YZF-R125", year: 2014 },
  { make: "Yamaha", model: "YZF-R125", year: 2017 },
  { make: "Yamaha", model: "YZF-R125", year: 2018 },
  { make: "Yamaha", model: "YZF-R125", year: 2019 },
  { make: "Yamaha", model: "YZF-R125", year: 2020 },
  { make: "Yamaha", model: "YZF-R125", year: 2021 },
  { make: "Yamaha", model: "YZF-R125", year: 2022 },
  { make: "Yamaha", model: "YZF-R125", year: 2023 },
  { make: "Yamaha", model: "YZF-R125", year: 2024 },
  // Yamaha - YZF1000
  { make: "Yamaha", model: "YZF1000", year: 2004 },
  { make: "Yamaha", model: "YZF1000", year: 2005 },
  { make: "Yamaha", model: "YZF1000", year: 2006 },
  // Zero
  // Zero - DSR/X
  { make: "Zero", model: "DSR/X", year: 2023 },
  { make: "Zero", model: "DSR/X", year: 2024 },
  { make: "Zero", model: "DSR/X", year: 2025 },
  { make: "Zero", model: "DSR/X", year: 2026 },
  // Zero - SR/F
  { make: "Zero", model: "SR/F", year: 2019 },
  { make: "Zero", model: "SR/F", year: 2020 },
  { make: "Zero", model: "SR/F", year: 2021 },
  { make: "Zero", model: "SR/F", year: 2022 },
  { make: "Zero", model: "SR/F", year: 2023 },
  { make: "Zero", model: "SR/F", year: 2024 },
  { make: "Zero", model: "SR/F", year: 2025 },
  { make: "Zero", model: "SR/F", year: 2026 },
  // Zero - SR/S
  { make: "Zero", model: "SR/S", year: 2020 },
  { make: "Zero", model: "SR/S", year: 2021 },
  { make: "Zero", model: "SR/S", year: 2022 },
  { make: "Zero", model: "SR/S", year: 2023 },
  { make: "Zero", model: "SR/S", year: 2024 },
  { make: "Zero", model: "SR/S", year: 2025 },
  { make: "Zero", model: "SR/S", year: 2026 },
];
